// Generated by scripts/sync-catalog-sitemap.mjs — do not edit by hand.
// Re-run: pnpm sync:catalog-sitemap
// Keys are `{providerSlug}/{gameSlug}` — game slugs are not unique across providers.
export const gamesSlugMap = {
    "1x2gaming/420_blaze_it": {
        slug: "420_blaze_it",
        name: "420 Blaze It",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/arctic_fruits": {
        slug: "arctic_fruits",
        name: "Arctic Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/asgard_warriors": {
        slug: "asgard_warriors",
        name: "Asgard Warriors",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/battle_maidens_cleopatra": {
        slug: "battle_maidens_cleopatra",
        name: "Battle Maidens: Cleopatra",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/battle_maidens_cleopatra_no_buy_feature": {
        slug: "battle_maidens_cleopatra_no_buy_feature",
        name: "Battle Maidens Cleopatra (No buy feature)",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/big_hitter": {
        slug: "big_hitter",
        name: "Big Hitter",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/blackjack_bonus": {
        slug: "blackjack_bonus",
        name: "Blackjack Bonus",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/blazing_777": {
        slug: "blazing_777",
        name: "Blazing 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/blood_rage": {
        slug: "blood_rage",
        name: "Blood Rage",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/branded_coin_vault": {
        slug: "branded_coin_vault",
        name: "Branded Coin Vault",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/candycash": {
        slug: "candycash",
        name: "CandyCash",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/classic_fruits": {
        slug: "classic_fruits",
        name: "Classic Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/coin_field": {
        slug: "coin_field",
        name: "Coin Field",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/coin_vault": {
        slug: "coin_vault",
        name: "Coin Vault",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/crashout_firework": {
        slug: "crashout_firework",
        name: "Crashout - Firework",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/darts_180": {
        slug: "darts_180",
        name: "Darts 180",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/disco_777": {
        slug: "disco_777",
        name: "Disco 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/fields_of_clover": {
        slug: "fields_of_clover",
        name: "Fields of clover",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/football_3x3": {
        slug: "football_3x3",
        name: "Football 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/fruit_snapz": {
        slug: "fruit_snapz",
        name: "Fruit Snapz",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/fruity_3x3": {
        slug: "fruity_3x3",
        name: "Fruity 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/gingerbread_joy": {
        slug: "gingerbread_joy",
        name: "Gingerbread Joy",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/ice_queen": {
        slug: "ice_queen",
        name: "Ice Queen",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/italia_3x3": {
        slug: "italia_3x3",
        name: "Italia 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/jackpot_3x3": {
        slug: "jackpot_3x3",
        name: "Jackpot 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/jesters_wilds": {
        slug: "jesters_wilds",
        name: "Jesters Wilds",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/jewel_of_athena": {
        slug: "jewel_of_athena",
        name: "Jewel of Athena",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/justice_machine_scratch": {
        slug: "justice_machine_scratch",
        name: "Justice Machine Scratch",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/kitty_cash_scratch": {
        slug: "kitty_cash_scratch",
        name: "Kitty Cash Scratch",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/leprechaun_charms": {
        slug: "leprechaun_charms",
        name: "Leprechaun Charms",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/lucky_streaks": {
        slug: "lucky_streaks",
        name: "Lucky Streaks",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/medieval_mania": {
        slug: "medieval_mania",
        name: "Medieval Mania",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/megablox_777": {
        slug: "megablox_777",
        name: "MegaBlox 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/megablox_pyramids": {
        slug: "megablox_pyramids",
        name: "Megablox Pyramids",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/phoenix_inferno": {
        slug: "phoenix_inferno",
        name: "Phoenix Inferno",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/pirate_armada": {
        slug: "pirate_armada",
        name: "Pirate Armada",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/plinko_go": {
        slug: "plinko_go",
        name: "Plinko Go",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/pop_till_you_drop": {
        slug: "pop_till_you_drop",
        name: "Pop TIll You Drop",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/puppy_payday": {
        slug: "puppy_payday",
        name: "Puppy Payday",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/queen_of_embers": {
        slug: "queen_of_embers",
        name: "Queen of Embers",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/rainbow_3x3": {
        slug: "rainbow_3x3",
        name: "Rainbow 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/red_queen_blackjack": {
        slug: "red_queen_blackjack",
        name: "Red Queen Blackjack",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/reel_diamonds": {
        slug: "reel_diamonds",
        name: "Reel Diamonds",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/reel_fruits": {
        slug: "reel_fruits",
        name: "Reel Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/roulette_diamond": {
        slug: "roulette_diamond",
        name: "Roulette Diamond",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/sic_bo_888": {
        slug: "sic_bo_888",
        name: "Sic Bo 888",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/smoking_hot_fruits": {
        slug: "smoking_hot_fruits",
        name: "Smoking Hot Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/smoking_hot_fruits_20_lines": {
        slug: "smoking_hot_fruits_20_lines",
        name: "Smoking Hot Fruits 20 Lines",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/smoking_hot_fruits_stacks": {
        slug: "smoking_hot_fruits_stacks",
        name: "Smoking Hot Fruits Stacks",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/smoking_hot_fruits_wild_respins": {
        slug: "smoking_hot_fruits_wild_respins",
        name: "Smoking Hot Fruits Wild Respins",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/sparkling_777s": {
        slug: "sparkling_777s",
        name: "Sparkling 777s",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/spino_cricket": {
        slug: "spino_cricket",
        name: "Spino Cricket",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/stellar_ways_": {
        slug: "stellar_ways_",
        name: "Stellar Ways -",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/super_rainbow_megaways": {
        slug: "super_rainbow_megaways",
        name: "Super Rainbow Megaways",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/theseus_rises": {
        slug: "theseus_rises",
        name: "Theseus Rises",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/trawler_fishin": {
        slug: "trawler_fishin",
        name: "Trawler Fishin'",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/triple_bar_": {
        slug: "triple_bar_",
        name: "Triple Bar -",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/tutan_keno": {
        slug: "tutan_keno",
        name: "Tutan Keno",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/van_helsings_book_of_the_undead": {
        slug: "van_helsings_book_of_the_undead",
        name: "Van Helsing's Book Of The Undead",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/virtual_football_pro": {
        slug: "virtual_football_pro",
        name: "Virtual Football Pro",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/virtual_soccer": {
        slug: "virtual_soccer",
        name: "Virtual Soccer",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/whisker_jones": {
        slug: "whisker_jones",
        name: "Whisker jones",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/xmas_3x3": {
        slug: "xmas_3x3",
        name: "Xmas 3x3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/xwild": {
        slug: "xwild",
        name: "X-Wild",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "3oaks/15_dragon_pearls": {
        slug: "15_dragon_pearls",
        name: "15 Dragon Pearls",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_african_drums": {
        slug: "3_african_drums",
        name: "3 African Drums",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_aztec_temples": {
        slug: "3_aztec_temples",
        name: "3 Aztec Temples",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_china_pots": {
        slug: "3_china_pots",
        name: "3 China Pots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_clover_pots": {
        slug: "3_clover_pots",
        name: "3 Clover Pots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_clover_pots_extra": {
        slug: "3_clover_pots_extra",
        name: "3 Clover Pots Extra",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_coin_volcanoes": {
        slug: "3_coin_volcanoes",
        name: "3 Coin Volcanoes",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_coins": {
        slug: "3_coins",
        name: "3 Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_egypt_chests": {
        slug: "3_egypt_chests",
        name: "3 Egypt Chests",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_hot_chillies": {
        slug: "3_hot_chillies",
        name: "3 Hot Chillies",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_hot_teapots": {
        slug: "3_hot_teapots",
        name: "3 Hot Teapots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_jewel_crowns": {
        slug: "3_jewel_crowns",
        name: "3 Jewel Crowns",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_lucky_sparks": {
        slug: "3_lucky_sparks",
        name: "3 Lucky Sparks",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_pots_of_egypt": {
        slug: "3_pots_of_egypt",
        name: "3 Pots of Egypt",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_super_coin_volcanoes": {
        slug: "3_super_coin_volcanoes",
        name: "3 Super Coin Volcanoes",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/3_super_hot_chillies": {
        slug: "3_super_hot_chillies",
        name: "3 Super Hot Chillies",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/4_african_drums": {
        slug: "4_african_drums",
        name: "4 African Drums",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/4_clover_pots": {
        slug: "4_clover_pots",
        name: "4 Clover Pots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/4_fairy_flowers": {
        slug: "4_fairy_flowers",
        name: "4 Fairy Flowers",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/4_fortune_clovers": {
        slug: "4_fortune_clovers",
        name: "4 Fortune Clovers",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/4_pots_of_egypt": {
        slug: "4_pots_of_egypt",
        name: "4 Pots of Egypt",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/4_wolf_drums": {
        slug: "4_wolf_drums",
        name: "4 Wolf Drums",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/777_coins": {
        slug: "777_coins",
        name: "777 Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/777_fruity_coins": {
        slug: "777_fruity_coins",
        name: "777 Fruity Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/777_gems_respin": {
        slug: "777_gems_respin",
        name: "777 Gems Respin",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/amazonia_wins": {
        slug: "amazonia_wins",
        name: "Amazonia Wins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/aztec_fire": {
        slug: "aztec_fire",
        name: "Aztec Fire",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/aztec_fire_2": {
        slug: "aztec_fire_2",
        name: "Aztec Fire 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/aztec_sun": {
        slug: "aztec_sun",
        name: "Aztec Sun",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/big_heist": {
        slug: "big_heist",
        name: "Big Heist",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/black_wolf": {
        slug: "black_wolf",
        name: "Black Wolf",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/black_wolf_2": {
        slug: "black_wolf_2",
        name: "Black Wolf 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/book_of_sun": {
        slug: "book_of_sun",
        name: "Book of Sun",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/book_of_sun_multichance": {
        slug: "book_of_sun_multichance",
        name: "Book of Sun: Multichance",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/book_of_wizard_crystal_chance": {
        slug: "book_of_wizard_crystal_chance",
        name: "Book of Wizard: Crystal Chance",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/buddha_megaways": {
        slug: "buddha_megaways",
        name: "Buddha Megaways",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/chili_coins": {
        slug: "chili_coins",
        name: "Chili Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/china_festival": {
        slug: "china_festival",
        name: "China Festival",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/coin_express": {
        slug: "coin_express",
        name: "Coin Express",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/coin_lamp": {
        slug: "coin_lamp",
        name: "Coin Lamp",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/coin_princess_x1000": {
        slug: "coin_princess_x1000",
        name: "Coin Princess x1000",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/coin_up_hot_fire": {
        slug: "coin_up_hot_fire",
        name: "Coin UP: Hot Fire",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/coin_up_lightning": {
        slug: "coin_up_lightning",
        name: "Coin Up: Lightning",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/coin_volcano": {
        slug: "coin_volcano",
        name: "Coin Volcano",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/coin_volcano_2": {
        slug: "coin_volcano_2",
        name: "Coin Volcano 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/crystal_scarabs": {
        slug: "crystal_scarabs",
        name: "Crystal Scarabs",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/dancing_joker": {
        slug: "dancing_joker",
        name: "Dancing Joker",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/dj_tiger_x1000": {
        slug: "dj_tiger_x1000",
        name: "DJ Tiger x1000",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/dragon_pearls": {
        slug: "dragon_pearls",
        name: "Dragon Pearls",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/egypt_fire": {
        slug: "egypt_fire",
        name: "Egypt Fire",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/egypt_fire_2": {
        slug: "egypt_fire_2",
        name: "Egypt Fire 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/egypt_power_x1000": {
        slug: "egypt_power_x1000",
        name: "Egypt Power x1000",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/eye_of_gold": {
        slug: "eye_of_gold",
        name: "Eye of Gold",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/fishin_bear": {
        slug: "fishin_bear",
        name: "Fishin' Bear",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/fortune_globe": {
        slug: "fortune_globe",
        name: "Fortune Globe",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/gold_express": {
        slug: "gold_express",
        name: "Gold Express",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/gold_nuggets": {
        slug: "gold_nuggets",
        name: "Gold Nuggets",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/golden_teapot": {
        slug: "golden_teapot",
        name: "Golden Teapot",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/grab_more_gold": {
        slug: "grab_more_gold",
        name: "Grab more Gold!",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/grab_the_gold": {
        slug: "grab_the_gold",
        name: "Grab the Gold!",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/grand": {
        slug: "grand",
        name: "Grand",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/green_chilli": {
        slug: "green_chilli",
        name: "Green Chilli",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/green_chilli_2": {
        slug: "green_chilli_2",
        name: "Green Chilli 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/hit_more_gold": {
        slug: "hit_more_gold",
        name: "Hit more Gold!",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/hit_the_gold": {
        slug: "hit_the_gold",
        name: "Hit the Gold!",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/hot_fire_fruits": {
        slug: "hot_fire_fruits",
        name: "Hot Fire Fruits",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/joker_glitz_x1000": {
        slug: "joker_glitz_x1000",
        name: "Joker Glitz x1000",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/jungle_volcano": {
        slug: "jungle_volcano",
        name: "Jungle Volcano",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/lady_fortune": {
        slug: "lady_fortune",
        name: "Lady Fortune",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/lava_coins": {
        slug: "lava_coins",
        name: "Lava Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/lava_coins_2": {
        slug: "lava_coins_2",
        name: "Lava Coins 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/little_farm": {
        slug: "little_farm",
        name: "Little Farm",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/lord_of_thunder": {
        slug: "lord_of_thunder",
        name: "Lord of Thunder",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/lucky_apple_x1000": {
        slug: "lucky_apple_x1000",
        name: "Lucky Apple x1000",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/lucky_penny": {
        slug: "lucky_penny",
        name: "Lucky Penny",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/lucky_penny_2": {
        slug: "lucky_penny_2",
        name: "Lucky Penny 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/lucky_penny_power_scatter": {
        slug: "lucky_penny_power_scatter",
        name: "Lucky Penny Power Scatter",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/magic_apple": {
        slug: "magic_apple",
        name: "Magic Apple",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/magic_apple_2": {
        slug: "magic_apple_2",
        name: "Magic Apple 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/magic_ball_multichance": {
        slug: "magic_ball_multichance",
        name: "Magic Ball: Multichance",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/magic_clovers": {
        slug: "magic_clovers",
        name: "Magic Clovers",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/moon_sisters": {
        slug: "moon_sisters",
        name: "Moon Sisters",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/more_magic_apple": {
        slug: "more_magic_apple",
        name: "More Magic Apple",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/olaf_viking": {
        slug: "olaf_viking",
        name: "Olaf Viking",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/olymp_fortunes": {
        slug: "olymp_fortunes",
        name: "Olymp Fortunes",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/pearl_diver": {
        slug: "pearl_diver",
        name: "Pearl Diver",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/power_sun": {
        slug: "power_sun",
        name: "Power Sun",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/power_sun_xxl": {
        slug: "power_sun_xxl",
        name: "Power Sun XXL",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/purple_diamonds": {
        slug: "purple_diamonds",
        name: "Purple Diamonds",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/rio_gems": {
        slug: "rio_gems",
        name: "Rio Gems",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/rush_for_gold": {
        slug: "rush_for_gold",
        name: "Rush for Gold",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/scarab_temple": {
        slug: "scarab_temple",
        name: "Scarab Temple",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/sky_coins": {
        slug: "sky_coins",
        name: "Sky Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/sky_pearls": {
        slug: "sky_pearls",
        name: "Sky Pearls",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/space_coins": {
        slug: "space_coins",
        name: "Space Coins",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/sun_of_egypt": {
        slug: "sun_of_egypt",
        name: "Sun of Egypt",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/sun_of_egypt_2": {
        slug: "sun_of_egypt_2",
        name: "Sun of Egypt 2",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/sun_of_egypt_3": {
        slug: "sun_of_egypt_3",
        name: "Sun of Egypt 3",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/sun_of_egypt_4": {
        slug: "sun_of_egypt_4",
        name: "Sun of Egypt 4",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/sun_of_egypt_5": {
        slug: "sun_of_egypt_5",
        name: "Sun of Egypt 5",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/sunlight_princess": {
        slug: "sunlight_princess",
        name: "Sunlight Princess",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/super_china_pots": {
        slug: "super_china_pots",
        name: "Super China Pots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/super_hot_chilli": {
        slug: "super_hot_chilli",
        name: "Super Hot Chilli",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/super_hot_teapots": {
        slug: "super_hot_teapots",
        name: "Super Hot Teapots",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/super_hotfire_diamonds": {
        slug: "super_hotfire_diamonds",
        name: "Super Hotfire Diamonds",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/super_sticky_piggy": {
        slug: "super_sticky_piggy",
        name: "Super Sticky Piggy",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/supreme_diamond_xxl": {
        slug: "supreme_diamond_xxl",
        name: "Supreme Diamond XXL",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/thunder_tiger": {
        slug: "thunder_tiger",
        name: "Thunder Tiger",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/tiger_gems": {
        slug: "tiger_gems",
        name: "Tiger Gems",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/tiger_jungle": {
        slug: "tiger_jungle",
        name: "Tiger Jungle",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/wolf_night": {
        slug: "wolf_night",
        name: "Wolf Night",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "3oaks/yoho_gold": {
        slug: "yoho_gold",
        name: "Yo-Ho Gold!",
        provider: "3oaks",
        providerSlug: "3oaks"
    },
    "4theplayer/100_bit_dice": {
        slug: "100_bit_dice",
        name: "100 Bit Dice",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/10000_bc_2_doublemax": {
        slug: "10000_bc_2_doublemax",
        name: "10000 BC 2 Doublemax",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/10000_bc_doublemax": {
        slug: "10000_bc_doublemax",
        name: "10000 BC Doublemax",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/10000x_gold": {
        slug: "10000x_gold",
        name: "10000x Gold",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/10000x_gold_2": {
        slug: "10000x_gold_2",
        name: "10000X Gold 2",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/1000x_busta": {
        slug: "1000x_busta",
        name: "1000x Busta",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/10x_rewind": {
        slug: "10x_rewind",
        name: "10X Rewind",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/12_trojan_mysteries": {
        slug: "12_trojan_mysteries",
        name: "12 Trojan Mysteries",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/123_boom": {
        slug: "123_boom",
        name: "123 Boom",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/2_sweet_4_u": {
        slug: "2_sweet_4_u",
        name: "2 Sweet 4 U",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/21_thor_lightning_ways": {
        slug: "21_thor_lightning_ways",
        name: "21 Thor Lightning Ways",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/3_lucky_leprechauns": {
        slug: "3_lucky_leprechauns",
        name: "3 Lucky Leprechauns",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/3_lucky_witches": {
        slug: "3_lucky_witches",
        name: "3 Lucky Witches",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/3_secret_cities": {
        slug: "3_secret_cities",
        name: "3 Secret Cities",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_deals_with_the_devil": {
        slug: "4_deals_with_the_devil",
        name: "4 Deals With The Devil",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_fish": {
        slug: "4_fantastic_fish",
        name: "4 Fantastic Fish",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_fish_amazon_adventure": {
        slug: "4_fantastic_fish_amazon_adventure",
        name: "4 Fantastic Fish Amazon Adventure",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_fish_gigablox": {
        slug: "4_fantastic_fish_gigablox",
        name: "4 Fantastic Fish Gigablox",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_fish_gold": {
        slug: "4_fantastic_fish_gold",
        name: "4 Fantastic Fish Gold",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_fish_in_egypt": {
        slug: "4_fantastic_fish_in_egypt",
        name: "4 Fantastic Fish in Egypt",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_vikings_go_fishing": {
        slug: "4_fantastic_vikings_go_fishing",
        name: "4 Fantastic Vikings Go Fishing",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_vikings_go_ice_fishing": {
        slug: "4_fantastic_vikings_go_ice_fishing",
        name: "4 Fantastic Vikings Go Ice Fishing",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_pirate_chests": {
        slug: "4_pirate_chests",
        name: "4 Pirate Chests",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_secret_pyramids": {
        slug: "4_secret_pyramids",
        name: "4 Secret Pyramids",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4tp_book_of_africra": {
        slug: "4tp_book_of_africra",
        name: "4TP Book of AfricRa",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4tp_guns_n_gold": {
        slug: "4tp_guns_n_gold",
        name: "4TP Guns N Gold",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4tp_pigs_n_pots": {
        slug: "4tp_pigs_n_pots",
        name: "4TP Pigs N' Pots",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4tp_railroad_robbery": {
        slug: "4tp_railroad_robbery",
        name: "4TP Railroad Robbery",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_doggy_dollars": {
        slug: "5_doggy_dollars",
        name: "5 Doggy Dollars",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_wild_buffalo": {
        slug: "5_wild_buffalo",
        name: "5 Wild Buffalo",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_wild_buffalo_2": {
        slug: "5_wild_buffalo_2",
        name: "5 Wild Buffalo 2",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_wild_buffalo_3": {
        slug: "5_wild_buffalo_3",
        name: "5 Wild Buffalo 3",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_wild_wolves": {
        slug: "5_wild_wolves",
        name: "5 Wild Wolves",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5k_gold_mine": {
        slug: "5k_gold_mine",
        name: "5K Gold Mine",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/6_wild_sharks": {
        slug: "6_wild_sharks",
        name: "6 Wild Sharks",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/60_second_heist": {
        slug: "60_second_heist",
        name: "60 Second Heist",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7_elements": {
        slug: "7_elements",
        name: "7 Elements",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7_gold_fruits": {
        slug: "7_gold_fruits",
        name: "7 Gold Fruits",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7_gold_gigablox": {
        slug: "7_gold_gigablox",
        name: "7 Gold Gigablox",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7x7_thor": {
        slug: "7x7_thor",
        name: "7x7 Thor",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7x7_zeus": {
        slug: "7x7_zeus",
        name: "7x7 Zeus",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/8k_ultra_gold_ultimate": {
        slug: "8k_ultra_gold_ultimate",
        name: "8K Ultra Gold Ultimate",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/90k_yeti_gigablox": {
        slug: "90k_yeti_gigablox",
        name: "90k Yeti Gigablox",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/9k_kong_in_vegas": {
        slug: "9k_kong_in_vegas",
        name: "9k Kong In Vegas",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/9k_yeti": {
        slug: "9k_yeti",
        name: "9k Yeti",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "adlunam/coinsweeper": {
        slug: "coinsweeper",
        name: "Coinsweeper",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "adlunam/flip_n_spin": {
        slug: "flip_n_spin",
        name: "Flip n Spin",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "adlunam/maverick": {
        slug: "maverick",
        name: "Maverick",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "adlunam/maverick_x": {
        slug: "maverick_x",
        name: "Maverick X",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "adlunam/pin_rush_x": {
        slug: "pin_rush_x",
        name: "Pin Rush X",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "adlunam/rock_paper_scissors_draw": {
        slug: "rock_paper_scissors_draw",
        name: "Rock Paper Scissors Draw",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "avatarux/3_builder_piggies": {
        slug: "3_builder_piggies",
        name: "3 Builder Piggies",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_jungle_beats": {
        slug: "3_jungle_beats",
        name: "3 Jungle Beats",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_power_bears": {
        slug: "3_power_bears",
        name: "3 Power Bears",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_power_dragons": {
        slug: "3_power_dragons",
        name: "3 Power Dragons",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_power_genies": {
        slug: "3_power_genies",
        name: "3 Power Genies",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_rockin_penguins": {
        slug: "3_rockin_penguins",
        name: "3 Rockin Penguins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/7_lucky_gods": {
        slug: "7_lucky_gods",
        name: "7 Lucky Gods",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/80spop": {
        slug: "80spop",
        name: "80sPOP",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/animals_strike": {
        slug: "animals_strike",
        name: "Animals Strike",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/arcanapop": {
        slug: "arcanapop",
        name: "ArcanaPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/astropop": {
        slug: "astropop",
        name: "AstroPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/beastly_burglars": {
        slug: "beastly_burglars",
        name: "Beastly Burglars",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/big_catch_craze": {
        slug: "big_catch_craze",
        name: "Big Catch Craze",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/big_catch_xmas": {
        slug: "big_catch_xmas",
        name: "Big Catch Xmas",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/blessings_of_caishen": {
        slug: "blessings_of_caishen",
        name: "Blessings of Caishen",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/bounty_pop": {
        slug: "bounty_pop",
        name: "Bounty Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/canyon_riches": {
        slug: "canyon_riches",
        name: "Canyon Riches",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/captain_moregain": {
        slug: "captain_moregain",
        name: "Captain More'gain",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/carioca_vibes": {
        slug: "carioca_vibes",
        name: "Carioca Vibes",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/cherry_pop": {
        slug: "cherry_pop",
        name: "Cherry Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/cherry_pop_deluxe": {
        slug: "cherry_pop_deluxe",
        name: "Cherry Pop Deluxe",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/cherrypop_burst": {
        slug: "cherrypop_burst",
        name: "CherryPop Burst",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/cosmic_jokers": {
        slug: "cosmic_jokers",
        name: "Cosmic Jokers",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/coyote_gold": {
        slug: "coyote_gold",
        name: "Coyote Gold",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crazy_mart_bonanza": {
        slug: "crazy_mart_bonanza",
        name: "Crazy Mart Bonanza",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/critter_pop": {
        slug: "critter_pop",
        name: "Critter Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crypto_bro": {
        slug: "crypto_bro",
        name: "Crypto Bro",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crypto_crown_10": {
        slug: "crypto_crown_10",
        name: "Crypto Crown 10",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crypto_crown_20": {
        slug: "crypto_crown_20",
        name: "Crypto Crown 20",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crypto_crown_40": {
        slug: "crypto_crown_40",
        name: "Crypto Crown 40",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crypto_crown_5": {
        slug: "crypto_crown_5",
        name: "Crypto Crown 5",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/depths_of_fortune": {
        slug: "depths_of_fortune",
        name: "Depths of Fortune",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/diamond_dez": {
        slug: "diamond_dez",
        name: "Diamond Dez",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/donkey_and_the_goats": {
        slug: "donkey_and_the_goats",
        name: "Donkey & The Goats",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/duck_hunt_500": {
        slug: "duck_hunt_500",
        name: "Duck Hunt 500",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/dyna_mule": {
        slug: "dyna_mule",
        name: "Dyna Mule",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/electric_rush": {
        slug: "electric_rush",
        name: "Electric Rush",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/electro_cubes": {
        slug: "electro_cubes",
        name: "Electro Cubes",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/floridaman": {
        slug: "floridaman",
        name: "Floridaman",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/fruitillionaire": {
        slug: "fruitillionaire",
        name: "Fruitillionaire",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/gempops": {
        slug: "gempops",
        name: "GemPOPs",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/gods_gone_wild": {
        slug: "gods_gone_wild",
        name: "Gods Gone Wild",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/heliopopolis": {
        slug: "heliopopolis",
        name: "HelioPOPolis",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/hiphop_pop": {
        slug: "hiphop_pop",
        name: "Hip-Hop Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/hippo_pop": {
        slug: "hippo_pop",
        name: "Hippo Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/imperial_coins": {
        slug: "imperial_coins",
        name: "Imperial Coins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/jinglepop": {
        slug: "jinglepop",
        name: "JinglePOP",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/juicypop": {
        slug: "juicypop",
        name: "JuicyPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/jungle_pop": {
        slug: "jungle_pop",
        name: "Jungle Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/king_of_samba": {
        slug: "king_of_samba",
        name: "King of Samba",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/kittypopins": {
        slug: "kittypopins",
        name: "KittyPOPins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/kokeshi_pop": {
        slug: "kokeshi_pop",
        name: "Kokeshi Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/lolli_pop": {
        slug: "lolli_pop",
        name: "Lolli Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/looney_pop": {
        slug: "looney_pop",
        name: "Looney Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/majestic_meow": {
        slug: "majestic_meow",
        name: "Majestic Meow",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/midnight_hunt": {
        slug: "midnight_hunt",
        name: "Midnight Hunt",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/monkey_pop": {
        slug: "monkey_pop",
        name: "Monkey Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/monkeypop_2": {
        slug: "monkeypop_2",
        name: "MonkeyPop 2",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/nugget": {
        slug: "nugget",
        name: "Nugget",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/papaya_pop": {
        slug: "papaya_pop",
        name: "Papaya Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/piggy_pop": {
        slug: "piggy_pop",
        name: "Piggy Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/piggy_pop_grand_affair_2": {
        slug: "piggy_pop_grand_affair_2",
        name: "Piggy Pop Grand Affair 2",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/piggypop_grand_affair": {
        slug: "piggypop_grand_affair",
        name: "PiggyPop Grand Affair",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pixel_paws": {
        slug: "pixel_paws",
        name: "Pixel Paws",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pixiepop": {
        slug: "pixiepop",
        name: "PixiePop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pop_noir": {
        slug: "pop_noir",
        name: "Pop Noir",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pop_ogold": {
        slug: "pop_ogold",
        name: "Pop o'Gold",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pop_rocks": {
        slug: "pop_rocks",
        name: "Pop Rocks",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pots_of_power_zeus": {
        slug: "pots_of_power_zeus",
        name: "Pots of Power Zeus",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/prince_of_purrwood": {
        slug: "prince_of_purrwood",
        name: "Prince of Purrwood",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/raging_pop": {
        slug: "raging_pop",
        name: "Raging Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/rebel_paws": {
        slug: "rebel_paws",
        name: "Rebel Paws",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/reef_pop": {
        slug: "reef_pop",
        name: "Reef Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/reel_warriors": {
        slug: "reel_warriors",
        name: "Reel Warriors",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/shippy_d_pop": {
        slug: "shippy_d_pop",
        name: "Shippy D Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/silicon_spinners": {
        slug: "silicon_spinners",
        name: "Silicon Spinners",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/sphinx_treasure": {
        slug: "sphinx_treasure",
        name: "Sphinx Treasure",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/spinfection": {
        slug: "spinfection",
        name: "Spinfection",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/spinxiety": {
        slug: "spinxiety",
        name: "Spinxiety",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/sweet_gummy": {
        slug: "sweet_gummy",
        name: "Sweet Gummy",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/the_vault_chase": {
        slug: "the_vault_chase",
        name: "The Vault Chase",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/tik_talkers": {
        slug: "tik_talkers",
        name: "Tik Talkers",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/tiki_pop": {
        slug: "tiki_pop",
        name: "Tiki Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/tikipop_spooky_temples": {
        slug: "tikipop_spooky_temples",
        name: "TikiPop Spooky Temples",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/toads_bounty": {
        slug: "toads_bounty",
        name: "Toad's Bounty",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/vegas_fortune": {
        slug: "vegas_fortune",
        name: "Vegas Fortune",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/wild_pops": {
        slug: "wild_pops",
        name: "Wild Pops",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/witchy_poppins": {
        slug: "witchy_poppins",
        name: "Witchy POPpins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/worms_of_valor": {
        slug: "worms_of_valor",
        name: "Worms of Valor",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/xmas_pop_delight": {
        slug: "xmas_pop_delight",
        name: "Xmas Pop Delight",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/zombie_apopalypse": {
        slug: "zombie_apopalypse",
        name: "Zombie aPOPalypse",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "aviatrix/aviatrix_fruits": {
        slug: "aviatrix_fruits",
        name: "Aviatrix Fruits",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "aviatrix/aviatrix_mines": {
        slug: "aviatrix_mines",
        name: "Aviatrix Mines",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "aviatrix/nft_aviatrix": {
        slug: "nft_aviatrix",
        name: "NFT Aviatrix",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "aviatrix/second_chance": {
        slug: "second_chance",
        name: "Second Chance",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "bang-bang-games/almighty_thunder_ultrahitz_gigablox": {
        slug: "almighty_thunder_ultrahitz_gigablox",
        name: "Almighty Thunder UltraHitz Gigablox",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/ancient_eclipse": {
        slug: "ancient_eclipse",
        name: "Ancient Eclipse",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/arctic_catch": {
        slug: "arctic_catch",
        name: "Arctic Catch",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/caribbean_crush": {
        slug: "caribbean_crush",
        name: "Caribbean Crush",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/chilli_champions_ultrahitz": {
        slug: "chilli_champions_ultrahitz",
        name: "Chilli Champions UltraHitz",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/fiesta_explosiva_duomax": {
        slug: "fiesta_explosiva_duomax",
        name: "Fiesta Explosiva DuoMax",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/fire_wilds": {
        slug: "fire_wilds",
        name: "Fire Wilds",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/jekyllz_wild_ultranudge": {
        slug: "jekyllz_wild_ultranudge",
        name: "Jekyllz Wild UltraNudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/jokrz_wild_ultranudge": {
        slug: "jokrz_wild_ultranudge",
        name: "Jokrz Wild UltraNudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/jokrz_wild_ultranudge_gigablox": {
        slug: "jokrz_wild_ultranudge_gigablox",
        name: "Jokrz Wild Ultranudge GigaBlox",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/jumbo_jellies": {
        slug: "jumbo_jellies",
        name: "Jumbo Jellies",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/mutant_trawlers": {
        slug: "mutant_trawlers",
        name: "Mutant Trawlers",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/pharaohs_gaze_doublemax": {
        slug: "pharaohs_gaze_doublemax",
        name: "Pharaoh's Gaze Doublemax",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/pharaohs_rage_ultraspinz": {
        slug: "pharaohs_rage_ultraspinz",
        name: "Pharaoh's Rage Ultraspinz",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/pulled_from_the_deep_ultranudge": {
        slug: "pulled_from_the_deep_ultranudge",
        name: "Pulled from the Deep Ultranudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/rainbow_power_potz_ultranudge": {
        slug: "rainbow_power_potz_ultranudge",
        name: "Rainbow Power Potz UltraNudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/shadow_raiders_multimax": {
        slug: "shadow_raiders_multimax",
        name: "Shadow Raiders Multimax",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/super_cash_drop_giga_blox": {
        slug: "super_cash_drop_giga_blox",
        name: "Super Cash Drop Giga Blox",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/the_hot_offer": {
        slug: "the_hot_offer",
        name: "The Hot Offer",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/the_runemakers": {
        slug: "the_runemakers",
        name: "The Runemakers",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bgaming/3_kings_scratch": {
        slug: "3_kings_scratch",
        name: "3 Kings Scratch",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/acceptance_test": {
        slug: "acceptance_test",
        name: "Acceptance Test",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/alice_wonderluck": {
        slug: "alice_wonderluck",
        name: "Alice Wonderluck",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/alien_fruits": {
        slug: "alien_fruits",
        name: "Alien Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/alien_fruits_2": {
        slug: "alien_fruits_2",
        name: "Alien Fruits 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/alien_fruits_3": {
        slug: "alien_fruits_3",
        name: "Alien Fruits 3",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/all_lucky_clover": {
        slug: "all_lucky_clover",
        name: "All Lucky Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/all_star_fruits": {
        slug: "all_star_fruits",
        name: "All Star Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aloha_king_elvis": {
        slug: "aloha_king_elvis",
        name: "Aloha King Elvis",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/always_up": {
        slug: "always_up",
        name: "Always Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/always_up_x10000": {
        slug: "always_up_x10000",
        name: "Always Up x10000",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/american_roulette": {
        slug: "american_roulette",
        name: "American Roulette",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/arrow_slot": {
        slug: "arrow_slot",
        name: "Arrow Slot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/avalon_the_lost_kingdom": {
        slug: "avalon_the_lost_kingdom",
        name: "Avalon: The Lost Kingdom",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aviamasters": {
        slug: "aviamasters",
        name: "Aviamasters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aviamasters_2": {
        slug: "aviamasters_2",
        name: "Aviamasters 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aviamasters_xmas": {
        slug: "aviamasters_xmas",
        name: "Aviamasters Xmas",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aztec_clusters": {
        slug: "aztec_clusters",
        name: "Aztec Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aztec_magic_bonanza": {
        slug: "aztec_magic_bonanza",
        name: "Aztec Magic Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aztec_magic_deluxe": {
        slug: "aztec_magic_deluxe",
        name: "Aztec Magic Deluxe",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aztec_magic_megaways": {
        slug: "aztec_magic_megaways",
        name: "Aztec Magic Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aztecs_claw_wild_dice": {
        slug: "aztecs_claw_wild_dice",
        name: "Aztec's Claw Wild Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/backyard_grill": {
        slug: "backyard_grill",
        name: "Backyard Grill!",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/balloon_mania": {
        slug: "balloon_mania",
        name: "Balloon Mania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/beast_band": {
        slug: "beast_band",
        name: "Beast Band",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/beer_bonanza": {
        slug: "beer_bonanza",
        name: "Beer Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/big_atlantis_frenzy": {
        slug: "big_atlantis_frenzy",
        name: "Big Atlantis Frenzy",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/big_boat_big_catch": {
        slug: "big_boat_big_catch",
        name: "Big Boat Big Catch",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/blackbeards_bounty": {
        slug: "blackbeards_bounty",
        name: "Blackbeard's Bounty",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/blazing_fire_pots_hold_and_spin": {
        slug: "blazing_fire_pots_hold_and_spin",
        name: "Blazing Fire Pots Hold and Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bling_blitz_diamond_drop": {
        slug: "bling_blitz_diamond_drop",
        name: "Bling Blitz Diamond Drop",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bobs_coffee_shop": {
        slug: "bobs_coffee_shop",
        name: "Bob's Coffee Shop",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bonanza_billion": {
        slug: "bonanza_billion",
        name: "Bonanza Billion",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bonanza_billion_xtreme": {
        slug: "bonanza_billion_xtreme",
        name: "Bonanza Billion Xtreme",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bonanza_trillion": {
        slug: "bonanza_trillion",
        name: "Bonanza Trillion",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bone_bonanza": {
        slug: "bone_bonanza",
        name: "Bone Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_cats": {
        slug: "book_of_cats",
        name: "Book of Cats",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_cats_megaways": {
        slug: "book_of_cats_megaways",
        name: "Book of Cats Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_kemet": {
        slug: "book_of_kemet",
        name: "Book of Kemet",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_panda_megaways": {
        slug: "book_of_panda_megaways",
        name: "Book of Panda Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_pyramids": {
        slug: "book_of_pyramids",
        name: "Book of Pyramids",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/burning_chilli_243": {
        slug: "burning_chilli_243",
        name: "Burning Chilli 243",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/burning_chilli_x": {
        slug: "burning_chilli_x",
        name: "Burning Chilli X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/candy_monsta": {
        slug: "candy_monsta",
        name: "Candy Monsta",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/capymania_green": {
        slug: "capymania_green",
        name: "Capymania Green",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/capymania_orange": {
        slug: "capymania_orange",
        name: "Capymania Orange",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/capymania_yellow": {
        slug: "capymania_yellow",
        name: "Capymania Yellow",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/carnival_bonanza": {
        slug: "carnival_bonanza",
        name: "Carnival Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/catch_the_gold_hold_and_win": {
        slug: "catch_the_gold_hold_and_win",
        name: "Catch the Gold Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/catdiana": {
        slug: "catdiana",
        name: "Catdiana",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/cats_soup": {
        slug: "cats_soup",
        name: "Cat's Soup",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/chicken_fire": {
        slug: "chicken_fire",
        name: "Chicken Fire",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/chicken_rush": {
        slug: "chicken_rush",
        name: "Chicken Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/chicken_shot": {
        slug: "chicken_shot",
        name: "Chicken Shot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/clash_of_gods_anubis_vs_hades": {
        slug: "clash_of_gods_anubis_vs_hades",
        name: "Clash of Gods Anubis vs Hades",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/classic_multihand_blackjack": {
        slug: "classic_multihand_blackjack",
        name: "Classic Multihand Blackjack",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/clover_bonanza": {
        slug: "clover_bonanza",
        name: "Clover Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/clucking_hell": {
        slug: "clucking_hell",
        name: "Clucking Hell",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/crystal_clusters": {
        slug: "crystal_clusters",
        name: "Crystal Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/deep_sea": {
        slug: "deep_sea",
        name: "Deep Sea",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/derby_rush": {
        slug: "derby_rush",
        name: "Derby Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/diamond_of_jungle": {
        slug: "diamond_of_jungle",
        name: "Diamond of Jungle",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dice_bonanza": {
        slug: "dice_bonanza",
        name: "Dice Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dice_million": {
        slug: "dice_million",
        name: "Dice Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dig_dig_digger": {
        slug: "dig_dig_digger",
        name: "Dig Dig Digger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/disco_party": {
        slug: "disco_party",
        name: "Disco Party",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/divine_queen_heart_of_ice": {
        slug: "divine_queen_heart_of_ice",
        name: "Divine Queen Heart of Ice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/domnitors_treasure": {
        slug: "domnitors_treasure",
        name: "Domnitor's Treasure",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/doomsday_saloon": {
        slug: "doomsday_saloon",
        name: "Doomsday Saloon",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dragon_age_hold_and_win_dragon_age": {
        slug: "dragon_age_hold_and_win_dragon_age",
        name: "Dragon Age Hold and Win (Dragon Age)",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dragon_queens_megaways": {
        slug: "dragon_queens_megaways",
        name: "Dragon Queens Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dragons_crash": {
        slug: "dragons_crash",
        name: "Dragon's Crash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dragons_gold_100": {
        slug: "dragons_gold_100",
        name: "Dragon's Gold 100",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dusty_duel": {
        slug: "dusty_duel",
        name: "Dusty Duel",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/easter_heist": {
        slug: "easter_heist",
        name: "Easter Heist",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/easter_plinko": {
        slug: "easter_plinko",
        name: "Easter Plinko",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/elements_of_power": {
        slug: "elements_of_power",
        name: "Elements of Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/elvis_frog_in_vegas": {
        slug: "elvis_frog_in_vegas",
        name: "Elvis Frog in Vegas",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/elvis_frog_trueways": {
        slug: "elvis_frog_trueways",
        name: "Elvis Frog TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/face_off": {
        slug: "face_off",
        name: "Face Off",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fashiontv_diamonds": {
        slug: "fashiontv_diamonds",
        name: "FashionTV Diamonds",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fiesta_clusters": {
        slug: "fiesta_clusters",
        name: "Fiesta Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fire_lightning": {
        slug: "fire_lightning",
        name: "Fire Lightning",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fishing_club": {
        slug: "fishing_club",
        name: "Fishing Club",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fishing_club_2": {
        slug: "fishing_club_2",
        name: "Fishing Club 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fishing_time": {
        slug: "fishing_time",
        name: "Fishing Time",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/football_plinko": {
        slug: "football_plinko",
        name: "Football Plinko",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/forgotten": {
        slug: "forgotten",
        name: "Forgotten",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fortuna_trueways": {
        slug: "fortuna_trueways",
        name: "Fortuna TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fortune_bells": {
        slug: "fortune_bells",
        name: "Fortune Bells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fortune_red_packets": {
        slug: "fortune_red_packets",
        name: "Fortune Red Packets",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fortune_spin": {
        slug: "fortune_spin",
        name: "Fortune Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/forty_fruity_million": {
        slug: "forty_fruity_million",
        name: "Forty Fruity Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/four_lucky_clover": {
        slug: "four_lucky_clover",
        name: "Four Lucky Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/four_lucky_diamonds": {
        slug: "four_lucky_diamonds",
        name: "Four Lucky Diamonds",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/french_roulette": {
        slug: "french_roulette",
        name: "French Roulette",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/frenzy_clusters": {
        slug: "frenzy_clusters",
        name: "Frenzy Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/frozen_fruit": {
        slug: "frozen_fruit",
        name: "Frozen Fruit",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fruit_million": {
        slug: "fruit_million",
        name: "Fruit Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fruit_million_respin": {
        slug: "fruit_million_respin",
        name: "Fruit Million Respin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gangsterz": {
        slug: "gangsterz",
        name: "Gangsterz",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gates_of_power": {
        slug: "gates_of_power",
        name: "Gates of Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gemhalla": {
        slug: "gemhalla",
        name: "Gemhalla",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gemhalla_xtreme": {
        slug: "gemhalla_xtreme",
        name: "Gemhalla Xtreme",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gemza": {
        slug: "gemza",
        name: "Gemza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gift_rush": {
        slug: "gift_rush",
        name: "Gift Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gift_x": {
        slug: "gift_x",
        name: "Gift X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/god_of_wealth_hold_and_win": {
        slug: "god_of_wealth_hold_and_win",
        name: "God of Wealth Hold And Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gold_magnate": {
        slug: "gold_magnate",
        name: "Gold Magnate",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gold_of_minos": {
        slug: "gold_of_minos",
        name: "Gold of Minos",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gold_rush_johnny_cash": {
        slug: "gold_rush_johnny_cash",
        name: "Gold Rush - Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gold_rush_with_johnny_cash": {
        slug: "gold_rush_with_johnny_cash",
        name: "Gold Rush with Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/golden_avalon_hold_and_win": {
        slug: "golden_avalon_hold_and_win",
        name: "Golden Avalon Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/golden_paw_hold_and_win": {
        slug: "golden_paw_hold_and_win",
        name: "Golden Paw Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/golden_pinata_hold_and_win": {
        slug: "golden_pinata_hold_and_win",
        name: "Golden Pinata Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/golden_pride": {
        slug: "golden_pride",
        name: "Golden Pride",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/grand_buffalo_hold_and_win": {
        slug: "grand_buffalo_hold_and_win",
        name: "Grand Buffalo Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/grand_mustang": {
        slug: "grand_mustang",
        name: "Grand Mustang",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/grand_patron": {
        slug: "grand_patron",
        name: "Grand Patron",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/halloween_bonanza": {
        slug: "halloween_bonanza",
        name: "Halloween Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/haunted_reels": {
        slug: "haunted_reels",
        name: "Haunted Reels",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/heads_and_tails": {
        slug: "heads_and_tails",
        name: "Heads and Tails",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/heads_and_tails_xy": {
        slug: "heads_and_tails_xy",
        name: "Heads and Tails XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/heart_of_tiki": {
        slug: "heart_of_tiki",
        name: "Heart of Tiki",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/hit_the_route": {
        slug: "hit_the_route",
        name: "Hit The Route",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/hot_chilli_bells": {
        slug: "hot_chilli_bells",
        name: "Hot Chilli Bells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/hot_chilli_bells_100": {
        slug: "hot_chilli_bells_100",
        name: "Hot Chilli Bells 100",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/hot_rocket_5x_3x_2x": {
        slug: "hot_rocket_5x_3x_2x",
        name: "Hot Rocket 5x 3x 2x",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/hottest_666": {
        slug: "hottest_666",
        name: "Hottest 666",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/ice_scratch_bronze": {
        slug: "ice_scratch_bronze",
        name: "Ice Scratch Bronze",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/ice_scratch_gold": {
        slug: "ice_scratch_gold",
        name: "Ice Scratch Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/ice_scratch_silver": {
        slug: "ice_scratch_silver",
        name: "Ice Scratch Silver",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/infinity_pull": {
        slug: "infinity_pull",
        name: "Infinity Pull",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/jewel_boom_super_drop": {
        slug: "jewel_boom_super_drop",
        name: "Jewel Boom Super Drop",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/jogo_do_bicho": {
        slug: "jogo_do_bicho",
        name: "Jogo Do Bicho",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/jogo_do_bicho_simple": {
        slug: "jogo_do_bicho_simple",
        name: "Jogo Do Bicho Simple",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/johnny_cash": {
        slug: "johnny_cash",
        name: "Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/joker_queen": {
        slug: "joker_queen",
        name: "Joker Queen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/joker_vs_joker": {
        slug: "joker_vs_joker",
        name: "Joker vs Joker",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/joker_x_love": {
        slug: "joker_x_love",
        name: "Joker X Love",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/jokers_million": {
        slug: "jokers_million",
        name: "Joker's Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/jungle_queen": {
        slug: "jungle_queen",
        name: "Jungle Queen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/keepers_of_the_secret": {
        slug: "keepers_of_the_secret",
        name: "Keepers Of The Secret",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/kicker_mania": {
        slug: "kicker_mania",
        name: "Kicker Mania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/krakens_hunger": {
        slug: "krakens_hunger",
        name: "Kraken's Hunger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lady_lucky_gun": {
        slug: "lady_lucky_gun",
        name: "Lady Lucky Gun",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lady_wolf_moon": {
        slug: "lady_wolf_moon",
        name: "Lady Wolf Moon",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lady_wolf_moon_megaways": {
        slug: "lady_wolf_moon_megaways",
        name: "Lady Wolf Moon Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/limbo_xy": {
        slug: "limbo_xy",
        name: "Limbo XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/loki_loot": {
        slug: "loki_loot",
        name: "Loki Loot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/luck_and_magic": {
        slug: "luck_and_magic",
        name: "Luck & Magic",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/luck_and_magic_scratch": {
        slug: "luck_and_magic_scratch",
        name: "Luck and Magic Scratch",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_8_merge_up": {
        slug: "lucky_8_merge_up",
        name: "Lucky 8 Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_birds": {
        slug: "lucky_birds",
        name: "Lucky Birds",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_crew": {
        slug: "lucky_crew",
        name: "Lucky Crew",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_dama_muerta": {
        slug: "lucky_dama_muerta",
        name: "Lucky Dama Muerta",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_dragon_multidice_x": {
        slug: "lucky_dragon_multidice_x",
        name: "Lucky Dragon MultiDice X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_ducky": {
        slug: "lucky_ducky",
        name: "Lucky Ducky",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_farm_bonanza": {
        slug: "lucky_farm_bonanza",
        name: "Lucky Farm Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_ladys_clover": {
        slug: "lucky_ladys_clover",
        name: "Lucky Lady's Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_lager_x9990": {
        slug: "lucky_lager_x9990",
        name: "Lucky Lager X9990",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_lu": {
        slug: "lucky_lu",
        name: "Lucky Lu",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_oak": {
        slug: "lucky_oak",
        name: "Lucky Oak",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_pack_2026_cup": {
        slug: "lucky_pack_2026_cup",
        name: "Lucky Pack 2026 Cup",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_sweets": {
        slug: "lucky_sweets",
        name: "Lucky Sweets",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/magic_mummy_megaways": {
        slug: "magic_mummy_megaways",
        name: "Magic Mummy Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/maneki_88_fortunes": {
        slug: "maneki_88_fortunes",
        name: "Maneki 88 Fortunes",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/maneki_88_gold": {
        slug: "maneki_88_gold",
        name: "Maneki 88 Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mechanical_clover": {
        slug: "mechanical_clover",
        name: "Mechanical Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mechanical_orange": {
        slug: "mechanical_orange",
        name: "Mechanical Orange",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/merge_up": {
        slug: "merge_up",
        name: "Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/merge_up_2": {
        slug: "merge_up_2",
        name: "Merge Up 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mice_and_magic_wonder_spin": {
        slug: "mice_and_magic_wonder_spin",
        name: "Mice and Magic Wonder Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mine_gems": {
        slug: "mine_gems",
        name: "Mine Gems",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/minesweeper": {
        slug: "minesweeper",
        name: "Minesweeper",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/minesweeper_xy": {
        slug: "minesweeper_xy",
        name: "Minesweeper XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/miss_cherry_fruits": {
        slug: "miss_cherry_fruits",
        name: "Miss Cherry Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/miss_cherry_fruits_jackpot_party": {
        slug: "miss_cherry_fruits_jackpot_party",
        name: "Miss Cherry Fruits Jackpot Party",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/money_maker": {
        slug: "money_maker",
        name: "Money Maker",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/monster_hunt": {
        slug: "monster_hunt",
        name: "Monster Hunt",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/multi_rush": {
        slug: "multi_rush",
        name: "Multi Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/multihand_blackjack": {
        slug: "multihand_blackjack",
        name: "Multihand Blackjack",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/multihand_blackjack_pro": {
        slug: "multihand_blackjack_pro",
        name: "Multihand Blackjack Pro",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/multihand_blackjack_pro_2": {
        slug: "multihand_blackjack_pro_2",
        name: "Multihand Blackjack Pro 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mummys_gold": {
        slug: "mummys_gold",
        name: "Mummy's Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mystery_garden": {
        slug: "mystery_garden",
        name: "Mystery Garden",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mystery_heist": {
        slug: "mystery_heist",
        name: "Mystery Heist",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/olympus_trueways": {
        slug: "olympus_trueways",
        name: "Olympus Trueways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/oof_the_goldmine_planet": {
        slug: "oof_the_goldmine_planet",
        name: "OOF The Goldmine Planet",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/open_it": {
        slug: "open_it",
        name: "Open It",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/panda_fortune_rush": {
        slug: "panda_fortune_rush",
        name: "Panda Fortune Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/panda_luck": {
        slug: "panda_luck",
        name: "Panda Luck",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/penalty_duel": {
        slug: "penalty_duel",
        name: "Penalty Duel",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/penalty_duel_with_julio_cesar": {
        slug: "penalty_duel_with_julio_cesar",
        name: "Penalty Duel with Julio Cesar",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/penny_pelican": {
        slug: "penny_pelican",
        name: "Penny Pelican",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/piggy_bank_hold_and_win": {
        slug: "piggy_bank_hold_and_win",
        name: "Piggy Bank Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/platinum_lightning": {
        slug: "platinum_lightning",
        name: "Platinum Lightning",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/platinum_lightning_deluxe": {
        slug: "platinum_lightning_deluxe",
        name: "Platinum Lightning Deluxe",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/plinko_2": {
        slug: "plinko_2",
        name: "Plinko 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/plinko_2_halloween": {
        slug: "plinko_2_halloween",
        name: "Plinko 2 Halloween",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/plinko_xy": {
        slug: "plinko_xy",
        name: "Plinko XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/pop_zen": {
        slug: "pop_zen",
        name: "Pop Zen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/potion_spells": {
        slug: "potion_spells",
        name: "Potion Spells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/princess_royal": {
        slug: "princess_royal",
        name: "Princess Royal",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/recycle_riches": {
        slug: "recycle_riches",
        name: "Recycle Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/reel_of_ra": {
        slug: "reel_of_ra",
        name: "Reel of Ra",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/retro_trader": {
        slug: "retro_trader",
        name: "Retro Trader",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/road_2_riches": {
        slug: "road_2_riches",
        name: "Road 2 Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/robospin": {
        slug: "robospin",
        name: "Robospin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/rocket_dice": {
        slug: "rocket_dice",
        name: "Rocket Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/rocket_dice_xy": {
        slug: "rocket_dice_xy",
        name: "Rocket Dice XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/rocket_eruption_triple_blast": {
        slug: "rocket_eruption_triple_blast",
        name: "Rocket Eruption Triple Blast",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/rotating_element": {
        slug: "rotating_element",
        name: "Rotating Element",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/royal_beellion_hold_and_win": {
        slug: "royal_beellion_hold_and_win",
        name: "Royal Beellion Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/royal_easter": {
        slug: "royal_easter",
        name: "Royal Easter",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/royal_fruits_multilines": {
        slug: "royal_fruits_multilines",
        name: "Royal Fruits MultiLines",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/royal_highroad": {
        slug: "royal_highroad",
        name: "Royal High-Road",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/royal_roulette_500x": {
        slug: "royal_roulette_500x",
        name: "Royal Roulette 500x",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sakura_riches_60": {
        slug: "sakura_riches_60",
        name: "Sakura Riches 60",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/savage_buffalo_spirit": {
        slug: "savage_buffalo_spirit",
        name: "Savage Buffalo Spirit",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/savage_buffalo_spirit_megaways": {
        slug: "savage_buffalo_spirit_megaways",
        name: "Savage Buffalo Spirit Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/scratch_alpaca_bronze": {
        slug: "scratch_alpaca_bronze",
        name: "Scratch Alpaca Bronze",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/scratch_alpaca_gold": {
        slug: "scratch_alpaca_gold",
        name: "Scratch Alpaca Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/scratch_alpaca_silver": {
        slug: "scratch_alpaca_silver",
        name: "Scratch Alpaca Silver",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/scratch_dice": {
        slug: "scratch_dice",
        name: "Scratch Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/scroll_of_adventure": {
        slug: "scroll_of_adventure",
        name: "Scroll of Adventure",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/secret_bar_multidice_x": {
        slug: "secret_bar_multidice_x",
        name: "Secret Bar Multidice X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/shark_and_spark_hold_and_win": {
        slug: "shark_and_spark_hold_and_win",
        name: "Shark and Spark Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/slot_machine": {
        slug: "slot_machine",
        name: "Slot Machine",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/slotomon_go": {
        slug: "slotomon_go",
        name: "Slotomon Go",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/snoop_dogg_dollars": {
        slug: "snoop_dogg_dollars",
        name: "Snoop Dogg Dollars",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/soccermania": {
        slug: "soccermania",
        name: "Soccermania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/space_xy": {
        slug: "space_xy",
        name: "Space XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/spin_and_spell": {
        slug: "spin_and_spell",
        name: "Spin And Spell",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/star_trek_the_next_generation": {
        slug: "star_trek_the_next_generation",
        name: "Star Trek The Next Generation",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/stars_and_stripes_hold_and_win": {
        slug: "stars_and_stripes_hold_and_win",
        name: "Stars and Stripes Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/street_power": {
        slug: "street_power",
        name: "Street Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sugar_merge_up": {
        slug: "sugar_merge_up",
        name: "Sugar Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sugar_mix": {
        slug: "sugar_mix",
        name: "Sugar Mix",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/surrender_multihand_blackjack": {
        slug: "surrender_multihand_blackjack",
        name: "Surrender Multihand Blackjack",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sweet_rush_megaways": {
        slug: "sweet_rush_megaways",
        name: "Sweet Rush Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sweet_samurai": {
        slug: "sweet_samurai",
        name: "Sweet Samurai",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/the_godfather_3_pillars_of_power": {
        slug: "the_godfather_3_pillars_of_power",
        name: "The Godfather: 3 Pillars of Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/tile_master": {
        slug: "tile_master",
        name: "Tile Master",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/top_eagle": {
        slug: "top_eagle",
        name: "Top Eagle",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/totally_hot": {
        slug: "totally_hot",
        name: "Totally Hot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/train_heist_johnny_cash": {
        slug: "train_heist_johnny_cash",
        name: "Train Heist Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/train_heist_johnny_coin": {
        slug: "train_heist_johnny_coin",
        name: "Train Heist Johnny Coin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/train_to_rio_grande": {
        slug: "train_to_rio_grande",
        name: "Train to Rio Grande",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/tramp_day": {
        slug: "tramp_day",
        name: "Tramp Day",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/tramp_day_trueways": {
        slug: "tramp_day_trueways",
        name: "Tramp Day Trueways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/treasure_explorer": {
        slug: "treasure_explorer",
        name: "Treasure Explorer",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/treasure_of_anubis": {
        slug: "treasure_of_anubis",
        name: "Treasure of Anubis",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/ufo_pyramids": {
        slug: "ufo_pyramids",
        name: "UFO Pyramids",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/ultras": {
        slug: "ultras",
        name: "Ultras",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/voodoo_people": {
        slug: "voodoo_people",
        name: "Voodoo People",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wbc_ring_of_riches": {
        slug: "wbc_ring_of_riches",
        name: "WBC Ring Of Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/west_town": {
        slug: "west_town",
        name: "West Town",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_card_gang": {
        slug: "wild_card_gang",
        name: "Wild Card Gang",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_cash": {
        slug: "wild_cash",
        name: "Wild Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_cash_dice": {
        slug: "wild_cash_dice",
        name: "Wild Cash Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_cash_x9990": {
        slug: "wild_cash_x9990",
        name: "Wild Cash x9990",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_chicago": {
        slug: "wild_chicago",
        name: "Wild Chicago",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_clusters": {
        slug: "wild_clusters",
        name: "Wild Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_heart": {
        slug: "wild_heart",
        name: "Wild Heart",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_million": {
        slug: "wild_million",
        name: "Wild Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_moon_thieves": {
        slug: "wild_moon_thieves",
        name: "Wild Moon Thieves",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_tiger": {
        slug: "wild_tiger",
        name: "Wild Tiger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_tiger_2": {
        slug: "wild_tiger_2",
        name: "Wild Tiger 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_west_trueways": {
        slug: "wild_west_trueways",
        name: "Wild West TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_wick": {
        slug: "wild_wick",
        name: "Wild Wick",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/winter_fishing_club": {
        slug: "winter_fishing_club",
        name: "Winter Fishing Club",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/winter_trophy_hold_and_win": {
        slug: "winter_trophy_hold_and_win",
        name: "Winter Trophy Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wow_vegas_elvis_frog_trueways": {
        slug: "wow_vegas_elvis_frog_trueways",
        name: "WOW Vegas Elvis Frog Trueways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/yokai": {
        slug: "yokai",
        name: "Yokai",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/yommi_rush": {
        slug: "yommi_rush",
        name: "Yommi Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/zeus_goes_wild": {
        slug: "zeus_goes_wild",
        name: "Zeus Goes Wild",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bigpot-gaming/aero_adventure": {
        slug: "aero_adventure",
        name: "Aero Adventure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/amazing_soda_rush": {
        slug: "amazing_soda_rush",
        name: "Amazing Soda Rush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/ancient_blocks": {
        slug: "ancient_blocks",
        name: "Ancient Blocks",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/ancient_stones": {
        slug: "ancient_stones",
        name: "Ancient Stones",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/andar_bahar": {
        slug: "andar_bahar",
        name: "Andar Bahar",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/astro_luck": {
        slug: "astro_luck",
        name: "Astro Luck",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/baccarat_classic": {
        slug: "baccarat_classic",
        name: "Baccarat Classic",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/baccarat_private": {
        slug: "baccarat_private",
        name: "Baccarat Private",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/baccarat_supersix": {
        slug: "baccarat_supersix",
        name: "Baccarat SuperSix",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/big_pot_gaming_table_lobby": {
        slug: "big_pot_gaming_table_lobby",
        name: "Big Pot Gaming Table Lobby",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/big_sevens_jackpot": {
        slug: "big_sevens_jackpot",
        name: "Big Sevens Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/bigbang_spin": {
        slug: "bigbang_spin",
        name: "BigBang Spin",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/bonanza_coins": {
        slug: "bonanza_coins",
        name: "Bonanza Coins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/book_of_pharaoh": {
        slug: "book_of_pharaoh",
        name: "Book of Pharaoh",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/book_of_pharaoh_777jackpot": {
        slug: "book_of_pharaoh_777jackpot",
        name: "Book of Pharaoh 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/bounty_hunter": {
        slug: "bounty_hunter",
        name: "Bounty Hunter",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/buffalo_begins": {
        slug: "buffalo_begins",
        name: "Buffalo Begins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/celestial_goddess": {
        slug: "celestial_goddess",
        name: "Celestial Goddess",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/chans_treasure": {
        slug: "chans_treasure",
        name: "Chan's Treasure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/cherry_bell": {
        slug: "cherry_bell",
        name: "Cherry Bell",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/cleos_fortune": {
        slug: "cleos_fortune",
        name: "Cleo’s Fortune",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/crash_wonder_blonde": {
        slug: "crash_wonder_blonde",
        name: "Crash Wonder Blonde",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/creature_of_mythology": {
        slug: "creature_of_mythology",
        name: "Creature of Mythology",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/detectives_dream": {
        slug: "detectives_dream",
        name: "Detective’s Dream",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/diamond_mask": {
        slug: "diamond_mask",
        name: "Diamond Mask",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/double_race": {
        slug: "double_race",
        name: "Double Race",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/dragontiger": {
        slug: "dragontiger",
        name: "DragonTiger",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/drfrankens_lab": {
        slug: "drfrankens_lab",
        name: "Dr.Franken’s Lab",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/drfrankens_lab_777jackpot": {
        slug: "drfrankens_lab_777jackpot",
        name: "Dr.Franken’s Lab 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/elizabeths_lab": {
        slug: "elizabeths_lab",
        name: "Elizabeth's Lab",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/fantastic_fairies": {
        slug: "fantastic_fairies",
        name: "Fantastic Fairies",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/festival_of_the_dead": {
        slug: "festival_of_the_dead",
        name: "Festival of the Dead",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/fiesta_frenzy": {
        slug: "fiesta_frenzy",
        name: "Fiesta Frenzy",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/frozen_blade": {
        slug: "frozen_blade",
        name: "Frozen Blade",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/fury_fighters": {
        slug: "fury_fighters",
        name: "Fury Fighters",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/gold_dragon": {
        slug: "gold_dragon",
        name: "Gold Dragon",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/gold_mine_rush": {
        slug: "gold_mine_rush",
        name: "Gold Mine Rush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/gold_of_the_king": {
        slug: "gold_of_the_king",
        name: "Gold of the King",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/golden_kitty": {
        slug: "golden_kitty",
        name: "Golden Kitty",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/golden_panda": {
        slug: "golden_panda",
        name: "Golden Panda",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/halloween_ghost": {
        slug: "halloween_ghost",
        name: "Halloween Ghost",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/hidden_city": {
        slug: "hidden_city",
        name: "Hidden City",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/high_low": {
        slug: "high_low",
        name: "High Low",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/hit_mahjong_wins": {
        slug: "hit_mahjong_wins",
        name: "Hit Mahjong Wins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/holy_knight": {
        slug: "holy_knight",
        name: "Holy Knight",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/hot_safari_run": {
        slug: "hot_safari_run",
        name: "Hot Safari Run",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/hotties_paradise": {
        slug: "hotties_paradise",
        name: "Hottie's Paradise",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/hotties_vacation": {
        slug: "hotties_vacation",
        name: "Hottie's Vacation",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/jam_crush": {
        slug: "jam_crush",
        name: "Jam Crush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/jewelry_spin": {
        slug: "jewelry_spin",
        name: "Jewelry Spin",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/journey_to_the_abyss": {
        slug: "journey_to_the_abyss",
        name: "Journey to the Abyss",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/king_of_the_pig": {
        slug: "king_of_the_pig",
        name: "King of the Pig",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/last_valkyrie": {
        slug: "last_valkyrie",
        name: "Last Valkyrie",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/legacy_of_midas": {
        slug: "legacy_of_midas",
        name: "Legacy of Midas",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/legend_of_tarzan": {
        slug: "legend_of_tarzan",
        name: "Legend of Tarzan",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/little_witch_fortune": {
        slug: "little_witch_fortune",
        name: "Little Witch Fortune",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/lost_treasure": {
        slug: "lost_treasure",
        name: "Lost Treasure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/luck_of_amazon": {
        slug: "luck_of_amazon",
        name: "Luck of Amazon",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/lucky_fifth": {
        slug: "lucky_fifth",
        name: "Lucky Fifth",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/lucky_goldbar": {
        slug: "lucky_goldbar",
        name: "Lucky Goldbar",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/lucky_rocket": {
        slug: "lucky_rocket",
        name: "Lucky Rocket",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/lucky_waterfalls": {
        slug: "lucky_waterfalls",
        name: "Lucky Waterfalls",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/magic_candy_factory": {
        slug: "magic_candy_factory",
        name: "Magic Candy Factory",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/magic_fire": {
        slug: "magic_fire",
        name: "Magic Fire",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/maze_adventure": {
        slug: "maze_adventure",
        name: "Maze Adventure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/medusa_blessing": {
        slug: "medusa_blessing",
        name: "Medusa Blessing",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/mega_cave": {
        slug: "mega_cave",
        name: "Mega Cave",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/mega_sevens": {
        slug: "mega_sevens",
        name: "Mega Sevens",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/miracle_ring": {
        slug: "miracle_ring",
        name: "Miracle Ring",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/monkey_king": {
        slug: "monkey_king",
        name: "Monkey King",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/monkey_king_777jackpot": {
        slug: "monkey_king_777jackpot",
        name: "Monkey King 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/moonlight_cats": {
        slug: "moonlight_cats",
        name: "Moonlight Cats",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/mountain_spirit": {
        slug: "mountain_spirit",
        name: "Mountain Spirit",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/mystery_wind": {
        slug: "mystery_wind",
        name: "Mystery Wind",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/olympus_legend": {
        slug: "olympus_legend",
        name: "Olympus Legend",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/oriental_treasures": {
        slug: "oriental_treasures",
        name: "Oriental Treasures",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/pandas_jackpot": {
        slug: "pandas_jackpot",
        name: "Panda’s Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/pirates_treasure": {
        slug: "pirates_treasure",
        name: "Pirate's Treasure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/pop_popcorns": {
        slug: "pop_popcorns",
        name: "Pop Popcorns",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/queens_bow": {
        slug: "queens_bow",
        name: "Queen's Bow",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/quests_of_olympus": {
        slug: "quests_of_olympus",
        name: "Quests of Olympus",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/reel_bass_family": {
        slug: "reel_bass_family",
        name: "Reel Bass Family",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/rhino_king": {
        slug: "rhino_king",
        name: "Rhino King",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/rhino_king_777jackpot": {
        slug: "rhino_king_777jackpot",
        name: "Rhino King 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/roulette": {
        slug: "roulette",
        name: "Roulette",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/royal_princess": {
        slug: "royal_princess",
        name: "Royal Princess",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/safari_race": {
        slug: "safari_race",
        name: "Safari Race",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/safari_run": {
        slug: "safari_run",
        name: "Safari Run",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/santa_in_the_summer": {
        slug: "santa_in_the_summer",
        name: "Santa in the Summer",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/secret_ball": {
        slug: "secret_ball",
        name: "Secret Ball",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/secret_of_earth": {
        slug: "secret_of_earth",
        name: "Secret of Earth",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/secret_of_goddess": {
        slug: "secret_of_goddess",
        name: "Secret of Goddess",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/shoot_piggy": {
        slug: "shoot_piggy",
        name: "Shoot Piggy",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/skull_lord": {
        slug: "skull_lord",
        name: "Skull Lord",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/sugar_crush": {
        slug: "sugar_crush",
        name: "Sugar Crush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/sword_master": {
        slug: "sword_master",
        name: "Sword Master",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/the_fates_of_sisters": {
        slug: "the_fates_of_sisters",
        name: "The Fates of Sisters",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/three_zombies": {
        slug: "three_zombies",
        name: "Three Zombies",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/tiger_train": {
        slug: "tiger_train",
        name: "Tiger Train",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/tiggy_luck": {
        slug: "tiggy_luck",
        name: "Tiggy Luck",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/toy_of_legend": {
        slug: "toy_of_legend",
        name: "Toy of Legend",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/western_sheriff": {
        slug: "western_sheriff",
        name: "Western Sheriff",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/wolf_begins": {
        slug: "wolf_begins",
        name: "Wolf Begins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/yummy_kitchen": {
        slug: "yummy_kitchen",
        name: "Yummy Kitchen",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "blue-guru/aussies_vs_emus": {
        slug: "aussies_vs_emus",
        name: "Aussies vs Emus",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "blue-guru/curse_of_the_mummies": {
        slug: "curse_of_the_mummies",
        name: "Curse of The Mummies",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "blue-guru/freaked_out_fish": {
        slug: "freaked_out_fish",
        name: "Freaked Out Fish",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "blue-guru/magawa_vs_mines": {
        slug: "magawa_vs_mines",
        name: "Magawa vs Mines",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "blue-guru/napoleon_vs_rabbits": {
        slug: "napoleon_vs_rabbits",
        name: "Napoleon Vs Rabbits",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "blue-guru/st_louis_1904": {
        slug: "st_louis_1904",
        name: "St Louis 1904",
        provider: "Blue Guru",
        providerSlug: "blue-guru"
    },
    "blueprint-gaming/777_deluxe": {
        slug: "777_deluxe",
        name: "777 Deluxe",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/almighty_bear_megaways": {
        slug: "almighty_bear_megaways",
        name: "Almighty Bear Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/almighty_mustang_express": {
        slug: "almighty_mustang_express",
        name: "Almighty Mustang Express",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bankin_bacon": {
        slug: "bankin_bacon",
        name: "Bankin' Bacon",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bankin_more_bacon": {
        slug: "bankin_more_bacon",
        name: "Bankin' More Bacon",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/barx_safecracker_megaways": {
        slug: "barx_safecracker_megaways",
        name: "Bar-X Safecracker Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_cat_gold": {
        slug: "big_cat_gold",
        name: "Big Cat Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_catch_bass_fishing_megaways": {
        slug: "big_catch_bass_fishing_megaways",
        name: "Big Catch Bass Fishing Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_catch_even_bigger_bass": {
        slug: "big_catch_even_bigger_bass",
        name: "Big Catch Even Bigger Bass",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_catch_even_bigger_bass_2": {
        slug: "big_catch_even_bigger_bass_2",
        name: "Big Catch Even Bigger Bass 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_catch_even_bigger_bass_3_megaways": {
        slug: "big_catch_even_bigger_bass_3_megaways",
        name: "Big Catch Even Bigger Bass 3 Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_money_frenzy_cash_gains": {
        slug: "big_money_frenzy_cash_gains",
        name: "Big Money Frenzy Cash Gains",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_money_megaways": {
        slug: "big_money_megaways",
        name: "Big Money Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bigger_catch_bass_fishing": {
        slug: "bigger_catch_bass_fishing",
        name: "Bigger Catch Bass Fishing",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bison_bonanza": {
        slug: "bison_bonanza",
        name: "Bison Bonanza",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bison_rising_gold_strike": {
        slug: "bison_rising_gold_strike",
        name: "Bison Rising Gold Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bison_rising_megaways": {
        slug: "bison_rising_megaways",
        name: "Bison Rising Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bison_rising_reloaded_megaways": {
        slug: "bison_rising_reloaded_megaways",
        name: "Bison Rising Reloaded Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/blazing_cash": {
        slug: "blazing_cash",
        name: "Blazing Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bounty_hunter_unchained": {
        slug: "bounty_hunter_unchained",
        name: "Bounty Hunter Unchained",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bullion_blitz_power_play": {
        slug: "bullion_blitz_power_play",
        name: "Bullion Blitz Power Play",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike": {
        slug: "cash_strike",
        name: "Cash Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_hotstepper": {
        slug: "cash_strike_hotstepper",
        name: "Cash Strike Hotstepper",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_hotstepper_2": {
        slug: "cash_strike_hotstepper_2",
        name: "Cash Strike Hotstepper 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_hotstepper_megaways": {
        slug: "cash_strike_hotstepper_megaways",
        name: "Cash Strike Hotstepper Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_power_5": {
        slug: "cash_strike_power_5",
        name: "Cash Strike Power 5",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_power_force_5": {
        slug: "cash_strike_power_force_5",
        name: "Cash Strike Power Force 5",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_power_force_5_megaways": {
        slug: "cash_strike_power_force_5_megaways",
        name: "Cash Strike Power force 5 Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_power_up": {
        slug: "cash_strike_power_up",
        name: "Cash Strike Power Up",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_triple_fire": {
        slug: "cash_strike_triple_fire",
        name: "Cash Strike Triple Fire",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_win_boost": {
        slug: "cash_strike_win_boost",
        name: "Cash Strike Win Boost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_xcash": {
        slug: "cash_strike_xcash",
        name: "Cash Strike X-Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cashpots_blazinator": {
        slug: "cashpots_blazinator",
        name: "Cashpots Blazinator",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/chilli_picante_megaways": {
        slug: "chilli_picante_megaways",
        name: "Chilli Picante Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cop_the_lot_megaways_power_play": {
        slug: "cop_the_lot_megaways_power_play",
        name: "Cop the Lot Megaways Power Play",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/crabbin_for_cash_extra_big_splash": {
        slug: "crabbin_for_cash_extra_big_splash",
        name: "Crabbin For Cash Extra Big Splash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/crabbin_for_cash_megaways": {
        slug: "crabbin_for_cash_megaways",
        name: "Crabbin' For Cash Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/crabbin_for_christmas": {
        slug: "crabbin_for_christmas",
        name: "Crabbin For Christmas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/diamond_mine_extra_gold": {
        slug: "diamond_mine_extra_gold",
        name: "Diamond Mine Extra Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/diamond_mine_megaways": {
        slug: "diamond_mine_megaways",
        name: "Diamond Mine Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/divine_links": {
        slug: "divine_links",
        name: "Divine Links",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/dragonfall": {
        slug: "dragonfall",
        name: "Dragonfall",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/eagle_storm": {
        slug: "eagle_storm",
        name: "Eagle Storm",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/el_jackpotto": {
        slug: "el_jackpotto",
        name: "El Jackpotto",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/eternal_phoenix_megaways": {
        slug: "eternal_phoenix_megaways",
        name: "Eternal Phoenix Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/eye_of_horus_megaways": {
        slug: "eye_of_horus_megaways",
        name: "Eye of Horus Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/eye_of_horus_rise_of_egypt": {
        slug: "eye_of_horus_rise_of_egypt",
        name: "Eye of Horus Rise of Egypt",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/eye_of_horus_tablets_of_destiny": {
        slug: "eye_of_horus_tablets_of_destiny",
        name: "Eye of Horus Tablets of Destiny",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/eye_of_horus_tablets_of_destiny_megaways": {
        slug: "eye_of_horus_tablets_of_destiny_megaways",
        name: "Eye of Horus Tablets of Destiny Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/fat_stacks_miami_cash": {
        slug: "fat_stacks_miami_cash",
        name: "Fat Stacks Miami Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/fishin_frenzy_big_catch_megaways": {
        slug: "fishin_frenzy_big_catch_megaways",
        name: "Fishin Frenzy Big Catch Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/fishin_frenzy_power_4_slots": {
        slug: "fishin_frenzy_power_4_slots",
        name: "Fishin Frenzy Power 4 Slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/fishin_frenzy_prize_lines": {
        slug: "fishin_frenzy_prize_lines",
        name: "Fishin' Frenzy Prize Lines",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/fishin_frenzy_the_big_catch_megaways": {
        slug: "fishin_frenzy_the_big_catch_megaways",
        name: "Fishin Frenzy The Big Catch Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/frankensteins_fortune": {
        slug: "frankensteins_fortune",
        name: "Frankenstein's Fortune",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/fruitopolis_fortune_play": {
        slug: "fruitopolis_fortune_play",
        name: "Fruitopolis Fortune Play",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/full_moon_fever": {
        slug: "full_moon_fever",
        name: "Full Moon Fever",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/funky_buddha": {
        slug: "funky_buddha",
        name: "Funky Buddha",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/genie_jackpot_combo_frenzy": {
        slug: "genie_jackpot_combo_frenzy",
        name: "Genie Jackpot Combo Frenzy",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/genie_jackpots_wishmaker": {
        slug: "genie_jackpots_wishmaker",
        name: "Genie Jackpots Wishmaker",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/gold_strike": {
        slug: "gold_strike",
        name: "Gold Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/gold_strike_2": {
        slug: "gold_strike_2",
        name: "Gold Strike 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/gold_strike_bonanza": {
        slug: "gold_strike_bonanza",
        name: "Gold Strike Bonanza",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/gold_strike_express": {
        slug: "gold_strike_express",
        name: "Gold Strike Express",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/gorilla_gold_megaways_power_4_slots": {
        slug: "gorilla_gold_megaways_power_4_slots",
        name: "Gorilla Gold Megaways: Power 4 slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/jungle_fortune_build_your_bonus": {
        slug: "jungle_fortune_build_your_bonus",
        name: "Jungle Fortune Build Your Bonus",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash": {
        slug: "king_kong_cash",
        name: "King Kong Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash_dj_prime8": {
        slug: "king_kong_cash_dj_prime8",
        name: "King Kong Cash DJ Prime8",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash_even_bigger_bananas": {
        slug: "king_kong_cash_even_bigger_bananas",
        name: "King Kong Cash Even Bigger Bananas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash_even_bigger_bananas_2": {
        slug: "king_kong_cash_even_bigger_bananas_2",
        name: "King Kong Cash Even Bigger Bananas 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash_even_bigger_bananas_4": {
        slug: "king_kong_cash_even_bigger_bananas_4",
        name: "King Kong Cash Even Bigger Bananas 4",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash_full_house": {
        slug: "king_kong_cash_full_house",
        name: "King Kong Cash Full House",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash_prize_lines": {
        slug: "king_kong_cash_prize_lines",
        name: "King Kong Cash Prize Lines",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_splash": {
        slug: "king_kong_splash",
        name: "King Kong Splash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_of_the_west": {
        slug: "king_of_the_west",
        name: "King of the West",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/kong_3_even_bigger_bonus": {
        slug: "kong_3_even_bigger_bonus",
        name: "Kong 3 Even Bigger Bonus",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/kong_even_bigger_balls": {
        slug: "kong_even_bigger_balls",
        name: "Kong Even Bigger Balls",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/kong_even_bigger_christmas": {
        slug: "kong_even_bigger_christmas",
        name: "Kong Even Bigger Christmas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/legacy_of_gods_megaways": {
        slug: "legacy_of_gods_megaways",
        name: "Legacy of Gods Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/legacy_of_ra_megaways": {
        slug: "legacy_of_ra_megaways",
        name: "Legacy Of Ra Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/lion_thunder": {
        slug: "lion_thunder",
        name: "Lion Thunder",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/loti_fortune_spins": {
        slug: "loti_fortune_spins",
        name: "LOTI Fortune Spins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/loti_gold_spins": {
        slug: "loti_gold_spins",
        name: "LOTI Gold Spins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/lucky_fire_blitz_megaways": {
        slug: "lucky_fire_blitz_megaways",
        name: "Lucky Fire Blitz Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/lucky_fire_blitz_win_boost": {
        slug: "lucky_fire_blitz_win_boost",
        name: "Lucky Fire Blitz Win Boost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/lucky_pharaoh": {
        slug: "lucky_pharaoh",
        name: "Lucky Pharaoh",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/majestic_fury_megaways": {
        slug: "majestic_fury_megaways",
        name: "Majestic Fury Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/majestic_fury_megaways_unleashed": {
        slug: "majestic_fury_megaways_unleashed",
        name: "Majestic Fury Megaways Unleashed",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/majestic_fury_power_5": {
        slug: "majestic_fury_power_5",
        name: "Majestic Fury Power 5",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/majestic_fury_win_stepper": {
        slug: "majestic_fury_win_stepper",
        name: "Majestic Fury Win Stepper",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/maradona": {
        slug: "maradona",
        name: "Maradona",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/maradona_el_diez": {
        slug: "maradona_el_diez",
        name: "Maradona El Diez",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/maradona_el_pibe_de_oro": {
        slug: "maradona_el_pibe_de_oro",
        name: "Maradona: El Pibe De Oro",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/mega_charged_cash": {
        slug: "mega_charged_cash",
        name: "Mega Charged Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/midas_king_of_gold": {
        slug: "midas_king_of_gold",
        name: "Midas King Of Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/napoleon_2_fat_stacks": {
        slug: "napoleon_2_fat_stacks",
        name: "Napoleon 2 Fat Stacks",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/napoleon_deluxe": {
        slug: "napoleon_deluxe",
        name: "Napoleon Deluxe",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/napoleon_megaways": {
        slug: "napoleon_megaways",
        name: "Napoleon Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/napoleon_rise_of_an_empire": {
        slug: "napoleon_rise_of_an_empire",
        name: "Napoleon: Rise of an Empire",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/pig_wizard_cash_lock": {
        slug: "pig_wizard_cash_lock",
        name: "Pig Wizard Cash Lock",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/plenty_o_fish": {
        slug: "plenty_o_fish",
        name: "Plenty o' Fish",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/primal_megaways": {
        slug: "primal_megaways",
        name: "Primal Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/red_hot_catch": {
        slug: "red_hot_catch",
        name: "Red Hot Catch",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/red_hot_chilli": {
        slug: "red_hot_chilli",
        name: "Red Hot Chilli",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/red_hot_eruption": {
        slug: "red_hot_eruption",
        name: "Red Hot Eruption",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/return_of_kong_megaways": {
        slug: "return_of_kong_megaways",
        name: "Return of Kong Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/rhino_rampage": {
        slug: "rhino_rampage",
        name: "Rhino Rampage",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/rise_of_atlantis": {
        slug: "rise_of_atlantis",
        name: "Rise of Atlantis",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/rise_of_atlantis_2": {
        slug: "rise_of_atlantis_2",
        name: "Rise of Atlantis 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/rise_of_atlantis_legacy": {
        slug: "rise_of_atlantis_legacy",
        name: "Rise of Atlantis Legacy",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/safari_gold_megaways": {
        slug: "safari_gold_megaways",
        name: "Safari Gold Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/saint_nicked_2": {
        slug: "saint_nicked_2",
        name: "Saint Nicked 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/saint_nicked_3_present_tense": {
        slug: "saint_nicked_3_present_tense",
        name: "Saint Nicked 3 Present Tense",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/scarab_rising_megaways": {
        slug: "scarab_rising_megaways",
        name: "Scarab Rising Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/spirit_wolf_wins": {
        slug: "spirit_wolf_wins",
        name: "Spirit Wolf Wins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/stickermania_wild_rumble": {
        slug: "stickermania_wild_rumble",
        name: "Stickermania Wild Rumble",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/super_7_winner": {
        slug: "super_7_winner",
        name: "Super 7 Winner",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/super_wild_diamonds": {
        slug: "super_wild_diamonds",
        name: "Super Wild Diamonds",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/sweet_success_megaways": {
        slug: "sweet_success_megaways",
        name: "Sweet Success Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/tasty_trailz": {
        slug: "tasty_trailz",
        name: "Tasty Trailz",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/ted": {
        slug: "ted",
        name: "Ted",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/temple_of_treasures_megaways": {
        slug: "temple_of_treasures_megaways",
        name: "Temple of Treasures Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/the_goat": {
        slug: "the_goat",
        name: "The G.O.A.T",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/the_goonies": {
        slug: "the_goonies",
        name: "The Goonies",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/tomb_of_dead_power_4_slots": {
        slug: "tomb_of_dead_power_4_slots",
        name: "Tomb of Dead: Power 4 slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/trailblazer": {
        slug: "trailblazer",
        name: "Trailblazer",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/treasures_of_the_dead": {
        slug: "treasures_of_the_dead",
        name: "Treasures of the Dead",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/triple_action_cash_strike": {
        slug: "triple_action_cash_strike",
        name: "Triple Action Cash Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/valletta_megaways": {
        slug: "valletta_megaways",
        name: "Valletta Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/viking_fall": {
        slug: "viking_fall",
        name: "Viking Fall",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/vikings_unleashed_megaways": {
        slug: "vikings_unleashed_megaways",
        name: "Vikings Unleashed MegaWays",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/vikings_unleashed_reloaded_megaways": {
        slug: "vikings_unleashed_reloaded_megaways",
        name: "Vikings Unleashed Reloaded Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wish_upon_a_cashpot": {
        slug: "wish_upon_a_cashpot",
        name: "Wish Upon a Cashpot",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wish_upon_a_jackpot": {
        slug: "wish_upon_a_jackpot",
        name: "Wish Upon a Jackpot",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wish_upon_a_jackpot_megaways": {
        slug: "wish_upon_a_jackpot_megaways",
        name: "Wish Upon a Jackpot Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wolf_fury_fire_blitz": {
        slug: "wolf_fury_fire_blitz",
        name: "Wolf Fury Fire Blitz",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wolf_legend_gold_megaways": {
        slug: "wolf_legend_gold_megaways",
        name: "Wolf Legend Gold Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wolf_legend_megaways": {
        slug: "wolf_legend_megaways",
        name: "Wolf Legend Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wolf_legend_spinboost": {
        slug: "wolf_legend_spinboost",
        name: "Wolf Legend Spinboost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "boominggames/64_gold_coins_hold_and_win": {
        slug: "64_gold_coins_hold_and_win",
        name: "64 Gold Coins Hold and Win ",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/64_gold_coins_hold_and_win_20000": {
        slug: "64_gold_coins_hold_and_win_20000",
        name: "64 Gold Coins Hold and Win 20000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/64_gold_coins_hold_and_win_live": {
        slug: "64_gold_coins_hold_and_win_live",
        name: "64 Gold Coins Hold and Win Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/64_nuggets_hold_and_win": {
        slug: "64_nuggets_hold_and_win",
        name: "64 Nuggets Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/64_presents_hold_and_win": {
        slug: "64_presents_hold_and_win",
        name: "64 Presents Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/64_presents_hold_and_win_live": {
        slug: "64_presents_hold_and_win_live",
        name: "64 Presents Hold and Win Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/arabian_spins": {
        slug: "arabian_spins",
        name: "Arabian spins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/asia_wins": {
        slug: "asia_wins",
        name: "Asia Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/bamboo_wilds": {
        slug: "bamboo_wilds",
        name: "Bamboo Wilds",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/bang_bang": {
        slug: "bang_bang",
        name: "Bang Bang",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/bang_bang_reloaded": {
        slug: "bang_bang_reloaded",
        name: "Bang Bang Reloaded",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/berserkin_buffalo_power_hit": {
        slug: "berserkin_buffalo_power_hit",
        name: "Berserkin Buffalo Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/big_apple_wins": {
        slug: "big_apple_wins",
        name: "Big Apple Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/black_friday_cart_craze": {
        slug: "black_friday_cart_craze",
        name: "Black Friday Cart Craze",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/blazin_bonus": {
        slug: "blazin_bonus",
        name: "Blazin' Bonus",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/blockchain_megaways": {
        slug: "blockchain_megaways",
        name: "Blockchain Megaways",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/bonza_bucks_hold_and_win_extreme_10000": {
        slug: "bonza_bucks_hold_and_win_extreme_10000",
        name: "Bonza Bucks Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/boogie_boom": {
        slug: "boogie_boom",
        name: "Boogie Boom",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/book_of_tombs": {
        slug: "book_of_tombs",
        name: "Book of Tombs",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/booming_buffalo_hold_and_win_extreme_25000": {
        slug: "booming_buffalo_hold_and_win_extreme_25000",
        name: "Booming Buffalo Hold and Win Extreme 25,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/booming_gold": {
        slug: "booming_gold",
        name: "Booming Gold",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/booming_seven_deluxe": {
        slug: "booming_seven_deluxe",
        name: "Booming Seven Deluxe",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/booming_seven_deluxe_legacy": {
        slug: "booming_seven_deluxe_legacy",
        name: "Booming Seven Deluxe Legacy",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/buffalo_hold_and_win": {
        slug: "buffalo_hold_and_win",
        name: "Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/buffalo_hold_and_win_extreme": {
        slug: "buffalo_hold_and_win_extreme",
        name: "Buffalo Hold and Win Extreme",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/buffalo_hold_and_win_extreme_10000": {
        slug: "buffalo_hold_and_win_extreme_10000",
        name: "Buffalo Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/buffalo_hold_and_win_extreme_10000_live": {
        slug: "buffalo_hold_and_win_extreme_10000_live",
        name: "Buffalo Hold and Win Extreme 10,000 Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_classic_2": {
        slug: "burning_classic_2",
        name: "Burning Classic 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_classics": {
        slug: "burning_classics",
        name: "Burning Classics",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_classics_5000": {
        slug: "burning_classics_5000",
        name: "Burning Classics 5000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_classics_go_wild": {
        slug: "burning_classics_go_wild",
        name: "Burning Classics go Wild",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_classics_royal_edition": {
        slug: "burning_classics_royal_edition",
        name: "Burning Classics Royal Edition",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_love": {
        slug: "burning_love",
        name: "Burning Love",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/cash_pig": {
        slug: "cash_pig",
        name: "Cash Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/cash_pig_2": {
        slug: "cash_pig_2",
        name: "Cash Pig 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/cash_pig_2_15000": {
        slug: "cash_pig_2_15000",
        name: "Cash Pig 2 15000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/chief_hawks_spirit_walk": {
        slug: "chief_hawks_spirit_walk",
        name: "Chief Hawks Spirit Walk",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/classic_coins": {
        slug: "classic_coins",
        name: "Classic Coins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/classic_fantastic": {
        slug: "classic_fantastic",
        name: "Classic Fantastic",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/classico": {
        slug: "classico",
        name: "Classico",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/coin_crusher_hold_and_win": {
        slug: "coin_crusher_hold_and_win",
        name: "Coin Crusher Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/crack_the_bank_hold_and_win": {
        slug: "crack_the_bank_hold_and_win",
        name: "Crack the Bank Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamond_forge_link_and_loot": {
        slug: "diamond_forge_link_and_loot",
        name: "Diamond Forge Link and Loot",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamond_hits": {
        slug: "diamond_hits",
        name: "Diamond Hits",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamond_hits_trio_instastrike": {
        slug: "diamond_hits_trio_instastrike",
        name: "Diamond Hits Trio Instastrike",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamond_riches": {
        slug: "diamond_riches",
        name: "Diamond Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamonds_diamonds_diamonds_hold_and_win": {
        slug: "diamonds_diamonds_diamonds_hold_and_win",
        name: "Diamonds Diamonds Diamonds Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamonds_of_liberty": {
        slug: "diamonds_of_liberty",
        name: "Diamonds of Liberty",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/dynamite_trio": {
        slug: "dynamite_trio",
        name: "Dynamite Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/easter_classics": {
        slug: "easter_classics",
        name: "Easter Classics",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_colossal_catch_link_and_loot": {
        slug: "fish_tales_colossal_catch_link_and_loot",
        name: "Fish Tales Colossal Catch Link and Loot",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_double_catch": {
        slug: "fish_tales_double_catch",
        name: "Fish Tales Double Catch",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_double_catch_max_scatter": {
        slug: "fish_tales_double_catch_max_scatter",
        name: "Fish Tales: Double Catch Max Scatter",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_halloween": {
        slug: "fish_tales_halloween",
        name: "Fish Tales Halloween",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_monster_bass": {
        slug: "fish_tales_monster_bass",
        name: "Fish Tales Monster Bass",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_monster_bass_10000": {
        slug: "fish_tales_monster_bass_10000",
        name: "Fish Tales Monster Bass 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/flaming_chillies": {
        slug: "flaming_chillies",
        name: "Flaming Chillies",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fly_on": {
        slug: "fly_on",
        name: "Fly On!",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/forbidden_temple_power_hit": {
        slug: "forbidden_temple_power_hit",
        name: "Forbidden Temple Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fortune_and_finery": {
        slug: "fortune_and_finery",
        name: "Fortune and Finery",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fortune_paw": {
        slug: "fortune_paw",
        name: "Fortune Paw",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fruit_heaven_hold_and_win": {
        slug: "fruit_heaven_hold_and_win",
        name: "Fruit Heaven Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/gamblelicious_hold_and_win": {
        slug: "gamblelicious_hold_and_win",
        name: "Gamblelicious Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/gold_and_glamour_hold_and_win": {
        slug: "gold_and_glamour_hold_and_win",
        name: "Gold and Glamour Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/gold_gold_gold": {
        slug: "gold_gold_gold",
        name: "Gold Gold Gold",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/gold_gold_gold_5000": {
        slug: "gold_gold_gold_5000",
        name: "Gold Gold Gold 5000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/gold_gold_gold_hold_and_win": {
        slug: "gold_gold_gold_hold_and_win",
        name: "Gold Gold Gold Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/greedy_for_gold_hold_and_win": {
        slug: "greedy_for_gold_hold_and_win",
        name: "Greedy for Gold: Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/greedy_for_gold_power_hit": {
        slug: "greedy_for_gold_power_hit",
        name: "Greedy for Gold Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/greek_legends": {
        slug: "greek_legends",
        name: "Greek Legends",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/holly_jolly_bonanza": {
        slug: "holly_jolly_bonanza",
        name: "Holly Jolly Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/holly_jolly_bonanza_2": {
        slug: "holly_jolly_bonanza_2",
        name: "Holly Jolly Bonanza 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/holly_jolly_cash_pig": {
        slug: "holly_jolly_cash_pig",
        name: "Holly Jolly Cash Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/hot_charge": {
        slug: "hot_charge",
        name: "Hot Charge",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/howling_for_gold": {
        slug: "howling_for_gold",
        name: "Howling for Gold",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/howling_wolves_megaways": {
        slug: "howling_wolves_megaways",
        name: "Howling Wolves Megaways",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/inferno_fortune_instastrike": {
        slug: "inferno_fortune_instastrike",
        name: "Inferno Fortune InstaStrike",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/inferno_fortune_power_hit": {
        slug: "inferno_fortune_power_hit",
        name: "Inferno Fortune Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/jam_bonanza": {
        slug: "jam_bonanza",
        name: "Jam Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/jesters_bells_bonanza": {
        slug: "jesters_bells_bonanza",
        name: "Jester's Bells Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/jesters_riches": {
        slug: "jesters_riches",
        name: "Jesters Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/king_cobra": {
        slug: "king_cobra",
        name: "King Cobra",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/la_romantica": {
        slug: "la_romantica",
        name: "La Romantica",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/legendary_diamonds": {
        slug: "legendary_diamonds",
        name: "Legendary Diamonds",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/let_it_spin": {
        slug: "let_it_spin",
        name: "Let it Spin",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/liberty_and_freedom_hold_and_win_extreme_10000": {
        slug: "liberty_and_freedom_hold_and_win_extreme_10000",
        name: "Liberty and Freedom Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/liberty_and_freedom_hold_and_win_extreme_10000_live": {
        slug: "liberty_and_freedom_hold_and_win_extreme_10000_live",
        name: "Liberty and Freedom Hold and Win Extreme 10,000 Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/lotus_love": {
        slug: "lotus_love",
        name: "Lotus Love",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/lucky_charms_trio": {
        slug: "lucky_charms_trio",
        name: "Lucky Charms Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/lucky_oasis": {
        slug: "lucky_oasis",
        name: "Lucky Oasis",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mighty_gorilla": {
        slug: "mighty_gorilla",
        name: "Mighty Gorilla",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mr_oinksters_hold_and_win": {
        slug: "mr_oinksters_hold_and_win",
        name: "Mr. Oinksters Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mr_oinksters_power_hit": {
        slug: "mr_oinksters_power_hit",
        name: "Mr. Oinkster's Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mustang_hold_and_win": {
        slug: "mustang_hold_and_win",
        name: "Mustang Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mustangs_and_stallions": {
        slug: "mustangs_and_stallions",
        name: "Mustangs and Stallions",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/paris_nights": {
        slug: "paris_nights",
        name: "Paris Nights",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/payday_pig": {
        slug: "payday_pig",
        name: "Payday Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/polar_buffalo_extreme_hold_and_win_25000": {
        slug: "polar_buffalo_extreme_hold_and_win_25000",
        name: "Polar Buffalo Extreme Hold and Win 25,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/power_of_atlantis_trio": {
        slug: "power_of_atlantis_trio",
        name: "Power of Atlantis Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/power_of_hercules_bonanza": {
        slug: "power_of_hercules_bonanza",
        name: "Power of Hercules Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/power_of_olympus": {
        slug: "power_of_olympus",
        name: "Power of Olympus",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/power_of_rome": {
        slug: "power_of_rome",
        name: "Power of Rome",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/ras_relics_bonanza": {
        slug: "ras_relics_bonanza",
        name: "Ra's Relics Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/reels_paradise": {
        slug: "reels_paradise",
        name: "Reels Paradise",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/rhino_hold_and_win": {
        slug: "rhino_hold_and_win",
        name: "Rhino Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/roll_the_dice": {
        slug: "roll_the_dice",
        name: "Roll the Dice",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/ronaldinho_scores_shoot_and_win": {
        slug: "ronaldinho_scores_shoot_and_win",
        name: "Ronaldinho Scores Shoot and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/ronaldinho_spins": {
        slug: "ronaldinho_spins",
        name: "Ronaldinho Spins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/ronaldinhos_streetball_bonanza": {
        slug: "ronaldinhos_streetball_bonanza",
        name: "Ronaldinho's Streetball Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/royal_wins": {
        slug: "royal_wins",
        name: "Royal Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/sacred_buffalo": {
        slug: "sacred_buffalo",
        name: "Sacred Buffalo",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/santa_in_vegas": {
        slug: "santa_in_vegas",
        name: "Santa in Vegas",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/santas_snowball_smash_instant_win": {
        slug: "santas_snowball_smash_instant_win",
        name: "Santas Snowball Smash Instant Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/secret_book_of_amun_ra": {
        slug: "secret_book_of_amun_ra",
        name: "Secret Book of Amun Ra",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/shields_of_gold_valkyrie_hold_and_win": {
        slug: "shields_of_gold_valkyrie_hold_and_win",
        name: "Shields of Gold Valkyrie Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/smoking_pistols": {
        slug: "smoking_pistols",
        name: "Smoking Pistols",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/space_cows_to_the_moon": {
        slug: "space_cows_to_the_moon",
        name: "Space Cows to the Moo'n",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/space_sam_walk_and_win": {
        slug: "space_sam_walk_and_win",
        name: "Space Sam Walk and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/spooktacular_bonanza": {
        slug: "spooktacular_bonanza",
        name: "Spooktacular Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/stampede_bonanza": {
        slug: "stampede_bonanza",
        name: "Stampede Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/super_duper": {
        slug: "super_duper",
        name: "Super Duper",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tasty_bonanza": {
        slug: "tasty_bonanza",
        name: "Tasty Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tasty_bonanza_1000": {
        slug: "tasty_bonanza_1000",
        name: "Tasty Bonanza 1,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tasty_bonanza_live": {
        slug: "tasty_bonanza_live",
        name: "Tasty Bonanza Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tasty_bonanza_max_scatter": {
        slug: "tasty_bonanza_max_scatter",
        name: "Tasty Bonanza Max Scatter",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/the_chillies": {
        slug: "the_chillies",
        name: "The Chillies",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/the_mighty_toro": {
        slug: "the_mighty_toro",
        name: "The Mighty Toro",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/the_wild_wings_of_phoenix": {
        slug: "the_wild_wings_of_phoenix",
        name: "The Wild Wings of Phoenix",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/the_wild_wings_of_phoenix_deluxe": {
        slug: "the_wild_wings_of_phoenix_deluxe",
        name: "The Wild Wings of Phoenix Deluxe",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/thunder_eagle_hold_and_win_10000": {
        slug: "thunder_eagle_hold_and_win_10000",
        name: "Thunder Eagle Hold and Win 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tnt_bonanza": {
        slug: "tnt_bonanza",
        name: "TNT Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tnt_bonanza_2": {
        slug: "tnt_bonanza_2",
        name: "TNT Bonanza 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/treasure_vault": {
        slug: "treasure_vault",
        name: "Treasure Vault",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/trollfufu_bonanza": {
        slug: "trollfufu_bonanza",
        name: "Trollfufu Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/twin_buffalo_hold_and_win": {
        slug: "twin_buffalo_hold_and_win",
        name: "Twin Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/ultimate_hold_n_win": {
        slug: "ultimate_hold_n_win",
        name: "Ultimate Hold 'N' Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/ultra_buffalo_hold_and_win": {
        slug: "ultra_buffalo_hold_and_win",
        name: "Ultra Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/vegas_pig_live": {
        slug: "vegas_pig_live",
        name: "Vegas Pig Live",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/vegas_wins": {
        slug: "vegas_wins",
        name: "Vegas Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/vip_filthy_riches": {
        slug: "vip_filthy_riches",
        name: "VIP Filthy Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/way_of_the_wolf_hold_and_win_extreme_10000": {
        slug: "way_of_the_wolf_hold_and_win_extreme_10000",
        name: "Way of the Wolf Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/wild_diamond_7x": {
        slug: "wild_diamond_7x",
        name: "Wild Diamond 7x",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/wild_silverback": {
        slug: "wild_silverback",
        name: "Wild Silverback",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/wild_wild_vegas": {
        slug: "wild_wild_vegas",
        name: "Wild Wild Vegas",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "bulletproof-games/7th_squadron_doublemax": {
        slug: "7th_squadron_doublemax",
        name: "7th Squadron Doublemax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/banana_twist": {
        slug: "banana_twist",
        name: "Banana Twist",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/crystal_falls": {
        slug: "crystal_falls",
        name: "Crystal Falls",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/diamond_symphony_doublemax": {
        slug: "diamond_symphony_doublemax",
        name: "Diamond Symphony Doublemax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/dragon_lore_gigarise": {
        slug: "dragon_lore_gigarise",
        name: "Dragon Lore Gigarise",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/hunters_moon": {
        slug: "hunters_moon",
        name: "Hunters Moon",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/hunters_moon_gigablox": {
        slug: "hunters_moon_gigablox",
        name: "Hunters Moon Gigablox",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/irish_pots_multimax": {
        slug: "irish_pots_multimax",
        name: "Irish Pots Multimax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/juiced_duomax": {
        slug: "juiced_duomax",
        name: "Juiced Duomax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/lollipop_drop_multimax": {
        slug: "lollipop_drop_multimax",
        name: "Lollipop Drop Multimax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/mega_cash_stacks": {
        slug: "mega_cash_stacks",
        name: "Mega Cash Stacks",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/midas_vs_medusa_wild_energy": {
        slug: "midas_vs_medusa_wild_energy",
        name: "Midas vs Medusa Wild Energy",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/roby_dick": {
        slug: "roby_dick",
        name: "Roby Dick",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/tempered_steel": {
        slug: "tempered_steel",
        name: "Tempered Steel",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/tiki_runner_2_doublemax": {
        slug: "tiki_runner_2_doublemax",
        name: "Tiki Runner 2 DoubleMax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/tiki_runner_clusters": {
        slug: "tiki_runner_clusters",
        name: "Tiki Runner Clusters",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/tiki_runner_gigablox": {
        slug: "tiki_runner_gigablox",
        name: "Tiki Runner GigaBlox",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/vault_raiders_doublemax": {
        slug: "vault_raiders_doublemax",
        name: "Vault Raiders DoubleMax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "electric-elephant/joker_jackpots": {
        slug: "joker_jackpots",
        name: "Joker Jackpots",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "electric-elephant/sherlock_bones": {
        slug: "sherlock_bones",
        name: "Sherlock Bones",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "electric-elephant/star_pops": {
        slug: "star_pops",
        name: "Star Pops",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "electric-elephant/super_boost": {
        slug: "super_boost",
        name: "Super Boost",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "electric-elephant/who_wants_to_be_a_millionaire_roulette": {
        slug: "who_wants_to_be_a_millionaire_roulette",
        name: "Who Wants to be a Millionaire Roulette",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "evoplay/3_bunny_pots_bonanza": {
        slug: "3_bunny_pots_bonanza",
        name: "3 Bunny Pots Bonanza",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/3_crowns_coin_hunt": {
        slug: "3_crowns_coin_hunt",
        name: "3 Crowns Coin Hunt",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ace_round": {
        slug: "ace_round",
        name: "Ace Round",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/adrenaline_rush": {
        slug: "adrenaline_rush",
        name: "Adrenaline Rush",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/adrenaline_rush_scratch": {
        slug: "adrenaline_rush_scratch",
        name: "Adrenaline Rush Scratch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/adrenaline_rush_super_boost": {
        slug: "adrenaline_rush_super_boost",
        name: "Adrenaline Rush: Super Boost",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/adrenaline_rush_xcrash": {
        slug: "adrenaline_rush_xcrash",
        name: "Adrenaline Rush: XCrash",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/american_roulette_3d": {
        slug: "american_roulette_3d",
        name: "American Roulette 3D",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/american_sevens": {
        slug: "american_sevens",
        name: "American Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/andar_nights": {
        slug: "andar_nights",
        name: "Andar Nights",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/animal_quest": {
        slug: "animal_quest",
        name: "Animal Quest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/anubis_moon": {
        slug: "anubis_moon",
        name: "Anubis’ Moon",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/atlantis": {
        slug: "atlantis",
        name: "Atlantis",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/avia_rush": {
        slug: "avia_rush",
        name: "Avia Rush",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/baccarat_777": {
        slug: "baccarat_777",
        name: "Baccarat 777",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bandit_bust": {
        slug: "bandit_bust",
        name: "Bandit Bust",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bandit_bust_bonus_buy": {
        slug: "bandit_bust_bonus_buy",
        name: "Bandit Bust Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/basket_bounty": {
        slug: "basket_bounty",
        name: "Basket Bounty",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/basketball": {
        slug: "basketball",
        name: "Basketball",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/battle_rooster": {
        slug: "battle_rooster",
        name: "Battle Rooster",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/battle_roosters": {
        slug: "battle_roosters",
        name: "Battle Roosters",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/battle_tanks": {
        slug: "battle_tanks",
        name: "Battle Tanks",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bball_blitz": {
        slug: "bball_blitz",
        name: "B-Ball Blitz",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/beanstalk_magic_treasures": {
        slug: "beanstalk_magic_treasures",
        name: "Beanstalk Magic Treasures",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/belfry_bliss": {
        slug: "belfry_bliss",
        name: "Belfry Bliss",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/belfry_bliss_hold_and_win": {
        slug: "belfry_bliss_hold_and_win",
        name: "Belfry Bliss Hold and Win",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/big_catch_game": {
        slug: "big_catch_game",
        name: "Big Catch Game",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bingo_lobby": {
        slug: "bingo_lobby",
        name: "Bingo Lobby",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/blackjack_lucky_7s_xmas": {
        slug: "blackjack_lucky_7s_xmas",
        name: "Blackjack Lucky 7s Xmas",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/blackjack_lucky_sevens": {
        slug: "blackjack_lucky_sevens",
        name: "BlackJack: Lucky Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/blessed_flame": {
        slug: "blessed_flame",
        name: "Blessed Flame",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bloody_brilliant": {
        slug: "bloody_brilliant",
        name: "Bloody Brilliant",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bomb_squad": {
        slug: "bomb_squad",
        name: "Bomb Squad",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bonanza_wheel": {
        slug: "bonanza_wheel",
        name: "Bonanza Wheel",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/book_of_keno": {
        slug: "book_of_keno",
        name: "Book of Keno",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/book_of_rest": {
        slug: "book_of_rest",
        name: "Book of Rest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/book_of_the_priestess": {
        slug: "book_of_the_priestess",
        name: "Book of the Priestess",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/book_of_the_priestess_bonus_buy": {
        slug: "book_of_the_priestess_bonus_buy",
        name: "Book of the Priestess Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/brutal_santa": {
        slug: "brutal_santa",
        name: "Brutal Santa",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/budai_reels": {
        slug: "budai_reels",
        name: "Budai Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/budai_reels_bonus_buy": {
        slug: "budai_reels_bonus_buy",
        name: "Budai Reels Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bulls_club": {
        slug: "bulls_club",
        name: "Bull's Club",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/camino_de_chili": {
        slug: "camino_de_chili",
        name: "Camino de Chili",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/camino_de_chili_bonus_buy": {
        slug: "camino_de_chili_bonus_buy",
        name: "Camino de Chili Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/candy_craze": {
        slug: "candy_craze",
        name: "Candy Craze",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/candy_dreams": {
        slug: "candy_dreams",
        name: "Candy Dreams",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/candy_dreams_bingo": {
        slug: "candy_dreams_bingo",
        name: "Candy Dreams: Bingo",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/candy_dreams_sweet_planet": {
        slug: "candy_dreams_sweet_planet",
        name: "Candy Dreams: Sweet Planet",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/candy_dreams_sweet_planet_bonus_buy": {
        slug: "candy_dreams_sweet_planet_bonus_buy",
        name: "Candy Dreams: Sweet Planet. Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/caramelo_dog_lucky_run": {
        slug: "caramelo_dog_lucky_run",
        name: "Caramelo Dog Lucky Run",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/catch_the_wind": {
        slug: "catch_the_wind",
        name: "Catch the Wind",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/catch_the_wind_bonus_buy": {
        slug: "catch_the_wind_bonus_buy",
        name: "Catch the Wind Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cats_blessing": {
        slug: "cats_blessing",
        name: "Cat's Blessing",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/chosen_by_the_gods": {
        slug: "chosen_by_the_gods",
        name: "Chosen by the Gods",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/christmas_crash": {
        slug: "christmas_crash",
        name: "Christmas Crash",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/christmas_reach": {
        slug: "christmas_reach",
        name: "Christmas Reach",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/christmas_reach_bonus_buy": {
        slug: "christmas_reach_bonus_buy",
        name: "Christmas Reach Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/clash_of_pirates": {
        slug: "clash_of_pirates",
        name: "Clash of Pirates",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/collapsed_castle": {
        slug: "collapsed_castle",
        name: "Collapsed Castle",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/collapsed_castle_bonus_buy": {
        slug: "collapsed_castle_bonus_buy",
        name: "Collapsed Castle Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/courier_sweeper": {
        slug: "courier_sweeper",
        name: "Courier Sweeper",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cricket_duel": {
        slug: "cricket_duel",
        name: "Cricket Duel",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/crimson_crown": {
        slug: "crimson_crown",
        name: "Crimson Crown",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/crown_and_anchor": {
        slug: "crown_and_anchor",
        name: "Crown & Anchor",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/curse_of_pharaoh": {
        slug: "curse_of_pharaoh",
        name: "Curse of Pharaoh",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/curse_of_the_pharaoh": {
        slug: "curse_of_the_pharaoh",
        name: "Curse of the Pharaoh",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/curse_of_the_pharaoh_bonus_buy": {
        slug: "curse_of_the_pharaoh_bonus_buy",
        name: "Curse of the Pharaoh Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cursed_can": {
        slug: "cursed_can",
        name: "Cursed Can",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cursed_can_bonus_buy": {
        slug: "cursed_can_bonus_buy",
        name: "Cursed Can Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cursed_castle": {
        slug: "cursed_castle",
        name: "Cursed Castle",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cycle_of_luck": {
        slug: "cycle_of_luck",
        name: "Cycle of Luck",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cycle_of_luck_bonus_buy": {
        slug: "cycle_of_luck_bonus_buy",
        name: "Cycle of Luck Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/diamond_hustle": {
        slug: "diamond_hustle",
        name: "Diamond Hustle",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/don_juan_peppers": {
        slug: "don_juan_peppers",
        name: "Don Juan Peppers",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/dragons_tavern": {
        slug: "dragons_tavern",
        name: "Dragon's Tavern",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/dragons_tavern_bonus_buy": {
        slug: "dragons_tavern_bonus_buy",
        name: "Dragon's Tavern Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/dungeon_immortal_evil": {
        slug: "dungeon_immortal_evil",
        name: "Dungeon: Immortal Evil",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/egypt_gods": {
        slug: "egypt_gods",
        name: "Egypt Gods",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ellens_fortune": {
        slug: "ellens_fortune",
        name: "Ellen's Fortune",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/elven_princesses": {
        slug: "elven_princesses",
        name: "Elven Princesses",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/elven_princesses_crown_quest": {
        slug: "elven_princesses_crown_quest",
        name: "Elven Princesses: Crown Quest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/emerald_brewer": {
        slug: "emerald_brewer",
        name: "Emerald Brewer",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/epic_gladiators": {
        slug: "epic_gladiators",
        name: "Epic Gladiators",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/epic_legends": {
        slug: "epic_legends",
        name: "Epic Legends",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/et_lost_socks": {
        slug: "et_lost_socks",
        name: "E.T. Lost Socks",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/europe_transit": {
        slug: "europe_transit",
        name: "Europe Transit",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/europe_transit_bonus_buy": {
        slug: "europe_transit_bonus_buy",
        name: "Europe Transit Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/europe_transit_snowdrift": {
        slug: "europe_transit_snowdrift",
        name: "Europe Transit Snowdrift",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/european_christmas_roulette": {
        slug: "european_christmas_roulette",
        name: "European Christmas Roulette",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/expanding_master": {
        slug: "expanding_master",
        name: "Expanding Master",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/exploding_fruits": {
        slug: "exploding_fruits",
        name: "Exploding Fruits",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/flame_of_ra": {
        slug: "flame_of_ra",
        name: "Flame of Ra",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fluffy_rangers": {
        slug: "fluffy_rangers",
        name: "Fluffy Rangers",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fogo_do_brasil_777": {
        slug: "fogo_do_brasil_777",
        name: "Fogo Do Brasil 777",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/food_feast": {
        slug: "food_feast",
        name: "Food Feast",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/football": {
        slug: "football",
        name: "Football",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/football_bet": {
        slug: "football_bet",
        name: "Football Bet",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/football_manager": {
        slug: "football_manager",
        name: "Football Manager",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/football_scratch": {
        slug: "football_scratch",
        name: "Football Scratch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/forest_dreams": {
        slug: "forest_dreams",
        name: "Forest Dreams",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/forgotten_fable": {
        slug: "forgotten_fable",
        name: "Forgotten Fable",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/four_aces": {
        slug: "four_aces",
        name: "Four Aces",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/french_roulette_classic": {
        slug: "french_roulette_classic",
        name: "French Roulette Classic",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_burst": {
        slug: "fruit_burst",
        name: "Fruit Burst",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_disco": {
        slug: "fruit_disco",
        name: "Fruit Disco",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_nova": {
        slug: "fruit_nova",
        name: "Fruit Nova",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova": {
        slug: "fruit_super_nova",
        name: "Fruit Super Nova",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova_100": {
        slug: "fruit_super_nova_100",
        name: "Fruit Super Nova 100",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova_30": {
        slug: "fruit_super_nova_30",
        name: "Fruit Super Nova 30",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova_40": {
        slug: "fruit_super_nova_40",
        name: "Fruit Super Nova 40",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova_60": {
        slug: "fruit_super_nova_60",
        name: "Fruit Super Nova 60",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova_80": {
        slug: "fruit_super_nova_80",
        name: "Fruit Super Nova 80",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruitburst": {
        slug: "fruitburst",
        name: "Fruitburst",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/gems_of_ra": {
        slug: "gems_of_ra",
        name: "Gems of Ra",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/goblin_run": {
        slug: "goblin_run",
        name: "Goblin Run",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/goddess_of_the_night": {
        slug: "goddess_of_the_night",
        name: "Goddess of the Night",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/goddess_of_the_night_bonus_buy": {
        slug: "goddess_of_the_night_bonus_buy",
        name: "Goddess of the Night Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/gold_of_sirens": {
        slug: "gold_of_sirens",
        name: "Gold of Sirens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/gold_of_sirens_bonus_buy": {
        slug: "gold_of_sirens_bonus_buy",
        name: "Gold of Sirens Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/good_luck_spell": {
        slug: "good_luck_spell",
        name: "Good Luck Spell",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/heads_and_tails": {
        slug: "heads_and_tails",
        name: "Heads and Tails",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/heart_of_africa_lion_way": {
        slug: "heart_of_africa_lion_way",
        name: "Heart of Africa: Lion Way",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hercules_sports_legend": {
        slug: "hercules_sports_legend",
        name: "Hercules: Sports Legend",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/high_striker": {
        slug: "high_striker",
        name: "High Striker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hockey_shootout": {
        slug: "hockey_shootout",
        name: "Hockey Shootout",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hocus_pocus_sorcery": {
        slug: "hocus_pocus_sorcery",
        name: "Hocus Pocus Sorcery",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_mania": {
        slug: "hot_mania",
        name: "Hot Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_rio_nights": {
        slug: "hot_rio_nights",
        name: "Hot Rio Nights",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_rio_nights_bonus_buy": {
        slug: "hot_rio_nights_bonus_buy",
        name: "Hot Rio Nights Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_rio_samba": {
        slug: "hot_rio_samba",
        name: "Hot Rio Samba",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_slice": {
        slug: "hot_slice",
        name: "Hot Slice",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_triple_sevens": {
        slug: "hot_triple_sevens",
        name: "Hot Triple Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_triple_sevens_hold_and_win": {
        slug: "hot_triple_sevens_hold_and_win",
        name: "Hot Triple Sevens Hold and Win",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_triple_sevens_special": {
        slug: "hot_triple_sevens_special",
        name: "Hot Triple Sevens Special",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_volcano": {
        slug: "hot_volcano",
        name: "Hot Volcano",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_volcano_bonus_buy": {
        slug: "hot_volcano_bonus_buy",
        name: "Hot Volcano Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hungry_night": {
        slug: "hungry_night",
        name: "Hungry Night",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ice_mania": {
        slug: "ice_mania",
        name: "Ice Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ignis_rex": {
        slug: "ignis_rex",
        name: "Ignis Rex",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/imperial_relics_three_pots": {
        slug: "imperial_relics_three_pots",
        name: "Imperial Relics Three Pots",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/indianas_quest": {
        slug: "indianas_quest",
        name: "Indiana's Quest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/inner_fire": {
        slug: "inner_fire",
        name: "Inner Fire",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/inner_fire_bonus_buy": {
        slug: "inner_fire_bonus_buy",
        name: "Inner Fire Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/instant_soccer": {
        slug: "instant_soccer",
        name: "Instant Soccer",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/irish_reels": {
        slug: "irish_reels",
        name: "Irish Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/irish_weekend": {
        slug: "irish_weekend",
        name: "Irish Weekend",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/irish_weekend_bonus_buy": {
        slug: "irish_weekend_bonus_buy",
        name: "Irish Weekend Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jackmaster_fruits": {
        slug: "jackmaster_fruits",
        name: "Jackmaster Fruits",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jelly_boom": {
        slug: "jelly_boom",
        name: "Jelly Boom",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jhana_of_god": {
        slug: "jhana_of_god",
        name: "Jhana of God",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jhana_of_god_bonus_buy": {
        slug: "jhana_of_god_bonus_buy",
        name: "Jhana of God Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jhana_of_god_scratch": {
        slug: "jhana_of_god_scratch",
        name: "Jhana of God: Scratch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/joker_jane": {
        slug: "joker_jane",
        name: "Joker Jane",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jolly_treasures": {
        slug: "jolly_treasures",
        name: "Jolly Treasures",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jolt_circuit": {
        slug: "jolt_circuit",
        name: "Jolt Circuit",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/journey_to_the_west": {
        slug: "journey_to_the_west",
        name: "Journey to the West",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/juicy_fruit_coins_hold_and_win": {
        slug: "juicy_fruit_coins_hold_and_win",
        name: "Juicy Fruit Coins Hold and Win",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/juicy_gems": {
        slug: "juicy_gems",
        name: "Juicy Gems",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/juicy_gems_bonus_buy": {
        slug: "juicy_gems_bonus_buy",
        name: "Juicy Gems Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lava_burst": {
        slug: "lava_burst",
        name: "Lava Burst",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/legacy_of_the_sages": {
        slug: "legacy_of_the_sages",
        name: "Legacy of the Sages",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/legacy_of_the_sages_bonus_buy": {
        slug: "legacy_of_the_sages_bonus_buy",
        name: "Legacy of the Sages Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/legend_of_ra": {
        slug: "legend_of_ra",
        name: "Legend of Ra",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/liberty_fireworks": {
        slug: "liberty_fireworks",
        name: "Liberty Fireworks",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/long_ball": {
        slug: "long_ball",
        name: "Long Ball",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/love_and_luck_joker": {
        slug: "love_and_luck_joker",
        name: "Love and Luck Joker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lu_fu_vortex": {
        slug: "lu_fu_vortex",
        name: "Lu Fu Vortex",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/luck_reactor": {
        slug: "luck_reactor",
        name: "Luck Reactor",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lucky_card": {
        slug: "lucky_card",
        name: "Lucky Card",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lucky_crumbling": {
        slug: "lucky_crumbling",
        name: "Lucky Crumbling",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lucky_girls": {
        slug: "lucky_girls",
        name: "Lucky Girls",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lucky_porker": {
        slug: "lucky_porker",
        name: "Lucky Porker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lucky_porker_bonus_buy": {
        slug: "lucky_porker_bonus_buy",
        name: "Lucky Porker Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lunar_wilds": {
        slug: "lunar_wilds",
        name: "Lunar Wilds",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/magic_wheel": {
        slug: "magic_wheel",
        name: "Magic Wheel",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/marys_mining_mania": {
        slug: "marys_mining_mania",
        name: "Mary's Mining Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/massive_luck": {
        slug: "massive_luck",
        name: "Massive Luck",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/massive_luck_bonus_buy": {
        slug: "massive_luck_bonus_buy",
        name: "Massive Luck Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/maze_desire_for_power": {
        slug: "maze_desire_for_power",
        name: "Maze: Desire for Power",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mega_greatest_catch": {
        slug: "mega_greatest_catch",
        name: "Mega Greatest Catch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mega_greatest_catch_blue_marlin": {
        slug: "mega_greatest_catch_blue_marlin",
        name: "Mega Greatest Catch Blue Marlin",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mega_greatest_catch_bonus_buy": {
        slug: "mega_greatest_catch_bonus_buy",
        name: "Mega Greatest Catch Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/midnight_show": {
        slug: "midnight_show",
        name: "Midnight Show",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mine_field": {
        slug: "mine_field",
        name: "Mine Field",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/money_minter": {
        slug: "money_minter",
        name: "Money Minter",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/money_minter_bonus_buy": {
        slug: "money_minter_bonus_buy",
        name: "Money Minter Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/more_or_less": {
        slug: "more_or_less",
        name: "More or Less",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mysteries_of_the_east": {
        slug: "mysteries_of_the_east",
        name: "Mysteries of the East",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mystery_planet": {
        slug: "mystery_planet",
        name: "Mystery Planet",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mystic_alaska": {
        slug: "mystic_alaska",
        name: "Mystic Alaska",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mystic_totems": {
        slug: "mystic_totems",
        name: "Mystic Totems",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/naughty_girls_cabaret": {
        slug: "naughty_girls_cabaret",
        name: "Naughty Girls Cabaret",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/neon_capital": {
        slug: "neon_capital",
        name: "Neon Capital",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/neon_capital_bonus_buy": {
        slug: "neon_capital_bonus_buy",
        name: "Neon Capital Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/neon_shapes": {
        slug: "neon_shapes",
        name: "Neon Shapes",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/night_of_the_living_tales": {
        slug: "night_of_the_living_tales",
        name: "Night of the Living Tales",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/northern_temple": {
        slug: "northern_temple",
        name: "Northern Temple",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/northern_temple_bonus_buy": {
        slug: "northern_temple_bonus_buy",
        name: "Northern Temple Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/nuke_world": {
        slug: "nuke_world",
        name: "Nuke World",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/oasis_poker_classic": {
        slug: "oasis_poker_classic",
        name: "Oasis Poker Classic",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/oath_of_steel": {
        slug: "oath_of_steel",
        name: "Oath of Steel",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ocean_catch_bonus_buy": {
        slug: "ocean_catch_bonus_buy",
        name: "Ocean Catch Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/october_pub": {
        slug: "october_pub",
        name: "October Pub",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/old_west": {
        slug: "old_west",
        name: "Old West",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/pachin_girl": {
        slug: "pachin_girl",
        name: "Pachin Girl",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/patricks_club_three_pots": {
        slug: "patricks_club_three_pots",
        name: "Patrick's Club Three Pots",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/patricks_magic_field": {
        slug: "patricks_magic_field",
        name: "Patrick's Magic Field",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_roulette": {
        slug: "penalty_roulette",
        name: "Penalty Roulette",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_series": {
        slug: "penalty_series",
        name: "Penalty Series",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_shoot_out_cup_mania": {
        slug: "penalty_shoot_out_cup_mania",
        name: "Penalty Shoot Out: Cup Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_shoot_out_super_cup": {
        slug: "penalty_shoot_out_super_cup",
        name: "Penalty Shoot Out Super Cup",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_shoot_out_super_spin": {
        slug: "penalty_shoot_out_super_spin",
        name: "Penalty Shoot Out Super Spin",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_shootout": {
        slug: "penalty_shootout",
        name: "Penalty Shoot-out",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_shootout_street": {
        slug: "penalty_shootout_street",
        name: "Penalty Shoot-out: Street",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/perfect_fishing": {
        slug: "perfect_fishing",
        name: "Perfect Fishing",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/piggy_bank_3_pots_bonanza": {
        slug: "piggy_bank_3_pots_bonanza",
        name: "Piggy Bank 3 Pots Bonanza",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/plinko_blast": {
        slug: "plinko_blast",
        name: "Plinko Blast",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/pride_fight": {
        slug: "pride_fight",
        name: "Pride Fight",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/pumpkin_master": {
        slug: "pumpkin_master",
        name: "Pumpkin Master",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/pyro_joker": {
        slug: "pyro_joker",
        name: "Pyro Joker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/queen_of_sirens": {
        slug: "queen_of_sirens",
        name: "Queen of Sirens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/raccoon_tales": {
        slug: "raccoon_tales",
        name: "Raccoon Tales",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/red_cliff": {
        slug: "red_cliff",
        name: "Red Cliff",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/red_queen": {
        slug: "red_queen",
        name: "Red Queen",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/redrose_sanctuary": {
        slug: "redrose_sanctuary",
        name: "Redrose Sanctuary",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/redrose_sanctuary_bonus_buy": {
        slug: "redrose_sanctuary_bonus_buy",
        name: "Redrose Sanctuary Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/reign_of_dragons": {
        slug: "reign_of_dragons",
        name: "Reign of Dragons",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rich_reels": {
        slug: "rich_reels",
        name: "Rich Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rise_of_horus": {
        slug: "rise_of_horus",
        name: "Rise of Horus",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/robin_hood": {
        slug: "robin_hood",
        name: "Robin Hood",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/robinson": {
        slug: "robinson",
        name: "Robinson",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/robots_energy_conflict": {
        slug: "robots_energy_conflict",
        name: "Robots: Energy Conflict",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rock_paper_scissors": {
        slug: "rock_paper_scissors",
        name: "Rock Paper Scissors",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rock_vs_paper_vikings_mode": {
        slug: "rock_vs_paper_vikings_mode",
        name: "Rock vs Paper: Viking’s mode",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rocket_stars": {
        slug: "rocket_stars",
        name: "Rocket Stars",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/roll_the_dice": {
        slug: "roll_the_dice",
        name: "Roll the Dice",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/roll_to_luck": {
        slug: "roll_to_luck",
        name: "Roll to Luck",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/roman_rule": {
        slug: "roman_rule",
        name: "Roman Rule",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rueda_de_chile": {
        slug: "rueda_de_chile",
        name: "Rueda de Chile",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rueda_de_chile_bonus_buy": {
        slug: "rueda_de_chile_bonus_buy",
        name: "Rueda de Chile Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rumble_in_the_shadows": {
        slug: "rumble_in_the_shadows",
        name: "Rumble in the Shadows",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/runes_of_destiny": {
        slug: "runes_of_destiny",
        name: "Runes of Destiny",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rush_riches": {
        slug: "rush_riches",
        name: "Rush Riches",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/safari_coins_heart_of_africa": {
        slug: "safari_coins_heart_of_africa",
        name: "Safari Coins: Heart of Africa",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/save_the_hamster": {
        slug: "save_the_hamster",
        name: "Save the Hamster",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/scratch_match": {
        slug: "scratch_match",
        name: "Scratch Match",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sea_of_spins": {
        slug: "sea_of_spins",
        name: "Sea of Spins",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sea_of_wealth": {
        slug: "sea_of_wealth",
        name: "Sea of Wealth",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sea_of_wealth_hunt_for_coin": {
        slug: "sea_of_wealth_hunt_for_coin",
        name: "Sea of Wealth: Hunt for Coin",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/season_sisters": {
        slug: "season_sisters",
        name: "Season Sisters",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/shadow_of_luxor": {
        slug: "shadow_of_luxor",
        name: "Shadow of Luxor",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sky_sentinels": {
        slug: "sky_sentinels",
        name: "Sky Sentinels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/soccer_solo_striker": {
        slug: "soccer_solo_striker",
        name: "Soccer Solo Striker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sold_it": {
        slug: "sold_it",
        name: "Sold it",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sold_it_bonus_buy": {
        slug: "sold_it_bonus_buy",
        name: "Sold it Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/star_guardians": {
        slug: "star_guardians",
        name: "Star Guardians",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sunstone_riches": {
        slug: "sunstone_riches",
        name: "Sunstone Riches",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/surf_zone": {
        slug: "surf_zone",
        name: "Surf Zone",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sweet_sugar": {
        slug: "sweet_sugar",
        name: "Sweet Sugar",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/talismans_of_fortune": {
        slug: "talismans_of_fortune",
        name: "Talismans of Fortune",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/tap_craze": {
        slug: "tap_craze",
        name: "Tap Craze",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_dead": {
        slug: "temple_of_dead",
        name: "Temple of Dead",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_dead_bonus_buy": {
        slug: "temple_of_dead_bonus_buy",
        name: "Temple of Dead Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_thunder": {
        slug: "temple_of_thunder",
        name: "Temple of Thunder",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_thunder_2": {
        slug: "temple_of_thunder_2",
        name: "Temple of Thunder 2",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_thunder_3": {
        slug: "temple_of_thunder_3",
        name: "Temple of Thunder 3",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_thunder_ii": {
        slug: "temple_of_thunder_ii",
        name: "Temple of Thunder II",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_thunder_ii_bonus_buy": {
        slug: "temple_of_thunder_ii_bonus_buy",
        name: "Temple of Thunder II Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/texas_holdem_poker": {
        slug: "texas_holdem_poker",
        name: "Texas Holdem Poker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/texas_holdem_poker_3d": {
        slug: "texas_holdem_poker_3d",
        name: "Texas Hold'em Poker 3D",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_belt_of_champion_bonus_buy": {
        slug: "the_belt_of_champion_bonus_buy",
        name: "The Belt Of Champion Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_easter_catch": {
        slug: "the_easter_catch",
        name: "The Easter Catch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_emperors_tomb": {
        slug: "the_emperors_tomb",
        name: "The Emperor's Tomb",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_great_conflict": {
        slug: "the_great_conflict",
        name: "The Great Conflict",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_greatest_catch": {
        slug: "the_greatest_catch",
        name: "The Greatest Catch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_greatest_catch_bonus_buy": {
        slug: "the_greatest_catch_bonus_buy",
        name: "The Greatest Catch Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_slavs": {
        slug: "the_slavs",
        name: "The Slavs",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/thimbles": {
        slug: "thimbles",
        name: "Thimbles",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/three_trojan_horses": {
        slug: "three_trojan_horses",
        name: "Three Trojan Horses",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/thunder_mega_sevens": {
        slug: "thunder_mega_sevens",
        name: "Thunder Mega Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/thunder_mega_sevens_bonus_buy": {
        slug: "thunder_mega_sevens_bonus_buy",
        name: "Thunder Mega Sevens Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/train_of_riches_capital_express": {
        slug: "train_of_riches_capital_express",
        name: "Train of Riches Capital Express",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/treasure_snipes": {
        slug: "treasure_snipes",
        name: "Treasure Snipes",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/treasure_snipes_bonus_buy": {
        slug: "treasure_snipes_bonus_buy",
        name: "Treasure Snipes Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/treasure_snipes_christmas": {
        slug: "treasure_snipes_christmas",
        name: "Treasure Snipes: Christmas",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/treasure_snipes_christmas_bonus_buy": {
        slug: "treasure_snipes_christmas_bonus_buy",
        name: "Treasure Snipes: Christmas Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/treasures_of_the_gods": {
        slug: "treasures_of_the_gods",
        name: "Treasures of the Gods",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/tree_of_light_fabled_fruits": {
        slug: "tree_of_light_fabled_fruits",
        name: "Tree of Light Fabled Fruits",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/trick_or_treat_joker": {
        slug: "trick_or_treat_joker",
        name: "Trick or Treat Joker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/triple_chili": {
        slug: "triple_chili",
        name: "Triple Chili",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ultra_reels_fruteria": {
        slug: "ultra_reels_fruteria",
        name: "Ultra Reels Fruteria",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/uncrossable_rush": {
        slug: "uncrossable_rush",
        name: "Uncrossable Rush",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/uncrossable_rush_eggster": {
        slug: "uncrossable_rush_eggster",
        name: "Uncrossable Rush Eggster",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/uncrossable_rush_xmas": {
        slug: "uncrossable_rush_xmas",
        name: "Uncrossable Rush Xmas",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/unlimited_treasures": {
        slug: "unlimited_treasures",
        name: "Unlimited Treasures",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/unlimited_treasures_bonus_buy": {
        slug: "unlimited_treasures_bonus_buy",
        name: "Unlimited Treasures Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/unlimited_wishes": {
        slug: "unlimited_wishes",
        name: "Unlimited Wishes",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/valley_of_dreams": {
        slug: "valley_of_dreams",
        name: "Valley of Dreams",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/vegas_nights": {
        slug: "vegas_nights",
        name: "Vegas Nights",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/velvet_gems": {
        slug: "velvet_gems",
        name: "Velvet Gems",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/venice_festival": {
        slug: "venice_festival",
        name: "Venice Festival",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/video_poker": {
        slug: "video_poker",
        name: "Video Poker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/western_reels": {
        slug: "western_reels",
        name: "Western Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wheel_of_time": {
        slug: "wheel_of_time",
        name: "Wheel of Time",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wild_bullet": {
        slug: "wild_bullet",
        name: "Wild Bullet",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wild_bullets": {
        slug: "wild_bullets",
        name: "Wild Bullets",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wild_overlords": {
        slug: "wild_overlords",
        name: "Wild Overlords",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wild_overlords_bonus_buy": {
        slug: "wild_overlords_bonus_buy",
        name: "Wild Overlords Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wild_pounce": {
        slug: "wild_pounce",
        name: "Wild Pounce",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/winter_star": {
        slug: "winter_star",
        name: "Winter Star",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/winter_star_bonus_buy": {
        slug: "winter_star_bonus_buy",
        name: "Winter Star Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wolf_hiding": {
        slug: "wolf_hiding",
        name: "Wolf Hiding",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wolf_hiding_bonus_buy": {
        slug: "wolf_hiding_bonus_buy",
        name: "Wolf Hiding Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wonder_farm": {
        slug: "wonder_farm",
        name: "Wonder Farm",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wonder_farm_bonus_buy": {
        slug: "wonder_farm_bonus_buy",
        name: "Wonder Farm Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/xdemon": {
        slug: "xdemon",
        name: "X-Demon",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/xdemon_bonus_buy": {
        slug: "xdemon_bonus_buy",
        name: "X-Demon Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/xmas_keno_cat": {
        slug: "xmas_keno_cat",
        name: "Xmas Keno Cat",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/xmas_kenocat": {
        slug: "xmas_kenocat",
        name: "Xmas KenoCat",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_buffalo_coins": {
        slug: "young_buffalo_coins",
        name: "Young Buffalo Coins",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_buffalo_song": {
        slug: "young_buffalo_song",
        name: "Young Buffalo Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_deer_song": {
        slug: "young_deer_song",
        name: "Young Deer Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_eagle_song": {
        slug: "young_eagle_song",
        name: "Young Eagle Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_wolf_song": {
        slug: "young_wolf_song",
        name: "Young Wolf Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "expanse-studios/100_super_icy": {
        slug: "100_super_icy",
        name: "100 Super Icy",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/battle_for_the_throne": {
        slug: "battle_for_the_throne",
        name: "Battle for the throne",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/beach_penalties": {
        slug: "beach_penalties",
        name: "Beach Penalties",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/book_of_eskimo": {
        slug: "book_of_eskimo",
        name: "Book of Eskimo",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/bounty_hunters": {
        slug: "bounty_hunters",
        name: "Bounty Hunters",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/casino_heist": {
        slug: "casino_heist",
        name: "Casino Heist",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/crazy_horses": {
        slug: "crazy_horses",
        name: "Crazy Horses",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/deuces_wild": {
        slug: "deuces_wild",
        name: "Deuces Wild",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/diamond_blackjack": {
        slug: "diamond_blackjack",
        name: "Diamond Blackjack",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/evoji": {
        slug: "evoji",
        name: "Evoji",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/gates_of_olympia": {
        slug: "gates_of_olympia",
        name: "Gates of Olympia",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/gem_miner": {
        slug: "gem_miner",
        name: "Gem Miner",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/god_of_coins": {
        slug: "god_of_coins",
        name: "God of Coins",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/hi_lo": {
        slug: "hi_lo",
        name: "Hi Lo",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/instant_keno": {
        slug: "instant_keno",
        name: "Instant Keno",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/joker_poker": {
        slug: "joker_poker",
        name: "Joker Poker",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/leprechaun_wish": {
        slug: "leprechaun_wish",
        name: "Leprechaun Wish",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/magic_wheel": {
        slug: "magic_wheel",
        name: "Magic Wheel",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/mayas_treasure": {
        slug: "mayas_treasure",
        name: "Maya's treasure",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/pia": {
        slug: "pia",
        name: "Pia",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/pinata_loca": {
        slug: "pinata_loca",
        name: "Pinata Loca",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/pixel_poker": {
        slug: "pixel_poker",
        name: "Pixel Poker",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/planets_power": {
        slug: "planets_power",
        name: "Planets Power",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/rich_panda": {
        slug: "rich_panda",
        name: "Rich Panda",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/shaolin_crew": {
        slug: "shaolin_crew",
        name: "Shaolin Crew",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/spinning_buddha": {
        slug: "spinning_buddha",
        name: "Spinning Buddha",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/super_heli": {
        slug: "super_heli",
        name: "Super Heli",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/swipe": {
        slug: "swipe",
        name: "Swipe",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/titan_roulette": {
        slug: "titan_roulette",
        name: "Titan roulette",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/veni_vidi_vici": {
        slug: "veni_vidi_vici",
        name: "Veni Vidi Vici",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/wild_corrida": {
        slug: "wild_corrida",
        name: "Wild Corrida",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/wild_icy_fruits": {
        slug: "wild_icy_fruits",
        name: "Wild Icy Fruits",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/wild_west_spirit": {
        slug: "wild_west_spirit",
        name: "Wild West Spirit",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/wild_white_whale": {
        slug: "wild_white_whale",
        name: "Wild White Whale",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/win_and_go": {
        slug: "win_and_go",
        name: "Win and Go",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/zombie_apocalypse": {
        slug: "zombie_apocalypse",
        name: "Zombie Apocalypse",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "fantasma/alice_in_adventureland": {
        slug: "alice_in_adventureland",
        name: "Alice in Adventureland",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/animal_carnival": {
        slug: "animal_carnival",
        name: "Animal Carnival",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/bounty_showdown": {
        slug: "bounty_showdown",
        name: "Bounty Showdown",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/caravan_of_riches": {
        slug: "caravan_of_riches",
        name: "Caravan of Riches",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/circle_of_sylvan": {
        slug: "circle_of_sylvan",
        name: "Circle of Sylvan",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/desert_shark": {
        slug: "desert_shark",
        name: "Desert Shark",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/elemento": {
        slug: "elemento",
        name: "Elemento",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/flower_fortunes_supreme": {
        slug: "flower_fortunes_supreme",
        name: "Flower Fortunes Supreme",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/fortune_llama": {
        slug: "fortune_llama",
        name: "Fortune Llama",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/golden_castle_titanways": {
        slug: "golden_castle_titanways",
        name: "Golden Castle TitanWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/hades_river_of_souls": {
        slug: "hades_river_of_souls",
        name: "Hades: River of Souls",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/heroes_hunt_2": {
        slug: "heroes_hunt_2",
        name: "Heroes Hunt 2",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/heroes_hunt_megaways": {
        slug: "heroes_hunt_megaways",
        name: "Heroes Hunt MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/magikspell": {
        slug: "magikspell",
        name: "Magikspell",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/maze_escape_megaways": {
        slug: "maze_escape_megaways",
        name: "Maze Escape MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/medallion_megaways": {
        slug: "medallion_megaways",
        name: "Medallion MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/mystic_spells": {
        slug: "mystic_spells",
        name: "Mystic Spells",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/pirate_multi_coins": {
        slug: "pirate_multi_coins",
        name: "Pirate Multi Coins",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/rich_raptors": {
        slug: "rich_raptors",
        name: "Rich Raptors",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/safari_sun": {
        slug: "safari_sun",
        name: "Safari Sun",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/serpent_shrine": {
        slug: "serpent_shrine",
        name: "Serpent Shrine",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/shadow_summoner_elementals": {
        slug: "shadow_summoner_elementals",
        name: "Shadow Summoner Elementals",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/twisted_turbine": {
        slug: "twisted_turbine",
        name: "Twisted Turbine",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/wins_of_mermaid_multi_power": {
        slug: "wins_of_mermaid_multi_power",
        name: "Wins of Mermaid Multi Power",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/wins_of_winter": {
        slug: "wins_of_winter",
        name: "Wins of Winter",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fbastards/anubis_curse": {
        slug: "anubis_curse",
        name: "Anubis Curse",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/anubis_curse_2": {
        slug: "anubis_curse_2",
        name: "Anubis Curse 2",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/bad_babushkas": {
        slug: "bad_babushkas",
        name: "Bad Babushkas",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/book_of_wizardry": {
        slug: "book_of_wizardry",
        name: "Book of Wizardry",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/bruce_bumerang": {
        slug: "bruce_bumerang",
        name: "Bruce Bumerang",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/cartel_chase": {
        slug: "cartel_chase",
        name: "Cartel Chase",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/crash_squad": {
        slug: "crash_squad",
        name: "Crash Squad",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/crash_squad_winter_party": {
        slug: "crash_squad_winter_party",
        name: "Crash Squad Winter Party",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/cyber_slot": {
        slug: "cyber_slot",
        name: "Cyber slot",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/demon_slayer": {
        slug: "demon_slayer",
        name: "Demon Slayer",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/dia_de_los_muertos": {
        slug: "dia_de_los_muertos",
        name: "Dia De Los Muertos",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/elves": {
        slug: "elves",
        name: "Elves",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/favela_boyz": {
        slug: "favela_boyz",
        name: "Favela Boyz",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/fire_dragon": {
        slug: "fire_dragon",
        name: "Fire dragon",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/football_hooligans": {
        slug: "football_hooligans",
        name: "Football Hooligans",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/frednfire": {
        slug: "frednfire",
        name: "Fred-Nfire",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/goldwins": {
        slug: "goldwins",
        name: "GoldWins",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/jack_win": {
        slug: "jack_win",
        name: "Jack win",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/jokersontop": {
        slug: "jokersontop",
        name: "JokersOnTop",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/jolly_casino": {
        slug: "jolly_casino",
        name: "Jolly casino",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/level20": {
        slug: "level20",
        name: "Level20",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/lucky_farm": {
        slug: "lucky_farm",
        name: "Lucky Farm",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/mafia": {
        slug: "mafia",
        name: "Mafia",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/mindiana_jones": {
        slug: "mindiana_jones",
        name: "Mindiana Jones",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/ocean_party": {
        slug: "ocean_party",
        name: "Ocean party",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/quest": {
        slug: "quest",
        name: "Quest",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/reels": {
        slug: "reels",
        name: "Reels",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/returntovalhalla": {
        slug: "returntovalhalla",
        name: "ReturnToValhalla",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/sit_n_win": {
        slug: "sit_n_win",
        name: "Sit 'N Win",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/skaterboy": {
        slug: "skaterboy",
        name: "SkaterBoy",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/thimbles": {
        slug: "thimbles",
        name: "Thimbles",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/treasure_hunter": {
        slug: "treasure_hunter",
        name: "Treasure Hunter",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/wildndice": {
        slug: "wildndice",
        name: "WildNDice",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/wonder_machine": {
        slug: "wonder_machine",
        name: "Wonder Machine",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/zombie_knight": {
        slug: "zombie_knight",
        name: "Zombie Knight",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "four-leaf-gaming/bloodaxe": {
        slug: "bloodaxe",
        name: "Bloodaxe",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/buffalo_blow": {
        slug: "buffalo_blow",
        name: "Buffalo Blow",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/clover_fortunes": {
        slug: "clover_fortunes",
        name: "Clover Fortunes",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/curse_of_ra": {
        slug: "curse_of_ra",
        name: "Curse of Ra",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/cyber_vault": {
        slug: "cyber_vault",
        name: "Cyber Vault",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/everest": {
        slug: "everest",
        name: "Everest",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/gold_rush_frenzy_megaways": {
        slug: "gold_rush_frenzy_megaways",
        name: "Gold Rush Frenzy Megaways",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/killer_sharks": {
        slug: "killer_sharks",
        name: "Killer Sharks",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/temple_rush": {
        slug: "temple_rush",
        name: "Temple Rush",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/the_3_bears": {
        slug: "the_3_bears",
        name: "The 3 Bears",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/wild_buccaneers_megaways": {
        slug: "wild_buccaneers_megaways",
        name: "Wild Buccaneers MegaWays",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/wild_buccaneers_triple_treasure": {
        slug: "wild_buccaneers_triple_treasure",
        name: "Wild Buccaneers Triple Treasure",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "galaxsys/american_roulette": {
        slug: "american_roulette",
        name: "American Roulette",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/atlantis": {
        slug: "atlantis",
        name: "Atlantis",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/aviashow": {
        slug: "aviashow",
        name: "Aviashow",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/bingo_star": {
        slug: "bingo_star",
        name: "Bingo Star",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/blacjkack": {
        slug: "blacjkack",
        name: "Blacjkack",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/cash_show": {
        slug: "cash_show",
        name: "Cash Show",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/chicken_crash": {
        slug: "chicken_crash",
        name: "Chicken Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/coin_flip": {
        slug: "coin_flip",
        name: "Coin Flip",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/coin_rush": {
        slug: "coin_rush",
        name: "Coin Rush",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/cosmo_saga": {
        slug: "cosmo_saga",
        name: "Cosmo Saga",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/crash": {
        slug: "crash",
        name: "Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/crasher": {
        slug: "crasher",
        name: "Crasher",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/deep_sea_wild": {
        slug: "deep_sea_wild",
        name: "Deep Sea Wild",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/dr_shocker": {
        slug: "dr_shocker",
        name: "Dr. Shocker",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/el_dorado": {
        slug: "el_dorado",
        name: "El Dorado",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/figoal": {
        slug: "figoal",
        name: "Figoal",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/fmines": {
        slug: "fmines",
        name: "Fmines",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/fruity_wilds": {
        slug: "fruity_wilds",
        name: "Fruity Wilds",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/funny_faces_hoglet_moglet": {
        slug: "funny_faces_hoglet_moglet",
        name: "Funny Faces Hoglet Moglet",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/galaxsys_leaderboard": {
        slug: "galaxsys_leaderboard",
        name: "Galaxsys Leaderboard",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/gangsta_piggy_hold_and_win": {
        slug: "gangsta_piggy_hold_and_win",
        name: "Gangsta Piggy Hold and Win",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/gates_of_asgard_nine_realms": {
        slug: "gates_of_asgard_nine_realms",
        name: "Gates of Asgard Nine Realms",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/golden_ra": {
        slug: "golden_ra",
        name: "Golden Ra",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/guardians_of_glory": {
        slug: "guardians_of_glory",
        name: "Guardians of Glory",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/hamster_mania": {
        slug: "hamster_mania",
        name: "Hamster Mania",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/hilo": {
        slug: "hilo",
        name: "Hilo",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/hot_gear": {
        slug: "hot_gear",
        name: "Hot Gear",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/hungry_wolf": {
        slug: "hungry_wolf",
        name: "Hungry Wolf",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/infinity": {
        slug: "infinity",
        name: "Infinity",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/instawin": {
        slug: "instawin",
        name: "Instawin",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/jungle_wheel": {
        slug: "jungle_wheel",
        name: "Jungle Wheel",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno_10_1_minute": {
        slug: "keno_10_1_minute",
        name: "Keno 10 1 Minute",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno_10_2_minutes": {
        slug: "keno_10_2_minutes",
        name: "Keno 10 2 Minutes",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno_8_1_minute": {
        slug: "keno_8_1_minute",
        name: "Keno 8 1 Minute",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno_8_2_minutes": {
        slug: "keno_8_2_minutes",
        name: "Keno 8 2 Minutes",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno_express": {
        slug: "keno_express",
        name: "Keno Express",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno8_1": {
        slug: "keno8_1",
        name: "Keno8_1",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/king_of_ocean": {
        slug: "king_of_ocean",
        name: "King of Ocean",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/knife_drop": {
        slug: "knife_drop",
        name: "Knife Drop",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/limbo_crash": {
        slug: "limbo_crash",
        name: "Limbo Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/lottoboom": {
        slug: "lottoboom",
        name: "LottoBoom",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/maestro": {
        slug: "maestro",
        name: "Maestro",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/magic_dice": {
        slug: "magic_dice",
        name: "Magic Dice",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/mr_thimble": {
        slug: "mr_thimble",
        name: "Mr Thimble",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/ninja_crash": {
        slug: "ninja_crash",
        name: "Ninja Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/olympian_legends": {
        slug: "olympian_legends",
        name: "Olympian Legends",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/penalty": {
        slug: "penalty",
        name: "Penalty",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/play_me": {
        slug: "play_me",
        name: "Play Me",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/plinko_dice": {
        slug: "plinko_dice",
        name: "Plinko Dice",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/plinkoman": {
        slug: "plinkoman",
        name: "Plinkoman",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/rocketon": {
        slug: "rocketon",
        name: "Rocketon",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/roulette_x": {
        slug: "roulette_x",
        name: "Roulette X",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/scratch_map": {
        slug: "scratch_map",
        name: "Scratch Map",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/sicbo": {
        slug: "sicbo",
        name: "SicBo",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/slap_shot": {
        slug: "slap_shot",
        name: "Slap Shot",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/starlight": {
        slug: "starlight",
        name: "Starlight",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/totem": {
        slug: "totem",
        name: "Totem",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/tower_rush": {
        slug: "tower_rush",
        name: "Tower Rush",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/turbo_mines": {
        slug: "turbo_mines",
        name: "Turbo Mines",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "gametech/abduction": {
        slug: "abduction",
        name: "Abduction",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/awesome_penguin": {
        slug: "awesome_penguin",
        name: "Awesome Penguin",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/beat_box": {
        slug: "beat_box",
        name: "Beat Box",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/blood_moon": {
        slug: "blood_moon",
        name: "Blood Moon",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/changing_face": {
        slug: "changing_face",
        name: "Changing Face",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/chaos_royale": {
        slug: "chaos_royale",
        name: "Chaos Royale",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/end_of_edo": {
        slug: "end_of_edo",
        name: "End Of Edo",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/four_sacred_souls": {
        slug: "four_sacred_souls",
        name: "Four Sacred Souls",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/great_beauties_of_china": {
        slug: "great_beauties_of_china",
        name: "Great Beauties of China",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/journey_to_the_gold": {
        slug: "journey_to_the_gold",
        name: "Journey to the Gold",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/kokeshi": {
        slug: "kokeshi",
        name: "Kokeshi",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/league_of_conquerors": {
        slug: "league_of_conquerors",
        name: "League of Conquerors",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/money_royale": {
        slug: "money_royale",
        name: "Money Royale",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/monster_quest": {
        slug: "monster_quest",
        name: "Monster Quest",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/neo_tokyo": {
        slug: "neo_tokyo",
        name: "Neo Tokyo",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/nezha": {
        slug: "nezha",
        name: "Nezha",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/niuniu": {
        slug: "niuniu",
        name: "NiuNiu",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/piggy_bank_millionaire": {
        slug: "piggy_bank_millionaire",
        name: "Piggy Bank Millionaire",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/power_of_elements": {
        slug: "power_of_elements",
        name: "Power of Elements",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/shiba_inu": {
        slug: "shiba_inu",
        name: "Shiba Inu",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/smash_and_crash": {
        slug: "smash_and_crash",
        name: "Smash and Crash",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/space_girl": {
        slug: "space_girl",
        name: "Space Girl",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/sumie": {
        slug: "sumie",
        name: "Sumi-E",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/sushicade": {
        slug: "sushicade",
        name: "Sushicade",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/tokyo_kombat": {
        slug: "tokyo_kombat",
        name: "Tokyo Kombat",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/ukiyoe": {
        slug: "ukiyoe",
        name: "Ukiyo-e",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gamevy/100k_joker": {
        slug: "100k_joker",
        name: "100k Joker",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/10p_10c_slot": {
        slug: "10p_10c_slot",
        name: "10p 10c Slot",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/10p_roulette": {
        slug: "10p_roulette",
        name: "10p Roulette",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/250k_deluxe": {
        slug: "250k_deluxe",
        name: "250k Deluxe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/500k_heist": {
        slug: "500k_heist",
        name: "500K Heist",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/7_11_21": {
        slug: "7_11_21",
        name: "7 11 21",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/777": {
        slug: "777",
        name: "777",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/7up": {
        slug: "7up",
        name: "7UP!",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/age_of_athena": {
        slug: "age_of_athena",
        name: "Age of Athena",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/american_roulette": {
        slug: "american_roulette",
        name: "American Roulette",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/atomic_monkey": {
        slug: "atomic_monkey",
        name: "Atomic Monkey",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/banana_split": {
        slug: "banana_split",
        name: "Banana Split",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/big_fishin_bounty": {
        slug: "big_fishin_bounty",
        name: "Big Fishin' Bounty",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/bingo": {
        slug: "bingo",
        name: "Bingo",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/bingo_75": {
        slug: "bingo_75",
        name: "Bingo 75",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/blitz_of_olympus": {
        slug: "blitz_of_olympus",
        name: "Blitz of Olympus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/bonsai_spins": {
        slug: "bonsai_spins",
        name: "Bonsai Spins",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/boss_the_lotto": {
        slug: "boss_the_lotto",
        name: "Boss The Lotto",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/calavera_bingo": {
        slug: "calavera_bingo",
        name: "Calavera Bingo",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/cash_cubes_trio_bonus": {
        slug: "cash_cubes_trio_bonus",
        name: "Cash Cubes Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/casino_scratch": {
        slug: "casino_scratch",
        name: "Casino Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/casino_solitaire": {
        slug: "casino_solitaire",
        name: "Casino Solitaire",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/cheeky_fruits": {
        slug: "cheeky_fruits",
        name: "Cheeky Fruits",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/cheeky_fruits_6_deluxe": {
        slug: "cheeky_fruits_6_deluxe",
        name: "Cheeky Fruits 6 Deluxe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/cheeky_fruits_6_royale": {
        slug: "cheeky_fruits_6_royale",
        name: "Cheeky Fruits 6 Royale",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/cheeky_fruits_split": {
        slug: "cheeky_fruits_split",
        name: "Cheeky Fruits Split",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/cheeky_fruits_trio_bonus": {
        slug: "cheeky_fruits_trio_bonus",
        name: "Cheeky Fruits Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/chocolossus": {
        slug: "chocolossus",
        name: "Chocolossus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/christmas_deal": {
        slug: "christmas_deal",
        name: "Christmas Deal",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/christmas_in_papertown": {
        slug: "christmas_in_papertown",
        name: "Christmas in Papertown",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/clover_rainbow": {
        slug: "clover_rainbow",
        name: "Clover Rainbow",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/clover_rainbow_6_deluxe": {
        slug: "clover_rainbow_6_deluxe",
        name: "Clover Rainbow 6 Deluxe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/coin_conqueror": {
        slug: "coin_conqueror",
        name: "Coin Conqueror",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/cthulhu": {
        slug: "cthulhu",
        name: "Cthulhu",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/dead_mans_fingers": {
        slug: "dead_mans_fingers",
        name: "Dead Man's Fingers",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/diamond_deal": {
        slug: "diamond_deal",
        name: "Diamond Deal",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/diamond_digger": {
        slug: "diamond_digger",
        name: "Diamond Digger",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/diamonds_scratch": {
        slug: "diamonds_scratch",
        name: "Diamonds Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/dragon_trio_bonus": {
        slug: "dragon_trio_bonus",
        name: "Dragon: Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/eastern_gold": {
        slug: "eastern_gold",
        name: "Eastern Gold",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/eastern_gold_6_deluxe": {
        slug: "eastern_gold_6_deluxe",
        name: "Eastern Gold 6 Deluxe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/el_diablo": {
        slug: "el_diablo",
        name: "El Diablo",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/elephant": {
        slug: "elephant",
        name: "Elephant",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/elite_of_evil_portal_of_gold": {
        slug: "elite_of_evil_portal_of_gold",
        name: "Elite of Evil - Portal of Gold",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/elite_of_evil_the_first_quest": {
        slug: "elite_of_evil_the_first_quest",
        name: "Elite of Evil: The First Quest",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/emotional_damage": {
        slug: "emotional_damage",
        name: "Emotional Damage",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/epic_crystal": {
        slug: "epic_crystal",
        name: "Epic Crystal",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/epic_crystal_deluxe": {
        slug: "epic_crystal_deluxe",
        name: "Epic Crystal Deluxe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/epic_gems": {
        slug: "epic_gems",
        name: "Epic Gems",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/european_roulette_dark_mode": {
        slug: "european_roulette_dark_mode",
        name: "European Roulette - Dark Mode",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/fishing_trawler": {
        slug: "fishing_trawler",
        name: "Fishing Trawler",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/football": {
        slug: "football",
        name: "Football",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/fortune_scratch": {
        slug: "fortune_scratch",
        name: "Fortune Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/fruit_punch_up": {
        slug: "fruit_punch_up",
        name: "Fruit Punch Up",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/fruity_flurry": {
        slug: "fruity_flurry",
        name: "Fruity Flurry",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/funkfest_bonanza": {
        slug: "funkfest_bonanza",
        name: "Funkfest Bonanza",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/gingerdead": {
        slug: "gingerdead",
        name: "Gingerdead",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/ho_ho_ho": {
        slug: "ho_ho_ho",
        name: "Ho Ho Ho",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/horse_trio_bonus": {
        slug: "horse_trio_bonus",
        name: "Horse Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/horseshoe": {
        slug: "horseshoe",
        name: "Horseshoe",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/indi": {
        slug: "indi",
        name: "Indi",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/inferno_fortune": {
        slug: "inferno_fortune",
        name: "Inferno Fortune",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/instant_bingo": {
        slug: "instant_bingo",
        name: "Instant Bingo",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/jingle_up": {
        slug: "jingle_up",
        name: "Jingle Up",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/juice_trio_bonus": {
        slug: "juice_trio_bonus",
        name: "J.U.I.C.E Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/kitty_puzzle": {
        slug: "kitty_puzzle",
        name: "Kitty Puzzle",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/legend_of_perseus": {
        slug: "legend_of_perseus",
        name: "Legend of Perseus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/leprechauns_luck_emporium": {
        slug: "leprechauns_luck_emporium",
        name: "Leprechaun's Luck Emporium",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/locktoberfest": {
        slug: "locktoberfest",
        name: "Locktoberfest",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/lost_treasure_of_tortuga": {
        slug: "lost_treasure_of_tortuga",
        name: "Lost Treasure of Tortuga",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/lucky_day_cheltenham_champions": {
        slug: "lucky_day_cheltenham_champions",
        name: "Lucky Day: Cheltenham Champions",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/lucky_day_christmas_cashcade": {
        slug: "lucky_day_christmas_cashcade",
        name: "Lucky Day: Christmas Cashcade",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/lucky_day_football_gold": {
        slug: "lucky_day_football_gold",
        name: "Lucky Day: Football Gold",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/lucky_day_mega_hallowin": {
        slug: "lucky_day_mega_hallowin",
        name: "Lucky Day: Mega Hallowin",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/lucky_day_summer_spike": {
        slug: "lucky_day_summer_spike",
        name: "Lucky Day: Summer Spike",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/lucky_lions_wild_life": {
        slug: "lucky_lions_wild_life",
        name: "Lucky Lions: Wild Life",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/lucky_piper": {
        slug: "lucky_piper",
        name: "Lucky Piper",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/magic_scratch": {
        slug: "magic_scratch",
        name: "Magic Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/midnight_jackpots_5000": {
        slug: "midnight_jackpots_5000",
        name: "Midnight Jackpots 5000",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/midnight_pursuit": {
        slug: "midnight_pursuit",
        name: "Midnight Pursuit",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/million_book": {
        slug: "million_book",
        name: "Million Book",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/moon_of_thoth": {
        slug: "moon_of_thoth",
        name: "Moon of Thoth",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/mummy_mia": {
        slug: "mummy_mia",
        name: "Mummy Mia",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/nerves_of_steal": {
        slug: "nerves_of_steal",
        name: "Nerves of Steal",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/nest_egg_trio_bonus": {
        slug: "nest_egg_trio_bonus",
        name: "Nest Egg Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/pizza_time": {
        slug: "pizza_time",
        name: "Pizza Time",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/platinum_roulette": {
        slug: "platinum_roulette",
        name: "Platinum Roulette",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/psycho_candies": {
        slug: "psycho_candies",
        name: "Psycho Candies",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/quest": {
        slug: "quest",
        name: "Quest",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/raid_the_piggy_bank": {
        slug: "raid_the_piggy_bank",
        name: "Raid the Piggy Bank",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/red_card": {
        slug: "red_card",
        name: "Red Card",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/retro_solitaire": {
        slug: "retro_solitaire",
        name: "Retro Solitaire",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/retropia": {
        slug: "retropia",
        name: "Retropia",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/rolling_start_usa": {
        slug: "rolling_start_usa",
        name: "Rolling Start USA",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/scarab_rising": {
        slug: "scarab_rising",
        name: "Scarab Rising",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/serendipity": {
        slug: "serendipity",
        name: "Serendipity",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/serendipity_deluxe_6": {
        slug: "serendipity_deluxe_6",
        name: "Serendipity Deluxe 6",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/snake_trio_bonus": {
        slug: "snake_trio_bonus",
        name: "Snake Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/space_force": {
        slug: "space_force",
        name: "Space Force",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/spingotts_trio_bonus": {
        slug: "spingotts_trio_bonus",
        name: "Spingotts Trio Bonus",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/spinlotto": {
        slug: "spinlotto",
        name: "Spinlotto",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/spinlotto_scratch": {
        slug: "spinlotto_scratch",
        name: "Spinlotto Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/squeak": {
        slug: "squeak",
        name: "Squeak",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/starsign_clusters": {
        slug: "starsign_clusters",
        name: "Starsign Clusters",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/stuffed_with_100s": {
        slug: "stuffed_with_100s",
        name: "Stuffed with 100s",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/super_shamrock": {
        slug: "super_shamrock",
        name: "Super Shamrock",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/tennis_scratch": {
        slug: "tennis_scratch",
        name: "Tennis Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/the_good_the_bad_and_the_ugly": {
        slug: "the_good_the_bad_and_the_ugly",
        name: "The Good, The Bad and the Ugly",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/the_link": {
        slug: "the_link",
        name: "The Link",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/the_link_scratch": {
        slug: "the_link_scratch",
        name: "The Link Scratch",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/thors_egg_hunt": {
        slug: "thors_egg_hunt",
        name: "Thor's Egg Hunt",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/tiger_tiger": {
        slug: "tiger_tiger",
        name: "Tiger Tiger",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/tnt_extravaganza": {
        slug: "tnt_extravaganza",
        name: "TNT Extravaganza",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/tomatina_bingo": {
        slug: "tomatina_bingo",
        name: "Tomatina Bingo",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/tomb_of_the_king": {
        slug: "tomb_of_the_king",
        name: "Tomb of the King",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/turbo_roulette": {
        slug: "turbo_roulette",
        name: "Turbo Roulette",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/vegans_vs_vampires": {
        slug: "vegans_vs_vampires",
        name: "Vegans vs Vampires",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/vegas_blackjack": {
        slug: "vegas_blackjack",
        name: "Vegas Blackjack",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/vegas_solitaire": {
        slug: "vegas_solitaire",
        name: "Vegas Solitaire",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/vomiting_unicorns": {
        slug: "vomiting_unicorns",
        name: "Vomiting Unicorns",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/wild_herd": {
        slug: "wild_herd",
        name: "Wild Herd",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/world_cup_roulette_platinum": {
        slug: "world_cup_roulette_platinum",
        name: "World Cup Roulette Platinum",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/zeldars_fortunes": {
        slug: "zeldars_fortunes",
        name: "Zeldar's Fortunes",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/zeus_rising": {
        slug: "zeus_rising",
        name: "Zeus Rising",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamevy/zodiac": {
        slug: "zodiac",
        name: "Zodiac",
        provider: "Gamevy",
        providerSlug: "gamevy"
    },
    "gamomat-games/100_flaring_fruits": {
        slug: "100_flaring_fruits",
        name: "100 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/20_ember_wilds": {
        slug: "20_ember_wilds",
        name: "20 Ember Wilds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/20_flaring_fruits": {
        slug: "20_flaring_fruits",
        name: "20 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/40_finest_xxl": {
        slug: "40_finest_xxl",
        name: "40 Finest XXL",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/40_finest_xxl_flaming_link": {
        slug: "40_finest_xxl_flaming_link",
        name: "40 Finest XXL Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/5_ember_wilds": {
        slug: "5_ember_wilds",
        name: "5 Ember Wilds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/5_flaring_fruits": {
        slug: "5_flaring_fruits",
        name: "5 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/50_flaring_fruits": {
        slug: "50_flaring_fruits",
        name: "50 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/alexandria_fire": {
        slug: "alexandria_fire",
        name: "Alexandria Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ancient_magic": {
        slug: "ancient_magic",
        name: "Ancient Magic",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ancient_riches": {
        slug: "ancient_riches",
        name: "Ancient Riches",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ancient_riches_rhfp": {
        slug: "ancient_riches_rhfp",
        name: "Ancient Riches RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/atlantic_wilds": {
        slug: "atlantic_wilds",
        name: "Atlantic Wilds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/aura_of_jupiter": {
        slug: "aura_of_jupiter",
        name: "Aura of Jupiter",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/aura_of_jupiter_ccs": {
        slug: "aura_of_jupiter_ccs",
        name: "Aura of Jupiter CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/back_to_the_fruits": {
        slug: "back_to_the_fruits",
        name: "Back to the Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/back_to_the_fruits_respins_of_amunre": {
        slug: "back_to_the_fruits_respins_of_amunre",
        name: "Back to the Fruits Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/beautiful_nature": {
        slug: "beautiful_nature",
        name: "Beautiful Nature",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/beer_party": {
        slug: "beer_party",
        name: "Beer Party",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/black_beauty": {
        slug: "black_beauty",
        name: "Black Beauty",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_ages": {
        slug: "book_of_ages",
        name: "Book of Ages",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_crazy_chicken_gdn": {
        slug: "book_of_crazy_chicken_gdn",
        name: "Book of Crazy Chicken GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_elements": {
        slug: "book_of_elements",
        name: "Book of Elements",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_juno": {
        slug: "book_of_juno",
        name: "Book of Juno",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_madness": {
        slug: "book_of_madness",
        name: "Book of Madness",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_madness_2": {
        slug: "book_of_madness_2",
        name: "Book of Madness 2",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_madness_deluxe": {
        slug: "book_of_madness_deluxe",
        name: "Book Of Madness Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_madness_flaming_link": {
        slug: "book_of_madness_flaming_link",
        name: "Book of Madness Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_madness_respins_of_amunre": {
        slug: "book_of_madness_respins_of_amunre",
        name: "Book of Madness Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_oasis": {
        slug: "book_of_oasis",
        name: "Book of Oasis",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_romeo_and_julia": {
        slug: "book_of_romeo_and_julia",
        name: "Book of Romeo and Julia",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/book_of_romeo_and_julia_gdn": {
        slug: "book_of_romeo_and_julia_gdn",
        name: "Book of Romeo and Julia GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/books_and_bounties": {
        slug: "books_and_bounties",
        name: "Books & Bounties",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/books_and_bulls": {
        slug: "books_and_bulls",
        name: "Books and Bulls",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/books_and_bulls_gdn": {
        slug: "books_and_bulls_gdn",
        name: "Books and Bulls GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/books_and_bulls_rhfp": {
        slug: "books_and_bulls_rhfp",
        name: "Books and Bulls RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/books_and_pearls": {
        slug: "books_and_pearls",
        name: "Books and Pearls",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/books_and_pearls_respins_of_amunre": {
        slug: "books_and_pearls_respins_of_amunre",
        name: "Books and Pearls Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/books_and_temples": {
        slug: "books_and_temples",
        name: "Books and Temples",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/crystal_ball": {
        slug: "crystal_ball",
        name: "Crystal Ball",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/crystal_ball_deluxe": {
        slug: "crystal_ball_deluxe",
        name: "Crystal Ball Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/crystal_ball_flaming_link": {
        slug: "crystal_ball_flaming_link",
        name: "Crystal Ball Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/crystal_ball_gdn": {
        slug: "crystal_ball_gdn",
        name: "Crystal Ball GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/crystal_ball_multi_symbols": {
        slug: "crystal_ball_multi_symbols",
        name: "Crystal Ball Multi Symbols",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/crystal_ball_rhfp": {
        slug: "crystal_ball_rhfp",
        name: "Crystal Ball RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/crystal_burst_xxl": {
        slug: "crystal_burst_xxl",
        name: "Crystal Burst XXL",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/crystal_strike": {
        slug: "crystal_strike",
        name: "Crystal Strike",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/cutie_cat": {
        slug: "cutie_cat",
        name: "Cutie Cat",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/cutie_cat_ccs": {
        slug: "cutie_cat_ccs",
        name: "Cutie Cat CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/dead_legion": {
        slug: "dead_legion",
        name: "Dead Legion",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/disc_of_athena": {
        slug: "disc_of_athena",
        name: "Disc of Athena",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/divine_fire": {
        slug: "divine_fire",
        name: "Divine Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/dragon_of_the_princess": {
        slug: "dragon_of_the_princess",
        name: "Dragon of the Princess",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/duck_shooter": {
        slug: "duck_shooter",
        name: "Duck Shooter",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/duck_shooter_ccs": {
        slug: "duck_shooter_ccs",
        name: "Duck Shooter CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/expanding_fireworks": {
        slug: "expanding_fireworks",
        name: "Expanding Fireworks",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/explodiac": {
        slug: "explodiac",
        name: "Explodiac",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/explodiac_rhfp": {
        slug: "explodiac_rhfp",
        name: "Explodiac RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fancy_fruits": {
        slug: "fancy_fruits",
        name: "Fancy Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fancy_fruits_ccs": {
        slug: "fancy_fruits_ccs",
        name: "Fancy Fruits CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fancy_fruits_deluxe": {
        slug: "fancy_fruits_deluxe",
        name: "Fancy Fruits Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fancy_fruits_flaming_link": {
        slug: "fancy_fruits_flaming_link",
        name: "Fancy Fruits Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fancy_fruits_gdn": {
        slug: "fancy_fruits_gdn",
        name: "Fancy Fruits GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fancy_fruits_respins_of_amunre": {
        slug: "fancy_fruits_respins_of_amunre",
        name: "Fancy Fruits Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fancy_fruits_rhfp": {
        slug: "fancy_fruits_rhfp",
        name: "Fancy Fruits RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fengs_fortune": {
        slug: "fengs_fortune",
        name: "Feng's Fortune",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/football_super_spins": {
        slug: "football_super_spins",
        name: "Football Super Spins",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/forever_diamonds": {
        slug: "forever_diamonds",
        name: "Forever Diamonds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fort_brave": {
        slug: "fort_brave",
        name: "Fort Brave",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/frooty_troupe_game_on_94": {
        slug: "frooty_troupe_game_on_94",
        name: "Frooty Troupe Game On 94",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/frooty_troupe_gold_club": {
        slug: "frooty_troupe_gold_club",
        name: "Frooty Troupe Gold Club",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/frooty_troupe_sun_splash": {
        slug: "frooty_troupe_sun_splash",
        name: "Frooty Troupe Sun Splash",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fruit_love": {
        slug: "fruit_love",
        name: "Fruit Love",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fruit_mania": {
        slug: "fruit_mania",
        name: "Fruit Mania",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fruit_mania_deluxe": {
        slug: "fruit_mania_deluxe",
        name: "Fruit Mania Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fruit_mania_flaming_link": {
        slug: "fruit_mania_flaming_link",
        name: "Fruit Mania Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fruit_mania_gdn": {
        slug: "fruit_mania_gdn",
        name: "Fruit Mania GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fruit_mania_rhfp": {
        slug: "fruit_mania_rhfp",
        name: "Fruit Mania RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/fruit_rush": {
        slug: "fruit_rush",
        name: "Fruit Rush",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/gates_of_persia": {
        slug: "gates_of_persia",
        name: "Gates of Persia",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/glamorous_times": {
        slug: "glamorous_times",
        name: "Glamorous Times",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/golden_egg_of_crazy_chicken": {
        slug: "golden_egg_of_crazy_chicken",
        name: "Golden Egg of Crazy Chicken",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/golden_egg_of_crazy_chicken_ccs": {
        slug: "golden_egg_of_crazy_chicken_ccs",
        name: "Golden Egg of Crazy Chicken CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/golden_touch": {
        slug: "golden_touch",
        name: "Golden Touch",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/great_grizzly": {
        slug: "great_grizzly",
        name: "Great Grizzly",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/great_warrior": {
        slug: "great_warrior",
        name: "Great Warrior",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/hellfire": {
        slug: "hellfire",
        name: "Hellfire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/juicy_joker": {
        slug: "juicy_joker",
        name: "Juicy Joker",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/king_and_queen": {
        slug: "king_and_queen",
        name: "King and Queen",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/king_of_the_jungle": {
        slug: "king_of_the_jungle",
        name: "King of the Jungle",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/king_of_the_jungle_gdn": {
        slug: "king_of_the_jungle_gdn",
        name: "King of the Jungle GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/king_of_the_jungle_rhfp": {
        slug: "king_of_the_jungle_rhfp",
        name: "King of the Jungle RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/la_dolce_vita": {
        slug: "la_dolce_vita",
        name: "La Dolce Vita",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/la_dolce_vita_2": {
        slug: "la_dolce_vita_2",
        name: "La Dolce Vita 2",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/la_dolce_vita_deluxe": {
        slug: "la_dolce_vita_deluxe",
        name: "La Dolce Vita Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/la_dolce_vita_flaming_link": {
        slug: "la_dolce_vita_flaming_link",
        name: "La Dolce Vita Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/la_dolce_vita_gdn": {
        slug: "la_dolce_vita_gdn",
        name: "La Dolce Vita GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/la_dolce_vita_rhfp": {
        slug: "la_dolce_vita_rhfp",
        name: "La Dolce Vita RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/land_of_heroes": {
        slug: "land_of_heroes",
        name: "Land of Heroes",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/land_of_heroes_gdn": {
        slug: "land_of_heroes_gdn",
        name: "Land of Heroes GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/lava_lions": {
        slug: "lava_lions",
        name: "Lava Lions",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/legacy_of_ramses_book": {
        slug: "legacy_of_ramses_book",
        name: "Legacy of Ramses Book",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/maaax_diamonds": {
        slug: "maaax_diamonds",
        name: "Maaax Diamonds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/maaax_diamonds_christmas_edition": {
        slug: "maaax_diamonds_christmas_edition",
        name: "Maaax Diamonds Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/maaax_diamonds_deluxe": {
        slug: "maaax_diamonds_deluxe",
        name: "Maaax Diamonds Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/maaax_diamonds_flaming_link": {
        slug: "maaax_diamonds_flaming_link",
        name: "Maaax Diamonds Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/maaax_diamonds_gdn": {
        slug: "maaax_diamonds_gdn",
        name: "Maaax Diamonds GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/magic_stone": {
        slug: "magic_stone",
        name: "Magic Stone",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/mayan_fire": {
        slug: "mayan_fire",
        name: "Mayan Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/mighty_dragon": {
        slug: "mighty_dragon",
        name: "Mighty Dragon",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/monkey_mania": {
        slug: "monkey_mania",
        name: "Monkey Mania",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/multi_machine": {
        slug: "multi_machine",
        name: "Multi Machine",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/night_wolves": {
        slug: "night_wolves",
        name: "Night Wolves",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/nordic_fire": {
        slug: "nordic_fire",
        name: "Nordic Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/old_fisherman": {
        slug: "old_fisherman",
        name: "Old Fisherman",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/phantoms_mirror": {
        slug: "phantoms_mirror",
        name: "Phantom's Mirror",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/pharaos_riches": {
        slug: "pharaos_riches",
        name: "Pharao's Riches",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/pharaos_riches_gdn": {
        slug: "pharaos_riches_gdn",
        name: "Pharao's Riches GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/pharaos_riches_rhfp": {
        slug: "pharaos_riches_rhfp",
        name: "Pharao's Riches RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ramses_book": {
        slug: "ramses_book",
        name: "Ramses Book",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ramses_book_christmas_edition": {
        slug: "ramses_book_christmas_edition",
        name: "Ramses Book Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ramses_book_deluxe": {
        slug: "ramses_book_deluxe",
        name: "Ramses Book Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ramses_book_easter_edition": {
        slug: "ramses_book_easter_edition",
        name: "Ramses Book Easter Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ramses_book_flaming_link": {
        slug: "ramses_book_flaming_link",
        name: "Ramses Book Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ramses_book_gdn": {
        slug: "ramses_book_gdn",
        name: "Ramses Book GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ramses_book_respins_of_amunre": {
        slug: "ramses_book_respins_of_amunre",
        name: "Ramses Book Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/ramses_book_rhfp": {
        slug: "ramses_book_rhfp",
        name: "Ramses Book RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/roman_legion": {
        slug: "roman_legion",
        name: "Roman Legion",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/roman_legion_deluxe": {
        slug: "roman_legion_deluxe",
        name: "Roman Legion Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/roman_legion_extreme": {
        slug: "roman_legion_extreme",
        name: "Roman Legion Extreme",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/roman_legion_extreme_rhfp": {
        slug: "roman_legion_extreme_rhfp",
        name: "Roman Legion Extreme RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/roman_legion_flaming_link": {
        slug: "roman_legion_flaming_link",
        name: "Roman Legion Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/roman_legion_gdn": {
        slug: "roman_legion_gdn",
        name: "Roman Legion GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royal_7_xxl_rhfp": {
        slug: "royal_7_xxl_rhfp",
        name: "Royal 7 XXL RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royal_seven": {
        slug: "royal_seven",
        name: "Royal Seven",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royal_seven_deluxe": {
        slug: "royal_seven_deluxe",
        name: "Royal Seven Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royal_seven_flaming_link": {
        slug: "royal_seven_flaming_link",
        name: "Royal Seven Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royal_seven_gdn": {
        slug: "royal_seven_gdn",
        name: "Royal Seven GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royal_seven_ultra": {
        slug: "royal_seven_ultra",
        name: "Royal Seven Ultra",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royal_seven_ultra_flaming_link": {
        slug: "royal_seven_ultra_flaming_link",
        name: "Royal Seven Ultra Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royal_seven_xxl": {
        slug: "royal_seven_xxl",
        name: "Royal Seven XXL",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royal_seven_xxl_easter_edition": {
        slug: "royal_seven_xxl_easter_edition",
        name: "Royal Seven XXL Easter Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royal_seven_xxl_flaming_link": {
        slug: "royal_seven_xxl_flaming_link",
        name: "Royal Seven XXL Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/royale_seven_deluxe_xxl_deluxe": {
        slug: "royale_seven_deluxe_xxl_deluxe",
        name: "Royale Seven Deluxe XXL Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/savanna_moon": {
        slug: "savanna_moon",
        name: "Savanna Moon",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/sevens_and_books": {
        slug: "sevens_and_books",
        name: "Sevens & Books",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/sevens_fire": {
        slug: "sevens_fire",
        name: "Sevens Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/shoguns_secret": {
        slug: "shoguns_secret",
        name: "Shogun's Secret",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/shoguns_secret_ccs": {
        slug: "shoguns_secret_ccs",
        name: "Shogun's Secret CCS",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/simply_the_best": {
        slug: "simply_the_best",
        name: "Simply the Best",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/stacks_of_jacks": {
        slug: "stacks_of_jacks",
        name: "Stacks of Jacks",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/sticky_diamonds": {
        slug: "sticky_diamonds",
        name: "Sticky Diamonds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/sticky_diamonds_easter_egg": {
        slug: "sticky_diamonds_easter_egg",
        name: "Sticky Diamonds Easter Egg",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/sticky_diamonds_flaming_link_94": {
        slug: "sticky_diamonds_flaming_link_94",
        name: "Sticky Diamonds Flaming Link 94",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/sticky_diamonds_rhfp": {
        slug: "sticky_diamonds_rhfp",
        name: "Sticky Diamonds RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/sunny_sevens": {
        slug: "sunny_sevens",
        name: "Sunny Sevens",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/super_duper_cherry": {
        slug: "super_duper_cherry",
        name: "Super Duper Cherry",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/super_duper_cherry_rhfp": {
        slug: "super_duper_cherry_rhfp",
        name: "Super Duper Cherry RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/take_5": {
        slug: "take_5",
        name: "Take 5",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/take_5_christmas_edition": {
        slug: "take_5_christmas_edition",
        name: "Take 5 Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/take_5_gdn": {
        slug: "take_5_gdn",
        name: "Take 5 GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/take_5_rhfp": {
        slug: "take_5_rhfp",
        name: "Take 5 RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/the_book_beyond": {
        slug: "the_book_beyond",
        name: "The Book Beyond",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/the_book_beyond_2": {
        slug: "the_book_beyond_2",
        name: "The Book Beyond 2",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/the_expandable": {
        slug: "the_expandable",
        name: "The Expandable",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/the_mighty_king": {
        slug: "the_mighty_king",
        name: "The Mighty King",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/tower_of_power": {
        slug: "tower_of_power",
        name: "Tower of Power",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/vegas_joker": {
        slug: "vegas_joker",
        name: "Vegas Joker",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/western_jack": {
        slug: "western_jack",
        name: "Western Jack",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/wild_rubies": {
        slug: "wild_rubies",
        name: "Wild Rubies",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/wild_rubies_christmas_edition": {
        slug: "wild_rubies_christmas_edition",
        name: "Wild Rubies Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/wild_rubies_gdn": {
        slug: "wild_rubies_gdn",
        name: "Wild Rubies GDN",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/wild_rubies_rhfp": {
        slug: "wild_rubies_rhfp",
        name: "Wild Rubies RHFP",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/wilds_gone_wild": {
        slug: "wilds_gone_wild",
        name: "Wilds Gone Wild",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/win_blaster": {
        slug: "win_blaster",
        name: "Win Blaster",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/win_blaster_christmas_edition": {
        slug: "win_blaster_christmas_edition",
        name: "Win Blaster Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/win_shooter": {
        slug: "win_shooter",
        name: "Win Shooter",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gamomat-games/xploding_pumpkins": {
        slug: "xploding_pumpkins",
        name: "Xploding Pumpkins",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "habanero/12_zodiacs": {
        slug: "12_zodiacs",
        name: "12 Zodiacs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/5_lucky_lions": {
        slug: "5_lucky_lions",
        name: "5 Lucky Lions",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/5_mariachis": {
        slug: "5_mariachis",
        name: "5 Mariachis",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aces_and_eights_1_hand": {
        slug: "aces_and_eights_1_hand",
        name: "Aces and Eights 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aces_and_eights_10_hand": {
        slug: "aces_and_eights_10_hand",
        name: "Aces and Eights 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aces_and_eights_100_hand": {
        slug: "aces_and_eights_100_hand",
        name: "Aces and Eights 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aces_and_eights_5_hand": {
        slug: "aces_and_eights_5_hand",
        name: "Aces and Eights 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aces_and_eights_50_hand": {
        slug: "aces_and_eights_50_hand",
        name: "Aces and Eights 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_american_poker_1_hand": {
        slug: "all_american_poker_1_hand",
        name: "All American Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_american_poker_10_hand": {
        slug: "all_american_poker_10_hand",
        name: "All American Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_american_poker_100_hand": {
        slug: "all_american_poker_100_hand",
        name: "All American Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_american_poker_5_hand": {
        slug: "all_american_poker_5_hand",
        name: "All American Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_american_poker_50_hand": {
        slug: "all_american_poker_50_hand",
        name: "All American Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_for_one": {
        slug: "all_for_one",
        name: "All For One",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/american_blackjack": {
        slug: "american_blackjack",
        name: "American Blackjack",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/arcane_elements": {
        slug: "arcane_elements",
        name: "Arcane Elements",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/arctic_hunt": {
        slug: "arctic_hunt",
        name: "Arctic Hunt",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/arctic_wonders": {
        slug: "arctic_wonders",
        name: "Arctic Wonders",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/atomic_kittens": {
        slug: "atomic_kittens",
        name: "Atomic Kittens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aztlans_gold": {
        slug: "aztlans_gold",
        name: "Aztlan's Gold",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/baba_yaga": {
        slug: "baba_yaga",
        name: "Baba Yaga",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/baccarat_zero_commission": {
        slug: "baccarat_zero_commission",
        name: "Baccarat Zero Commission",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/barnstormer_bucks": {
        slug: "barnstormer_bucks",
        name: "Barnstormer Bucks",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/before_time_runs_out": {
        slug: "before_time_runs_out",
        name: "Before Time Runs Out",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bikini_island": {
        slug: "bikini_island",
        name: "Bikini Island",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bikini_island_deluxe": {
        slug: "bikini_island_deluxe",
        name: "Bikini Island Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bird_of_thunder": {
        slug: "bird_of_thunder",
        name: "Bird of Thunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/blackbeards_bounty": {
        slug: "blackbeards_bounty",
        name: "Blackbeard's Bounty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/blackjack_3_hand": {
        slug: "blackjack_3_hand",
        name: "Blackjack 3 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bomb_runner": {
        slug: "bomb_runner",
        name: "Bomb Runner",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bombs_away": {
        slug: "bombs_away",
        name: "Bombs Away",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_deuces_wild_1_hand": {
        slug: "bonus_deuces_wild_1_hand",
        name: "Bonus Deuces Wild 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_deuces_wild_10_hand": {
        slug: "bonus_deuces_wild_10_hand",
        name: "Bonus Deuces Wild 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_deuces_wild_100_hand": {
        slug: "bonus_deuces_wild_100_hand",
        name: "Bonus Deuces Wild 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_deuces_wild_5_hand": {
        slug: "bonus_deuces_wild_5_hand",
        name: "Bonus Deuces Wild 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_deuces_wild_50_hand": {
        slug: "bonus_deuces_wild_50_hand",
        name: "Bonus Deuces Wild 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_poker_1_hand": {
        slug: "bonus_poker_1_hand",
        name: "Bonus Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_poker_10_hand": {
        slug: "bonus_poker_10_hand",
        name: "Bonus Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_poker_100_hand": {
        slug: "bonus_poker_100_hand",
        name: "Bonus Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_poker_5_hand": {
        slug: "bonus_poker_5_hand",
        name: "Bonus Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_poker_50_hand": {
        slug: "bonus_poker_50_hand",
        name: "Bonus Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/buggy_bonus": {
        slug: "buggy_bonus",
        name: "Buggy Bonus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/cake_valley": {
        slug: "cake_valley",
        name: "Cake Valley",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/calaveras_explosivas": {
        slug: "calaveras_explosivas",
        name: "Calaveras Explosivas",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/candy_tower": {
        slug: "candy_tower",
        name: "Candy Tower",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/caribbean_holdem": {
        slug: "caribbean_holdem",
        name: "Caribbean Hold'em",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/caribbean_stud": {
        slug: "caribbean_stud",
        name: "Caribbean Stud",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/carnival_cash": {
        slug: "carnival_cash",
        name: "Carnival Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/carnival_cove": {
        slug: "carnival_cove",
        name: "Carnival Cove",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/cash_reef": {
        slug: "cash_reef",
        name: "Cash Reef",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/cashosaurus": {
        slug: "cashosaurus",
        name: "Cashosaurus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/christmas_gift_rush": {
        slug: "christmas_gift_rush",
        name: "Christmas Gift Rush",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/colossal_gems": {
        slug: "colossal_gems",
        name: "Colossal Gems",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/coyote_crash": {
        slug: "coyote_crash",
        name: "Coyote Crash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/crystopia": {
        slug: "crystopia",
        name: "Crystopia",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/daruma_impact": {
        slug: "daruma_impact",
        name: "Daruma Impact",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/deuces_wild_1_hand": {
        slug: "deuces_wild_1_hand",
        name: "Deuces Wild 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/deuces_wild_10_hand": {
        slug: "deuces_wild_10_hand",
        name: "Deuces Wild 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/deuces_wild_100_hand": {
        slug: "deuces_wild_100_hand",
        name: "Deuces Wild 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/deuces_wild_5_hand": {
        slug: "deuces_wild_5_hand",
        name: "Deuces Wild 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/deuces_wild_50_hand": {
        slug: "deuces_wild_50_hand",
        name: "Deuces Wild 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/disco_beats": {
        slug: "disco_beats",
        name: "Disco Beats",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/disco_funk": {
        slug: "disco_funk",
        name: "Disco Funk",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_bonus_poker_1_hand": {
        slug: "double_bonus_poker_1_hand",
        name: "Double Bonus Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_bonus_poker_10_hand": {
        slug: "double_bonus_poker_10_hand",
        name: "Double Bonus Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_bonus_poker_100_hand": {
        slug: "double_bonus_poker_100_hand",
        name: "Double Bonus Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_bonus_poker_5_hand": {
        slug: "double_bonus_poker_5_hand",
        name: "Double Bonus Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_bonus_poker_50_hand": {
        slug: "double_bonus_poker_50_hand",
        name: "Double Bonus Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_double_bonus_poker_1_hand": {
        slug: "double_double_bonus_poker_1_hand",
        name: "Double Double Bonus Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_double_bonus_poker_10_hand": {
        slug: "double_double_bonus_poker_10_hand",
        name: "Double Double Bonus Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_double_bonus_poker_100_hand": {
        slug: "double_double_bonus_poker_100_hand",
        name: "Double Double Bonus Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_double_bonus_poker_5_hand": {
        slug: "double_double_bonus_poker_5_hand",
        name: "Double Double Bonus Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_double_bonus_poker_50_hand": {
        slug: "double_double_bonus_poker_50_hand",
        name: "Double Double Bonus Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_exposure_3_hand": {
        slug: "double_exposure_3_hand",
        name: "Double Exposure 3 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_o_dollars": {
        slug: "double_o_dollars",
        name: "Double O Dollars",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dr_feelgood": {
        slug: "dr_feelgood",
        name: "Dr Feelgood",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dragon_castle": {
        slug: "dragon_castle",
        name: "Dragon Castle",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dragon_tiger_gate": {
        slug: "dragon_tiger_gate",
        name: "Dragon Tiger Gate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dragons_realm": {
        slug: "dragons_realm",
        name: "Dragon's Realm",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dragons_throne": {
        slug: "dragons_throne",
        name: "Dragon's Throne",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/egyptian_dreams": {
        slug: "egyptian_dreams",
        name: "Egyptian Dreams",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/egyptian_dreams_deluxe": {
        slug: "egyptian_dreams_deluxe",
        name: "Egyptian Dreams Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fa_cai_shen": {
        slug: "fa_cai_shen",
        name: "Fa Cai Shen",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fa_cai_shen_deluxe": {
        slug: "fa_cai_shen_deluxe",
        name: "Fa Cai Shen Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fenghuang": {
        slug: "fenghuang",
        name: "Fenghuang",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fire_rooster": {
        slug: "fire_rooster",
        name: "Fire Rooster",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fly": {
        slug: "fly",
        name: "Fly!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fortune_dogs": {
        slug: "fortune_dogs",
        name: "Fortune Dogs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fortune_dragon_joy": {
        slug: "fortune_dragon_joy",
        name: "Fortune Dragon Joy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/four_divine_beasts": {
        slug: "four_divine_beasts",
        name: "Four Divine Beasts",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/frontier_fortunes": {
        slug: "frontier_fortunes",
        name: "Frontier Fortunes",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fruity_halloween": {
        slug: "fruity_halloween",
        name: "Fruity Halloween",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fruity_mayan": {
        slug: "fruity_mayan",
        name: "Fruity Mayan",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/galactic_cash": {
        slug: "galactic_cash",
        name: "Galactic Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/galaxy_babies": {
        slug: "galaxy_babies",
        name: "Galaxy Babies",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/gangsters": {
        slug: "gangsters",
        name: "Gangsters",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/genies_showtime": {
        slug: "genies_showtime",
        name: "Genie's Showtime",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/gladiator_royal": {
        slug: "gladiator_royal",
        name: "Gladiator Royal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/glam_rock": {
        slug: "glam_rock",
        name: "Glam Rock",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/glory_of_rome": {
        slug: "glory_of_rome",
        name: "Glory Of Rome",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/gold_koi_fortune": {
        slug: "gold_koi_fortune",
        name: "Gold Koi Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/gold_rush": {
        slug: "gold_rush",
        name: "Gold Rush",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/golden_taj_mahal": {
        slug: "golden_taj_mahal",
        name: "Golden Taj Mahal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/golden_unicorn": {
        slug: "golden_unicorn",
        name: "Golden Unicorn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/golden_unicorn_deluxe": {
        slug: "golden_unicorn_deluxe",
        name: "Golden Unicorn Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/happiest_christmas_tree": {
        slug: "happiest_christmas_tree",
        name: "Happiest Christmas Tree",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/happy_ape": {
        slug: "happy_ape",
        name: "Happy Ape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/happy_hatchlings": {
        slug: "happy_hatchlings",
        name: "Happy Hatchlings",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/haunted_harbor": {
        slug: "haunted_harbor",
        name: "Haunted Harbor",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/haunted_house": {
        slug: "haunted_house",
        name: "Haunted House",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/hey_sushi": {
        slug: "hey_sushi",
        name: "Hey Sushi",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/hot_hot_fruit": {
        slug: "hot_hot_fruit",
        name: "Hot Hot Fruit",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/hot_hot_halloween": {
        slug: "hot_hot_halloween",
        name: "Hot Hot Halloween",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/hot_hot_summer": {
        slug: "hot_hot_summer",
        name: "Hot Hot Summer",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/hyper_hues": {
        slug: "hyper_hues",
        name: "Hyper Hues",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/indian_cash_catcher": {
        slug: "indian_cash_catcher",
        name: "Indian Cash Catcher",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/indiana_wolf": {
        slug: "indiana_wolf",
        name: "Indiana Wolf",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/infernal_fury": {
        slug: "infernal_fury",
        name: "Infernal Fury",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/isibaya_queens": {
        slug: "isibaya_queens",
        name: "Isibaya Queens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jacks_or_better_1_hand": {
        slug: "jacks_or_better_1_hand",
        name: "Jacks or Better 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jacks_or_better_10_hand": {
        slug: "jacks_or_better_10_hand",
        name: "Jacks or Better 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jacks_or_better_100_hand": {
        slug: "jacks_or_better_100_hand",
        name: "Jacks or Better 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jacks_or_better_5_hand": {
        slug: "jacks_or_better_5_hand",
        name: "Jacks or Better 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jacks_or_better_50_hand": {
        slug: "jacks_or_better_50_hand",
        name: "Jacks or Better 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/japanese_mask": {
        slug: "japanese_mask",
        name: "Japanese Mask",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jellyfish_flow": {
        slug: "jellyfish_flow",
        name: "Jellyfish Flow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jellyfish_flow_ultra": {
        slug: "jellyfish_flow_ultra",
        name: "Jellyfish Flow Ultra",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/joker_poker_1_hand": {
        slug: "joker_poker_1_hand",
        name: "Joker Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/joker_poker_10_hand": {
        slug: "joker_poker_10_hand",
        name: "Joker Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/joker_poker_100_hand": {
        slug: "joker_poker_100_hand",
        name: "Joker Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/joker_poker_5_hand": {
        slug: "joker_poker_5_hand",
        name: "Joker Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/joker_poker_50_hand": {
        slug: "joker_poker_50_hand",
        name: "Joker Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jugglenaut": {
        slug: "jugglenaut",
        name: "Jugglenaut",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jump": {
        slug: "jump",
        name: "Jump!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jump_2": {
        slug: "jump_2",
        name: "Jump! 2",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jungle_rumble": {
        slug: "jungle_rumble",
        name: "Jungle Rumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/kanes_inferno": {
        slug: "kanes_inferno",
        name: "Kane's Inferno",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/king_tuts_tomb": {
        slug: "king_tuts_tomb",
        name: "King Tut's Tomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/knockout_football": {
        slug: "knockout_football",
        name: "Knockout Football",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/knockout_football_rush": {
        slug: "knockout_football_rush",
        name: "Knockout Football Rush",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/koi_gate": {
        slug: "koi_gate",
        name: "Koi Gate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/koi_koi_treasure": {
        slug: "koi_koi_treasure",
        name: "Koi Koi Treasure",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/lantern_luck": {
        slug: "lantern_luck",
        name: "Lantern Luck",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/laughing_buddha": {
        slug: "laughing_buddha",
        name: "Laughing Buddha",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/legend_of_nezha": {
        slug: "legend_of_nezha",
        name: "Legend Of Nezha",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/legendary_beasts": {
        slug: "legendary_beasts",
        name: "Legendary Beasts",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/little_green_money": {
        slug: "little_green_money",
        name: "Little Green Money",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/london_hunter": {
        slug: "london_hunter",
        name: "London Hunter",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/loony_blox": {
        slug: "loony_blox",
        name: "Loony Blox",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/love_and_riches_el_dorado": {
        slug: "love_and_riches_el_dorado",
        name: "Love and Riches El Dorado",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/lucky_durian": {
        slug: "lucky_durian",
        name: "Lucky Durian",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/lucky_fortune_cat": {
        slug: "lucky_fortune_cat",
        name: "Lucky Fortune Cat",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/lucky_lucky": {
        slug: "lucky_lucky",
        name: "Lucky Lucky",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/magic_oak": {
        slug: "magic_oak",
        name: "Magic Oak",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/marvelous_furlongs": {
        slug: "marvelous_furlongs",
        name: "Marvelous Furlongs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/meow_janken": {
        slug: "meow_janken",
        name: "Meow Janken",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mighty_medusa": {
        slug: "mighty_medusa",
        name: "Mighty Medusa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/monster_mash_cash": {
        slug: "monster_mash_cash",
        name: "Monster Mash Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/moo_moo_cow": {
        slug: "moo_moo_cow",
        name: "Moo Moo Cow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mount_mazuma": {
        slug: "mount_mazuma",
        name: "Mount Mazuma",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mr_bling": {
        slug: "mr_bling",
        name: "Mr Bling",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mummy_hunter": {
        slug: "mummy_hunter",
        name: "Mummy Hunter",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mummy_money": {
        slug: "mummy_money",
        name: "Mummy Money",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mx_mania": {
        slug: "mx_mania",
        name: "MX Mania",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mystic_fortune": {
        slug: "mystic_fortune",
        name: "Mystic Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mystic_fortune_deluxe": {
        slug: "mystic_fortune_deluxe",
        name: "Mystic Fortune Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mystic_rings": {
        slug: "mystic_rings",
        name: "Mystic Rings",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mystic_shaman": {
        slug: "mystic_shaman",
        name: "Mystic Shaman",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/naughty_santa": {
        slug: "naughty_santa",
        name: "Naughty Santa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/naughty_wukong": {
        slug: "naughty_wukong",
        name: "Naughty Wukong",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/new_years_bash": {
        slug: "new_years_bash",
        name: "New Years Bash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/nine_tails": {
        slug: "nine_tails",
        name: "Nine Tails",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/nuwa": {
        slug: "nuwa",
        name: "Nuwa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/nuwa_deluxe": {
        slug: "nuwa_deluxe",
        name: "Nuwa Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/oceans_call": {
        slug: "oceans_call",
        name: "Ocean's Call",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/orbs_of_atlantis": {
        slug: "orbs_of_atlantis",
        name: "Orbs of Atlantis",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/pamper_me": {
        slug: "pamper_me",
        name: "Pamper Me",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/panda_panda": {
        slug: "panda_panda",
        name: "Panda Panda",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/pirates_plunder": {
        slug: "pirates_plunder",
        name: "Pirate's Plunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/poker_gamble_beat_the_dealer": {
        slug: "poker_gamble_beat_the_dealer",
        name: "Poker Gamble Beat the Dealer",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/pool_shark": {
        slug: "pool_shark",
        name: "Pool Shark",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/poseidon": {
        slug: "poseidon",
        name: "Poseidon",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/presto": {
        slug: "presto",
        name: "Presto!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/prosperity_horse": {
        slug: "prosperity_horse",
        name: "Prosperity Horse",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/prost": {
        slug: "prost",
        name: "Prost!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/pucker_up_prince": {
        slug: "pucker_up_prince",
        name: "Pucker Up Prince",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/pumpkin_patch": {
        slug: "pumpkin_patch",
        name: "Pumpkin Patch",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/queen_of_queens": {
        slug: "queen_of_queens",
        name: "Queen of Queens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/queen_of_queens_ii": {
        slug: "queen_of_queens_ii",
        name: "Queen of Queens II",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/racing_royalty": {
        slug: "racing_royalty",
        name: "Racing Royalty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/raiden_shogun": {
        slug: "raiden_shogun",
        name: "Raiden Shogun",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/rainbowmania": {
        slug: "rainbowmania",
        name: "Rainbowmania",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/return_to_the_feature": {
        slug: "return_to_the_feature",
        name: "Return To The Feature",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/ride_em_cowboy": {
        slug: "ride_em_cowboy",
        name: "Ride 'em Cowboy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/rodeo_drive": {
        slug: "rodeo_drive",
        name: "Rodeo Drive",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/rolling_roger": {
        slug: "rolling_roger",
        name: "Rolling Roger",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/roman_empire": {
        slug: "roman_empire",
        name: "Roman Empire",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/roulette": {
        slug: "roulette",
        name: "Roulette",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/ruffled_up": {
        slug: "ruffled_up",
        name: "Ruffled Up",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/safari_rumble": {
        slug: "safari_rumble",
        name: "Safari Rumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/santas_inn": {
        slug: "santas_inn",
        name: "Santa's Inn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/santas_village": {
        slug: "santas_village",
        name: "Santa's Village",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/scopa": {
        slug: "scopa",
        name: "Scopa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/scruffy_scallywags": {
        slug: "scruffy_scallywags",
        name: "Scruffy Scallywags",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/shamrock_quest": {
        slug: "shamrock_quest",
        name: "Shamrock Quest",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/shaolin_fortunes": {
        slug: "shaolin_fortunes",
        name: "Shaolin Fortunes",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/shaolin_fortunes_100": {
        slug: "shaolin_fortunes_100",
        name: "Shaolin Fortunes 100",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/shivering_strings": {
        slug: "shivering_strings",
        name: "Shivering Strings",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/shoguns_land": {
        slug: "shoguns_land",
        name: "Shogun's Land",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/sic_bo": {
        slug: "sic_bo",
        name: "Sic Bo",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/sir_blingalot": {
        slug: "sir_blingalot",
        name: "Sir Blingalot",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/sirens_spell": {
        slug: "sirens_spell",
        name: "Siren's Spell",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/skys_the_limit": {
        slug: "skys_the_limit",
        name: "Sky's the Limit",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/slime_party": {
        slug: "slime_party",
        name: "Slime Party",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/soju_bomb": {
        slug: "soju_bomb",
        name: "Soju Bomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/sos": {
        slug: "sos",
        name: "S.O.S!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/space_fortune": {
        slug: "space_fortune",
        name: "Space Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/space_goonz": {
        slug: "space_goonz",
        name: "Space Goonz",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/sparta": {
        slug: "sparta",
        name: "Sparta",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/steampunk_plinko": {
        slug: "steampunk_plinko",
        name: "Steampunk Plinko",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/super_fruit_blast": {
        slug: "super_fruit_blast",
        name: "Super Fruit Blast",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/super_strike": {
        slug: "super_strike",
        name: "Super Strike",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/super_twister": {
        slug: "super_twister",
        name: "Super Twister",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/taberna_de_los_muertos": {
        slug: "taberna_de_los_muertos",
        name: "Taberna De Los Muertos",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/taberna_de_los_muertos_ultra": {
        slug: "taberna_de_los_muertos_ultra",
        name: "Taberna De Los Muertos Ultra",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/taiko_beats": {
        slug: "taiko_beats",
        name: "Taiko Beats",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/techno_tumble": {
        slug: "techno_tumble",
        name: "Techno Tumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tens_or_better_1_hand": {
        slug: "tens_or_better_1_hand",
        name: "Tens or Better 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tens_or_better_10_hand": {
        slug: "tens_or_better_10_hand",
        name: "Tens or Better 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tens_or_better_100_hand": {
        slug: "tens_or_better_100_hand",
        name: "Tens or Better 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tens_or_better_5_hand": {
        slug: "tens_or_better_5_hand",
        name: "Tens or Better 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tens_or_better_50_hand": {
        slug: "tens_or_better_50_hand",
        name: "Tens or Better 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/the_big_deal": {
        slug: "the_big_deal",
        name: "The Big Deal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/the_big_deal_deluxe": {
        slug: "the_big_deal_deluxe",
        name: "The Big Deal Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/the_dead_escape": {
        slug: "the_dead_escape",
        name: "The Dead Escape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/the_grape_escape": {
        slug: "the_grape_escape",
        name: "The Grape Escape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/three_card_poker": {
        slug: "three_card_poker",
        name: "Three Card Poker",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/three_card_poker_deluxe": {
        slug: "three_card_poker_deluxe",
        name: "Three Card Poker Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tooty_fruity_fruits": {
        slug: "tooty_fruity_fruits",
        name: "Tooty Fruity Fruits",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/totem_towers": {
        slug: "totem_towers",
        name: "Totem Towers",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/totem_warrior": {
        slug: "totem_warrior",
        name: "Totem Warrior",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tower_of_pizza": {
        slug: "tower_of_pizza",
        name: "Tower Of Pizza",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/treasure_diver": {
        slug: "treasure_diver",
        name: "Treasure Diver",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/treasure_tomb": {
        slug: "treasure_tomb",
        name: "Treasure Tomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tuk_tuk_thailand": {
        slug: "tuk_tuk_thailand",
        name: "Tuk Tuk Thailand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/valentine_monchy": {
        slug: "valentine_monchy",
        name: "Valentine Monchy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/vampires_fate": {
        slug: "vampires_fate",
        name: "Vampire's Fate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/vikings_plunder": {
        slug: "vikings_plunder",
        name: "Viking's Plunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/waltz_beauty": {
        slug: "waltz_beauty",
        name: "Waltz Beauty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/war": {
        slug: "war",
        name: "War",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/ways_of_fortune": {
        slug: "ways_of_fortune",
        name: "Ways Of Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/wealth_inn": {
        slug: "wealth_inn",
        name: "Wealth Inn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/weird_science": {
        slug: "weird_science",
        name: "Weird Science",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/wicked_witch": {
        slug: "wicked_witch",
        name: "Wicked Witch",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/wild_flow": {
        slug: "wild_flow",
        name: "Wild Flow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/wild_trucks": {
        slug: "wild_trucks",
        name: "Wild Trucks",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/witches_tome": {
        slug: "witches_tome",
        name: "Witches Tome",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/wizards_want_war": {
        slug: "wizards_want_war",
        name: "Wizards Want War!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/zeus": {
        slug: "zeus",
        name: "Zeus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/zeus_2": {
        slug: "zeus_2",
        name: "Zeus 2",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/zeus_deluxe": {
        slug: "zeus_deluxe",
        name: "Zeus Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hacksaw-gaming/3_cursed_chests_hold_and_win": {
        slug: "3_cursed_chests_hold_and_win",
        name: "3 Cursed Chests: Hold and Win",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/aliens_among_us": {
        slug: "aliens_among_us",
        name: "Aliens Among Us",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/arena_of_iron": {
        slug: "arena_of_iron",
        name: "Arena of Iron",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/army_of_ares": {
        slug: "army_of_ares",
        name: "Army of Ares",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/balloons": {
        slug: "balloons",
        name: "Balloons",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/bash_bros": {
        slug: "bash_bros",
        name: "Bash Bros",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/behind_bars_master_plan": {
        slug: "behind_bars_master_plan",
        name: "Behind Bars: Master Plan",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/belle_the_blade_hunter": {
        slug: "belle_the_blade_hunter",
        name: "Belle the Blade Hunter",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/benny_the_beer": {
        slug: "benny_the_beer",
        name: "Benny the Beer",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/blocks": {
        slug: "blocks",
        name: "Blocks",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/book_of_time": {
        slug: "book_of_time",
        name: "Book of Time",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/booze_bash": {
        slug: "booze_bash",
        name: "Booze Bash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/born_wild": {
        slug: "born_wild",
        name: "Born Wild",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/bouncy_bombs": {
        slug: "bouncy_bombs",
        name: "Bouncy Bombs",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/boxes": {
        slug: "boxes",
        name: "Boxes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/break_bones": {
        slug: "break_bones",
        name: "Break Bones",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/break_the_ice": {
        slug: "break_the_ice",
        name: "Break the Ice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/buffalo_stack_n_sync": {
        slug: "buffalo_stack_n_sync",
        name: "Buffalo Stack 'n Sync",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/buffalo_stacknsync": {
        slug: "buffalo_stacknsync",
        name: "Buffalo Stack'n'Sync",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/bullets_and_bounty": {
        slug: "bullets_and_bounty",
        name: "Bullets and Bounty",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_compass": {
        slug: "cash_compass",
        name: "Cash Compass",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_crew": {
        slug: "cash_crew",
        name: "Cash Crew",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_pool": {
        slug: "cash_pool",
        name: "Cash Pool",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_quest": {
        slug: "cash_quest",
        name: "Cash Quest",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_scratch": {
        slug: "cash_scratch",
        name: "Cash Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_vault_i": {
        slug: "cash_vault_i",
        name: "Cash Vault I",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_vault_ii": {
        slug: "cash_vault_ii",
        name: "Cash Vault II",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/chaos_crew": {
        slug: "chaos_crew",
        name: "Chaos Crew",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/chaos_crew_2": {
        slug: "chaos_crew_2",
        name: "Chaos Crew 2",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/chaos_crew_3": {
        slug: "chaos_crew_3",
        name: "Chaos Crew 3",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/chaos_crew_scratch": {
        slug: "chaos_crew_scratch",
        name: "Chaos Crew Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/circle_of_life": {
        slug: "circle_of_life",
        name: "Circle of Life",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cloud_princess": {
        slug: "cloud_princess",
        name: "Cloud Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/coins": {
        slug: "coins",
        name: "Coins",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/colors": {
        slug: "colors",
        name: "Colors",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/crazy_donuts": {
        slug: "crazy_donuts",
        name: "Crazy Donuts",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/crownlings_clusters": {
        slug: "crownlings_clusters",
        name: "Crownlings Clusters",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cubes": {
        slug: "cubes",
        name: "Cubes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cubes_2": {
        slug: "cubes_2",
        name: "Cubes 2",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cursed_crypt": {
        slug: "cursed_crypt",
        name: "Cursed Crypt",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cursed_seas": {
        slug: "cursed_seas",
        name: "Cursed Seas",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cut_the_grass": {
        slug: "cut_the_grass",
        name: "Cut the Grass",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dandy_diamonds": {
        slug: "dandy_diamonds",
        name: "Dandy Diamonds",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/danny_dollar": {
        slug: "danny_dollar",
        name: "Danny Dollar",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dark_spiral": {
        slug: "dark_spiral",
        name: "Dark Spiral",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dark_summoning": {
        slug: "dark_summoning",
        name: "Dark Summoning",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dawn_of_kings": {
        slug: "dawn_of_kings",
        name: "Dawn of Kings",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dead_by_noon": {
        slug: "dead_by_noon",
        name: "Dead By Noon",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/deal_with_death": {
        slug: "deal_with_death",
        name: "Deal with Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/death_becomes_you": {
        slug: "death_becomes_you",
        name: "Death Becomes You",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/demon_queen": {
        slug: "demon_queen",
        name: "Demon Queen",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/densho": {
        slug: "densho",
        name: "Densho",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/diamond_rush": {
        slug: "diamond_rush",
        name: "Diamond Rush",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dice": {
        slug: "dice",
        name: "Dice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/divine_drop": {
        slug: "divine_drop",
        name: "Divine Drop",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/donny_and_danny": {
        slug: "donny_and_danny",
        name: "Donny and Danny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/donny_dough": {
        slug: "donny_dough",
        name: "Donny Dough",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/donut_division": {
        slug: "donut_division",
        name: "Donut Division",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dork_unit": {
        slug: "dork_unit",
        name: "Dork Unit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dorks_of_the_deep": {
        slug: "dorks_of_the_deep",
        name: "Dorks of the Deep",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/double_rainbow": {
        slug: "double_rainbow",
        name: "Double Rainbow",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/double_salary_1_year": {
        slug: "double_salary_1_year",
        name: "Double Salary 1 Year",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dragons_domain": {
        slug: "dragons_domain",
        name: "Dragon's Domain",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dream_car_speed": {
        slug: "dream_car_speed",
        name: "Dream Car Speed",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dream_car_suv": {
        slug: "dream_car_suv",
        name: "Dream Car SUV",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dream_car_urban": {
        slug: "dream_car_urban",
        name: "Dream Car Urban",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dropem": {
        slug: "dropem",
        name: "Drop'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/duel_at_dawn": {
        slug: "duel_at_dawn",
        name: "Duel at Dawn",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dusk_princess": {
        slug: "dusk_princess",
        name: "Dusk Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dynasty_of_death": {
        slug: "dynasty_of_death",
        name: "Dynasty of Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/eggstra_cash": {
        slug: "eggstra_cash",
        name: "Eggstra Cash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/epic_bullets_and_bounty_94": {
        slug: "epic_bullets_and_bounty_94",
        name: "Epic Bullets and Bounty 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/eternal_duel_94": {
        slug: "eternal_duel_94",
        name: "Eternal Duel 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/evil_eyes": {
        slug: "evil_eyes",
        name: "Evil Eyes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/express_200_scratch": {
        slug: "express_200_scratch",
        name: "Express 200 Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/eye_of_medusa": {
        slug: "eye_of_medusa",
        name: "Eye of Medusa",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/eye_of_the_panda": {
        slug: "eye_of_the_panda",
        name: "Eye of the Panda",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fear_of_the_dark": {
        slug: "fear_of_the_dark",
        name: "Fear of the Dark",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fear_the_dark": {
        slug: "fear_the_dark",
        name: "Fear the Dark",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/feel_the_beat": {
        slug: "feel_the_beat",
        name: "Feel the Beat",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fighter_pit": {
        slug: "fighter_pit",
        name: "Fighter Pit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fire_my_laser": {
        slug: "fire_my_laser",
        name: "Fire My Laser",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fist_of_destruction": {
        slug: "fist_of_destruction",
        name: "Fist of Destruction",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/football_scratch": {
        slug: "football_scratch",
        name: "Football Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/forest_fortune": {
        slug: "forest_fortune",
        name: "Forest Fortune",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/franks_farm": {
        slug: "franks_farm",
        name: "Frank's Farm",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/freds_food_truck": {
        slug: "freds_food_truck",
        name: "Fred's Food Truck",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/frkn_bananas": {
        slug: "frkn_bananas",
        name: "FRKN Bananas",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/frogs_scratch": {
        slug: "frogs_scratch",
        name: "Frogs Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fruit_duel": {
        slug: "fruit_duel",
        name: "Fruit Duel",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/frutz": {
        slug: "frutz",
        name: "Frutz",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/get_the_cheese": {
        slug: "get_the_cheese",
        name: "Get the Cheese",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/gladiator_legends": {
        slug: "gladiator_legends",
        name: "Gladiator Legends",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/go_panda": {
        slug: "go_panda",
        name: "Go Panda",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/gold_coins": {
        slug: "gold_coins",
        name: "Gold Coins",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/gold_rush": {
        slug: "gold_rush",
        name: "Gold Rush",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/great_game_rockies": {
        slug: "great_game_rockies",
        name: "Great Game Rockies",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/grinning_harvest": {
        slug: "grinning_harvest",
        name: "Grinning Harvest",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/gronks_gems": {
        slug: "gronks_gems",
        name: "Gronk's Gems",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/grug_make_fire": {
        slug: "grug_make_fire",
        name: "Grug Make Fire",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/hand_of_anubis": {
        slug: "hand_of_anubis",
        name: "Hand of Anubis",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/happy_scratch": {
        slug: "happy_scratch",
        name: "Happy Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/harvest_wilds": {
        slug: "harvest_wilds",
        name: "Harvest Wilds",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/hilo": {
        slug: "hilo",
        name: "Hi-Lo",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/hot_ross": {
        slug: "hot_ross",
        name: "Hot Ross",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/invictus": {
        slug: "invictus",
        name: "Invictus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/itero": {
        slug: "itero",
        name: "Itero",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/its_bananas": {
        slug: "its_bananas",
        name: "It's Bananas!",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/jaws_of_justice": {
        slug: "jaws_of_justice",
        name: "Jaws of Justice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/jelly_slice": {
        slug: "jelly_slice",
        name: "Jelly Slice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/joker_bombs": {
        slug: "joker_bombs",
        name: "Joker Bombs",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/keep_em": {
        slug: "keep_em",
        name: "Keep Em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/keep_em_cool": {
        slug: "keep_em_cool",
        name: "Keep 'em Cool",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/keepem": {
        slug: "keepem",
        name: "Keep'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/king_carrot": {
        slug: "king_carrot",
        name: "King Carrot",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/king_treasure": {
        slug: "king_treasure",
        name: "King Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/klowns": {
        slug: "klowns",
        name: "Klowns",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/koi_cash": {
        slug: "koi_cash",
        name: "Koi Cash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_bandit": {
        slug: "le_bandit",
        name: "Le Bandit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_bunny": {
        slug: "le_bunny",
        name: "Le Bunny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_digger": {
        slug: "le_digger",
        name: "Le Digger",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_fisherman": {
        slug: "le_fisherman",
        name: "Le Fisherman",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_football_fan": {
        slug: "le_football_fan",
        name: "Le Football Fan",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_hooligan": {
        slug: "le_hooligan",
        name: "Le Hooligan",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_king": {
        slug: "le_king",
        name: "Le King",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_pharaoh": {
        slug: "le_pharaoh",
        name: "Le Pharaoh",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_prachaun": {
        slug: "le_prachaun",
        name: "Le Prachaun",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_santa": {
        slug: "le_santa",
        name: "Le Santa",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_soccer": {
        slug: "le_soccer",
        name: "Le Soccer",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_viking": {
        slug: "le_viking",
        name: "Le Viking",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_zeus": {
        slug: "le_zeus",
        name: "Le Zeus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/leather_heads": {
        slug: "leather_heads",
        name: "Leather Heads",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/let_it_snow": {
        slug: "let_it_snow",
        name: "Let it Snow",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/life_and_death": {
        slug: "life_and_death",
        name: "Life and Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/limbo": {
        slug: "limbo",
        name: "Limbo",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lines": {
        slug: "lines",
        name: "Lines",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/love_is_all_you_need": {
        slug: "love_is_all_you_need",
        name: "LOVE is all you need",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_numbers_x12": {
        slug: "lucky_numbers_x12",
        name: "Lucky Numbers x12",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_numbers_x16": {
        slug: "lucky_numbers_x16",
        name: "Lucky Numbers x16",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_numbers_x20": {
        slug: "lucky_numbers_x20",
        name: "Lucky Numbers x20",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_numbers_x8": {
        slug: "lucky_numbers_x8",
        name: "Lucky Numbers x8",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_scratch": {
        slug: "lucky_scratch",
        name: "Lucky Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_shot": {
        slug: "lucky_shot",
        name: "Lucky Shot",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/magic_piggy": {
        slug: "magic_piggy",
        name: "Magic Piggy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/magic_piggy_og": {
        slug: "magic_piggy_og",
        name: "Magic Piggy OG",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/marlin_masters": {
        slug: "marlin_masters",
        name: "Marlin Masters",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/marlin_masters_atlantis": {
        slug: "marlin_masters_atlantis",
        name: "Marlin Masters: Atlantis",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/marlin_masters_og": {
        slug: "marlin_masters_og",
        name: "Marlin Masters OG",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/marlin_masters_the_big_haul": {
        slug: "marlin_masters_the_big_haul",
        name: "Marlin Masters: The Big Haul",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mayan_stackways": {
        slug: "mayan_stackways",
        name: "Mayan Stackways",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/miami_mayhem": {
        slug: "miami_mayhem",
        name: "Miami Mayhem",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/miami_multiplier": {
        slug: "miami_multiplier",
        name: "Miami Multiplier",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mighty_masks": {
        slug: "mighty_masks",
        name: "Mighty Masks",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mines": {
        slug: "mines",
        name: "Mines",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mines_supreme": {
        slug: "mines_supreme",
        name: "Mines Supreme",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mirage_city": {
        slug: "mirage_city",
        name: "Mirage City",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/miss_candys_sweet_escape": {
        slug: "miss_candys_sweet_escape",
        name: "Miss Candy's Sweet Escape",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/munchy_milo": {
        slug: "munchy_milo",
        name: "Munchy Milo",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mystery_motel": {
        slug: "mystery_motel",
        name: "Mystery Motel",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/nitro_nights": {
        slug: "nitro_nights",
        name: "Nitro Nights",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/octo_attack": {
        slug: "octo_attack",
        name: "Octo Attack",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/omnom": {
        slug: "omnom",
        name: "OmNom",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/opa_santorini": {
        slug: "opa_santorini",
        name: "Opa Santorini!",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/orb_of_destiny": {
        slug: "orb_of_destiny",
        name: "Orb of Destiny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/outlaws_inc": {
        slug: "outlaws_inc",
        name: "Outlaws Inc.",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/phoenix_duelreels": {
        slug: "phoenix_duelreels",
        name: "Phoenix DuelReels",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/power_of_ten": {
        slug: "power_of_ten",
        name: "Power of Ten",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/pray_for_six": {
        slug: "pray_for_six",
        name: "Pray for Six",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/pray_for_three": {
        slug: "pray_for_three",
        name: "Pray for Three",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/prince_treasure": {
        slug: "prince_treasure",
        name: "Prince Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/pug_life": {
        slug: "pug_life",
        name: "Pug Life",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/queen_treasure": {
        slug: "queen_treasure",
        name: "Queen Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rad_maxx": {
        slug: "rad_maxx",
        name: "Rad Maxx",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rainbow_princess": {
        slug: "rainbow_princess",
        name: "Rainbow Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rat_riches": {
        slug: "rat_riches",
        name: "Rat Riches",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/red_rascal": {
        slug: "red_rascal",
        name: "Red Rascal",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/reign_of_rome": {
        slug: "reign_of_rome",
        name: "Reign of Rome",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rip_city": {
        slug: "rip_city",
        name: "RIP City",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rise_of_fortuna": {
        slug: "rise_of_fortuna",
        name: "Rise of Fortuna",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rise_of_ymir": {
        slug: "rise_of_ymir",
        name: "Rise of Ymir",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rocket_reels": {
        slug: "rocket_reels",
        name: "Rocket Reels",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/ronin_stackways": {
        slug: "ronin_stackways",
        name: "Ronin Stackways",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rotten": {
        slug: "rotten",
        name: "Rotten",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/ruby_rush": {
        slug: "ruby_rush",
        name: "Ruby Rush",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rusty_and_curly": {
        slug: "rusty_and_curly",
        name: "Rusty and Curly",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/sand_and_ashes": {
        slug: "sand_and_ashes",
        name: "Sand and Ashes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratch_bronze": {
        slug: "scratch_bronze",
        name: "SCRATCH! Bronze",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratch_em": {
        slug: "scratch_em",
        name: "Scratch 'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratch_gold": {
        slug: "scratch_gold",
        name: "SCRATCH! Gold",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratch_platinum": {
        slug: "scratch_platinum",
        name: "SCRATCH! Platinum",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratch_silver": {
        slug: "scratch_silver",
        name: "SCRATCH! Silver",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratchy": {
        slug: "scratchy",
        name: "Scratchy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratchy_big": {
        slug: "scratchy_big",
        name: "Scratchy Big",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratchy_mini": {
        slug: "scratchy_mini",
        name: "Scratchy Mini",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/shaolin_master": {
        slug: "shaolin_master",
        name: "Shaolin Master",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/shave_the_beard": {
        slug: "shave_the_beard",
        name: "Shave the Beard",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/shave_the_sheep": {
        slug: "shave_the_sheep",
        name: "Shave the Sheep",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/sixsixsix": {
        slug: "sixsixsix",
        name: "SixSixSix",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/slayers_inc": {
        slug: "slayers_inc",
        name: "Slayers Inc",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/smoking_dragon": {
        slug: "smoking_dragon",
        name: "Smoking Dragon",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/snow_scratcher": {
        slug: "snow_scratcher",
        name: "Snow Scratcher",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/snow_slingers": {
        slug: "snow_slingers",
        name: "Snow Slingers",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/spear_of_athena": {
        slug: "spear_of_athena",
        name: "Spear of Athena",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/speed_crash": {
        slug: "speed_crash",
        name: "Speed Crash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/spinman": {
        slug: "spinman",
        name: "Spinman",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/spinman_hv": {
        slug: "spinman_hv",
        name: "Spinman H.V.",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/spooky_scary_scratchy": {
        slug: "spooky_scary_scratchy",
        name: "Spooky Scary Scratchy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stack_em": {
        slug: "stack_em",
        name: "Stack 'Em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stack_em_scratch": {
        slug: "stack_em_scratch",
        name: "Stack 'em Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stackem": {
        slug: "stackem",
        name: "Stack'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/steamrunners": {
        slug: "steamrunners",
        name: "Steamrunners",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stick_em": {
        slug: "stick_em",
        name: "Stick 'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stormborn": {
        slug: "stormborn",
        name: "Stormborn",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stormforged": {
        slug: "stormforged",
        name: "Stormforged",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/strength_of_hercules": {
        slug: "strength_of_hercules",
        name: "Strength of Hercules",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/summer_scratch": {
        slug: "summer_scratch",
        name: "Summer Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/sun_princess": {
        slug: "sun_princess",
        name: "Sun Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/superstar_sevens": {
        slug: "superstar_sevens",
        name: "Superstar Sevens",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/supreme_zeus": {
        slug: "supreme_zeus",
        name: "Supreme Zeus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/tai_the_toad": {
        slug: "tai_the_toad",
        name: "Tai the Toad",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/tasty_treats": {
        slug: "tasty_treats",
        name: "Tasty Treats",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/temple_of_torment": {
        slug: "temple_of_torment",
        name: "Temple of Torment",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_bowery_boys": {
        slug: "the_bowery_boys",
        name: "The Bowery Boys",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_count": {
        slug: "the_count",
        name: "The Count",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_crime_file": {
        slug: "the_crime_file",
        name: "The Crime File",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_perfect_scratch": {
        slug: "the_perfect_scratch",
        name: "The Perfect Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/tiger_scratch": {
        slug: "tiger_scratch",
        name: "Tiger Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/toshi_ways_club": {
        slug: "toshi_ways_club",
        name: "Toshi Ways Club",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/twentyone": {
        slug: "twentyone",
        name: "Twenty-One",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/wheel": {
        slug: "wheel",
        name: "Wheel",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/zeus_ze_zecond": {
        slug: "zeus_ze_zecond",
        name: "Zeus Ze Zecond",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hot-rise-games/medusa_hot1": {
        slug: "medusa_hot1",
        name: "Medusa Hot1",
        provider: "Hot Rise Games",
        providerSlug: "hot-rise-games"
    },
    "indigomagic/40_hot_diamond_desire": {
        slug: "40_hot_diamond_desire",
        name: "40 Hot Diamond Desire",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/5_hot_diamond_desire": {
        slug: "5_hot_diamond_desire",
        name: "5 Hot Diamond Desire",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/7_fates": {
        slug: "7_fates",
        name: "7 Fates",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/almighty_hera": {
        slug: "almighty_hera",
        name: "Almighty Hera",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/alpha_gold": {
        slug: "alpha_gold",
        name: "Alpha Gold",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/amulets_of_horus": {
        slug: "amulets_of_horus",
        name: "Amulets of Horus",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/bad_bass": {
        slug: "bad_bass",
        name: "Bad Bass",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/bad_bass_cash_haul": {
        slug: "bad_bass_cash_haul",
        name: "Bad Bass Cash Haul",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/bad_bass_cash_towers": {
        slug: "bad_bass_cash_towers",
        name: "Bad Bass Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/bankers_and_cash": {
        slug: "bankers_and_cash",
        name: "Bankers & Cash",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/beer_boost": {
        slug: "beer_boost",
        name: "Beer Boost",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/big_roar": {
        slug: "big_roar",
        name: "Big Roar",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/book_of_blackeyes_bounty": {
        slug: "book_of_blackeyes_bounty",
        name: "Book of Blackeye's Bounty",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/book_of_buffalo": {
        slug: "book_of_buffalo",
        name: "Book of Buffalo",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/candy_treasures": {
        slug: "candy_treasures",
        name: "Candy Treasures",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/candy_treasures_3_reels": {
        slug: "candy_treasures_3_reels",
        name: "Candy Treasures 3 Reels",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/candy_treasures_cash_towers": {
        slug: "candy_treasures_cash_towers",
        name: "Candy Treasures Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/carts_of_cash": {
        slug: "carts_of_cash",
        name: "Carts of Cash",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/carts_of_cash_xmas": {
        slug: "carts_of_cash_xmas",
        name: "Carts of Cash Xmas",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/casino_barbut": {
        slug: "casino_barbut",
        name: "Casino Barbut",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/casino_patience": {
        slug: "casino_patience",
        name: "Casino Patience",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/charming_hearts": {
        slug: "charming_hearts",
        name: "Charming Hearts",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/crazy_diamonds": {
        slug: "crazy_diamonds",
        name: "Crazy Diamonds",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/creepy_christmas": {
        slug: "creepy_christmas",
        name: "Creepy Christmas",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/cross_it": {
        slug: "cross_it",
        name: "Cross It",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/dega_baby": {
        slug: "dega_baby",
        name: "Dega Baby",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/diamond_desire": {
        slug: "diamond_desire",
        name: "Diamond Desire",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/diamond_desire_deluxe": {
        slug: "diamond_desire_deluxe",
        name: "Diamond Desire Deluxe",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/diamond_desire_flame": {
        slug: "diamond_desire_flame",
        name: "Diamond Desire Flame",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/down_the_chimney": {
        slug: "down_the_chimney",
        name: "Down The Chimney",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/duck_king": {
        slug: "duck_king",
        name: "Duck King",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/extreme_pay": {
        slug: "extreme_pay",
        name: "Extreme Pay",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/fortune_babies": {
        slug: "fortune_babies",
        name: "Fortune Babies",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/fortune_babies_harmony": {
        slug: "fortune_babies_harmony",
        name: "Fortune Babies Harmony",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/fruit_lines": {
        slug: "fruit_lines",
        name: "Fruit Lines",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/fruit_lines_winter": {
        slug: "fruit_lines_winter",
        name: "Fruit Lines Winter",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/golden_avalanche": {
        slug: "golden_avalanche",
        name: "Golden Avalanche",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/golden_gals": {
        slug: "golden_gals",
        name: "Golden Gal's",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/golden_gals_3_reels": {
        slug: "golden_gals_3_reels",
        name: "Golden Gal's 3 Reels",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/golden_gals_cash_towers": {
        slug: "golden_gals_cash_towers",
        name: "Golden Gal's Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/golden_gals_hen_hunt": {
        slug: "golden_gals_hen_hunt",
        name: "Golden Gals Hen Hunt",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/golden_horn": {
        slug: "golden_horn",
        name: "Golden Horn",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/golden_ticket": {
        slug: "golden_ticket",
        name: "Golden Ticket",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/golfing_glory": {
        slug: "golfing_glory",
        name: "Golfing Glory",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/hard_cash": {
        slug: "hard_cash",
        name: "Hard Cash",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/hot_heads": {
        slug: "hot_heads",
        name: "Hot Heads",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/juicy_explosion": {
        slug: "juicy_explosion",
        name: "Juicy Explosion",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/karens_merry_meltdown": {
        slug: "karens_merry_meltdown",
        name: "Karen's Merry Meltdown",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/kings_and_jewels": {
        slug: "kings_and_jewels",
        name: "Kings & Jewels",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/mega_mystery_mine": {
        slug: "mega_mystery_mine",
        name: "Mega Mystery Mine",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/mighty_marlin": {
        slug: "mighty_marlin",
        name: "Mighty Marlin",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/mighty_marlin_super_reel": {
        slug: "mighty_marlin_super_reel",
        name: "Mighty Marlin Super Reel",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/mighty_mountain": {
        slug: "mighty_mountain",
        name: "Mighty Mountain",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/mystical_forest": {
        slug: "mystical_forest",
        name: "Mystical Forest",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/paddys_pooches": {
        slug: "paddys_pooches",
        name: "Paddy's Pooches",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/paradise_ticket": {
        slug: "paradise_ticket",
        name: "Paradise Ticket",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/phoenix_fury": {
        slug: "phoenix_fury",
        name: "Phoenix Fury",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/plushie_peril": {
        slug: "plushie_peril",
        name: "Plushie Peril",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/pumped_up": {
        slug: "pumped_up",
        name: "Pumped Up",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/raging_rabbits": {
        slug: "raging_rabbits",
        name: "Raging Rabbits",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/reel_goal_cash_towers": {
        slug: "reel_goal_cash_towers",
        name: "Reel Goal Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/samurai_ikusa": {
        slug: "samurai_ikusa",
        name: "Samurai Ikusa",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/santas_sack": {
        slug: "santas_sack",
        name: "Santa's Sack",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/sea_of_plenty": {
        slug: "sea_of_plenty",
        name: "Sea of Plenty",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/sevens_and_jok3rs": {
        slug: "sevens_and_jok3rs",
        name: "Sevens and Jok3rs",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/sevens_and_suns": {
        slug: "sevens_and_suns",
        name: "Sevens & Suns",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/side_strike": {
        slug: "side_strike",
        name: "Side Strike",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/speed_champion": {
        slug: "speed_champion",
        name: "Speed Champion",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/super_egg_hunt": {
        slug: "super_egg_hunt",
        name: "Super Egg Hunt",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/super_sake": {
        slug: "super_sake",
        name: "Super Sake",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/super_sevens": {
        slug: "super_sevens",
        name: "Super Sevens",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/treat_yo_elf": {
        slug: "treat_yo_elf",
        name: "Treat Yo' Elf",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/truckers_vs_aliens": {
        slug: "truckers_vs_aliens",
        name: "Truckers vs Aliens",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/wicked_whiskers": {
        slug: "wicked_whiskers",
        name: "Wicked Whiskers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "indigomagic/wild_hour_league": {
        slug: "wild_hour_league",
        name: "Wild Hour League",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "irondog/1_million_fortunes_megaways": {
        slug: "1_million_fortunes_megaways",
        name: "1 Million Fortunes Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/1_million_megaways_bc": {
        slug: "1_million_megaways_bc",
        name: "1 Million Megaways BC",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/12_volt_diamonds": {
        slug: "12_volt_diamonds",
        name: "12 Volt Diamonds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_apex_treasures": {
        slug: "3_apex_treasures",
        name: "3 Apex Treasures",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_capybaras": {
        slug: "3_capybaras",
        name: "3 Capybaras",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_cheeky_chimps": {
        slug: "3_cheeky_chimps",
        name: "3 Cheeky Chimps",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_christmas_fortunes": {
        slug: "3_christmas_fortunes",
        name: "3 Christmas Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_crazy_tikis": {
        slug: "3_crazy_tikis",
        name: "3 Crazy Tikis",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_gods_of_goalympus": {
        slug: "3_gods_of_goalympus",
        name: "3 Gods of Goalympus",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_hot_chilli_peppers": {
        slug: "3_hot_chilli_peppers",
        name: "3 Hot Chilli Peppers",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_hot_chilli_peppers_extra": {
        slug: "3_hot_chilli_peppers_extra",
        name: "3 Hot Chilli Peppers Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_leprechaun_charms": {
        slug: "3_leprechaun_charms",
        name: "3 Leprechaun Charms",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_mad_frogs": {
        slug: "3_mad_frogs",
        name: "3 Mad Frogs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_pinatas": {
        slug: "3_pinatas",
        name: "3 Pinatas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_plucky_hens": {
        slug: "3_plucky_hens",
        name: "3 Plucky Hens",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_porky_banks_christmas": {
        slug: "3_porky_banks_christmas",
        name: "3 Porky Banks Christmas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_porky_banks_hold_and_win": {
        slug: "3_porky_banks_hold_and_win",
        name: "3 Porky Banks Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_porky_banks_hold_and_win_extra": {
        slug: "3_porky_banks_hold_and_win_extra",
        name: "3 Porky Banks Hold and Win Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_runaway_riches": {
        slug: "3_runaway_riches",
        name: "3 Runaway Riches",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_super_porky_banks": {
        slug: "3_super_porky_banks",
        name: "3 Super Porky Banks",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_top_dogs": {
        slug: "3_top_dogs",
        name: "3 Top Dogs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_wicked_devils": {
        slug: "3_wicked_devils",
        name: "3 Wicked Devils",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_wild_aliens": {
        slug: "3_wild_aliens",
        name: "3 Wild Aliens",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3d_baccarat": {
        slug: "3d_baccarat",
        name: "3D Baccarat",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3d_blackjack": {
        slug: "3d_blackjack",
        name: "3D Blackjack",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3d_european_roulette": {
        slug: "3d_european_roulette",
        name: "3D European Roulette",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/4_crabbin_fortunes": {
        slug: "4_crabbin_fortunes",
        name: "4 Crabbin' Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/4_dragon_pots": {
        slug: "4_dragon_pots",
        name: "4 Dragon Pots",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/4_wild_riches": {
        slug: "4_wild_riches",
        name: "4 Wild Riches",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/8_treasures_luck_of_the_dragon": {
        slug: "8_treasures_luck_of_the_dragon",
        name: "8 Treasures Luck of the Dragon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/ahoy_royale": {
        slug: "ahoy_royale",
        name: "Ahoy Royale",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/apex_strike_lucky_cache": {
        slug: "apex_strike_lucky_cache",
        name: "Apex Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/apex_strike_megaways": {
        slug: "apex_strike_megaways",
        name: "Apex Strike Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/arriba_heat_salsa_wilds": {
        slug: "arriba_heat_salsa_wilds",
        name: "Arriba Heat Salsa Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/astro_newts_megaways": {
        slug: "astro_newts_megaways",
        name: "Astro Newts Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/aztec_wilds_megaways": {
        slug: "aztec_wilds_megaways",
        name: "Aztec Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/bacon_banker": {
        slug: "bacon_banker",
        name: "Bacon Banker",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/barbarian_gold": {
        slug: "barbarian_gold",
        name: "Barbarian Gold",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/blackjack_classic": {
        slug: "blackjack_classic",
        name: "Blackjack Classic",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/blirix_workshop": {
        slug: "blirix_workshop",
        name: "Blirix workshop",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/blood_queen_scratch": {
        slug: "blood_queen_scratch",
        name: "Blood Queen Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/book_of_baal": {
        slug: "book_of_baal",
        name: "Book Of Ba'al",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/boom_time": {
        slug: "boom_time",
        name: "Boom Time",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/branded_book_of": {
        slug: "branded_book_of",
        name: "Branded Book Of",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/branded_megaways": {
        slug: "branded_megaways",
        name: "Branded Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/cherry_blast_scratch": {
        slug: "cherry_blast_scratch",
        name: "Cherry Blast Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/christmas_megaways": {
        slug: "christmas_megaways",
        name: "Christmas Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/cleopatras_fortune": {
        slug: "cleopatras_fortune",
        name: "Cleopatra's Fortune",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/cosmic_crystals_scratch": {
        slug: "cosmic_crystals_scratch",
        name: "Cosmic Crystals Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/cowboy_showdown": {
        slug: "cowboy_showdown",
        name: "Cowboy Showdown",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/crazy_tiki_hold_and_win": {
        slug: "crazy_tiki_hold_and_win",
        name: "Crazy Tiki Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/crown_of_avalon": {
        slug: "crown_of_avalon",
        name: "Crown of Avalon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/diamond_charge_extra": {
        slug: "diamond_charge_extra",
        name: "Diamond Charge Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/diamond_charge_hold_and_win": {
        slug: "diamond_charge_hold_and_win",
        name: "Diamond Charge Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/diamond_charge_megaways": {
        slug: "diamond_charge_megaways",
        name: "Diamond Charge Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/diamond_supercharge": {
        slug: "diamond_supercharge",
        name: "Diamond Supercharge",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/dolla_dolla_bill": {
        slug: "dolla_dolla_bill",
        name: "Dolla Dolla Bill",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/dolla_dolla_bill_mo_money": {
        slug: "dolla_dolla_bill_mo_money",
        name: "Dolla Dolla Bill Mo Money",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/double_cash_mummy": {
        slug: "double_cash_mummy",
        name: "Double Cash Mummy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/dwarven_gems_megaways": {
        slug: "dwarven_gems_megaways",
        name: "Dwarven Gems Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/eagle_strike": {
        slug: "eagle_strike",
        name: "Eagle Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/eagle_strike_extra": {
        slug: "eagle_strike_extra",
        name: "Eagle Strike Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/eagle_strike_lucky_cache": {
        slug: "eagle_strike_lucky_cache",
        name: "Eagle Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/everest_avalanche": {
        slug: "everest_avalanche",
        name: "Everest Avalanche",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/farming_frenzy": {
        slug: "farming_frenzy",
        name: "Farming Frenzy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/feeding_fury": {
        slug: "feeding_fury",
        name: "Feeding Fury",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/football_hold_and_blitz": {
        slug: "football_hold_and_blitz",
        name: "Football Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/forge_of_the_gods": {
        slug: "forge_of_the_gods",
        name: "Forge of the Gods",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/fruit_lightning": {
        slug: "fruit_lightning",
        name: "Fruit Lightning",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/fruit_lightning_3x5": {
        slug: "fruit_lightning_3x5",
        name: "Fruit Lightning 3x5",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/fruity_hold_and_blitz": {
        slug: "fruity_hold_and_blitz",
        name: "Fruity Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/fruity_megaways": {
        slug: "fruity_megaways",
        name: "Fruity Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gifts_of_ostara_scratch": {
        slug: "gifts_of_ostara_scratch",
        name: "Gifts of Ostara Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/goal_blitz": {
        slug: "goal_blitz",
        name: "Goal Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/goal_blitz_shootout": {
        slug: "goal_blitz_shootout",
        name: "Goal Blitz Shootout",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gods_of_asgard_megaways": {
        slug: "gods_of_asgard_megaways",
        name: "Gods Of Asgard Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gods_of_olympus_3_megaways": {
        slug: "gods_of_olympus_3_megaways",
        name: "Gods Of Olympus 3 Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gods_of_olympus_ii": {
        slug: "gods_of_olympus_ii",
        name: "Gods of Olympus II",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gods_of_olympus_iv": {
        slug: "gods_of_olympus_iv",
        name: "Gods of Olympus IV",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/goldstar_express": {
        slug: "goldstar_express",
        name: "Goldstar Express",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/grand_ahoy": {
        slug: "grand_ahoy",
        name: "Grand Ahoy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/grizzly_strike": {
        slug: "grizzly_strike",
        name: "Grizzly Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/grizzly_strike_lucky_cache": {
        slug: "grizzly_strike_lucky_cache",
        name: "Grizzly Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/halloween_horrors_megaways": {
        slug: "halloween_horrors_megaways",
        name: "Halloween Horrors Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/hot_joker_fruits_20": {
        slug: "hot_joker_fruits_20",
        name: "Hot Joker Fruits 20",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/inspector_wilds": {
        slug: "inspector_wilds",
        name: "Inspector Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/jewelling_diamonds": {
        slug: "jewelling_diamonds",
        name: "Jewelling Diamonds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/jolly_bonus_wins": {
        slug: "jolly_bonus_wins",
        name: "Jolly Bonus Wins",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/leprechaun_charms_rainbow_jackpot": {
        slug: "leprechaun_charms_rainbow_jackpot",
        name: "Leprechaun Charms Rainbow Jackpot",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/loot_crab": {
        slug: "loot_crab",
        name: "Loot Crab",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/luck_of_the_dragon": {
        slug: "luck_of_the_dragon",
        name: "Luck of the Dragon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/lucky_cauldron": {
        slug: "lucky_cauldron",
        name: "Lucky Cauldron",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/mad_cabs": {
        slug: "mad_cabs",
        name: "Mad Cabs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/mad_cabs_hold_and_win": {
        slug: "mad_cabs_hold_and_win",
        name: "Mad Cabs Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/megaways_jack": {
        slug: "megaways_jack",
        name: "MegaWays Jack",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/megaways_jack_and_the_magic_beans": {
        slug: "megaways_jack_and_the_magic_beans",
        name: "MegaWays Jack and The Magic Beans",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/megaways_jack_frost": {
        slug: "megaways_jack_frost",
        name: "Megaways Jack Frost",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/merry_megaways": {
        slug: "merry_megaways",
        name: "Merry Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/moirai_blaze_scratch": {
        slug: "moirai_blaze_scratch",
        name: "Moirai Blaze Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/money_minecarts": {
        slug: "money_minecarts",
        name: "Money Minecarts",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/mr_porky_banker_cash_stash": {
        slug: "mr_porky_banker_cash_stash",
        name: "Mr Porky Banker: Cash Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/neon_jungle_scratch": {
        slug: "neon_jungle_scratch",
        name: "Neon Jungle Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/paint_scratch": {
        slug: "paint_scratch",
        name: "Paint Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/piggy_bank_cash": {
        slug: "piggy_bank_cash",
        name: "Piggy Bank Cash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/piggy_bank_stash": {
        slug: "piggy_bank_stash",
        name: "Piggy Bank Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/pinata_go_go": {
        slug: "pinata_go_go",
        name: "Pinata Go Go",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/pirate_kingdom_megaways": {
        slug: "pirate_kingdom_megaways",
        name: "Pirate Kingdom Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/rainbow_wilds_megaways": {
        slug: "rainbow_wilds_megaways",
        name: "Rainbow Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/rainbow_wilds_scratch": {
        slug: "rainbow_wilds_scratch",
        name: "Rainbow Wilds Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/rainin_money": {
        slug: "rainin_money",
        name: "Rainin Money",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/red_zone_blitz": {
        slug: "red_zone_blitz",
        name: "Red Zone Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/red_zone_blitz_hold_and_win": {
        slug: "red_zone_blitz_hold_and_win",
        name: "Red Zone Blitz Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/robbin_robin": {
        slug: "robbin_robin",
        name: "Robbin Robin",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/roulette_classic": {
        slug: "roulette_classic",
        name: "Roulette Classic",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/rum_and_raiders": {
        slug: "rum_and_raiders",
        name: "Rum and Raiders",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/santas_big_bash_megaways": {
        slug: "santas_big_bash_megaways",
        name: "Santa's Big Bash Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/santas_express_hold_and_win": {
        slug: "santas_express_hold_and_win",
        name: "Santa's Express Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/savannah_strike": {
        slug: "savannah_strike",
        name: "Savannah Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/savannah_strike_extra": {
        slug: "savannah_strike_extra",
        name: "Savannah Strike Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/si_xiang_scratch": {
        slug: "si_xiang_scratch",
        name: "Si Xiang Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sirens_kingdom": {
        slug: "sirens_kingdom",
        name: "Siren's Kingdom",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sirens_kingdom_scratch": {
        slug: "sirens_kingdom_scratch",
        name: "Siren's Kingdom Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/smoking_hot_fortunes": {
        slug: "smoking_hot_fortunes",
        name: "Smoking Hot Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/soccer_hold_and_blitz": {
        slug: "soccer_hold_and_blitz",
        name: "Soccer Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/solar_nova": {
        slug: "solar_nova",
        name: "Solar Nova",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/solar_nova_megaways": {
        slug: "solar_nova_megaways",
        name: "Solar Nova Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/stampeding_strike": {
        slug: "stampeding_strike",
        name: "Stampeding Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/stickman_cash": {
        slug: "stickman_cash",
        name: "Stickman Cash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sweet_candy_blitz": {
        slug: "sweet_candy_blitz",
        name: "Sweet Candy Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sweet_candy_cash_megaways": {
        slug: "sweet_candy_cash_megaways",
        name: "Sweet Candy Cash Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sweet_candy_cash_megaways_deluxe": {
        slug: "sweet_candy_cash_megaways_deluxe",
        name: "Sweet Candy Cash Megaways Deluxe",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sweet_candy_cash_stash": {
        slug: "sweet_candy_cash_stash",
        name: "Sweet Candy Cash Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sweet_candy_christmas": {
        slug: "sweet_candy_christmas",
        name: "Sweet Candy Christmas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/the_choice_is_yours_megaways": {
        slug: "the_choice_is_yours_megaways",
        name: "The Choice is Yours Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/the_curious_cabinet_scratch": {
        slug: "the_curious_cabinet_scratch",
        name: "The Curious Cabinet Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/the_golden_mummy_hold_and_win": {
        slug: "the_golden_mummy_hold_and_win",
        name: "The Golden Mummy Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/tomb_of": {
        slug: "tomb_of",
        name: "Tomb Of",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/train_strike_hold_and_win": {
        slug: "train_strike_hold_and_win",
        name: "Train Strike Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/treasure_of_horus_scratch": {
        slug: "treasure_of_horus_scratch",
        name: "Treasure of Horus Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/tropical_thunder": {
        slug: "tropical_thunder",
        name: "Tropical Thunder",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/vegas_hold_and_win": {
        slug: "vegas_hold_and_win",
        name: "Vegas Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/vegas_hot_spots": {
        slug: "vegas_hot_spots",
        name: "Vegas Hot spots",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/viking_wilds_scratch": {
        slug: "viking_wilds_scratch",
        name: "Viking Wilds Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/waikiki_scratch": {
        slug: "waikiki_scratch",
        name: "Wai-Kiki Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/western_wilds": {
        slug: "western_wilds",
        name: "Western Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/western_wilds_hold_and_win": {
        slug: "western_wilds_hold_and_win",
        name: "Western Wilds Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/western_wilds_megaways": {
        slug: "western_wilds_megaways",
        name: "Western Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/wolf_strike": {
        slug: "wolf_strike",
        name: "Wolf Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/wolf_strike_hold_and_win_extra": {
        slug: "wolf_strike_hold_and_win_extra",
        name: "Wolf Strike Hold and Win Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "jili-games/10_sparkling_crown": {
        slug: "10_sparkling_crown",
        name: "10 Sparkling Crown",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/100_blazing_clover": {
        slug: "100_blazing_clover",
        name: "100 Blazing Clover",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/20_blazing_clover": {
        slug: "20_blazing_clover",
        name: "20 Blazing Clover",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_charge_buffalo": {
        slug: "3_charge_buffalo",
        name: "3 Charge Buffalo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_coin_golden_ox": {
        slug: "3_coin_golden_ox",
        name: "3 Coin Golden Ox",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_coin_treasures": {
        slug: "3_coin_treasures",
        name: "3 Coin Treasures",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_coin_treasures_2": {
        slug: "3_coin_treasures_2",
        name: "3 Coin Treasures 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_coin_wild_horse": {
        slug: "3_coin_wild_horse",
        name: "3 Coin Wild Horse",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_coin_wild_tiger": {
        slug: "3_coin_wild_tiger",
        name: "3 Coin Wild Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_lucky_baozhu": {
        slug: "3_lucky_baozhu",
        name: "3 Lucky Baozhu",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_lucky_lions": {
        slug: "3_lucky_lions",
        name: "3 Lucky Lions",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_lucky_piggy": {
        slug: "3_lucky_piggy",
        name: "3 Lucky Piggy",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_pot_dragons": {
        slug: "3_pot_dragons",
        name: "3 Pot Dragons",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_witchs_lamp": {
        slug: "3_witchs_lamp",
        name: "3 Witch's Lamp",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/40_sparkling_crown": {
        slug: "40_sparkling_crown",
        name: "40 Sparkling Crown",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/7_updown": {
        slug: "7_updown",
        name: "7 UP-DOWN",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/7up7down": {
        slug: "7up7down",
        name: "7up7down",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/agent_ace": {
        slug: "agent_ace",
        name: "Agent Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/ak47": {
        slug: "ak47",
        name: "AK47",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/ali_baba": {
        slug: "ali_baba",
        name: "Ali Baba",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/allstar_fishing": {
        slug: "allstar_fishing",
        name: "All-star Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/amar_akhbar_anthony": {
        slug: "amar_akhbar_anthony",
        name: "Amar Akhbar Anthony",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/arena_fighter": {
        slug: "arena_fighter",
        name: "Arena Fighter",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/aztec_priestess": {
        slug: "aztec_priestess",
        name: "Aztec Priestess",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bangla_beauty": {
        slug: "bangla_beauty",
        name: "Bangla Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bao_boon_chin": {
        slug: "bao_boon_chin",
        name: "Bao boon chin",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/big_small": {
        slug: "big_small",
        name: "Big Small",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/big_small_casino_royale": {
        slug: "big_small_casino_royale",
        name: "Big Small Casino Royale",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bingo_adventure": {
        slug: "bingo_adventure",
        name: "Bingo Adventure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bingo_carnaval": {
        slug: "bingo_carnaval",
        name: "Bingo Carnaval",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/blackjack_lucky_ladies": {
        slug: "blackjack_lucky_ladies",
        name: "Blackjack Lucky Ladies",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bombing_fishing": {
        slug: "bombing_fishing",
        name: "Bombing Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bone_fortune": {
        slug: "bone_fortune",
        name: "Bone Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bonus_hunter": {
        slug: "bonus_hunter",
        name: "Bonus Hunter",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/book_of_gold": {
        slug: "book_of_gold",
        name: "Book of Gold",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/boom_legend": {
        slug: "boom_legend",
        name: "Boom Legend",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/boxing_extravaganza": {
        slug: "boxing_extravaganza",
        name: "Boxing Extravaganza",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/boxing_king": {
        slug: "boxing_king",
        name: "Boxing King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/boxing_king_title_match": {
        slug: "boxing_king_title_match",
        name: "Boxing King Title Match",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bubble_beauty": {
        slug: "bubble_beauty",
        name: "Bubble Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/calaca_bingo": {
        slug: "calaca_bingo",
        name: "Calaca Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/candy_baby": {
        slug: "candy_baby",
        name: "Candy Baby",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/candyland_bingo": {
        slug: "candyland_bingo",
        name: "Candyland Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/cash_balloon": {
        slug: "cash_balloon",
        name: "Cash balloon",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/cash_stack": {
        slug: "cash_stack",
        name: "Cash Stack",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/charge_buffalo": {
        slug: "charge_buffalo",
        name: "Charge Buffalo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/charge_buffalo_ascent": {
        slug: "charge_buffalo_ascent",
        name: "Charge Buffalo Ascent",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/chicken_dash": {
        slug: "chicken_dash",
        name: "Chicken Dash",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/chicken_dash_1000": {
        slug: "chicken_dash_1000",
        name: "Chicken Dash 1000",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/chin_shi_huang": {
        slug: "chin_shi_huang",
        name: "Chin Shi Huang",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/circus_jackpot": {
        slug: "circus_jackpot",
        name: "Circus Jackpot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/circus_joker_4096": {
        slug: "circus_joker_4096",
        name: "Circus Joker 4096",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/clover_coins_3x3": {
        slug: "clover_coins_3x3",
        name: "Clover Coins 3x3",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/clover_coins_4x4": {
        slug: "clover_coins_4x4",
        name: "Clover Coins 4x4",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/coin_of_lightning": {
        slug: "coin_of_lightning",
        name: "Coin of Lightning",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/coin_tree": {
        slug: "coin_tree",
        name: "Coin Tree",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/color_game": {
        slug: "color_game",
        name: "Color Game",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/color_prediction": {
        slug: "color_prediction",
        name: "Color Prediction",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crash_bonus": {
        slug: "crash_bonus",
        name: "Crash Bonus",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crash_fruit": {
        slug: "crash_fruit",
        name: "Crash Fruit",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crash_puck": {
        slug: "crash_puck",
        name: "Crash Puck",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crash_touchdown": {
        slug: "crash_touchdown",
        name: "Crash Touchdown",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crash_trader": {
        slug: "crash_trader",
        name: "Crash Trader",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy_777_2": {
        slug: "crazy_777_2",
        name: "Crazy 777 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy_fafafa": {
        slug: "crazy_fafafa",
        name: "Crazy FaFaFa",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy_hunter": {
        slug: "crazy_hunter",
        name: "Crazy Hunter",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy_hunter_2": {
        slug: "crazy_hunter_2",
        name: "Crazy Hunter 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy_pusher": {
        slug: "crazy_pusher",
        name: "Crazy Pusher",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy777": {
        slug: "crazy777",
        name: "Crazy777",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/cricket_king_18": {
        slug: "cricket_king_18",
        name: "Cricket King 18",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/cricket_roulette": {
        slug: "cricket_roulette",
        name: "Cricket Roulette",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/cricket_sah_75": {
        slug: "cricket_sah_75",
        name: "Cricket Sah 75",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crown_of_fortune": {
        slug: "crown_of_fortune",
        name: "Crown of Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crystal_777_deluxe": {
        slug: "crystal_777_deluxe",
        name: "Crystal 777 Deluxe",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dabanggg": {
        slug: "dabanggg",
        name: "Dabanggg",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/devil_fire": {
        slug: "devil_fire",
        name: "Devil Fire",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/devil_fire_2": {
        slug: "devil_fire_2",
        name: "Devil Fire 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/devil_fire_twins": {
        slug: "devil_fire_twins",
        name: "Devil Fire Twins",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/diamondparty": {
        slug: "diamondparty",
        name: "DiamondParty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dice": {
        slug: "dice",
        name: "Dice",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dice_and_drop": {
        slug: "dice_and_drop",
        name: "Dice and Drop",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dinosaur_tycoon": {
        slug: "dinosaur_tycoon",
        name: "Dinosaur Tycoon",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dinosaur_tycoon_ii": {
        slug: "dinosaur_tycoon_ii",
        name: "Dinosaur Tycoon II",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dragon_and_tiger": {
        slug: "dragon_and_tiger",
        name: "Dragon and Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dragon_fortune": {
        slug: "dragon_fortune",
        name: "Dragon Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dragon_treasure": {
        slug: "dragon_treasure",
        name: "Dragon Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/drop_ball": {
        slug: "drop_ball",
        name: "Drop Ball",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/egypts_glow": {
        slug: "egypts_glow",
        name: "Egypt's Glow",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/elf_bingo": {
        slug: "elf_bingo",
        name: "Elf Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/extreme_color_game": {
        slug: "extreme_color_game",
        name: "Extreme Color Game",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fa_fa_fa": {
        slug: "fa_fa_fa",
        name: "Fa Fa Fa",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fengshen": {
        slug: "fengshen",
        name: "Fengshen",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/football_golden_cup": {
        slug: "football_golden_cup",
        name: "Football Golden Cup",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_bingo": {
        slug: "fortune_bingo",
        name: "Fortune Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_coins": {
        slug: "fortune_coins",
        name: "Fortune Coins",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_coins_2": {
        slug: "fortune_coins_2",
        name: "Fortune Coins 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gartuda_500": {
        slug: "fortune_gartuda_500",
        name: "Fortune Gartuda 500",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gems": {
        slug: "fortune_gems",
        name: "Fortune Gems",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gems_2": {
        slug: "fortune_gems_2",
        name: "Fortune Gems 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gems_3": {
        slug: "fortune_gems_3",
        name: "Fortune Gems 3",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gems_500": {
        slug: "fortune_gems_500",
        name: "Fortune Gems 500",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gems_scratch": {
        slug: "fortune_gems_scratch",
        name: "Fortune Gems Scratch",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_hook_boom": {
        slug: "fortune_hook_boom",
        name: "Fortune Hook Boom",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_king_jackpot": {
        slug: "fortune_king_jackpot",
        name: "Fortune King Jackpot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_monkey": {
        slug: "fortune_monkey",
        name: "Fortune Monkey",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_roulette": {
        slug: "fortune_roulette",
        name: "Fortune Roulette",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_tree": {
        slug: "fortune_tree",
        name: "Fortune Tree",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_zombie": {
        slug: "fortune_zombie",
        name: "Fortune Zombie",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortunepig": {
        slug: "fortunepig",
        name: "FortunePig",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/frog_dash": {
        slug: "frog_dash",
        name: "Frog Dash",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fruity_wheel": {
        slug: "fruity_wheel",
        name: "Fruity Wheel",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/gem_party": {
        slug: "gem_party",
        name: "Gem Party",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/go_for_champion": {
        slug: "go_for_champion",
        name: "Go for Champion",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/go_goal_bingo": {
        slug: "go_goal_bingo",
        name: "Go Goal BIngo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/go_rush": {
        slug: "go_rush",
        name: "Go Rush",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/god_of_martial": {
        slug: "god_of_martial",
        name: "God Of Martial",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/gold_rush": {
        slug: "gold_rush",
        name: "Gold Rush",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_bank": {
        slug: "golden_bank",
        name: "Golden Bank",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_bank_2": {
        slug: "golden_bank_2",
        name: "Golden Bank 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_empire": {
        slug: "golden_empire",
        name: "Golden Empire",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_empire_2": {
        slug: "golden_empire_2",
        name: "Golden Empire 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_joker": {
        slug: "golden_joker",
        name: "Golden Joker",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_land": {
        slug: "golden_land",
        name: "Golden Land",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_queen": {
        slug: "golden_queen",
        name: "Golden Queen",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_temple": {
        slug: "golden_temple",
        name: "Golden Temple",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_treasure": {
        slug: "golden_treasure",
        name: "Golden Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_treasure_lightning": {
        slug: "golden_treasure_lightning",
        name: "Golden Treasure Lightning",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/happy_fishing": {
        slug: "happy_fishing",
        name: "Happy Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/happy_taxi": {
        slug: "happy_taxi",
        name: "Happy Taxi",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/hawaii_beauty": {
        slug: "hawaii_beauty",
        name: "Hawaii Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/hilo": {
        slug: "hilo",
        name: "HILO",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/hot_chilli": {
        slug: "hot_chilli",
        name: "Hot Chilli",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/hyper_burst": {
        slug: "hyper_burst",
        name: "Hyper Burst",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/irich_bingo": {
        slug: "irich_bingo",
        name: "iRich Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_bingo": {
        slug: "jackpot_bingo",
        name: "Jackpot Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_fishing": {
        slug: "jackpot_fishing",
        name: "Jackpot Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_fishing_2_shoot_and_win": {
        slug: "jackpot_fishing_2_shoot_and_win",
        name: "Jackpot Fishing 2 Shoot and Win",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_football": {
        slug: "jackpot_football",
        name: "Jackpot Football",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_joker": {
        slug: "jackpot_joker",
        name: "Jackpot Joker",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_joker_fever": {
        slug: "jackpot_joker_fever",
        name: "Jackpot Joker Fever",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jili_caishen": {
        slug: "jili_caishen",
        name: "JILI CAISHEN",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jogo_do_bicho": {
        slug: "jogo_do_bicho",
        name: "Jogo do Bicho",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/joker_coins": {
        slug: "joker_coins",
        name: "Joker Coins",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jokers_fortune": {
        slug: "jokers_fortune",
        name: "Joker's Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/journey_west_m": {
        slug: "journey_west_m",
        name: "Journey West M",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jungle_king": {
        slug: "jungle_king",
        name: "Jungle King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/keno": {
        slug: "keno",
        name: "Keno",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/keno_bonus_number": {
        slug: "keno_bonus_number",
        name: "Keno Bonus Number",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/keno_extra_bet": {
        slug: "keno_extra_bet",
        name: "Keno Extra Bet",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/king_arthur": {
        slug: "king_arthur",
        name: "King Arthur",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/limbo": {
        slug: "limbo",
        name: "Limbo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_ball": {
        slug: "lucky_ball",
        name: "Lucky Ball",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_bingo": {
        slug: "lucky_bingo",
        name: "Lucky Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_caramelo": {
        slug: "lucky_caramelo",
        name: "Lucky Caramelo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_coming": {
        slug: "lucky_coming",
        name: "Lucky Coming",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_goldbricks": {
        slug: "lucky_goldbricks",
        name: "Lucky Goldbricks",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_jaguar": {
        slug: "lucky_jaguar",
        name: "Lucky Jaguar",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_jaguar_2": {
        slug: "lucky_jaguar_2",
        name: "Lucky Jaguar 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_macaw": {
        slug: "lucky_macaw",
        name: "Lucky Macaw",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_number": {
        slug: "lucky_number",
        name: "Lucky Number",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_tiger": {
        slug: "lucky_tiger",
        name: "Lucky Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/magic_lamp": {
        slug: "magic_lamp",
        name: "Magic Lamp",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/magic_lamp_bingo": {
        slug: "magic_lamp_bingo",
        name: "Magic Lamp Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/master_tiger": {
        slug: "master_tiger",
        name: "Master Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mayan_empire": {
        slug: "mayan_empire",
        name: "Mayan Empire",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/medusa": {
        slug: "medusa",
        name: "Medusa",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mega_ace": {
        slug: "mega_ace",
        name: "Mega Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mega_fishing": {
        slug: "mega_fishing",
        name: "Mega Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mines": {
        slug: "mines",
        name: "Mines",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mines_cricket": {
        slug: "mines_cricket",
        name: "Mines Cricket",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mines_football": {
        slug: "mines_football",
        name: "Mines football",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mines_gold": {
        slug: "mines_gold",
        name: "Mines Gold",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mines_grand": {
        slug: "mines_grand",
        name: "Mines Grand",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/money_coming": {
        slug: "money_coming",
        name: "Money Coming",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/money_coming_2": {
        slug: "money_coming_2",
        name: "Money Coming 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/money_pot": {
        slug: "money_pot",
        name: "Money Pot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/monkey_party": {
        slug: "monkey_party",
        name: "Monkey Party",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/neko_fortune": {
        slug: "neko_fortune",
        name: "Neko Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/night_city": {
        slug: "night_city",
        name: "Night City",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/nightfall_hunting": {
        slug: "nightfall_hunting",
        name: "Nightfall Hunting",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/number_king": {
        slug: "number_king",
        name: "Number King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/ocean_king_jackpot": {
        slug: "ocean_king_jackpot",
        name: "Ocean King Jackpot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pappu": {
        slug: "pappu",
        name: "PAPPU",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/party_ape": {
        slug: "party_ape",
        name: "Party Ape",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/party_night": {
        slug: "party_night",
        name: "Party Night",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pearls_of_bingo": {
        slug: "pearls_of_bingo",
        name: "Pearls of Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/penalty_kicks": {
        slug: "penalty_kicks",
        name: "Penalty Kicks",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pharaoh_treasure": {
        slug: "pharaoh_treasure",
        name: "Pharaoh Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pirate_queen": {
        slug: "pirate_queen",
        name: "Pirate Queen",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pirate_queen_2": {
        slug: "pirate_queen_2",
        name: "Pirate Queen 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/plinko_football": {
        slug: "plinko_football",
        name: "Plinko Football",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/plinko_of_mine": {
        slug: "plinko_of_mine",
        name: "Plinko of Mine",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/poker_king": {
        slug: "poker_king",
        name: "Poker King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/poseidon": {
        slug: "poseidon",
        name: "Poseidon",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/potion_wizard": {
        slug: "potion_wizard",
        name: "Potion Wizard",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pusoy_go": {
        slug: "pusoy_go",
        name: "Pusoy Go",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/rapid_gems_777": {
        slug: "rapid_gems_777",
        name: "Rapid Gems 777",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/roma_x_10000": {
        slug: "roma_x_10000",
        name: "Roma X 10000",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/roma_x_deluxe": {
        slug: "roma_x_deluxe",
        name: "Roma X Deluxe",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/romax": {
        slug: "romax",
        name: "RomaX",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/royal_fishing": {
        slug: "royal_fishing",
        name: "Royal Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/royal_quest": {
        slug: "royal_quest",
        name: "Royal Quest",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/rummy": {
        slug: "rummy",
        name: "Rummy",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/samba": {
        slug: "samba",
        name: "Samba",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/secret_treasure": {
        slug: "secret_treasure",
        name: "Secret Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/sevensevenseven": {
        slug: "sevensevenseven",
        name: "SevenSevenSeven",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/shanghai_beauty": {
        slug: "shanghai_beauty",
        name: "Shanghai Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/shogun": {
        slug: "shogun",
        name: "Shogun",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/sic_bo": {
        slug: "sic_bo",
        name: "Sic Bo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/sin_city": {
        slug: "sin_city",
        name: "Sin City",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/speed_andar_bahar": {
        slug: "speed_andar_bahar",
        name: "Speed Andar Bahar",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/speed_baccarat": {
        slug: "speed_baccarat",
        name: "Speed Baccarat",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/storm_of_seth_2": {
        slug: "storm_of_seth_2",
        name: "Storm of Seth 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_ace": {
        slug: "super_ace",
        name: "Super Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_ace_ii": {
        slug: "super_ace_ii",
        name: "Super Ace II",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_ace_joker": {
        slug: "super_ace_joker",
        name: "Super Ace Joker",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_ace_speed": {
        slug: "super_ace_speed",
        name: "Super Ace SPEED",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_bingo": {
        slug: "super_bingo",
        name: "Super Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_esabong": {
        slug: "super_esabong",
        name: "Super E-Sabong",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_rich": {
        slug: "super_rich",
        name: "Super Rich",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/supernova": {
        slug: "supernova",
        name: "Supernova",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/sweet_land": {
        slug: "sweet_land",
        name: "Sweet Land",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/sweet_magic": {
        slug: "sweet_magic",
        name: "Sweet Magic",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/teenpatti": {
        slug: "teenpatti",
        name: "TeenPatti",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/thai_hilo": {
        slug: "thai_hilo",
        name: "Thai Hilo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/thor_dice": {
        slug: "thor_dice",
        name: "Thor Dice",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/thor_x": {
        slug: "thor_x",
        name: "Thor X",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/tongits_go": {
        slug: "tongits_go",
        name: "Tongits Go",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/tower": {
        slug: "tower",
        name: "Tower",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/treasure_quest": {
        slug: "treasure_quest",
        name: "Treasure Quest",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/trial_of_phoenix": {
        slug: "trial_of_phoenix",
        name: "Trial of Phoenix",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/twin_wins": {
        slug: "twin_wins",
        name: "TWIN WINS",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/ultimate_texas_holdem": {
        slug: "ultimate_texas_holdem",
        name: "Ultimate Texas Hold'em",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/video_poker": {
        slug: "video_poker",
        name: "Video Poker",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/west_hunter_bingo": {
        slug: "west_hunter_bingo",
        name: "West Hunter Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/wheel": {
        slug: "wheel",
        name: "Wheel",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/wild_ace": {
        slug: "wild_ace",
        name: "Wild Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/wild_racer": {
        slug: "wild_racer",
        name: "Wild Racer",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/win_drop": {
        slug: "win_drop",
        name: "Win Drop",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/witches_night": {
        slug: "witches_night",
        name: "Witches Night",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/world_cup": {
        slug: "world_cup",
        name: "World Cup",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/xiyangyang": {
        slug: "xiyangyang",
        name: "XiYangYang",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/zeus": {
        slug: "zeus",
        name: "Zeus",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "manna-play/88_ya": {
        slug: "88_ya",
        name: "88 Ya",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/88fa": {
        slug: "88fa",
        name: "88FA",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/aloha_cuties_jp": {
        slug: "aloha_cuties_jp",
        name: "Aloha Cuties JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queen_dating": {
        slug: "bikini_queen_dating",
        name: "Bikini Queen Dating",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queens": {
        slug: "bikini_queens",
        name: "Bikini Queens",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queens_live": {
        slug: "bikini_queens_live",
        name: "Bikini Queens Live",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queens_making_waves": {
        slug: "bikini_queens_making_waves",
        name: "Bikini Queens Making Waves",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queens_xmas": {
        slug: "bikini_queens_xmas",
        name: "Bikini Queens Xmas",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bingo_fun": {
        slug: "bingo_fun",
        name: "Bingo Fun",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bounty_hunter": {
        slug: "bounty_hunter",
        name: "Bounty Hunter",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bull_fafa": {
        slug: "bull_fafa",
        name: "Bull FaFa",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/candy_rocket": {
        slug: "candy_rocket",
        name: "Candy Rocket",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/candy_storm_rainbow_rush": {
        slug: "candy_storm_rainbow_rush",
        name: "Candy Storm Rainbow Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/carnival_beats": {
        slug: "carnival_beats",
        name: "Carnival Beats",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/choi_sun_yeah_jp": {
        slug: "choi_sun_yeah_jp",
        name: "Choi Sun Yeah JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/cleopatras_code": {
        slug: "cleopatras_code",
        name: "Cleopatra's Code",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/coin_tank": {
        slug: "coin_tank",
        name: "Coin Tank",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/cougar_gold": {
        slug: "cougar_gold",
        name: "Cougar Gold",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/cougar_roar": {
        slug: "cougar_roar",
        name: "Cougar Roar",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/danssser": {
        slug: "danssser",
        name: "Danssser",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/diamond_777_plus": {
        slug: "diamond_777_plus",
        name: "Diamond 777 Plus",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/diamond_love_777": {
        slug: "diamond_love_777",
        name: "Diamond Love 777",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/diamond_storm": {
        slug: "diamond_storm",
        name: "Diamond Storm",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/diamond_storm_jewel_blast": {
        slug: "diamond_storm_jewel_blast",
        name: "Diamond Storm Jewel Blast",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/double_dragons": {
        slug: "double_dragons",
        name: "Double Dragons",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragon_emperor": {
        slug: "dragon_emperor",
        name: "Dragon Emperor",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragon_reborn": {
        slug: "dragon_reborn",
        name: "Dragon Reborn",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragon_reborn_rush": {
        slug: "dragon_reborn_rush",
        name: "Dragon Reborn Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragon_x_tiger": {
        slug: "dragon_x_tiger",
        name: "Dragon X Tiger",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragon_x_tiger_ii": {
        slug: "dragon_x_tiger_ii",
        name: "Dragon X Tiger II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragons_hoard": {
        slug: "dragons_hoard",
        name: "Dragon's Hoard",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragons_legend": {
        slug: "dragons_legend",
        name: "Dragons Legend",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/elves_kingdom": {
        slug: "elves_kingdom",
        name: "Elves Kingdom",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fa_choi_tree_jp": {
        slug: "fa_choi_tree_jp",
        name: "Fa Choi Tree JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fancy_alice": {
        slug: "fancy_alice",
        name: "Fancy Alice",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fortune_dragon_3": {
        slug: "fortune_dragon_3",
        name: "Fortune Dragon 3",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fortune_dragon_ii": {
        slug: "fortune_dragon_ii",
        name: "Fortune Dragon II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fortune_fish": {
        slug: "fortune_fish",
        name: "Fortune Fish",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fortune_lucky_jp": {
        slug: "fortune_lucky_jp",
        name: "Fortune Lucky JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/four_saint_treasure": {
        slug: "four_saint_treasure",
        name: "Four Saint Treasure",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fruit_saga": {
        slug: "fruit_saga",
        name: "Fruit Saga",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fruit_splash": {
        slug: "fruit_splash",
        name: "Fruit Splash",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fufu_fa_jp": {
        slug: "fufu_fa_jp",
        name: "Fufu Fa JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/ganesha_lucky": {
        slug: "ganesha_lucky",
        name: "Ganesha Lucky",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/ganesha_shine": {
        slug: "ganesha_shine",
        name: "Ganesha Shine",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/gem_hunter": {
        slug: "gem_hunter",
        name: "Gem Hunter",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/gem_hunter_crash": {
        slug: "gem_hunter_crash",
        name: "Gem Hunter Crash",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/gem_princess": {
        slug: "gem_princess",
        name: "Gem Princess",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_buffalo_rush": {
        slug: "golden_buffalo_rush",
        name: "Golden Buffalo Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_dragon_ii": {
        slug: "golden_dragon_ii",
        name: "Golden Dragon II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_egypt": {
        slug: "golden_egypt",
        name: "Golden Egypt",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_mouse": {
        slug: "golden_mouse",
        name: "Golden Mouse",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_mouse_3": {
        slug: "golden_mouse_3",
        name: "Golden Mouse 3",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_sea": {
        slug: "golden_sea",
        name: "Golden Sea",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_try": {
        slug: "golden_try",
        name: "Golden Try",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/hey_fu_cai": {
        slug: "hey_fu_cai",
        name: "Hey Fu Cai",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/high_up": {
        slug: "high_up",
        name: "High UP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/jumping_frog": {
        slug: "jumping_frog",
        name: "Jumping Frog",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/king_lion": {
        slug: "king_lion",
        name: "King Lion",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/legacy_of_egypt_jp": {
        slug: "legacy_of_egypt_jp",
        name: "Legacy of Egypt JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/legend_of_atlantis": {
        slug: "legend_of_atlantis",
        name: "Legend of Atlantis",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/legend_of_piggies_royal_edition": {
        slug: "legend_of_piggies_royal_edition",
        name: "Legend of Piggies Royal Edition",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_4_spirits": {
        slug: "lucky_4_spirits",
        name: "Lucky 4 Spirits",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_bunny_eggs_bonanza": {
        slug: "lucky_bunny_eggs_bonanza",
        name: "Lucky Bunny Eggs Bonanza",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_calico_mahjong": {
        slug: "lucky_calico_mahjong",
        name: "Lucky Calico Mahjong",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_cat_and_maid_rush": {
        slug: "lucky_cat_and_maid_rush",
        name: "Lucky Cat & Maid Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_gallops_mega": {
        slug: "lucky_gallops_mega",
        name: "Lucky Gallops Mega",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/magic_jewels": {
        slug: "magic_jewels",
        name: "Magic Jewels",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mahjong_master": {
        slug: "mahjong_master",
        name: "Mahjong Master",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mahjong_master_2": {
        slug: "mahjong_master_2",
        name: "Mahjong Master 2",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mega_dragon": {
        slug: "mega_dragon",
        name: "Mega Dragon",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mega_fruits_777": {
        slug: "mega_fruits_777",
        name: "Mega Fruits 777",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/misa_augur_swettie": {
        slug: "misa_augur_swettie",
        name: "Misa Augur Swettie",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mouse_gold_mega_edition": {
        slug: "mouse_gold_mega_edition",
        name: "Mouse Gold Mega Edition",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mouse_gold_rush": {
        slug: "mouse_gold_rush",
        name: "Mouse Gold Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/muay_thai_unlimited_ii": {
        slug: "muay_thai_unlimited_ii",
        name: "Muay Thai Unlimited II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/ninja_master": {
        slug: "ninja_master",
        name: "Ninja Master",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/pirate_queen_treasure_raid": {
        slug: "pirate_queen_treasure_raid",
        name: "Pirate Queen: Treasure Raid",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/pirates_gold": {
        slug: "pirates_gold",
        name: "Pirate's Gold",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/pirates_gold_jp": {
        slug: "pirates_gold_jp",
        name: "Pirates Gold JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/pixel_eater": {
        slug: "pixel_eater",
        name: "Pixel Eater",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/space_candy_enhanced": {
        slug: "space_candy_enhanced",
        name: "Space Candy Enhanced",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/splash_party": {
        slug: "splash_party",
        name: "Splash Party",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/sushi_cat": {
        slug: "sushi_cat",
        name: "Sushi Cat",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/sweet_paradise": {
        slug: "sweet_paradise",
        name: "Sweet Paradise",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/sweets_paradise_jp": {
        slug: "sweets_paradise_jp",
        name: "Sweets Paradise JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/taisho_samurai": {
        slug: "taisho_samurai",
        name: "Taisho Samurai",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/the_eye_of_horus": {
        slug: "the_eye_of_horus",
        name: "The Eye of Horus",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/tokyo_sweeties": {
        slug: "tokyo_sweeties",
        name: "Tokyo Sweeties",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/tokyo_sweeties_jp": {
        slug: "tokyo_sweeties_jp",
        name: "Tokyo Sweeties JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/treasure_comet": {
        slug: "treasure_comet",
        name: "Treasure Comet",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/true_dragon_x": {
        slug: "true_dragon_x",
        name: "True Dragon X",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/wild_buffalo": {
        slug: "wild_buffalo",
        name: "Wild Buffalo",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/wild_joker": {
        slug: "wild_joker",
        name: "Wild Joker",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/wild_pirates": {
        slug: "wild_pirates",
        name: "Wild Pirates",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/wolf_moon": {
        slug: "wolf_moon",
        name: "Wolf Moon",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/wolf_queen": {
        slug: "wolf_queen",
        name: "Wolf Queen",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/yokai_village": {
        slug: "yokai_village",
        name: "Yokai Village",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "million-games/book_of_love": {
        slug: "book_of_love",
        name: "Book of Love",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/captains_curse": {
        slug: "captains_curse",
        name: "Captain's Curse",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/chicken_x": {
        slug: "chicken_x",
        name: "Chicken X",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/chicken_x_and_friends": {
        slug: "chicken_x_and_friends",
        name: "Chicken X and Friends",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/coco_rush": {
        slug: "coco_rush",
        name: "Coco Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/draw_sevens": {
        slug: "draw_sevens",
        name: "Draw Sevens",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/druids_drop": {
        slug: "druids_drop",
        name: "Druid's Drop",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/east_west_wild": {
        slug: "east_west_wild",
        name: "East West Wild",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/farm_frenzy": {
        slug: "farm_frenzy",
        name: "Farm Frenzy",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/fortune_fairies_holdandwin": {
        slug: "fortune_fairies_holdandwin",
        name: "Fortune Fairies Hold&Win",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/freakshow_hotel": {
        slug: "freakshow_hotel",
        name: "Freakshow Hotel",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/gatsby_gold_booster_bar": {
        slug: "gatsby_gold_booster_bar",
        name: "Gatsby Gold Booster Bar",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/ghost_harbour": {
        slug: "ghost_harbour",
        name: "Ghost Harbour",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/give_me_the_money": {
        slug: "give_me_the_money",
        name: "Give Me The Money",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/goblin_brew": {
        slug: "goblin_brew",
        name: "Goblin Brew",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/golden_chase_booster_bar": {
        slug: "golden_chase_booster_bar",
        name: "Golden Chase Booster Bar",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/halloween_queen": {
        slug: "halloween_queen",
        name: "Halloween Queen",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/hard_eight_poker": {
        slug: "hard_eight_poker",
        name: "Hard Eight Poker",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/icarus_wilds": {
        slug: "icarus_wilds",
        name: "Icarus Wilds",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/infinite_x": {
        slug: "infinite_x",
        name: "Infinite X",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/island_ices": {
        slug: "island_ices",
        name: "Island Ices",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/looting_raccoons": {
        slug: "looting_raccoons",
        name: "Looting Raccoons",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_baccarat": {
        slug: "million_baccarat",
        name: "Million Baccarat",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_blackjack_london_deal": {
        slug: "million_blackjack_london_deal",
        name: "Million Blackjack London Deal",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_blackjack_peek": {
        slug: "million_blackjack_peek",
        name: "Million Blackjack Peek",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_dice": {
        slug: "million_dice",
        name: "Million Dice",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_hilo": {
        slug: "million_hilo",
        name: "Million HiLo",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_mine": {
        slug: "million_mine",
        name: "Million Mine",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_plinko": {
        slug: "million_plinko",
        name: "Million Plinko",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_wheel": {
        slug: "million_wheel",
        name: "Million Wheel",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/perfect_catch": {
        slug: "perfect_catch",
        name: "Perfect Catch",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/piggy_rush": {
        slug: "piggy_rush",
        name: "Piggy Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/riches_of_zeus": {
        slug: "riches_of_zeus",
        name: "Riches of Zeus",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/rudolphs_gone_rogue": {
        slug: "rudolphs_gone_rogue",
        name: "Rudolph's Gone Rogue",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/skull_kings_treasure": {
        slug: "skull_kings_treasure",
        name: "Skull King's Treasure",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/temple_treasure_holdandwin": {
        slug: "temple_treasure_holdandwin",
        name: "Temple Treasure Hold&Win",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/temple_x": {
        slug: "temple_x",
        name: "Temple X",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/thorfinns_journey": {
        slug: "thorfinns_journey",
        name: "Thorfinn's Journey",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/van_gogh": {
        slug: "van_gogh",
        name: "Van Gogh",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/vault_rush": {
        slug: "vault_rush",
        name: "Vault Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/wild_island": {
        slug: "wild_island",
        name: "Wild Island",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/xmas_rush": {
        slug: "xmas_rush",
        name: "Xmas Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/yin_and_yang": {
        slug: "yin_and_yang",
        name: "Yin & Yang",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "netent/101_candies": {
        slug: "101_candies",
        name: "101 Candies",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/aloha_christmas": {
        slug: "aloha_christmas",
        name: "Aloha! Christmas",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/aloha_cluster_pays": {
        slug: "aloha_cluster_pays",
        name: "Aloha! Cluster Pays",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/arcane_reel_chaos": {
        slug: "arcane_reel_chaos",
        name: "Arcane: Reel Chaos",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/archangels_salvation": {
        slug: "archangels_salvation",
        name: "Archangels Salvation",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/asgardian_stones": {
        slug: "asgardian_stones",
        name: "Asgardian Stones",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/babylon_riches": {
        slug: "babylon_riches",
        name: "Babylon Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/beach_invaders": {
        slug: "beach_invaders",
        name: "Beach Invaders",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/bee_hive_bonanza": {
        slug: "bee_hive_bonanza",
        name: "Bee Hive Bonanza",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/berry_burst_max": {
        slug: "berry_burst_max",
        name: "Berry burst MAX",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/berryburst": {
        slug: "berryburst",
        name: "Berryburst",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/big_bang_boom": {
        slug: "big_bang_boom",
        name: "Big Bang Boom",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/big_money_wheel": {
        slug: "big_money_wheel",
        name: "Big Money Wheel",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/blood_suckers": {
        slug: "blood_suckers",
        name: "Blood Suckers",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/blood_suckers_ii": {
        slug: "blood_suckers_ii",
        name: "Blood Suckers II",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/buckshot_wilds": {
        slug: "buckshot_wilds",
        name: "Buckshot Wilds",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/busters_bones": {
        slug: "busters_bones",
        name: "Buster's Bones",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/butterfly_staxx": {
        slug: "butterfly_staxx",
        name: "Butterfly Staxx",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/butterfly_staxx_2": {
        slug: "butterfly_staxx_2",
        name: "Butterfly Staxx 2",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/cash_noire": {
        slug: "cash_noire",
        name: "Cash Noire",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/cashomatic": {
        slug: "cashomatic",
        name: "Cash-o-Matic",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/casino_night": {
        slug: "casino_night",
        name: "Casino Night",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/codex_of_fortune": {
        slug: "codex_of_fortune",
        name: "Codex of Fortune",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/coins_of_egypt": {
        slug: "coins_of_egypt",
        name: "Coins of Egypt",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/cornelius": {
        slug: "cornelius",
        name: "Cornelius",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/cornelius_milk_hunter_megaways": {
        slug: "cornelius_milk_hunter_megaways",
        name: "Cornelius Milk Hunter Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/crab_trap": {
        slug: "crab_trap",
        name: "Crab Trap",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/creature_from_the_black_lagoon": {
        slug: "creature_from_the_black_lagoon",
        name: "Creature from the Black Lagoon",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/cupcakes": {
        slug: "cupcakes",
        name: "Cupcakes",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/cursed_treasure": {
        slug: "cursed_treasure",
        name: "Cursed treasure",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dark_king_forbidden_riches": {
        slug: "dark_king_forbidden_riches",
        name: "Dark King: Forbidden Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dazzle_me": {
        slug: "dazzle_me",
        name: "Dazzle Me",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dazzle_me_megaways": {
        slug: "dazzle_me_megaways",
        name: "Dazzle Me Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dead_or_alive": {
        slug: "dead_or_alive",
        name: "Dead or Alive",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dead_or_alive_2": {
        slug: "dead_or_alive_2",
        name: "Dead or Alive 2",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dead_or_alive_2_feature_buy": {
        slug: "dead_or_alive_2_feature_buy",
        name: "Dead or Alive 2 Feature Buy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dead_or_alive_3": {
        slug: "dead_or_alive_3",
        name: "Dead or Alive 3",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dead_west": {
        slug: "dead_west",
        name: "Dead West",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/disco_danny": {
        slug: "disco_danny",
        name: "Disco Danny",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/divine_fortune_black": {
        slug: "divine_fortune_black",
        name: "Divine Fortune Black",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/divine_fortune_gold": {
        slug: "divine_fortune_gold",
        name: "Divine Fortune Gold",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/divine_fortune_megaways": {
        slug: "divine_fortune_megaways",
        name: "Divine Fortune Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dont_eat_the_candy": {
        slug: "dont_eat_the_candy",
        name: "Don’t Eat The Candy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/double_stacks": {
        slug: "double_stacks",
        name: "Double Stacks",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dracula": {
        slug: "dracula",
        name: "Dracula",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/dragons_playground": {
        slug: "dragons_playground",
        name: "Dragons Playground",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/drive_multiplier_mayhem": {
        slug: "drive_multiplier_mayhem",
        name: "Drive: Multiplier Mayhem",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/druids_dream": {
        slug: "druids_dream",
        name: "Druids' Dream",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/druids_magic": {
        slug: "druids_magic",
        name: "Druid's Magic",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/east_sea_dragon_king": {
        slug: "east_sea_dragon_king",
        name: "East Sea Dragon King",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/eggomatic": {
        slug: "eggomatic",
        name: "EggOMatic",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/elements_the_awakening": {
        slug: "elements_the_awakening",
        name: "Elements: The Awakening",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/elk_hunter": {
        slug: "elk_hunter",
        name: "Elk Hunter",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/excalibur": {
        slug: "excalibur",
        name: "Excalibur",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fairytale_legends_hansel_and_gretel": {
        slug: "fairytale_legends_hansel_and_gretel",
        name: "Fairytale Legends: Hansel and Gretel",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fairytale_legends_mirror_mirror": {
        slug: "fairytale_legends_mirror_mirror",
        name: "Fairytale Legends: Mirror Mirror",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fairytale_legends_red_riding_hood": {
        slug: "fairytale_legends_red_riding_hood",
        name: "Fairytale Legends: Red Riding Hood",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/finn_and_the_candy_spin": {
        slug: "finn_and_the_candy_spin",
        name: "Finn and The Candy Spin",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/finn_and_the_dragon_tales": {
        slug: "finn_and_the_dragon_tales",
        name: "Finn and the Dragon Tales",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/finn_and_the_swirly_spin": {
        slug: "finn_and_the_swirly_spin",
        name: "Finn and the Swirly Spin",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/finns_golden_tavern": {
        slug: "finns_golden_tavern",
        name: "Finn's Golden Tavern",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/flock_me": {
        slug: "flock_me",
        name: "Flock Me",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/flowers": {
        slug: "flowers",
        name: "Flowers",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/flowers_christmas_edition": {
        slug: "flowers_christmas_edition",
        name: "Flowers Christmas Edition",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/football_champions_cup": {
        slug: "football_champions_cup",
        name: "Football: Champions Cup",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fortune_rangers": {
        slug: "fortune_rangers",
        name: "Fortune Rangers",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fruit_blaze": {
        slug: "fruit_blaze",
        name: "Fruit Blaze",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fruit_case": {
        slug: "fruit_case",
        name: "Fruit Case",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fruit_shop": {
        slug: "fruit_shop",
        name: "Fruit Shop",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fruit_shop_christmas_edition": {
        slug: "fruit_shop_christmas_edition",
        name: "Fruit Shop Christmas Edition",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fruit_shop_frenzy": {
        slug: "fruit_shop_frenzy",
        name: "Fruit Shop Frenzy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fruit_shop_grand_reopening": {
        slug: "fruit_shop_grand_reopening",
        name: "Fruit Shop Grand Re-Opening",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fruit_shop_megaways": {
        slug: "fruit_shop_megaways",
        name: "Fruit Shop Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/fruit_spin": {
        slug: "fruit_spin",
        name: "Fruit Spin",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/funk_master": {
        slug: "funk_master",
        name: "Funk Master",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/gem_crush": {
        slug: "gem_crush",
        name: "Gem Crush",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/ghost_pirates": {
        slug: "ghost_pirates",
        name: "Ghost Pirates",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/gladiator_clash": {
        slug: "gladiator_clash",
        name: "Gladiator Clash",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/go_bananas": {
        slug: "go_bananas",
        name: "Go Bananas!",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/godbreaker": {
        slug: "godbreaker",
        name: "Godbreaker",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/gods_of_gold_infinireels": {
        slug: "gods_of_gold_infinireels",
        name: "Gods Of Gold: InfiniReels",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/golden_egg_invaders": {
        slug: "golden_egg_invaders",
        name: "Golden Egg Invaders",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/golden_grimoire": {
        slug: "golden_grimoire",
        name: "Golden Grimoire",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/golden_realms": {
        slug: "golden_realms",
        name: "Golden Realms",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/golden_wheels_of_egypt": {
        slug: "golden_wheels_of_egypt",
        name: "Golden Wheels of Egypt",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/gonzos_gold": {
        slug: "gonzos_gold",
        name: "Gonzo's Gold",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/gonzos_quest": {
        slug: "gonzos_quest",
        name: "Gonzo's Quest",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/gonzos_quest_2_return_to_el_dorado": {
        slug: "gonzos_quest_2_return_to_el_dorado",
        name: "Gonzo's Quest 2 Return to El Dorado",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/good_old_7s": {
        slug: "good_old_7s",
        name: "Good Old 7's",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/gordon_ramsay_hells_kitchen": {
        slug: "gordon_ramsay_hells_kitchen",
        name: "Gordon Ramsay Hell’s Kitchen",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/gorilla_kingdom": {
        slug: "gorilla_kingdom",
        name: "Gorilla Kingdom",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/grand_spinn": {
        slug: "grand_spinn",
        name: "Grand Spinn",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/guns_n_roses_video_slots": {
        slug: "guns_n_roses_video_slots",
        name: "Guns N' Roses video Slots",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/halloween_jack": {
        slug: "halloween_jack",
        name: "Halloween Jack",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/happy_riches": {
        slug: "happy_riches",
        name: "Happy Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/hooks_heroes": {
        slug: "hooks_heroes",
        name: "Hook's Heroes",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/hotline": {
        slug: "hotline",
        name: "Hotline",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/hotline_2": {
        slug: "hotline_2",
        name: "Hotline 2",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/in_and_out": {
        slug: "in_and_out",
        name: "In and Out",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/irish_pot_luck": {
        slug: "irish_pot_luck",
        name: "Irish Pot Luck",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jack_and_the_beanstalk_remastered": {
        slug: "jack_and_the_beanstalk_remastered",
        name: "Jack and the Beanstalk Remastered",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jack_hammer": {
        slug: "jack_hammer",
        name: "Jack Hammer",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jack_hammer_2_fishy_business": {
        slug: "jack_hammer_2_fishy_business",
        name: "Jack Hammer 2: Fishy Business",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jack_hammer_3_diamond_affair": {
        slug: "jack_hammer_3_diamond_affair",
        name: "Jack Hammer 3: Diamond Affair",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jack_hammer_4_chasing_the_dragon": {
        slug: "jack_hammer_4_chasing_the_dragon",
        name: "Jack Hammer 4: Chasing the Dragon",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jacks_or_better_double_up": {
        slug: "jacks_or_better_double_up",
        name: "Jacks or Better Double Up",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jelly_belly_megaways": {
        slug: "jelly_belly_megaways",
        name: "Jelly Belly Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jimi_hendrix_online_slot": {
        slug: "jimi_hendrix_online_slot",
        name: "Jimi Hendrix Online Slot",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jingle_bells_bonanza": {
        slug: "jingle_bells_bonanza",
        name: "Jingle Bells Bonanza",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jingle_spin": {
        slug: "jingle_spin",
        name: "Jingle Spin",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/joker_pro": {
        slug: "joker_pro",
        name: "Joker Pro",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jumanji": {
        slug: "jumanji",
        name: "Jumanji",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jungle_spirit_call_of_the_wild": {
        slug: "jungle_spirit_call_of_the_wild",
        name: "Jungle Spirit: Call of the Wild",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/jungle_spirit_megaways": {
        slug: "jungle_spirit_megaways",
        name: "Jungle Spirit Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/king_of_3_kingdoms": {
        slug: "king_of_3_kingdoms",
        name: "King of 3 Kingdoms",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/king_of_slots": {
        slug: "king_of_slots",
        name: "King of Slots",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/knight_rider": {
        slug: "knight_rider",
        name: "Knight Rider",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/koi_princess": {
        slug: "koi_princess",
        name: "Koi Princess",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/leprechaun_joy": {
        slug: "leprechaun_joy",
        name: "Leprechaun Joy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/let_it_burn": {
        slug: "let_it_burn",
        name: "Let It Burn",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/lights": {
        slug: "lights",
        name: "Lights",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/lights_camera_cash": {
        slug: "lights_camera_cash",
        name: "Lights, Camera, Cash!",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/lock_and_pop": {
        slug: "lock_and_pop",
        name: "Lock and Pop",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/long_pao": {
        slug: "long_pao",
        name: "Long Pao",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/lost_relics": {
        slug: "lost_relics",
        name: "Lost Relics",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/lucky_angler_a_snowy_catch": {
        slug: "lucky_angler_a_snowy_catch",
        name: "Lucky Angler: A Snowy Catch",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/magic_lab": {
        slug: "magic_lab",
        name: "Magic lab",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/magic_maid_cafe": {
        slug: "magic_maid_cafe",
        name: "Magic Maid Cafe",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/mermaids": {
        slug: "mermaids",
        name: "Mermaids",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/milkshake_xxxtreme": {
        slug: "milkshake_xxxtreme",
        name: "Milkshake XXXtreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/mine_blown": {
        slug: "mine_blown",
        name: "Mine Blown",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/monopoly_money_line": {
        slug: "monopoly_money_line",
        name: "Monopoly Money Line",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/motorhead_video_slot": {
        slug: "motorhead_video_slot",
        name: "Motorhead Video Slot",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/ms_robin_hood": {
        slug: "ms_robin_hood",
        name: "Ms Robin Hood",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/mummy_megaways": {
        slug: "mummy_megaways",
        name: "Mummy MegaWays",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/mythic_maiden": {
        slug: "mythic_maiden",
        name: "Mythic Maiden",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/narcos": {
        slug: "narcos",
        name: "Narcos",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/neon_staxx": {
        slug: "neon_staxx",
        name: "Neon Staxx",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/oceans_treasure": {
        slug: "oceans_treasure",
        name: "Ocean's Treasure",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/ozzy_osbourne_video_slots": {
        slug: "ozzy_osbourne_video_slots",
        name: "Ozzy Osbourne Video Slots",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/pandoras_treasure": {
        slug: "pandoras_treasure",
        name: "Pandora’s Treasure",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/parthenon_quest_for_immortality": {
        slug: "parthenon_quest_for_immortality",
        name: "Parthenon: Quest for Immortality",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/piggy_riches": {
        slug: "piggy_riches",
        name: "Piggy Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/piggy_riches_3_hog_heaven": {
        slug: "piggy_riches_3_hog_heaven",
        name: "Piggy Riches 3 Hog Heaven",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/pirates_party": {
        slug: "pirates_party",
        name: "Pirates Party",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/pyramid_quest_for_immortality": {
        slug: "pyramid_quest_for_immortality",
        name: "Pyramid: Quest for Immortality",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/rabid_randy": {
        slug: "rabid_randy",
        name: "Rabid Randy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/rage": {
        slug: "rage",
        name: "Rage",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/rage_of_the_seas": {
        slug: "rage_of_the_seas",
        name: "Rage of the Seas",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/rainforest_gold": {
        slug: "rainforest_gold",
        name: "Rainforest Gold",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/rapid_randy_dark_trails": {
        slug: "rapid_randy_dark_trails",
        name: "Rapid Randy Dark Trails",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/reef_raider": {
        slug: "reef_raider",
        name: "Reef Raider",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/reel_rush": {
        slug: "reel_rush",
        name: "Reel Rush",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/reel_rush_2": {
        slug: "reel_rush_2",
        name: "Reel Rush 2",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/reel_rush_xxxtreme": {
        slug: "reel_rush_xxxtreme",
        name: "Reel Rush XXXTreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/reel_steal": {
        slug: "reel_steal",
        name: "Reel Steal",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/riches_of_midgard_land_and_expand": {
        slug: "riches_of_midgard_land_and_expand",
        name: "Riches of Midgard: Land and Expand",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/rise_of_maya": {
        slug: "rise_of_maya",
        name: "Rise of Maya",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/robin_hood_shifting_riches": {
        slug: "robin_hood_shifting_riches",
        name: "Robin Hood: Shifting Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/rome_the_golden_age": {
        slug: "rome_the_golden_age",
        name: "Rome: The Golden Age",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/royal_nuts": {
        slug: "royal_nuts",
        name: "Royal Nuts",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/santa_vs_rudolf": {
        slug: "santa_vs_rudolf",
        name: "Santa vs Rudolf",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/scruffy_duck": {
        slug: "scruffy_duck",
        name: "Scruffy Duck",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/scudamores_super_stakes": {
        slug: "scudamores_super_stakes",
        name: "Scudamore's Super Stakes",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/secret_of_the_stones": {
        slug: "secret_of_the_stones",
        name: "Secret of the Stones",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/secrets_of_atlantis": {
        slug: "secrets_of_atlantis",
        name: "Secrets of Atlantis",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/secrets_of_christmas": {
        slug: "secrets_of_christmas",
        name: "Secrets of Christmas",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/serengeti_kings": {
        slug: "serengeti_kings",
        name: "Serengeti Kings",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/silverback_gold": {
        slug: "silverback_gold",
        name: "Silverback Gold",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/space_wars": {
        slug: "space_wars",
        name: "Space Wars",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/space_wars_2": {
        slug: "space_wars_2",
        name: "Space Wars 2",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/space_wars_megaways_xxxtreme": {
        slug: "space_wars_megaways_xxxtreme",
        name: "Space Wars Megaways XXXtreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/spinata_grande": {
        slug: "spinata_grande",
        name: "Spinata Grande",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/spinsane": {
        slug: "spinsane",
        name: "Spinsane",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/starburst": {
        slug: "starburst",
        name: "Starburst",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/starburst_galaxy": {
        slug: "starburst_galaxy",
        name: "Starburst Galaxy",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/starburst_xxxtreme": {
        slug: "starburst_xxxtreme",
        name: "Starburst XXXtreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/steam_tower": {
        slug: "steam_tower",
        name: "Steam Tower",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/stickers": {
        slug: "stickers",
        name: "Stickers",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/street_fighter_ii_the_world_warrior_slot": {
        slug: "street_fighter_ii_the_world_warrior_slot",
        name: "Street Fighter II: The World Warrior Slot",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/strolling_staxx_cubic_fruits": {
        slug: "strolling_staxx_cubic_fruits",
        name: "Strolling Staxx: Cubic Fruits",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/super_striker": {
        slug: "super_striker",
        name: "Super Striker",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/superstars": {
        slug: "superstars",
        name: "Superstars",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/sweety_honey_fruity": {
        slug: "sweety_honey_fruity",
        name: "Sweety Honey Fruity",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/taco_fury_xxxtreme": {
        slug: "taco_fury_xxxtreme",
        name: "Taco Fury XXXtreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/temple_of_nudges": {
        slug: "temple_of_nudges",
        name: "Temple of Nudges",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/the_invisible_man": {
        slug: "the_invisible_man",
        name: "The Invisible Man",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/the_legend_of_shangrila_cluster_pays": {
        slug: "the_legend_of_shangrila_cluster_pays",
        name: "The Legend of Shangri-La: Cluster Pays",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/the_wish_master": {
        slug: "the_wish_master",
        name: "The Wish Master",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/the_wish_master_megaways": {
        slug: "the_wish_master_megaways",
        name: "The Wish Master Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/the_wolfs_bane": {
        slug: "the_wolfs_bane",
        name: "The Wolf's Bane",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/theme_park_tickets_of_fortune": {
        slug: "theme_park_tickets_of_fortune",
        name: "Theme Park Tickets of Fortune",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/thrill_to_grill": {
        slug: "thrill_to_grill",
        name: "Thrill To Grill",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/ticket_to_wild": {
        slug: "ticket_to_wild",
        name: "Ticket To Wild",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/trollpot_5000": {
        slug: "trollpot_5000",
        name: "Trollpot 5000",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/turn_your_fortune": {
        slug: "turn_your_fortune",
        name: "Turn Your Fortune",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/twin_happiness": {
        slug: "twin_happiness",
        name: "Twin Happiness",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/twin_spin": {
        slug: "twin_spin",
        name: "Twin Spin",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/twin_spin_megaways": {
        slug: "twin_spin_megaways",
        name: "Twin Spin Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/twin_spin_xxxtreme": {
        slug: "twin_spin_xxxtreme",
        name: "Twin Spin XXXtreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/twister": {
        slug: "twister",
        name: "Twister",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/victorious": {
        slug: "victorious",
        name: "Victorious",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/vikings_video_slot": {
        slug: "vikings_video_slot",
        name: "Vikings Video Slot",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/warlords_crystals_of_power": {
        slug: "warlords_crystals_of_power",
        name: "Warlords: Crystals of Power",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/whats_up_witches": {
        slug: "whats_up_witches",
        name: "What's Up Witches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/whos_the_bride": {
        slug: "whos_the_bride",
        name: "Who's the Bride",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wild_bazaar": {
        slug: "wild_bazaar",
        name: "Wild Bazaar",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wild_mining_xxxtreme": {
        slug: "wild_mining_xxxtreme",
        name: "Wild Mining XXXTreme",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wild_turkey": {
        slug: "wild_turkey",
        name: "Wild Turkey",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wild_turkey_megaways": {
        slug: "wild_turkey_megaways",
        name: "Wild Turkey Megaways",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wild_water": {
        slug: "wild_water",
        name: "Wild Water",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wild_wild_west_the_great_train_heist": {
        slug: "wild_wild_west_the_great_train_heist",
        name: "Wild Wild West: The Great Train Heist",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wild_worlds": {
        slug: "wild_worlds",
        name: "Wild Worlds",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wilderland": {
        slug: "wilderland",
        name: "Wilderland",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wildotron_3000": {
        slug: "wildotron_3000",
        name: "Wild-O-Tron 3000",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/willys_hot_chillies": {
        slug: "willys_hot_chillies",
        name: "Willy's Hot Chillies",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wings_of_riches": {
        slug: "wings_of_riches",
        name: "Wings of Riches",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wolf_cub": {
        slug: "wolf_cub",
        name: "Wolf Cub",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "netent/wonders_of_christmas": {
        slug: "wonders_of_christmas",
        name: "Wonders of Christmas",
        provider: "NetEnt",
        providerSlug: "netent"
    },
    "northern-lights-gaming/aurora": {
        slug: "aurora",
        name: "Aurora",
        provider: "Northern Lights Gaming",
        providerSlug: "northern-lights-gaming"
    },
    "northern-lights-gaming/electric_wilds": {
        slug: "electric_wilds",
        name: "Electric Wilds",
        provider: "Northern Lights Gaming",
        providerSlug: "northern-lights-gaming"
    },
    "northern-lights-gaming/rockys_gold": {
        slug: "rockys_gold",
        name: "Rocky's Gold",
        provider: "Northern Lights Gaming",
        providerSlug: "northern-lights-gaming"
    },
    "northern-lights-gaming/trail_blazer": {
        slug: "trail_blazer",
        name: "Trail Blazer",
        provider: "Northern Lights Gaming",
        providerSlug: "northern-lights-gaming"
    },
    "peter-and-sons/abrakadabra": {
        slug: "abrakadabra",
        name: "Abrakadabra",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/alibi": {
        slug: "alibi",
        name: "Alibi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/animafia": {
        slug: "animafia",
        name: "Animafia",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/artifacts": {
        slug: "artifacts",
        name: "Artifacts",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/bad_santa": {
        slug: "bad_santa",
        name: "Bad Santa",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/barbarossa": {
        slug: "barbarossa",
        name: "Barbarossa",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/barbarossa_dragon_empire": {
        slug: "barbarossa_dragon_empire",
        name: "Barbarossa Dragon Empire",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/barbarossa_revenge": {
        slug: "barbarossa_revenge",
        name: "Barbarossa Revenge",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/big_bounty_bandits_3_pots": {
        slug: "big_bounty_bandits_3_pots",
        name: "Big Bounty Bandits: 3 Pots",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/blood_club": {
        slug: "blood_club",
        name: "Blood Club",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/book_of_books": {
        slug: "book_of_books",
        name: "Book of Books",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/boom_farm": {
        slug: "boom_farm",
        name: "Boom Farm",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/bubblegum_and_robo": {
        slug: "bubblegum_and_robo",
        name: "Bubblegum and Robo",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/bunny_heist": {
        slug: "bunny_heist",
        name: "Bunny Heist",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/burning_riot": {
        slug: "burning_riot",
        name: "Burning RIot",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/cauldron": {
        slug: "cauldron",
        name: "Cauldron",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/clash_of_claws": {
        slug: "clash_of_claws",
        name: "Clash of Claws",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/coin_blox": {
        slug: "coin_blox",
        name: "Coin Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/coins_of_cleo": {
        slug: "coins_of_cleo",
        name: "Coins of Cleo",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/cyber_doom": {
        slug: "cyber_doom",
        name: "Cyber Doom",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/cyber_runner": {
        slug: "cyber_runner",
        name: "Cyber Runner",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/dcirque": {
        slug: "dcirque",
        name: "Dcirque",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/dig_it": {
        slug: "dig_it",
        name: "Dig it",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/dragon_blox": {
        slug: "dragon_blox",
        name: "Dragon Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/dungeon_tower": {
        slug: "dungeon_tower",
        name: "Dungeon Tower",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/epic_hellas": {
        slug: "epic_hellas",
        name: "Epic Hellas",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/evil_devil": {
        slug: "evil_devil",
        name: "Evil Devil",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/frozen_age": {
        slug: "frozen_age",
        name: "Frozen Age",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/ghost_father": {
        slug: "ghost_father",
        name: "Ghost Father",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/ghostfather_awakened": {
        slug: "ghostfather_awakened",
        name: "Ghostfather Awakened",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/ginger_wins_wild_jungle": {
        slug: "ginger_wins_wild_jungle",
        name: "Ginger Wins: Wild Jungle",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/gnomes_and_giants": {
        slug: "gnomes_and_giants",
        name: "Gnomes and Giants",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/golden_triad": {
        slug: "golden_triad",
        name: "Golden Triad",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/greedy_alice": {
        slug: "greedy_alice",
        name: "Greedy Alice",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/gun_powder": {
        slug: "gun_powder",
        name: "Gun Powder",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/hammer_of_gods": {
        slug: "hammer_of_gods",
        name: "Hammer of Gods",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/headhunter": {
        slug: "headhunter",
        name: "Headhunter",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/johnan_legendarian": {
        slug: "johnan_legendarian",
        name: "Johnan Legendarian",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/kaiser": {
        slug: "kaiser",
        name: "Kaiser",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/kill_road_66": {
        slug: "kill_road_66",
        name: "Kill Road 66",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/king_power": {
        slug: "king_power",
        name: "King Power",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/lockn_load": {
        slug: "lockn_load",
        name: "Lock'n Load",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/manic_fairy": {
        slug: "manic_fairy",
        name: "Manic Fairy",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/monster_blox": {
        slug: "monster_blox",
        name: "Monster Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/muddy_waters": {
        slug: "muddy_waters",
        name: "Muddy Waters",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/mutagenes": {
        slug: "mutagenes",
        name: "Mutagenes",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/peter_hunter": {
        slug: "peter_hunter",
        name: "Peter Hunter",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/pop_cop": {
        slug: "pop_cop",
        name: "Pop Cop",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/potion_power": {
        slug: "potion_power",
        name: "Potion Power",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/precious_7": {
        slug: "precious_7",
        name: "Precious 7",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/punch_club": {
        slug: "punch_club",
        name: "Punch Club",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/roadquake": {
        slug: "roadquake",
        name: "Roadquake",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/robin_nottingham_raiders": {
        slug: "robin_nottingham_raiders",
        name: "Robin - Nottingham Raiders",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/robin_sherwood_marauders": {
        slug: "robin_sherwood_marauders",
        name: "Robin - Sherwood Marauders",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/roman_glory": {
        slug: "roman_glory",
        name: "Roman Glory",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/rome_the_conquerors": {
        slug: "rome_the_conquerors",
        name: "Rome - The Conquerors",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/rudis": {
        slug: "rudis",
        name: "Rudis",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/rust_world": {
        slug: "rust_world",
        name: "Rust World",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/sands_of_destiny": {
        slug: "sands_of_destiny",
        name: "Sands of Destiny",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/sheriff_colt": {
        slug: "sheriff_colt",
        name: "Sheriff Colt",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/speed_freaks": {
        slug: "speed_freaks",
        name: "Speed Freaks",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/spell_forged": {
        slug: "spell_forged",
        name: "Spell Forged",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/steamworks_gears_of_fortune": {
        slug: "steamworks_gears_of_fortune",
        name: "Steamworks Gears of Fortune",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/steamworks_the_workshop": {
        slug: "steamworks_the_workshop",
        name: "Steamworks the Workshop",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/street_ninja": {
        slug: "street_ninja",
        name: "Street Ninja",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/tango_of_chaos": {
        slug: "tango_of_chaos",
        name: "Tango of Chaos",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/the_legend_of_musashi": {
        slug: "the_legend_of_musashi",
        name: "The Legend of Musashi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/the_mafiosi": {
        slug: "the_mafiosi",
        name: "The Mafiosi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/the_soapranos": {
        slug: "the_soapranos",
        name: "The Soapranos",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/thunder_hawk": {
        slug: "thunder_hawk",
        name: "Thunder Hawk",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/valkyries": {
        slug: "valkyries",
        name: "Valkyries",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/voodoo_hex": {
        slug: "voodoo_hex",
        name: "Voodoo Hex",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/water_blox": {
        slug: "water_blox",
        name: "Water Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/wild_bard": {
        slug: "wild_bard",
        name: "Wild Bard",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/wild_duel": {
        slug: "wild_duel",
        name: "Wild Duel",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/wild_one": {
        slug: "wild_one",
        name: "Wild One",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/xibalba": {
        slug: "xibalba",
        name: "Xibalba",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/zombie_road": {
        slug: "zombie_road",
        name: "Zombie Road",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/zombies": {
        slug: "zombies",
        name: "Zombies",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "pgsoft/alchemy_gold": {
        slug: "alchemy_gold",
        name: "Alchemy Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/alibabas_cave_of_fortune": {
        slug: "alibabas_cave_of_fortune",
        name: "Alibaba's Cave of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/anubis_wrath": {
        slug: "anubis_wrath",
        name: "Anubis Wrath",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/asgardian_rising": {
        slug: "asgardian_rising",
        name: "Asgardian Rising",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/baccarat_deluxe": {
        slug: "baccarat_deluxe",
        name: "Baccarat Deluxe",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/bakery_bonanza": {
        slug: "bakery_bonanza",
        name: "Bakery Bonanza",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/bali_vacation": {
        slug: "bali_vacation",
        name: "Bali Vacation",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/battleground_royale": {
        slug: "battleground_royale",
        name: "Battleground Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/bikini_paradise": {
        slug: "bikini_paradise",
        name: "Bikini Paradise",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/buffalo_win": {
        slug: "buffalo_win",
        name: "Buffalo Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/butterfly_blossom": {
        slug: "butterfly_blossom",
        name: "Butterfly Blossom",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/caishen_wins": {
        slug: "caishen_wins",
        name: "Caishen Wins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/candy_bonanza": {
        slug: "candy_bonanza",
        name: "Candy Bonanza",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/candy_burst": {
        slug: "candy_burst",
        name: "Candy Burst",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/captains_bounty": {
        slug: "captains_bounty",
        name: "Captain's Bounty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/cash_mania": {
        slug: "cash_mania",
        name: "Cash Mania",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/chicky_run": {
        slug: "chicky_run",
        name: "Chicky Run",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/chocolate_deluxe": {
        slug: "chocolate_deluxe",
        name: "Chocolate Deluxe",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/circus_delight": {
        slug: "circus_delight",
        name: "Circus Delight",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/cocktail_nights": {
        slug: "cocktail_nights",
        name: "Cocktail Nights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/cruise_royale": {
        slug: "cruise_royale",
        name: "Cruise Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/crypto_gold": {
        slug: "crypto_gold",
        name: "Crypto Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dead_mans_riches": {
        slug: "dead_mans_riches",
        name: "Dead Man's Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/destiny_of_sun_and_moon": {
        slug: "destiny_of_sun_and_moon",
        name: "Destiny of Sun and Moon",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/diner_delights": {
        slug: "diner_delights",
        name: "Diner Delights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/diner_frenzy_spins": {
        slug: "diner_frenzy_spins",
        name: "Diner Frenzy Spins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/doomsday_rampage": {
        slug: "doomsday_rampage",
        name: "Doomsday Rampage",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/double_fortune": {
        slug: "double_fortune",
        name: "Double Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dragon_hatch": {
        slug: "dragon_hatch",
        name: "Dragon Hatch",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dragon_legend": {
        slug: "dragon_legend",
        name: "Dragon Legend",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dragon_tiger_luck": {
        slug: "dragon_tiger_luck",
        name: "Dragon Tiger Luck",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dragons_treasure_quest": {
        slug: "dragons_treasure_quest",
        name: "Dragon's Treasure Quest",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dreams_of_macau": {
        slug: "dreams_of_macau",
        name: "Dreams of Macau",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/egypts_book_of_mystery": {
        slug: "egypts_book_of_mystery",
        name: "Egypt's Book of Mystery",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/emoji_riches": {
        slug: "emoji_riches",
        name: "Emoji Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/emperors_favour": {
        slug: "emperors_favour",
        name: "Emperor's Favour",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/flirting_scholar": {
        slug: "flirting_scholar",
        name: "Flirting Scholar",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/forbidden_alchemy": {
        slug: "forbidden_alchemy",
        name: "Forbidden Alchemy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/forge_of_wealth": {
        slug: "forge_of_wealth",
        name: "Forge of Wealth",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_dragon": {
        slug: "fortune_dragon",
        name: "Fortune Dragon",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_gods": {
        slug: "fortune_gods",
        name: "Fortune Gods",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_horse": {
        slug: "fortune_horse",
        name: "Fortune Horse",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_mouse": {
        slug: "fortune_mouse",
        name: "Fortune Mouse",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_ox": {
        slug: "fortune_ox",
        name: "Fortune Ox",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_rabbit": {
        slug: "fortune_rabbit",
        name: "Fortune Rabbit",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_snake": {
        slug: "fortune_snake",
        name: "Fortune Snake",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_tiger": {
        slug: "fortune_tiger",
        name: "Fortune Tiger",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fruit_candy": {
        slug: "fruit_candy",
        name: "Fruit Candy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/funky_fortunez": {
        slug: "funky_fortunez",
        name: "Funky Fortunez",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/futebol_fever": {
        slug: "futebol_fever",
        name: "Futebol Fever",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/galactic_gems": {
        slug: "galactic_gems",
        name: "Galactic Gems",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/galaxy_miner": {
        slug: "galaxy_miner",
        name: "Galaxy Miner",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ganesha_fortune": {
        slug: "ganesha_fortune",
        name: "Ganesha Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ganesha_gold": {
        slug: "ganesha_gold",
        name: "Ganesha Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/garuda_gems": {
        slug: "garuda_gems",
        name: "Garuda Gems",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/geishas_revenge": {
        slug: "geishas_revenge",
        name: "Geisha's Revenge",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/gem_saviour": {
        slug: "gem_saviour",
        name: "Gem Saviour",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/gem_saviour_conquest": {
        slug: "gem_saviour_conquest",
        name: "Gem Saviour Conquest",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/gem_saviour_sword": {
        slug: "gem_saviour_sword",
        name: "Gem Saviour Sword",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/gemstones_gold": {
        slug: "gemstones_gold",
        name: "Gemstones Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/genies_3_wishes": {
        slug: "genies_3_wishes",
        name: "Genie's 3 Wishes",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/gladiators_glory": {
        slug: "gladiators_glory",
        name: "Gladiator's Glory",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/graffiti_rush": {
        slug: "graffiti_rush",
        name: "Graffiti Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/grimms_bounty_hanset_and_gretel": {
        slug: "grimms_bounty_hanset_and_gretel",
        name: "Grimms Bounty Hanset and Gretel",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/guardians_of_ice_and_fire": {
        slug: "guardians_of_ice_and_fire",
        name: "Guardians of Ice and Fire",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/hawaiian_tiki": {
        slug: "hawaiian_tiki",
        name: "Hawaiian Tiki",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/heist_stakes": {
        slug: "heist_stakes",
        name: "Heist Stakes",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/hip_hop_panda": {
        slug: "hip_hop_panda",
        name: "Hip Hop Panda",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/honey_trap_of_diao_chan": {
        slug: "honey_trap_of_diao_chan",
        name: "Honey Trap of Diao Chan",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/hood_vs_wolf": {
        slug: "hood_vs_wolf",
        name: "Hood vs Wolf",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/hotpot": {
        slug: "hotpot",
        name: "Hotpot",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/incan_wonders": {
        slug: "incan_wonders",
        name: "Incan Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/inferno_mayhem": {
        slug: "inferno_mayhem",
        name: "Inferno Mayhem",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/jack_frosts_winter": {
        slug: "jack_frosts_winter",
        name: "Jack Frost's Winter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/jack_the_giant_hunter": {
        slug: "jack_the_giant_hunter",
        name: "Jack the Giant Hunter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/jewels_of_prosperity": {
        slug: "jewels_of_prosperity",
        name: "Jewels of Prosperity",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/journey_to_the_wealth": {
        slug: "journey_to_the_wealth",
        name: "Journey to the Wealth",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/jungle_delight": {
        slug: "jungle_delight",
        name: "Jungle Delight",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/jurassic_kingdom": {
        slug: "jurassic_kingdom",
        name: "Jurassic Kingdom",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/knockout_riches": {
        slug: "knockout_riches",
        name: "Knockout Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/kraken_gold_rush": {
        slug: "kraken_gold_rush",
        name: "Kraken Gold Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/legend_of_hou_yi": {
        slug: "legend_of_hou_yi",
        name: "Legend of Hou Yi",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/legend_of_perseus": {
        slug: "legend_of_perseus",
        name: "Legend of Perseus",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/legendary_monkey_king": {
        slug: "legendary_monkey_king",
        name: "Legendary Monkey King",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/leprechaun_riches": {
        slug: "leprechaun_riches",
        name: "Leprechaun Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/lucky_clover_lady": {
        slug: "lucky_clover_lady",
        name: "Lucky Clover Lady",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/lucky_neko": {
        slug: "lucky_neko",
        name: "Lucky Neko",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/lucky_piggy": {
        slug: "lucky_piggy",
        name: "Lucky Piggy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mahjong_ways": {
        slug: "mahjong_ways",
        name: "Mahjong Ways",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mahjong_ways_2": {
        slug: "mahjong_ways_2",
        name: "Mahjong Ways 2",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/majestic_empire": {
        slug: "majestic_empire",
        name: "Majestic Empire",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/majestic_treasures": {
        slug: "majestic_treasures",
        name: "Majestic Treasures",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mask_carnival": {
        slug: "mask_carnival",
        name: "Mask Carnival",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mayan_destiny": {
        slug: "mayan_destiny",
        name: "Mayan Destiny",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/medusa": {
        slug: "medusa",
        name: "Medusa",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/medusa_ii": {
        slug: "medusa_ii",
        name: "Medusa II",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mermaid_riches": {
        slug: "mermaid_riches",
        name: "Mermaid Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/midas_fortune": {
        slug: "midas_fortune",
        name: "Midas Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mighty_mania": {
        slug: "mighty_mania",
        name: "Mighty Mania",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/monkeys_wild_party": {
        slug: "monkeys_wild_party",
        name: "Monkeys Wild Party",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mr_hallowwin": {
        slug: "mr_hallowwin",
        name: "Mr. Hallow-Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mr_treasures_fortune": {
        slug: "mr_treasures_fortune",
        name: "Mr Treasure's Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/muay_thai_champion": {
        slug: "muay_thai_champion",
        name: "Muay Thai Champion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/museum_mystery": {
        slug: "museum_mystery",
        name: "Museum Mystery",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mystic_potion": {
        slug: "mystic_potion",
        name: "Mystic Potion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mystical_spirits": {
        slug: "mystical_spirits",
        name: "Mystical Spirits",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mythical_guardians": {
        slug: "mythical_guardians",
        name: "Mythical Guardians",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ninja_vs_samurai": {
        slug: "ninja_vs_samurai",
        name: "Ninja vs Samurai",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/oishi_delights": {
        slug: "oishi_delights",
        name: "Oishi Delights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/opera_dynasty": {
        slug: "opera_dynasty",
        name: "Opera Dynasty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/oriental_prosperity": {
        slug: "oriental_prosperity",
        name: "Oriental Prosperity",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/perfect_strike": {
        slug: "perfect_strike",
        name: "Perfect Strike",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/pharaoh_royale": {
        slug: "pharaoh_royale",
        name: "Pharaoh Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/phoenix_rises": {
        slug: "phoenix_rises",
        name: "Phoenix Rises",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/piggy_gold": {
        slug: "piggy_gold",
        name: "Piggy Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/pinata_wins": {
        slug: "pinata_wins",
        name: "Pinata Wins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/plushie_frenzy": {
        slug: "plushie_frenzy",
        name: "Plushie Frenzy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/poker_kingdom_win": {
        slug: "poker_kingdom_win",
        name: "Poker Kingdom Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/prosperity_fortune_tree": {
        slug: "prosperity_fortune_tree",
        name: "Prosperity Fortune Tree",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/prosperity_lion": {
        slug: "prosperity_lion",
        name: "Prosperity Lion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/queen_of_bounty": {
        slug: "queen_of_bounty",
        name: "Queen of Bounty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/raider_janes_crypt_of_fortune": {
        slug: "raider_janes_crypt_of_fortune",
        name: "Raider Jane's Crypt of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/rave_party_fever": {
        slug: "rave_party_fever",
        name: "Rave Party Fever",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/reel_love": {
        slug: "reel_love",
        name: "Reel Love",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/reel_royale_showdown": {
        slug: "reel_royale_showdown",
        name: "Reel Royale Showdown",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/rio_fantasia": {
        slug: "rio_fantasia",
        name: "Rio Fantasia",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/rise_of_apollo": {
        slug: "rise_of_apollo",
        name: "Rise of Apollo",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/rooster_rumble": {
        slug: "rooster_rumble",
        name: "Rooster Rumble",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/safari_wilds": {
        slug: "safari_wilds",
        name: "Safari Wilds",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/santas_gift_rush": {
        slug: "santas_gift_rush",
        name: "Santa's Gift Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/secrets_of_cleopatra": {
        slug: "secrets_of_cleopatra",
        name: "Secrets of Cleopatra",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/shaolin_soccer": {
        slug: "shaolin_soccer",
        name: "Shaolin Soccer",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/shark_hunter": {
        slug: "shark_hunter",
        name: "Shark Hunter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/skylight_wonders": {
        slug: "skylight_wonders",
        name: "Skylight Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/songkran_splash": {
        slug: "songkran_splash",
        name: "Songkran Splash",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/speed_winner": {
        slug: "speed_winner",
        name: "Speed Winner",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/spirited_wonders": {
        slug: "spirited_wonders",
        name: "Spirited Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/super_golf_drive": {
        slug: "super_golf_drive",
        name: "Super Golf Drive",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/super_wildrix": {
        slug: "super_wildrix",
        name: "Super Wildrix",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/supermarket_spree": {
        slug: "supermarket_spree",
        name: "Supermarket Spree",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/symbols_of_egypt": {
        slug: "symbols_of_egypt",
        name: "Symbols of Egypt",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/thai_river_wonders": {
        slug: "thai_river_wonders",
        name: "Thai River Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/the_great_icescape": {
        slug: "the_great_icescape",
        name: "The Great Icescape",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/the_queens_banquet": {
        slug: "the_queens_banquet",
        name: "The Queen's Banquet",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/three_crazy_piggies": {
        slug: "three_crazy_piggies",
        name: "Three Crazy Piggies",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/totem_wonders": {
        slug: "totem_wonders",
        name: "Totem Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/treasures_of_aztec": {
        slug: "treasures_of_aztec",
        name: "Treasures of Aztec",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/tree_of_fortune": {
        slug: "tree_of_fortune",
        name: "Tree of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ultimate_striker": {
        slug: "ultimate_striker",
        name: "Ultimate Striker",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/vampires_charm": {
        slug: "vampires_charm",
        name: "Vampire's Charm",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ways_of_the_qilin": {
        slug: "ways_of_the_qilin",
        name: "Ways of the Qilin",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wild_ape_3258": {
        slug: "wild_ape_3258",
        name: "Wild Ape 3258",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wild_bandito": {
        slug: "wild_bandito",
        name: "Wild Bandito",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wild_bounty_showdown": {
        slug: "wild_bounty_showdown",
        name: "Wild Bounty Showdown",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wild_coaster": {
        slug: "wild_coaster",
        name: "Wild Coaster",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wild_fireworks": {
        slug: "wild_fireworks",
        name: "Wild Fireworks",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/win_win_fish_prawn_crab": {
        slug: "win_win_fish_prawn_crab",
        name: "Win Win Fish Prawn Crab",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/win_win_won": {
        slug: "win_win_won",
        name: "Win Win Won",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wings_of_iguazu": {
        slug: "wings_of_iguazu",
        name: "Wings of Iguazu",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/yakuza_honor": {
        slug: "yakuza_honor",
        name: "Yakuza Honor",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/zombie_blasters": {
        slug: "zombie_blasters",
        name: "Zombie Blasters",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/zombie_outbreak": {
        slug: "zombie_outbreak",
        name: "Zombie Outbreak",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pinoy-bet-games/aswang_attack": {
        slug: "aswang_attack",
        name: "Aswang Attack",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/boracay_beauties": {
        slug: "boracay_beauties",
        name: "Boracay Beauties",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/dragon_vs_phoenix": {
        slug: "dragon_vs_phoenix",
        name: "Dragon vs Phoenix",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/fruit_fiesta": {
        slug: "fruit_fiesta",
        name: "Fruit Fiesta",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/good_luck_money": {
        slug: "good_luck_money",
        name: "Good Luck Money",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/jeepney_scatter": {
        slug: "jeepney_scatter",
        name: "Jeepney Scatter",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/pixiemagic_color_game": {
        slug: "pixiemagic_color_game",
        name: "PixieMagic Color Game",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/pop_monsters_cutesy_clash": {
        slug: "pop_monsters_cutesy_clash",
        name: "Pop Monsters: Cutesy Clash",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/sari_sari_store": {
        slug: "sari_sari_store",
        name: "Sari Sari Store",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/sweet_dash": {
        slug: "sweet_dash",
        name: "Sweet Dash",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/war_for_olympus": {
        slug: "war_for_olympus",
        name: "War for Olympus",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/xmas_around_the_world": {
        slug: "xmas_around_the_world",
        name: "Xmas Around the World",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "pinoy-bet-games/yamashitas_treasure": {
        slug: "yamashitas_treasure",
        name: "Yamashita's Treasure",
        provider: "Pinoy Bet Games",
        providerSlug: "pinoy-bet-games"
    },
    "play-n-go/1001_mystery_genie_fortunes": {
        slug: "1001_mystery_genie_fortunes",
        name: "1001 Mystery Genie Fortunes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/13th_trial_hercules_abyssways": {
        slug: "13th_trial_hercules_abyssways",
        name: "13th Trial Hercules Abyssways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/15_crystal_roses_a_tale_of_love": {
        slug: "15_crystal_roses_a_tale_of_love",
        name: "15 Crystal Roses: A Tale of Love",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/24k_dragon": {
        slug: "24k_dragon",
        name: "24K Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/3_blades_and_blessings": {
        slug: "3_blades_and_blessings",
        name: "3 Blades and Blessings",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/3_clown_monty": {
        slug: "3_clown_monty",
        name: "3 Clown Monty",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/3_clown_monty_ii": {
        slug: "3_clown_monty_ii",
        name: "3 Clown Monty II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/3_hand_casino": {
        slug: "3_hand_casino",
        name: "3 Hand Casino",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/5x_magic": {
        slug: "5x_magic",
        name: "5x Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/7_sins": {
        slug: "7_sins",
        name: "7 Sins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ace_of_spades": {
        slug: "ace_of_spades",
        name: "Ace of Spades",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/agent_destiny": {
        slug: "agent_destiny",
        name: "Agent Destiny",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/agent_of_hearts": {
        slug: "agent_of_hearts",
        name: "Agent of Hearts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/animal_madness": {
        slug: "animal_madness",
        name: "Animal Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ankh_of_anubis": {
        slug: "ankh_of_anubis",
        name: "Ankh of Anubis",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ankh_of_anubis_awakening": {
        slug: "ankh_of_anubis_awakening",
        name: "Ankh of Anubis  Awakening",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/annihilator": {
        slug: "annihilator",
        name: "Annihilator",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/athena_ascending": {
        slug: "athena_ascending",
        name: "Athena Ascending",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/aztec_idols": {
        slug: "aztec_idols",
        name: "Aztec Idols",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/aztec_warrior_princess": {
        slug: "aztec_warrior_princess",
        name: "Aztec Warrior Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bakers_treat": {
        slug: "bakers_treat",
        name: "Baker's Treat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/banana_rock": {
        slug: "banana_rock",
        name: "Banana Rock",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/banana_rush": {
        slug: "banana_rush",
        name: "Banana Rush",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/banquet_of_dead": {
        slug: "banquet_of_dead",
        name: "Banquet of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bao_shi": {
        slug: "bao_shi",
        name: "Bao Shi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/barn_busters": {
        slug: "barn_busters",
        name: "Barn Busters",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/baron_lord_of_saturday": {
        slug: "baron_lord_of_saturday",
        name: "Baron Lord of Saturday",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/battle_royal": {
        slug: "battle_royal",
        name: "Battle Royal",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/beasts_of_fire": {
        slug: "beasts_of_fire",
        name: "Beasts of Fire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/beasts_of_fire_maximum": {
        slug: "beasts_of_fire_maximum",
        name: "Beasts of Fire Maximum",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/big_win_777": {
        slug: "big_win_777",
        name: "Big Win 777",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/big_win_cat": {
        slug: "big_win_cat",
        name: "Big Win Cat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/big_win_city_pawsperity": {
        slug: "big_win_city_pawsperity",
        name: "Big Win City Pawsperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/black_mamba": {
        slug: "black_mamba",
        name: "Black Mamba",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/blackjack_multi_hand": {
        slug: "blackjack_multi_hand",
        name: "Blackjack Multi Hand",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/blazin_bullfrog": {
        slug: "blazin_bullfrog",
        name: "Blazin' Bullfrog",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/blinged": {
        slug: "blinged",
        name: "Blinged",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/boat_bonanza": {
        slug: "boat_bonanza",
        name: "Boat Bonanza",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/boat_bonanza_christmas": {
        slug: "boat_bonanza_christmas",
        name: "Boat Bonanza Christmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/boat_bonanza_colossal_catch": {
        slug: "boat_bonanza_colossal_catch",
        name: "Boat Bonanza Colossal Catch",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/boat_bonanza_croconile": {
        slug: "boat_bonanza_croconile",
        name: "Boat Bonanza Croconile",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/boat_bonanza_down_under": {
        slug: "boat_bonanza_down_under",
        name: "Boat Bonanza Down Under",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/book_of_dead": {
        slug: "book_of_dead",
        name: "Book of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/book_of_dead_go_collect": {
        slug: "book_of_dead_go_collect",
        name: "Book of Dead Go Collect",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bubblin_riches": {
        slug: "bubblin_riches",
        name: "Bubblin Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/buffalo_of_wealth": {
        slug: "buffalo_of_wealth",
        name: "Buffalo of Wealth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/buildin_bucks": {
        slug: "buildin_bucks",
        name: "Buildin Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/buildin_even_more_bucks": {
        slug: "buildin_even_more_bucks",
        name: "Buildin' Even More Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/buildin_more_bucks": {
        slug: "buildin_more_bucks",
        name: "Buildin More Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bull_in_a_china_shop": {
        slug: "bull_in_a_china_shop",
        name: "Bull in a China Shop",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bull_in_a_rodeo": {
        slug: "bull_in_a_rodeo",
        name: "Bull in a Rodeo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bullion_express": {
        slug: "bullion_express",
        name: "Bullion Express",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/candy_island_princess": {
        slug: "candy_island_princess",
        name: "Candy Island Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/canine_carnage": {
        slug: "canine_carnage",
        name: "Canine Carnage",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/captain_glum_pirate_hunter": {
        slug: "captain_glum_pirate_hunter",
        name: "Captain Glum: Pirate Hunter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/captain_xenos_earth_adventure": {
        slug: "captain_xenos_earth_adventure",
        name: "Captain Xeno's Earth Adventure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cash_a_cabana": {
        slug: "cash_a_cabana",
        name: "Cash a Cabana",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cash_of_command": {
        slug: "cash_of_command",
        name: "Cash of Command",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cash_pump": {
        slug: "cash_pump",
        name: "Cash Pump",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cash_vandal": {
        slug: "cash_vandal",
        name: "Cash Vandal",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cashin_joker": {
        slug: "cashin_joker",
        name: "Cashin' Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cat_wilde_and_the_doom_of_dead": {
        slug: "cat_wilde_and_the_doom_of_dead",
        name: "Cat Wilde and the Doom of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cat_wilde_and_the_incan_quest": {
        slug: "cat_wilde_and_the_incan_quest",
        name: "Cat Wilde and the Incan Quest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cat_wilde_and_the_lost_chapter": {
        slug: "cat_wilde_and_the_lost_chapter",
        name: "Cat Wilde and the Lost Chapter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cat_wilde_and_the_pyramids_of_dead": {
        slug: "cat_wilde_and_the_pyramids_of_dead",
        name: "Cat Wilde and the Pyramids of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cat_wilde_in_the_eclipse_of_the_sun_god": {
        slug: "cat_wilde_in_the_eclipse_of_the_sun_god",
        name: "Cat Wilde in the Eclipse of the Sun God",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cats_and_cash": {
        slug: "cats_and_cash",
        name: "Cats and Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/chambers_of_ancients": {
        slug: "chambers_of_ancients",
        name: "Chambers of Ancients",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/champions_of_mithrune": {
        slug: "champions_of_mithrune",
        name: "Champions of Mithrune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/charlie_chance": {
        slug: "charlie_chance",
        name: "Charlie Chance",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/charlie_chance_and_the_curse_of_cleopatra": {
        slug: "charlie_chance_and_the_curse_of_cleopatra",
        name: "Charlie Chance and The Curse of Cleopatra",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/charlie_chance_in_hell_to_pay": {
        slug: "charlie_chance_in_hell_to_pay",
        name: "Charlie Chance in Hell to Pay",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/chinese_new_year": {
        slug: "chinese_new_year",
        name: "Chinese New Year",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/chronos_joker": {
        slug: "chronos_joker",
        name: "Chronos Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/city_of_sound": {
        slug: "city_of_sound",
        name: "City of Sound",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/clash_of_camelot": {
        slug: "clash_of_camelot",
        name: "Clash of Camelot",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cloud_quest": {
        slug: "cloud_quest",
        name: "Cloud Quest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/coils_of_cash": {
        slug: "coils_of_cash",
        name: "Coils of Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/colt_lightning": {
        slug: "colt_lightning",
        name: "Colt Lightning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/colt_lightning_firestorm": {
        slug: "colt_lightning_firestorm",
        name: "Colt Lightning Firestorm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/contact": {
        slug: "contact",
        name: "Contact",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/copsnrobbers": {
        slug: "copsnrobbers",
        name: "Cops'n'Robbers",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/count_jokula": {
        slug: "count_jokula",
        name: "Count Jokula",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/court_of_hearts": {
        slug: "court_of_hearts",
        name: "Court of Hearts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/coywolf_cash": {
        slug: "coywolf_cash",
        name: "Coywolf Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/crabbys_gold": {
        slug: "crabbys_gold",
        name: "Crabby's Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/crabbys_gold_ii": {
        slug: "crabbys_gold_ii",
        name: "Crabby's Gold II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/crazy_cows": {
        slug: "crazy_cows",
        name: "Crazy Cows",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/crystal_hall": {
        slug: "crystal_hall",
        name: "Crystal Hall",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/crystal_sun": {
        slug: "crystal_sun",
        name: "Crystal Sun",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dansband_pa_turne": {
        slug: "dansband_pa_turne",
        name: "Dansband Pa Turne",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dawn_of_egypt": {
        slug: "dawn_of_egypt",
        name: "Dawn of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/demon": {
        slug: "demon",
        name: "Demon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/derby_wheel": {
        slug: "derby_wheel",
        name: "Derby Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/diamond_vortex": {
        slug: "diamond_vortex",
        name: "Diamond Vortex",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/diamonds_of_the_realm": {
        slug: "diamonds_of_the_realm",
        name: "Diamonds of the Realm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dio_killing_the_dragon": {
        slug: "dio_killing_the_dragon",
        name: "DIO Killing the Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/disco_diamonds": {
        slug: "disco_diamonds",
        name: "Disco Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/divina_commedia_i_nove_cerchi": {
        slug: "divina_commedia_i_nove_cerchi",
        name: "Divina Commedia I Nove Cerchi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/divine_divas": {
        slug: "divine_divas",
        name: "Divine Divas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/divine_showdown": {
        slug: "divine_showdown",
        name: "Divine Showdown",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/doom_of_egypt": {
        slug: "doom_of_egypt",
        name: "Doom of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/double_exposure_blackjack": {
        slug: "double_exposure_blackjack",
        name: "Double Exposure Blackjack",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dr_toonz": {
        slug: "dr_toonz",
        name: "Dr. Toonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dragon_maiden": {
        slug: "dragon_maiden",
        name: "Dragon Maiden",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dragon_ship": {
        slug: "dragon_ship",
        name: "Dragon Ship",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dragonfates_favour": {
        slug: "dragonfates_favour",
        name: "Dragonfate's Favour",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/easter_eggs": {
        slug: "easter_eggs",
        name: "Easter Eggs",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/easter_eggspedition": {
        slug: "easter_eggspedition",
        name: "Easter Eggspedition",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/enchanted_crystals": {
        slug: "enchanted_crystals",
        name: "Enchanted Crystals",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/enchanted_meadow": {
        slug: "enchanted_meadow",
        name: "Enchanted Meadow",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/energoonz": {
        slug: "energoonz",
        name: "Energoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/european_blackjack": {
        slug: "european_blackjack",
        name: "European Blackjack",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/eye_of_atum": {
        slug: "eye_of_atum",
        name: "Eye of Atum",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/eye_of_the_kraken": {
        slug: "eye_of_the_kraken",
        name: "Eye of the Kraken",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fangs_and_fire": {
        slug: "fangs_and_fire",
        name: "Fangs and Fire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fat_frankies": {
        slug: "fat_frankies",
        name: "Fat Frankies",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fate_of_dead_blitzways": {
        slug: "fate_of_dead_blitzways",
        name: "Fate of Dead Blitzways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fates_fortune": {
        slug: "fates_fortune",
        name: "Fate's Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/feline_fury": {
        slug: "feline_fury",
        name: "Feline Fury",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_joker": {
        slug: "fire_joker",
        name: "Fire Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_joker_100": {
        slug: "fire_joker_100",
        name: "Fire Joker 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_joker_blitz": {
        slug: "fire_joker_blitz",
        name: "Fire Joker Blitz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_joker_freeze": {
        slug: "fire_joker_freeze",
        name: "Fire Joker Freeze",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_toad": {
        slug: "fire_toad",
        name: "Fire Toad",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_toad_2": {
        slug: "fire_toad_2",
        name: "Fire Toad 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/firefly_frenzy": {
        slug: "firefly_frenzy",
        name: "Firefly Frenzy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/forge_of_fortunes": {
        slug: "forge_of_fortunes",
        name: "Forge of Fortunes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/forge_of_gems": {
        slug: "forge_of_gems",
        name: "Forge of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fortune_rewind": {
        slug: "fortune_rewind",
        name: "Fortune Rewind",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fortune_teller": {
        slug: "fortune_teller",
        name: "Fortune Teller",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fortunes_of_ali_baba": {
        slug: "fortunes_of_ali_baba",
        name: "Fortunes of Ali Baba",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fox_mayhem": {
        slug: "fox_mayhem",
        name: "Fox Mayhem",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/free_reelin_joker": {
        slug: "free_reelin_joker",
        name: "Free Reelin' Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/free_reelin_joker_1000": {
        slug: "free_reelin_joker_1000",
        name: "Free Reelin' Joker 1000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/frozen_gems": {
        slug: "frozen_gems",
        name: "Frozen Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fu_er_dai": {
        slug: "fu_er_dai",
        name: "Fu Er Dai",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fulong_88": {
        slug: "fulong_88",
        name: "Fulong 88",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/game_of_gladiators": {
        slug: "game_of_gladiators",
        name: "Game of Gladiators",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/game_of_gladiators_uprising": {
        slug: "game_of_gladiators_uprising",
        name: "Game of Gladiators: Uprising",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gargantoonz": {
        slug: "gargantoonz",
        name: "Gargantoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gates_of_troy": {
        slug: "gates_of_troy",
        name: "Gates of Troy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gemix": {
        slug: "gemix",
        name: "GEMiX",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gemix_100": {
        slug: "gemix_100",
        name: "Gemix 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gemix_2": {
        slug: "gemix_2",
        name: "Gemix 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gerards_gambit": {
        slug: "gerards_gambit",
        name: "Gerard's Gambit",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ghost_of_dead": {
        slug: "ghost_of_dead",
        name: "Ghost of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gigantoonz": {
        slug: "gigantoonz",
        name: "Gigantoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gnawn_gold": {
        slug: "gnawn_gold",
        name: "Gnaw'n Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/go_craps": {
        slug: "go_craps",
        name: "Go Craps",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gold_king": {
        slug: "gold_king",
        name: "Gold King",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gold_of_fortune_god": {
        slug: "gold_of_fortune_god",
        name: "Gold of Fortune God",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gold_trophy_2": {
        slug: "gold_trophy_2",
        name: "Gold Trophy 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gold_volcano": {
        slug: "gold_volcano",
        name: "Gold Volcano",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_caravan": {
        slug: "golden_caravan",
        name: "Golden Caravan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_colts": {
        slug: "golden_colts",
        name: "Golden Colts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_legend": {
        slug: "golden_legend",
        name: "Golden Legend",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_osiris": {
        slug: "golden_osiris",
        name: "Golden Osiris",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_ticket": {
        slug: "golden_ticket",
        name: "Golden Ticket",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_ticket_2": {
        slug: "golden_ticket_2",
        name: "Golden Ticket 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/grannys_wild": {
        slug: "grannys_wild",
        name: "Granny's Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/grim_muerto": {
        slug: "grim_muerto",
        name: "Grim Muerto",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/happy_halloween": {
        slug: "happy_halloween",
        name: "Happy Halloween",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/highway_legends": {
        slug: "highway_legends",
        name: "Highway Legends",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/holiday_season": {
        slug: "holiday_season",
        name: "Holiday Season",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/holiday_spirits": {
        slug: "holiday_spirits",
        name: "Holiday Spirits",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/honey_rush": {
        slug: "honey_rush",
        name: "Honey Rush",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/honey_rush_100": {
        slug: "honey_rush_100",
        name: "Honey Rush 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/honey_rush_black_and_yellow": {
        slug: "honey_rush_black_and_yellow",
        name: "Honey Rush Black and Yellow",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/hooligan_hustle": {
        slug: "hooligan_hustle",
        name: "Hooligan Hustle",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/hope_unleashed_fortune_reels": {
        slug: "hope_unleashed_fortune_reels",
        name: "Hope Unleashed Fortune Reels",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/hot_dog_heist": {
        slug: "hot_dog_heist",
        name: "Hot Dog Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/hotel_yetiway": {
        slug: "hotel_yetiway",
        name: "Hotel Yeti-Way",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/house_of_doom": {
        slug: "house_of_doom",
        name: "House of Doom",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/house_of_doom_2_the_crypt": {
        slug: "house_of_doom_2_the_crypt",
        name: "House of Doom 2: The Crypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ice_joker": {
        slug: "ice_joker",
        name: "Ice Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/idol_of_fortune": {
        slug: "idol_of_fortune",
        name: "Idol of Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/immortails_of_egypt": {
        slug: "immortails_of_egypt",
        name: "Immortails of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/imperial_opera": {
        slug: "imperial_opera",
        name: "Imperial Opera",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/inferno_joker": {
        slug: "inferno_joker",
        name: "Inferno Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/inferno_star": {
        slug: "inferno_star",
        name: "Inferno Star",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/invading_vegas": {
        slug: "invading_vegas",
        name: "Invading Vegas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/invading_vegas_las_christmas": {
        slug: "invading_vegas_las_christmas",
        name: "Invading Vegas: Las Christmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/invading_vegas_revenge_on_mars": {
        slug: "invading_vegas_revenge_on_mars",
        name: "Invading Vegas Revenge on Mars",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/irish_gold": {
        slug: "irish_gold",
        name: "Irish Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/iron_girl": {
        slug: "iron_girl",
        name: "Iron Girl",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/jade_magician": {
        slug: "jade_magician",
        name: "Jade Magician",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/jewel_box": {
        slug: "jewel_box",
        name: "Jewel Box",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/joker_flip": {
        slug: "joker_flip",
        name: "Joker Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/jolly_roger": {
        slug: "jolly_roger",
        name: "Jolly Roger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/jolly_roger_2": {
        slug: "jolly_roger_2",
        name: "Jolly Roger 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/jolly_roger_wild_kraken": {
        slug: "jolly_roger_wild_kraken",
        name: "Jolly Roger Wild Kraken",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/journey_to_paris": {
        slug: "journey_to_paris",
        name: "Journey to Paris",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/king_of_sweets": {
        slug: "king_of_sweets",
        name: "King of Sweets",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/kingdom_below": {
        slug: "kingdom_below",
        name: "Kingdom Below",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/kings_mask": {
        slug: "kings_mask",
        name: "King's Mask",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/kings_mask_eclipse_of_gods": {
        slug: "kings_mask_eclipse_of_gods",
        name: "King's Mask Eclipse of Gods",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lab_of_madness": {
        slug: "lab_of_madness",
        name: "Lab of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lady_of_fortune": {
        slug: "lady_of_fortune",
        name: "Lady of Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lady_of_fortune_destiny_spins": {
        slug: "lady_of_fortune_destiny_spins",
        name: "Lady of Fortune Destiny Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lady_of_fortune_remastered": {
        slug: "lady_of_fortune_remastered",
        name: "Lady of Fortune Remastered",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lawn_n_disorder": {
        slug: "lawn_n_disorder",
        name: "Lawn N' Disorder",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_dead": {
        slug: "legacy_of_dead",
        name: "Legacy of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_dynasties": {
        slug: "legacy_of_dynasties",
        name: "Legacy of Dynasties",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_egypt": {
        slug: "legacy_of_egypt",
        name: "Legacy of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_gems_blitzways": {
        slug: "legacy_of_gems_blitzways",
        name: "Legacy of Gems Blitzways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_inca": {
        slug: "legacy_of_inca",
        name: "Legacy of Inca",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_undead_dragon_abyssways": {
        slug: "legacy_of_undead_dragon_abyssways",
        name: "Legacy of Undead Dragon Abyssways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legend_of_the_ice_dragon": {
        slug: "legend_of_the_ice_dragon",
        name: "Legend of the Ice Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold": {
        slug: "legion_gold",
        name: "Legion Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold_and_the_sphinx_of_dead": {
        slug: "legion_gold_and_the_sphinx_of_dead",
        name: "Legion Gold and the Sphinx of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold_and_the_throne_of_dead": {
        slug: "legion_gold_and_the_throne_of_dead",
        name: "Legion Gold And The Throne Of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold_reckoning": {
        slug: "legion_gold_reckoning",
        name: "Legion Gold Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold_unleashed": {
        slug: "legion_gold_unleashed",
        name: "Legion Gold Unleashed",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold_victory": {
        slug: "legion_gold_victory",
        name: "Legion Gold Victory",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/leprechaun_goes_egypt": {
        slug: "leprechaun_goes_egypt",
        name: "Leprechaun goes Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/leprechaun_goes_wild": {
        slug: "leprechaun_goes_wild",
        name: "Leprechaun Goes Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/leprechauns_diamond_dig": {
        slug: "leprechauns_diamond_dig",
        name: "Leprechaun's Diamond Dig",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/leprechauns_vault": {
        slug: "leprechauns_vault",
        name: "Leprechaun's Vault",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lion_saga_odyssey": {
        slug: "lion_saga_odyssey",
        name: "Lion Saga Odyssey",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/loot_and_labyrinths": {
        slug: "loot_and_labyrinths",
        name: "Loot and Labyrinths",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lord_merlin_and_the_lady_of_the_lake": {
        slug: "lord_merlin_and_the_lady_of_the_lake",
        name: "Lord Merlin and the Lady of the Lake",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/love_is_in_the_fair": {
        slug: "love_is_in_the_fair",
        name: "Love is in the Fair",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/love_joker": {
        slug: "love_joker",
        name: "Love Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/luchamigos": {
        slug: "luchamigos",
        name: "Luchamigos",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lucky_diamonds": {
        slug: "lucky_diamonds",
        name: "Lucky Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/madame_ink": {
        slug: "madame_ink",
        name: "Madame Ink",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mafia_gold": {
        slug: "mafia_gold",
        name: "Mafia Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mahjong_88": {
        slug: "mahjong_88",
        name: "Mahjong 88",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/manta_mayhem": {
        slug: "manta_mayhem",
        name: "Manta Mayhem",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/matsuri": {
        slug: "matsuri",
        name: "Matsuri",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/medusas_madness": {
        slug: "medusas_madness",
        name: "Medusa's Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mega_don_feeding_frenzy": {
        slug: "mega_don_feeding_frenzy",
        name: "Mega Don Feeding Frenzy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mega_don_triple_threat": {
        slug: "mega_don_triple_threat",
        name: "Mega Don Triple Threat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/megadon": {
        slug: "megadon",
        name: "Megadon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/merlin_and_the_ice_queen_morgana": {
        slug: "merlin_and_the_ice_queen_morgana",
        name: "Merlin and the Ice Queen Morgana",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/merlin_journey_of_flame": {
        slug: "merlin_journey_of_flame",
        name: "Merlin: Journey of Flame",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/merlin_realm_of_charm": {
        slug: "merlin_realm_of_charm",
        name: "Merlin Realm of Charm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/merlins_grimoire": {
        slug: "merlins_grimoire",
        name: "Merlin's Grimoire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mermaids_diamond": {
        slug: "mermaids_diamond",
        name: "Mermaid's Diamond",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/merry_xmas": {
        slug: "merry_xmas",
        name: "Merry Xmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/midnight_gold": {
        slug: "midnight_gold",
        name: "Midnight Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/miner_donkey_trouble": {
        slug: "miner_donkey_trouble",
        name: "Miner Donkey Trouble",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mini_baccarat": {
        slug: "mini_baccarat",
        name: "Mini Baccarat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mirror_joker": {
        slug: "mirror_joker",
        name: "Mirror Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mission_cash": {
        slug: "mission_cash",
        name: "Mission Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mole_digger": {
        slug: "mole_digger",
        name: "Mole Digger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/money_wheel": {
        slug: "money_wheel",
        name: "Money Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/monkey_battle_for_the_scrolls": {
        slug: "monkey_battle_for_the_scrolls",
        name: "Monkey Battle for the Scrolls",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess": {
        slug: "moon_princess",
        name: "Moon Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_christmas_kingdom": {
        slug: "moon_princess_christmas_kingdom",
        name: "Moon Princess: Christmas Kingdom",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_origins": {
        slug: "moon_princess_origins",
        name: "Moon Princess Origins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_power_of_love": {
        slug: "moon_princess_power_of_love",
        name: "Moon Princess Power of Love",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_stargazing": {
        slug: "moon_princess_stargazing",
        name: "Moon Princess Stargazing",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_trinity": {
        slug: "moon_princess_trinity",
        name: "Moon Princess Trinity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/motley_crue": {
        slug: "motley_crue",
        name: "Motley Crue",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mount_m": {
        slug: "mount_m",
        name: "Mount M",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/muerto_en_mictlan": {
        slug: "muerto_en_mictlan",
        name: "Muerto En Mictlan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/multifruit_81": {
        slug: "multifruit_81",
        name: "MultiFruit 81",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mystery_egg_surprise": {
        slug: "mystery_egg_surprise",
        name: "Mystery Egg Surprise",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mystery_genie_fortunes_of_the_lamp": {
        slug: "mystery_genie_fortunes_of_the_lamp",
        name: "Mystery Genie Fortunes of the Lamp",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mystery_joker": {
        slug: "mystery_joker",
        name: "Mystery Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mystery_joker_6000": {
        slug: "mystery_joker_6000",
        name: "Mystery Joker 6000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/myth": {
        slug: "myth",
        name: "Myth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/myth_of_dead": {
        slug: "myth_of_dead",
        name: "Myth of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/naughty_nicks_book": {
        slug: "naughty_nicks_book",
        name: "Naughty Nick's Book",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/new_year_riches": {
        slug: "new_year_riches",
        name: "New Year Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ninja_fruits": {
        slug: "ninja_fruits",
        name: "Ninja Fruits",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/nugget_n_nonsense": {
        slug: "nugget_n_nonsense",
        name: "Nugget N' Nonsense",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/oasis_of_dead": {
        slug: "oasis_of_dead",
        name: "Oasis of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/octopus_treasure": {
        slug: "octopus_treasure",
        name: "Octopus Treasure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/odin_protector_of_realms": {
        slug: "odin_protector_of_realms",
        name: "Odin: Protector of Realms",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pack_and_cash": {
        slug: "pack_and_cash",
        name: "Pack and Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pandastic_adventure": {
        slug: "pandastic_adventure",
        name: "Pandastic Adventure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pandoras_box_of_evil": {
        slug: "pandoras_box_of_evil",
        name: "Pandora's Box of Evil",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pearl_lagoon": {
        slug: "pearl_lagoon",
        name: "Pearl Lagoon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pearls_of_india": {
        slug: "pearls_of_india",
        name: "Pearls of India",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/perfect_gems": {
        slug: "perfect_gems",
        name: "Perfect Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/phoenix_reborn": {
        slug: "phoenix_reborn",
        name: "Phoenix Reborn",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/photo_safari": {
        slug: "photo_safari",
        name: "Photo Safari",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_bank_farm": {
        slug: "piggy_bank_farm",
        name: "Piggy Bank Farm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_blitz": {
        slug: "piggy_blitz",
        name: "Piggy Blitz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_blitz_casino_gold": {
        slug: "piggy_blitz_casino_gold",
        name: "Piggy Blitz Casino Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_blitz_disco_gold": {
        slug: "piggy_blitz_disco_gold",
        name: "Piggy Blitz Disco Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_heist": {
        slug: "piggy_heist",
        name: "Piggy Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pilgrim_of_dead": {
        slug: "pilgrim_of_dead",
        name: "Pilgrim of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pimped": {
        slug: "pimped",
        name: "Pimped",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pirahna_pays": {
        slug: "pirahna_pays",
        name: "Pirahna Pays",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/planet_fortune": {
        slug: "planet_fortune",
        name: "Planet Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/potion_of_madness": {
        slug: "potion_of_madness",
        name: "Potion of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/primal_rampage": {
        slug: "primal_rampage",
        name: "Primal Rampage",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/prism_of_gems": {
        slug: "prism_of_gems",
        name: "Prism of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/prissy_princess": {
        slug: "prissy_princess",
        name: "Prissy Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/prosperity_palace": {
        slug: "prosperity_palace",
        name: "Prosperity Palace",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/puebla_parade": {
        slug: "puebla_parade",
        name: "Puebla Parade",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/queens_day_tilt": {
        slug: "queens_day_tilt",
        name: "Queen's Day Tilt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rabbit_hole_riches": {
        slug: "rabbit_hole_riches",
        name: "Rabbit Hole Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rage_to_riches": {
        slug: "rage_to_riches",
        name: "Rage to Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/raging_rex": {
        slug: "raging_rex",
        name: "Raging Rex",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/raging_rex_2": {
        slug: "raging_rex_2",
        name: "Raging Rex 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/raging_rex_3": {
        slug: "raging_rex_3",
        name: "Raging Rex 3",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rainforest_magic": {
        slug: "rainforest_magic",
        name: "Rainforest Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rainforest_magic_bingo": {
        slug: "rainforest_magic_bingo",
        name: "Rainforest Magic Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rally_4_riches": {
        slug: "rally_4_riches",
        name: "Rally 4 Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ras_reckoning": {
        slug: "ras_reckoning",
        name: "Ra's Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rascal_riches": {
        slug: "rascal_riches",
        name: "Rascal Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/reactoonz": {
        slug: "reactoonz",
        name: "Reactoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/reactoonz_100": {
        slug: "reactoonz_100",
        name: "Reactoonz 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/reactoonz_2": {
        slug: "reactoonz_2",
        name: "Reactoonz 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_amulet_of_dead": {
        slug: "rich_wilde_and_the_amulet_of_dead",
        name: "Rich Wilde and The Amulet of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_pearls_of_vishnu": {
        slug: "rich_wilde_and_the_pearls_of_vishnu",
        name: "Rich Wilde and the Pearls of Vishnu",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_shield_of_athena": {
        slug: "rich_wilde_and_the_shield_of_athena",
        name: "Rich Wilde and the Shield of Athena",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_tome_of_dead": {
        slug: "rich_wilde_and_the_tome_of_dead",
        name: "Rich Wilde and the Tome of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_tome_of_insanity": {
        slug: "rich_wilde_and_the_tome_of_insanity",
        name: "Rich Wilde and the Tome of Insanity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_tome_of_madness": {
        slug: "rich_wilde_and_the_tome_of_madness",
        name: "Rich Wilde and the Tome of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_wandering_city": {
        slug: "rich_wilde_and_the_wandering_city",
        name: "Rich Wilde and the Wandering City",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/riches_of_ra": {
        slug: "riches_of_ra",
        name: "Riches of RA",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/riches_of_robin": {
        slug: "riches_of_robin",
        name: "Riches of Robin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/riddle_reels_a_case_of_riches": {
        slug: "riddle_reels_a_case_of_riches",
        name: "Riddle Reels: A Case of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ring_of_odin": {
        slug: "ring_of_odin",
        name: "Ring of Odin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rings_of_prosperity": {
        slug: "rings_of_prosperity",
        name: "Rings of Prosperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_athena": {
        slug: "rise_of_athena",
        name: "Rise of Athena",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_dead": {
        slug: "rise_of_dead",
        name: "Rise of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_gods_reckoning": {
        slug: "rise_of_gods_reckoning",
        name: "Rise of Gods: Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_merlin": {
        slug: "rise_of_merlin",
        name: "Rise of Merlin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus": {
        slug: "rise_of_olympus",
        name: "Rise of Olympus",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus_100": {
        slug: "rise_of_olympus_100",
        name: "Rise of Olympus 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus_1000": {
        slug: "rise_of_olympus_1000",
        name: "Rise of Olympus 1000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus_bingo": {
        slug: "rise_of_olympus_bingo",
        name: "Rise of Olympus Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus_extreme": {
        slug: "rise_of_olympus_extreme",
        name: "Rise of Olympus Extreme",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus_origins": {
        slug: "rise_of_olympus_origins",
        name: "Rise of Olympus Origins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_orpheus": {
        slug: "rise_of_orpheus",
        name: "Rise of Orpheus",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rocco_gallo": {
        slug: "rocco_gallo",
        name: "Rocco Gallo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ronins_honour": {
        slug: "ronins_honour",
        name: "Ronin's Honour",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rosy_orbit_treasure_turn": {
        slug: "rosy_orbit_treasure_turn",
        name: "Rosy Orbit Treasure Turn",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rotiki": {
        slug: "rotiki",
        name: "RoTiki",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/royal_masquerade": {
        slug: "royal_masquerade",
        name: "Royal Masquerade",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ruff_heist": {
        slug: "ruff_heist",
        name: "Ruff Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sabaton": {
        slug: "sabaton",
        name: "Sabaton",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/safari_of_wealth": {
        slug: "safari_of_wealth",
        name: "Safari of Wealth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sails_of_gold": {
        slug: "sails_of_gold",
        name: "Sails of Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sails_of_riches": {
        slug: "sails_of_riches",
        name: "Sails of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/samba_carnival": {
        slug: "samba_carnival",
        name: "Samba Carnival",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/scales_of_dead": {
        slug: "scales_of_dead",
        name: "Scales of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/scourge_of_rome": {
        slug: "scourge_of_rome",
        name: "Scourge of Rome",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/scroll_of_dead": {
        slug: "scroll_of_dead",
        name: "Scroll of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/scroll_of_seth": {
        slug: "scroll_of_seth",
        name: "Scroll of Seth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sea_hunter": {
        slug: "sea_hunter",
        name: "Sea Hunter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/secret_of_dead": {
        slug: "secret_of_dead",
        name: "Secret of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/shamrock_miner": {
        slug: "shamrock_miner",
        name: "Shamrock Miner",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/shark_feast": {
        slug: "shark_feast",
        name: "Shark Feast",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sherwood_gold": {
        slug: "sherwood_gold",
        name: "Sherwood Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/shimmering_woods": {
        slug: "shimmering_woods",
        name: "Shimmering Woods",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/single_deck_blackjack": {
        slug: "single_deck_blackjack",
        name: "Single Deck Blackjack",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sisters_of_the_sun": {
        slug: "sisters_of_the_sun",
        name: "Sisters of the Sun",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sizzling_spins": {
        slug: "sizzling_spins",
        name: "Sizzling Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/slashimi": {
        slug: "slashimi",
        name: "Slashimi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sobeks_godly_spins": {
        slug: "sobeks_godly_spins",
        name: "Sobek's Godly Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/space_race": {
        slug: "space_race",
        name: "Space Race",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/spark_of_genius": {
        slug: "spark_of_genius",
        name: "Spark of Genius",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sparky_and_shortz": {
        slug: "sparky_and_shortz",
        name: "Sparky & Shortz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sparky_and_shortz_hidden_joules": {
        slug: "sparky_and_shortz_hidden_joules",
        name: "Sparky & Shortz Hidden Joules",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/spice_spice_baby": {
        slug: "spice_spice_baby",
        name: "Spice Spice Baby",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/spin_party": {
        slug: "spin_party",
        name: "Spin Party",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/spinnin_records_into_the_beat": {
        slug: "spinnin_records_into_the_beat",
        name: "Spinnin Records into the Beat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/spinnin_records_raving_reels": {
        slug: "spinnin_records_raving_reels",
        name: "Spinnin Records Raving Reels",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/stadium_of_riches": {
        slug: "stadium_of_riches",
        name: "Stadium of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/star_joker": {
        slug: "star_joker",
        name: "Star Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/static_nightmare": {
        slug: "static_nightmare",
        name: "Static Nightmare",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/stepping_diamonds": {
        slug: "stepping_diamonds",
        name: "Stepping Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sticky_joker": {
        slug: "sticky_joker",
        name: "Sticky Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/street_magic": {
        slug: "street_magic",
        name: "Street Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/super_flip": {
        slug: "super_flip",
        name: "Super Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/super_flip_deluxe": {
        slug: "super_flip_deluxe",
        name: "Super Flip Deluxe",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/super_wheel": {
        slug: "super_wheel",
        name: "Super Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sweet_27": {
        slug: "sweet_27",
        name: "Sweet 27",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sweet_alchemy": {
        slug: "sweet_alchemy",
        name: "Sweet Alchemy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sweet_alchemy_100": {
        slug: "sweet_alchemy_100",
        name: "Sweet Alchemy 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sweet_alchemy_2": {
        slug: "sweet_alchemy_2",
        name: "Sweet Alchemy 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sweet_alchemy_bingo": {
        slug: "sweet_alchemy_bingo",
        name: "Sweet Alchemy Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tale_of_kyubiko": {
        slug: "tale_of_kyubiko",
        name: "Tale of Kyubiko",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tales_of_asgard_freyas_wedding": {
        slug: "tales_of_asgard_freyas_wedding",
        name: "Tales of Asgard: Freya's Wedding",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tales_of_asgard_lokis_fortune": {
        slug: "tales_of_asgard_lokis_fortune",
        name: "Tales of Asgard: Loki's Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tales_of_mithrune_syns_fortune": {
        slug: "tales_of_mithrune_syns_fortune",
        name: "Tales of Mithrune Syn's Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/temple_of_prosperity": {
        slug: "temple_of_prosperity",
        name: "Temple of Prosperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/temple_of_three": {
        slug: "temple_of_three",
        name: "Temple of Three",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/temple_of_tollan": {
        slug: "temple_of_tollan",
        name: "Temple of Tollan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ternion": {
        slug: "ternion",
        name: "Ternion",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/testament": {
        slug: "testament",
        name: "Testament",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/thats_rich": {
        slug: "thats_rich",
        name: "That's Rich",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_faces_of_freya": {
        slug: "the_faces_of_freya",
        name: "The Faces of Freya",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_green_knight": {
        slug: "the_green_knight",
        name: "The Green Knight",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_green_knight_oath_of_thorns": {
        slug: "the_green_knight_oath_of_thorns",
        name: "The Green Knight Oath of Thorns",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_last_sundown": {
        slug: "the_last_sundown",
        name: "The Last Sundown",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_paying_piano_club": {
        slug: "the_paying_piano_club",
        name: "The Paying Piano Club",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_return_of_the_green_knight": {
        slug: "the_return_of_the_green_knight",
        name: "The Return of the Green Knight",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_sword_and_the_grail": {
        slug: "the_sword_and_the_grail",
        name: "The Sword and The Grail",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_sword_and_the_grail_excalibur": {
        slug: "the_sword_and_the_grail_excalibur",
        name: "The Sword and the Grail Excalibur",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_wild_class": {
        slug: "the_wild_class",
        name: "The Wild Class",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/thunderscreech": {
        slug: "thunderscreech",
        name: "Thunderscreech",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tomb_of_gold": {
        slug: "tomb_of_gold",
        name: "Tomb of Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tomb_of_gold_ii": {
        slug: "tomb_of_gold_ii",
        name: "Tomb of Gold II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tomb_of_gold_reimagined": {
        slug: "tomb_of_gold_reimagined",
        name: "Tomb of Gold Reimagined",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tome_of_madness_bingo": {
        slug: "tome_of_madness_bingo",
        name: "Tome Of Madness Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/track_n_gold": {
        slug: "track_n_gold",
        name: "Track n' Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/treasures_of_kongar": {
        slug: "treasures_of_kongar",
        name: "Treasures of Kongar",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/treats_of_terror": {
        slug: "treats_of_terror",
        name: "Treats of Terror",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/trinity_impact": {
        slug: "trinity_impact",
        name: "Trinity Impact",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/triple_launch_fortune_wild": {
        slug: "triple_launch_fortune_wild",
        name: "Triple Launch Fortune Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/troll_hunters": {
        slug: "troll_hunters",
        name: "Troll Hunters",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/troll_hunters_2": {
        slug: "troll_hunters_2",
        name: "Troll Hunters 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/undefeated_xerxes": {
        slug: "undefeated_xerxes",
        name: "Undefeated Xerxes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/usa_flip": {
        slug: "usa_flip",
        name: "USA Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/valhalluck": {
        slug: "valhalluck",
        name: "Valhalluck",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/video_poker": {
        slug: "video_poker",
        name: "Video Poker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viking_apocalypse": {
        slug: "viking_apocalypse",
        name: "Viking Apocalypse",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viking_runecraft": {
        slug: "viking_runecraft",
        name: "Viking Runecraft",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viking_runecraft_100": {
        slug: "viking_runecraft_100",
        name: "Viking Runecraft 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viking_runecraft_bingo": {
        slug: "viking_runecraft_bingo",
        name: "Viking Runecraft Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viper_city_heist": {
        slug: "viper_city_heist",
        name: "Viper City Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wheel_of_mictlan": {
        slug: "wheel_of_mictlan",
        name: "Wheel of Mictlan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/whispering_winds": {
        slug: "whispering_winds",
        name: "Whispering Winds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_bandolier": {
        slug: "wild_bandolier",
        name: "Wild Bandolier",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_blood": {
        slug: "wild_blood",
        name: "Wild Blood",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_blood_2": {
        slug: "wild_blood_2",
        name: "Wild Blood 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_falls": {
        slug: "wild_falls",
        name: "Wild Falls",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_falls_2": {
        slug: "wild_falls_2",
        name: "Wild Falls 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_frames": {
        slug: "wild_frames",
        name: "Wild Frames",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_melon": {
        slug: "wild_melon",
        name: "Wild Melon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_north": {
        slug: "wild_north",
        name: "Wild North",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_north_radiant_skies": {
        slug: "wild_north_radiant_skies",
        name: "Wild North Radiant Skies",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_rails": {
        slug: "wild_rails",
        name: "Wild Rails",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_survivor": {
        slug: "wild_survivor",
        name: "Wild Survivor",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_trigger": {
        slug: "wild_trigger",
        name: "Wild Trigger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wildest_gambit": {
        slug: "wildest_gambit",
        name: "Wildest Gambit",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wildhound_derby": {
        slug: "wildhound_derby",
        name: "Wildhound Derby",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/winabeest": {
        slug: "winabeest",
        name: "Win-A-Beest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wizard_of_gems": {
        slug: "wizard_of_gems",
        name: "Wizard of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wrappin_gold": {
        slug: "wrappin_gold",
        name: "Wrappin Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/xmas_joker": {
        slug: "xmas_joker",
        name: "Xmas Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/xmas_magic": {
        slug: "xmas_magic",
        name: "Xmas Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "playzia/all_men_are_brothers_94": {
        slug: "all_men_are_brothers_94",
        name: "All Men are Brothers 94",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/american_party_riches": {
        slug: "american_party_riches",
        name: "American Party Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/aztec_prosperity": {
        slug: "aztec_prosperity",
        name: "Aztec Prosperity",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/billionaire_bison": {
        slug: "billionaire_bison",
        name: "Billionaire Bison",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/billionaire_buffalo": {
        slug: "billionaire_buffalo",
        name: "Billionaire Buffalo",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/billionaire_rhino": {
        slug: "billionaire_rhino",
        name: "Billionaire Rhino",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/billionaire_wolf": {
        slug: "billionaire_wolf",
        name: "Billionaire Wolf",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/bills_buck_bonanza": {
        slug: "bills_buck_bonanza",
        name: "Bill's Buck Bonanza",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/blazing_fruit_7s": {
        slug: "blazing_fruit_7s",
        name: "Blazing Fruit 7s",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/book_of_alexandria": {
        slug: "book_of_alexandria",
        name: "Book of Alexandria",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/caishens_coins": {
        slug: "caishens_coins",
        name: "Caishen’s Coins",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/cosmos_cash": {
        slug: "cosmos_cash",
        name: "Cosmos Cash",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/crazy_chilli_party": {
        slug: "crazy_chilli_party",
        name: "Crazy Chilli Party",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/dwarves_treasure_race": {
        slug: "dwarves_treasure_race",
        name: "Dwarves Treasure Race",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/fight_or_die_crew": {
        slug: "fight_or_die_crew",
        name: "Fight or Die Crew",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/fire_horse_fortune": {
        slug: "fire_horse_fortune",
        name: "Fire Horse Fortune",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/fortune_dragon_riches": {
        slug: "fortune_dragon_riches",
        name: "Fortune Dragon Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/freedom_frenzy": {
        slug: "freedom_frenzy",
        name: "Freedom Frenzy",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/fruity_fiesta": {
        slug: "fruity_fiesta",
        name: "Fruity Fiesta",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/goal_rush_deluxe": {
        slug: "goal_rush_deluxe",
        name: "Goal Rush Deluxe",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/grand_ocean_megaways": {
        slug: "grand_ocean_megaways",
        name: "Grand Ocean Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/greek_goddess_siege_of_olympus_megaways": {
        slug: "greek_goddess_siege_of_olympus_megaways",
        name: "Greek Goddess: Siege of Olympus Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/jokers_dice": {
        slug: "jokers_dice",
        name: "Joker’s Dice",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/knights_the_siege": {
        slug: "knights_the_siege",
        name: "Knights: The Siege",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/la_copa_grande": {
        slug: "la_copa_grande",
        name: "La Copa Grande",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/lollipop_loot": {
        slug: "lollipop_loot",
        name: "Lollipop Loot",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/love_island_hold_the_love": {
        slug: "love_island_hold_the_love",
        name: "Love Island Hold the Love",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/love_island_instant_match": {
        slug: "love_island_instant_match",
        name: "Love Island Instant Match",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/love_island_love_in_a_spin": {
        slug: "love_island_love_in_a_spin",
        name: "Love Island Love in a Spin",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/lucky_aces": {
        slug: "lucky_aces",
        name: "Lucky Aces",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/medusa_mystic_reels_megaways": {
        slug: "medusa_mystic_reels_megaways",
        name: "Medusa Mystic Reels Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/not_yet_another_irish_game_94": {
        slug: "not_yet_another_irish_game_94",
        name: "Not Yet Another Irish Game 94",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/piggy_clusters": {
        slug: "piggy_clusters",
        name: "Piggy Clusters",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/playzia_coin_flip": {
        slug: "playzia_coin_flip",
        name: "Playzia Coin Flip",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/playzia_magic_7": {
        slug: "playzia_magic_7",
        name: "Playzia Magic 7",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/playzia_plinko": {
        slug: "playzia_plinko",
        name: "Playzia Plinko",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/playzia_wheel": {
        slug: "playzia_wheel",
        name: "Playzia Wheel",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/raiders_of_valhalla_megaways": {
        slug: "raiders_of_valhalla_megaways",
        name: "Raiders of Valhalla Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/raul_the_vampire": {
        slug: "raul_the_vampire",
        name: "Raul the Vampire",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/red_envelope_riches": {
        slug: "red_envelope_riches",
        name: "Red Envelope Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/safari_kingdom": {
        slug: "safari_kingdom",
        name: "Safari Kingdom",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/santas_reels": {
        slug: "santas_reels",
        name: "Santa’s Reels",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/sweet_candy_fortune": {
        slug: "sweet_candy_fortune",
        name: "Sweet Candy Fortune",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/sweet_candy_fortune_bonanza": {
        slug: "sweet_candy_fortune_bonanza",
        name: "Sweet Candy Fortune Bonanza",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/tale_of_the_red_dragon": {
        slug: "tale_of_the_red_dragon",
        name: "Tale of The Red Dragon",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/the_great_fishing_adventure": {
        slug: "the_great_fishing_adventure",
        name: "The Great Fishing Adventure",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/the_great_fishing_adventure_bonanza": {
        slug: "the_great_fishing_adventure_bonanza",
        name: "The Great Fishing Adventure Bonanza",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/tomb_of_luxor": {
        slug: "tomb_of_luxor",
        name: "Tomb of Luxor",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/trans_santas_sack": {
        slug: "trans_santas_sack",
        name: "Trans Santa's Sack",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/trex_treasure_hunt_megaways": {
        slug: "trex_treasure_hunt_megaways",
        name: "T-Rex Treasure Hunt Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/velvet_riches": {
        slug: "velvet_riches",
        name: "Velvet Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/volcanic_coins": {
        slug: "volcanic_coins",
        name: "Volcanic Coins",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/wanted_los_desesperados": {
        slug: "wanted_los_desesperados",
        name: "Wanted: Los Desesperados",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/wild_tigers_bounty": {
        slug: "wild_tigers_bounty",
        name: "Wild Tiger's Bounty",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/zeuss_thunderstrike": {
        slug: "zeuss_thunderstrike",
        name: "Zeus's Thunderstrike",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/zombie_the_apocalypse": {
        slug: "zombie_the_apocalypse",
        name: "Zombie the Apocalypse",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "pragmatic-play-live/24d_spin": {
        slug: "24d_spin",
        name: "24D Spin",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/amazing_baccarat": {
        slug: "amazing_baccarat",
        name: "Amazing Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/american_roulette": {
        slug: "american_roulette",
        name: "American Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/andar_bahar": {
        slug: "andar_bahar",
        name: "Andar Bahar",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/auto_mega_roulette": {
        slug: "auto_mega_roulette",
        name: "Auto Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/auto_roulette": {
        slug: "auto_roulette",
        name: "Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/autoroulette": {
        slug: "autoroulette",
        name: "Auto-Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/baccarat_lobby": {
        slug: "baccarat_lobby",
        name: "Baccarat Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/bet_behind_pro_blackjack": {
        slug: "bet_behind_pro_blackjack",
        name: "Bet Behind Pro Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/big_small_baccarat": {
        slug: "big_small_baccarat",
        name: "Big Small Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_azure": {
        slug: "blackjack_azure",
        name: "Blackjack - Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_emerald": {
        slug: "blackjack_emerald",
        name: "Blackjack - Emerald",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_lobby": {
        slug: "blackjack_lobby",
        name: "Blackjack Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_ruby": {
        slug: "blackjack_ruby",
        name: "Blackjack - Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_the_club": {
        slug: "blackjack_the_club",
        name: "Blackjack - The Club",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_x_azure": {
        slug: "blackjack_x_azure",
        name: "Blackjack X Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_x_ruby": {
        slug: "blackjack_x_ruby",
        name: "Blackjack X Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjackx": {
        slug: "blackjackx",
        name: "BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/boom_city": {
        slug: "boom_city",
        name: "Boom City",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/brazilian_baccarat": {
        slug: "brazilian_baccarat",
        name: "Brazilian Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/brazilian_mega_roulette": {
        slug: "brazilian_mega_roulette",
        name: "Brazilian Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/brazilian_one_blackjack": {
        slug: "brazilian_one_blackjack",
        name: "Brazilian One Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/brazilian_roulette": {
        slug: "brazilian_roulette",
        name: "Brazilian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/brazilian_turbo_baccarat": {
        slug: "brazilian_turbo_baccarat",
        name: "Brazilian Turbo Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/casino_holdem": {
        slug: "casino_holdem",
        name: "Casino Hold'em",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/chinese_speed_baccarat": {
        slug: "chinese_speed_baccarat",
        name: "Chinese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/crystal_roulette": {
        slug: "crystal_roulette",
        name: "Crystal Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/dice_city": {
        slug: "dice_city",
        name: "Dice City",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/dragon_tiger_lobby": {
        slug: "dragon_tiger_lobby",
        name: "Dragon Tiger Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/football_blitz_top_card": {
        slug: "football_blitz_top_card",
        name: "Football Blitz Top Card",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/fortune_baccarat": {
        slug: "fortune_baccarat",
        name: "Fortune Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/fortune_roulette": {
        slug: "fortune_roulette",
        name: "Fortune Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/free_bet_blackjack_1": {
        slug: "free_bet_blackjack_1",
        name: "Free Bet Blackjack 1",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/french_roulette": {
        slug: "french_roulette",
        name: "French Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/game_show_lobby": {
        slug: "game_show_lobby",
        name: "Game Show Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/game_shows": {
        slug: "game_shows",
        name: "Game Shows",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/gates_of_olympus_roulette": {
        slug: "gates_of_olympus_roulette",
        name: "Gates of Olympus Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/german_roulette": {
        slug: "german_roulette",
        name: "German Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/greek_roulette": {
        slug: "greek_roulette",
        name: "Greek Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/hilo_baccarat": {
        slug: "hilo_baccarat",
        name: "Hi-Lo Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/immersive_roulette_deluxe": {
        slug: "immersive_roulette_deluxe",
        name: "Immersive Roulette Deluxe",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/indonesia_roulette": {
        slug: "indonesia_roulette",
        name: "Indonesia Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/indonesian_blackjackx": {
        slug: "indonesian_blackjackx",
        name: "Indonesian BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/indonesian_roulette": {
        slug: "indonesian_roulette",
        name: "Indonesian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/indonesian_speed_baccarat": {
        slug: "indonesian_speed_baccarat",
        name: "Indonesian Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/italian_mega_roulette": {
        slug: "italian_mega_roulette",
        name: "Italian Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/japanese_speed_baccarat": {
        slug: "japanese_speed_baccarat",
        name: "Japanese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/korean_blackjackx": {
        slug: "korean_blackjackx",
        name: "Korean BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/korean_roulette": {
        slug: "korean_roulette",
        name: "Korean Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/korean_speed_baccarat": {
        slug: "korean_speed_baccarat",
        name: "Korean Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/live_staging_tests": {
        slug: "live_staging_tests",
        name: "Live Staging Tests",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/lucky_roulette": {
        slug: "lucky_roulette",
        name: "Lucky Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_baccarat": {
        slug: "mega_baccarat",
        name: "Mega Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_roulette": {
        slug: "mega_roulette",
        name: "Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_roulette_3000": {
        slug: "mega_roulette_3000",
        name: "Mega Roulette 3000",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_roulette_brazilian": {
        slug: "mega_roulette_brazilian",
        name: "Mega Roulette Brazilian",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_sic_bac": {
        slug: "mega_sic_bac",
        name: "Mega Sic Bac",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_sic_bo": {
        slug: "mega_sic_bo",
        name: "Mega Sic Bo",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_sic_bo_lobby": {
        slug: "mega_sic_bo_lobby",
        name: "Mega Sic Bo Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_wheel": {
        slug: "mega_wheel",
        name: "Mega Wheel",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/money_time": {
        slug: "money_time",
        name: "Money Time",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/no_comm_baccarat": {
        slug: "no_comm_baccarat",
        name: "No Comm Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/no_comm_speed_baccarat": {
        slug: "no_comm_speed_baccarat",
        name: "No Comm Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/one_blackjack": {
        slug: "one_blackjack",
        name: "One Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/one_blackjack_dutch": {
        slug: "one_blackjack_dutch",
        name: "ONE Blackjack - Dutch",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/one_blackjack_ruby": {
        slug: "one_blackjack_ruby",
        name: "ONE Blackjack - Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/pay4d_speed_baccarat": {
        slug: "pay4d_speed_baccarat",
        name: "PAY4D SPEED BACCARAT",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/powerup_roulette": {
        slug: "powerup_roulette",
        name: "PowerUp Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/pragmatic_live_lobby": {
        slug: "pragmatic_live_lobby",
        name: "Pragmatic Live Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/pragmatic_play_live_lobby": {
        slug: "pragmatic_play_live_lobby",
        name: "Pragmatic Play Live Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/prive_lounge_baccarat": {
        slug: "prive_lounge_baccarat",
        name: "Prive Lounge Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/prive_lounge_blackjack": {
        slug: "prive_lounge_blackjack",
        name: "Prive Lounge Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/prive_lounge_russian_poker": {
        slug: "prive_lounge_russian_poker",
        name: "Prive Lounge Russian Poker",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/punto_banco_italia_tricolore": {
        slug: "punto_banco_italia_tricolore",
        name: "Punto Banco Italia Tricolore",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/romanian_roulette": {
        slug: "romanian_roulette",
        name: "Romanian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette": {
        slug: "roulette",
        name: "Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_azure": {
        slug: "roulette_azure",
        name: "Roulette - Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_dutch": {
        slug: "roulette_dutch",
        name: "Roulette - Dutch",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_german": {
        slug: "roulette_german",
        name: "Roulette - German",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_india": {
        slug: "roulette_india",
        name: "Roulette India",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_indian": {
        slug: "roulette_indian",
        name: "Roulette - Indian",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_italia_tricolore": {
        slug: "roulette_italia_tricolore",
        name: "Roulette Italia Tricolore",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_italian": {
        slug: "roulette_italian",
        name: "Roulette - Italian",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_latina": {
        slug: "roulette_latina",
        name: "Roulette Latina",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_lobby": {
        slug: "roulette_lobby",
        name: "Roulette Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_macao": {
        slug: "roulette_macao",
        name: "Roulette Macao",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_romanian": {
        slug: "roulette_romanian",
        name: "Roulette - Romanian",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_ruby": {
        slug: "roulette_ruby",
        name: "Roulette Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_russian": {
        slug: "roulette_russian",
        name: "Roulette - Russian",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_spanish": {
        slug: "roulette_spanish",
        name: "Roulette - Spanish",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_the_club": {
        slug: "roulette_the_club",
        name: "Roulette - The Club",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_turkish": {
        slug: "roulette_turkish",
        name: "Roulette - Turkish",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/russian_prive_lounge_blackjack": {
        slug: "russian_prive_lounge_blackjack",
        name: "Russian Prive Lounge Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/russian_roulette": {
        slug: "russian_roulette",
        name: "Russian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/sic_bo": {
        slug: "sic_bo",
        name: "Sic Bo",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/sic_bo_lobby": {
        slug: "sic_bo_lobby",
        name: "Sic Bo Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/snakes_and_ladders_live": {
        slug: "snakes_and_ladders_live",
        name: "Snakes and Ladders Live",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/spaceman": {
        slug: "spaceman",
        name: "Spaceman",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/speed_auto_roulette": {
        slug: "speed_auto_roulette",
        name: "Speed Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/speed_baccarat": {
        slug: "speed_baccarat",
        name: "Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/speed_baccarat_korean": {
        slug: "speed_baccarat_korean",
        name: "Speed Baccarat - Korean",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/speed_blackjack_azure": {
        slug: "speed_blackjack_azure",
        name: "Speed Blackjack - Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/speed_blackjack_emerald": {
        slug: "speed_blackjack_emerald",
        name: "Speed Blackjack - Emerald",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/speed_blackjack_ruby": {
        slug: "speed_blackjack_ruby",
        name: "Speed Blackjack - Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/speed_roulette": {
        slug: "speed_roulette",
        name: "Speed Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/squeeze_baccarat": {
        slug: "squeeze_baccarat",
        name: "Squeeze Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/super_baccarat": {
        slug: "super_baccarat",
        name: "Super Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/sweet_bonanza_candyland": {
        slug: "sweet_bonanza_candyland",
        name: "Sweet Bonanza Candyland",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/thai_baccarat": {
        slug: "thai_baccarat",
        name: "Thai Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/thai_roulette": {
        slug: "thai_roulette",
        name: "Thai Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/thai_speed_baccarat": {
        slug: "thai_speed_baccarat",
        name: "Thai Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/the_bingo_spot": {
        slug: "the_bingo_spot",
        name: "The Bingo Spot",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/treasure_island": {
        slug: "treasure_island",
        name: "Treasure Island",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/turkish_mega_roulette": {
        slug: "turkish_mega_roulette",
        name: "Turkish Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/turkish_one_blackjack": {
        slug: "turkish_one_blackjack",
        name: "Turkish ONE Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/turkish_roulette": {
        slug: "turkish_roulette",
        name: "Turkish Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vegas_ball_bonanza": {
        slug: "vegas_ball_bonanza",
        name: "Vegas Ball Bonanza",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vietnamese_roulette": {
        slug: "vietnamese_roulette",
        name: "Vietnamese Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vietnamese_speed_baccarat": {
        slug: "vietnamese_speed_baccarat",
        name: "Vietnamese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vip_auto_roulette": {
        slug: "vip_auto_roulette",
        name: "VIP Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vip_blackjack_emerald": {
        slug: "vip_blackjack_emerald",
        name: "VIP Blackjack - Emerald",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vip_blackjack_ruby": {
        slug: "vip_blackjack_ruby",
        name: "VIP Blackjack - Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vip_roulette": {
        slug: "vip_roulette",
        name: "VIP Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play/3_buzzing_wilds": {
        slug: "3_buzzing_wilds",
        name: "3 Buzzing Wilds",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/3_dancing_monkeys": {
        slug: "3_dancing_monkeys",
        name: "3 Dancing Monkeys",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/3_genie_wishes": {
        slug: "3_genie_wishes",
        name: "3 Genie Wishes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/3_kingdoms_battle_of_red_cliffs": {
        slug: "3_kingdoms_battle_of_red_cliffs",
        name: "3 Kingdoms - Battle of Red Cliffs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/3_magic_eggs": {
        slug: "3_magic_eggs",
        name: "3 Magic Eggs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_frozen_charms_megaways": {
        slug: "5_frozen_charms_megaways",
        name: "5 Frozen Charms Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions": {
        slug: "5_lions",
        name: "5 Lions",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions_dance": {
        slug: "5_lions_dance",
        name: "5 Lions Dance",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions_gold": {
        slug: "5_lions_gold",
        name: "5 Lions Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions_megaways": {
        slug: "5_lions_megaways",
        name: "5 Lions MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions_megaways_2": {
        slug: "5_lions_megaways_2",
        name: "5 Lions Megaways 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions_reborn": {
        slug: "5_lions_reborn",
        name: "5 Lions Reborn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_rabbits_megaways": {
        slug: "5_rabbits_megaways",
        name: "5 Rabbits MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/6_jokers": {
        slug: "6_jokers",
        name: "6 Jokers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/7_clovers_of_fortune": {
        slug: "7_clovers_of_fortune",
        name: "7 Clovers of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/7_monkeys": {
        slug: "7_monkeys",
        name: "7 Monkeys",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/7_monkeys_jp": {
        slug: "7_monkeys_jp",
        name: "7 Monkeys JP",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/7_piggies": {
        slug: "7_piggies",
        name: "7 Piggies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/7_piggies_scratch_25000": {
        slug: "7_piggies_scratch_25000",
        name: "7 Piggies Scratch 25,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/8_dragons": {
        slug: "8_dragons",
        name: "8 Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/8_golden_dragon_challenge": {
        slug: "8_golden_dragon_challenge",
        name: "8 Golden Dragon Challenge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/888_bonanza": {
        slug: "888_bonanza",
        name: "888 Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/888_dragons": {
        slug: "888_dragons",
        name: "888 Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/888_gold": {
        slug: "888_gold",
        name: "888 Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/african_elephant": {
        slug: "african_elephant",
        name: "African Elephant",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aladdin_and_the_sorcerer": {
        slug: "aladdin_and_the_sorcerer",
        name: "Aladdin and The Sorcerer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/alien_invaders": {
        slug: "alien_invaders",
        name: "Alien Invaders",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/amazing_money_machine": {
        slug: "amazing_money_machine",
        name: "Amazing Money Machine",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/american_blackjack": {
        slug: "american_blackjack",
        name: "American Blackjack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/anacoda_gold": {
        slug: "anacoda_gold",
        name: "Anacoda Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ancient_egypt": {
        slug: "ancient_egypt",
        name: "Ancient Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ancient_egypt_classic": {
        slug: "ancient_egypt_classic",
        name: "Ancient Egypt Classic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ancient_island_megaways": {
        slug: "ancient_island_megaways",
        name: "Ancient Island Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/angel_vs_sinner": {
        slug: "angel_vs_sinner",
        name: "Angel vs Sinner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/anime_mecha_megaways": {
        slug: "anime_mecha_megaways",
        name: "Anime Mecha Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/argonauts": {
        slug: "argonauts",
        name: "Argonauts",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/asgard": {
        slug: "asgard",
        name: "Asgard",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_blaze": {
        slug: "aztec_blaze",
        name: "Aztec Blaze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_bonanza": {
        slug: "aztec_bonanza",
        name: "Aztec Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_gems": {
        slug: "aztec_gems",
        name: "Aztec Gems",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_gems_deluxe": {
        slug: "aztec_gems_deluxe",
        name: "Aztec Gems Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_gems_megaways": {
        slug: "aztec_gems_megaways",
        name: "Aztec Gems Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_king": {
        slug: "aztec_king",
        name: "Aztec King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_king_megaways": {
        slug: "aztec_king_megaways",
        name: "Aztec King MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_powernudge": {
        slug: "aztec_powernudge",
        name: "Aztec Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_smash": {
        slug: "aztec_smash",
        name: "Aztec Smash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_treasure": {
        slug: "aztec_treasure",
        name: "Aztec Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_treasure_hunt": {
        slug: "aztec_treasure_hunt",
        name: "Aztec Treasure Hunt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/badge_blitz": {
        slug: "badge_blitz",
        name: "Badge Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bali_dragon": {
        slug: "bali_dragon",
        name: "Bali Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bandit_megaways": {
        slug: "bandit_megaways",
        name: "Bandit Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/barn_festival": {
        slug: "barn_festival",
        name: "Barn Festival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/barnyard_megahays_megaways": {
        slug: "barnyard_megahays_megaways",
        name: "Barnyard Megahays Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bear_crazy": {
        slug: "bear_crazy",
        name: "Bear Crazy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bee_keeper": {
        slug: "bee_keeper",
        name: "Bee Keeper",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bermuda_riches": {
        slug: "bermuda_riches",
        name: "Bermuda Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/better_barn_house_bonanza": {
        slug: "better_barn_house_bonanza",
        name: "Better Barn House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/beware_the_deep_megaways": {
        slug: "beware_the_deep_megaways",
        name: "Beware The Deep Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_amazon_xtreme": {
        slug: "big_bass_amazon_xtreme",
        name: "Big Bass Amazon Xtreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_blast": {
        slug: "big_bass_blast",
        name: "Big Bass Blast",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza": {
        slug: "big_bass_bonanza",
        name: "Big Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_1000": {
        slug: "big_bass_bonanza_1000",
        name: "Big Bass Bonanza 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_3_reeler": {
        slug: "big_bass_bonanza_3_reeler",
        name: "Big Bass Bonanza 3 Reeler",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_jackpot_play": {
        slug: "big_bass_bonanza_jackpot_play",
        name: "Big Bass Bonanza Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_keeping_it_reel": {
        slug: "big_bass_bonanza_keeping_it_reel",
        name: "Big Bass Bonanza Keeping it Reel",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_megaways": {
        slug: "big_bass_bonanza_megaways",
        name: "Big Bass Bonanza Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_reel_action": {
        slug: "big_bass_bonanza_reel_action",
        name: "Big Bass Bonanza Reel Action",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_boxing_bonus_round": {
        slug: "big_bass_boxing_bonus_round",
        name: "Big Bass Boxing Bonus Round",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_christmas_bash": {
        slug: "big_bass_christmas_bash",
        name: "Big Bass Christmas Bash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_christmas_frozen_lake": {
        slug: "big_bass_christmas_frozen_lake",
        name: "Big Bass Christmas Frozen Lake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_crash": {
        slug: "big_bass_crash",
        name: "BIg Bass Crash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_day_at_the_races": {
        slug: "big_bass_day_at_the_races",
        name: "Big Bass Day At The Races",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_floats_my_boat": {
        slug: "big_bass_floats_my_boat",
        name: "Big Bass Floats My Boat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_football_bonanza": {
        slug: "big_bass_football_bonanza",
        name: "Big Bass Football Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_halloween": {
        slug: "big_bass_halloween",
        name: "Big Bass Halloween",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_halloween_2": {
        slug: "big_bass_halloween_2",
        name: "Big Bass Halloween 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_halloween_3": {
        slug: "big_bass_halloween_3",
        name: "Big Bass Halloween 3",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_hold_and_spinner": {
        slug: "big_bass_hold_and_spinner",
        name: "Big Bass Hold and Spinner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_hold_and_spinner_megaways": {
        slug: "big_bass_hold_and_spinner_megaways",
        name: "Big Bass Hold and Spinner Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_mission_fishin": {
        slug: "big_bass_mission_fishin",
        name: "Big Bass Mission Fishin'",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_raceday_repeat": {
        slug: "big_bass_raceday_repeat",
        name: "Big Bass Raceday Repeat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_reel_repeat": {
        slug: "big_bass_reel_repeat",
        name: "Big Bass Reel Repeat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_return_to_the_races": {
        slug: "big_bass_return_to_the_races",
        name: "Big Bass Return to the Races",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_secrets_of_the_golden_lake": {
        slug: "big_bass_secrets_of_the_golden_lake",
        name: "Big Bass Secrets of the Golden Lake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_splash": {
        slug: "big_bass_splash",
        name: "Big Bass Splash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_splash_1000": {
        slug: "big_bass_splash_1000",
        name: "Big Bass Splash 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_splash_jackpot_play": {
        slug: "big_bass_splash_jackpot_play",
        name: "Big Bass Splash Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_trophy_catch": {
        slug: "big_bass_trophy_catch",
        name: "Big Bass Trophy Catch",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_vegas_double_down_deluxe": {
        slug: "big_bass_vegas_double_down_deluxe",
        name: "Big Bass Vegas Double Down Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_xmas_xtreme": {
        slug: "big_bass_xmas_xtreme",
        name: "Big Bass Xmas Xtreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_burger_load_it_up_with_xtra_cheese": {
        slug: "big_burger_load_it_up_with_xtra_cheese",
        name: "Big Burger Load it up with Xtra cheese",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_juan": {
        slug: "big_juan",
        name: "Big Juan",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bigger_barn_house_bonanza": {
        slug: "bigger_barn_house_bonanza",
        name: "Bigger Barn House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bigger_bass_blizzard_christmas_catch": {
        slug: "bigger_bass_blizzard_christmas_catch",
        name: "Bigger Bass Blizzard Christmas Catch",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bigger_bass_bonanza": {
        slug: "bigger_bass_bonanza",
        name: "Bigger Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bigger_bass_splash": {
        slug: "bigger_bass_splash",
        name: "Bigger Bass Splash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bingo_mania": {
        slug: "bingo_mania",
        name: "Bingo Mania",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/black_bull": {
        slug: "black_bull",
        name: "Black Bull",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/blade_and_fangs": {
        slug: "blade_and_fangs",
        name: "Blade & Fangs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/blazing_wilds_megaways": {
        slug: "blazing_wilds_megaways",
        name: "Blazing Wilds Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/blitz_super_wheel": {
        slug: "blitz_super_wheel",
        name: "Blitz Super Wheel",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bloody_dawn": {
        slug: "bloody_dawn",
        name: "Bloody Dawn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bomb_bonanza": {
        slug: "bomb_bonanza",
        name: "Bomb Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bonanza_gold": {
        slug: "bonanza_gold",
        name: "Bonanza Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_aztec_king": {
        slug: "book_of_aztec_king",
        name: "Book of Aztec King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_fallen": {
        slug: "book_of_fallen",
        name: "Book of Fallen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_golden_sands": {
        slug: "book_of_golden_sands",
        name: "Book of Golden Sands",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_kingdoms": {
        slug: "book_of_kingdoms",
        name: "Book of Kingdoms",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_monsters": {
        slug: "book_of_monsters",
        name: "Book of Monsters",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_the_fallen": {
        slug: "book_of_the_fallen",
        name: "Book of the Fallen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_tut": {
        slug: "book_of_tut",
        name: "Book of Tut",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_tut_respin": {
        slug: "book_of_tut_respin",
        name: "Book of Tut Respin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bounty_gold": {
        slug: "bounty_gold",
        name: "Bounty Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bounty_hunter": {
        slug: "bounty_hunter",
        name: "Bounty Hunter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bow_of_artemis": {
        slug: "bow_of_artemis",
        name: "Bow of Artemis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/brick_house_bonanza": {
        slug: "brick_house_bonanza",
        name: "Brick House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bronco_spirit": {
        slug: "bronco_spirit",
        name: "Bronco Spirit",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bubble_pop": {
        slug: "bubble_pop",
        name: "Bubble Pop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/buffalo_king": {
        slug: "buffalo_king",
        name: "Buffalo King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/buffalo_king_megaways": {
        slug: "buffalo_king_megaways",
        name: "Buffalo King MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/buffalo_king_untamed_megaways": {
        slug: "buffalo_king_untamed_megaways",
        name: "Buffalo King Untamed Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bull_fiesta": {
        slug: "bull_fiesta",
        name: "Bull Fiesta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/busy_bees": {
        slug: "busy_bees",
        name: "Busy Bees",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/caishens_cash": {
        slug: "caishens_cash",
        name: "Caishen's Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/caishens_cash_pots": {
        slug: "caishens_cash_pots",
        name: "Caishen's Cash Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/caishens_gold": {
        slug: "caishens_gold",
        name: "Caishen's Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_blitz": {
        slug: "candy_blitz",
        name: "Candy Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_blitz_bombs": {
        slug: "candy_blitz_bombs",
        name: "Candy Blitz Bombs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_corner": {
        slug: "candy_corner",
        name: "Candy Corner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_jar_cluster": {
        slug: "candy_jar_cluster",
        name: "Candy Jar Cluster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_jar_clusters": {
        slug: "candy_jar_clusters",
        name: "Candy Jar Clusters",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_rush": {
        slug: "candy_rush",
        name: "Candy Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_stars": {
        slug: "candy_stars",
        name: "Candy Stars",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_village": {
        slug: "candy_village",
        name: "Candy Village",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/captain_kraken_megaways": {
        slug: "captain_kraken_megaways",
        name: "Captain Kraken Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_bonanza": {
        slug: "cash_bonanza",
        name: "Cash Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_box": {
        slug: "cash_box",
        name: "Cash Box",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_chips": {
        slug: "cash_chips",
        name: "Cash Chips",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_elevator": {
        slug: "cash_elevator",
        name: "Cash Elevator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_patrol": {
        slug: "cash_patrol",
        name: "Cash Patrol",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_surge": {
        slug: "cash_surge",
        name: "Cash Surge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/casino_heist_megaways": {
        slug: "casino_heist_megaways",
        name: "Casino Heist Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/castle_of_fire": {
        slug: "castle_of_fire",
        name: "Castle of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chase_for_glory": {
        slug: "chase_for_glory",
        name: "Chase for Glory",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cheeky_emperor": {
        slug: "cheeky_emperor",
        name: "Cheeky Emperor",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chests_of_cai_shen": {
        slug: "chests_of_cai_shen",
        name: "Chests of Cai Shen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chests_of_cai_shen_2": {
        slug: "chests_of_cai_shen_2",
        name: "Chests of Cai Shen 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chicken": {
        slug: "chicken",
        name: "Chicken+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chicken_chase": {
        slug: "chicken_chase",
        name: "Chicken Chase",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chicken_drop": {
        slug: "chicken_drop",
        name: "Chicken Drop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chilli_heat": {
        slug: "chilli_heat",
        name: "Chilli Heat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chilli_heat_megaways": {
        slug: "chilli_heat_megaways",
        name: "Chilli Heat MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chilli_heat_spicy_spins": {
        slug: "chilli_heat_spicy_spins",
        name: "Chilli Heat Spicy Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/christmas_big_bass_bonanza": {
        slug: "christmas_big_bass_bonanza",
        name: "Christmas Big Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/christmas_carol_megaways": {
        slug: "christmas_carol_megaways",
        name: "Christmas Carol MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cleocatra": {
        slug: "cleocatra",
        name: "Cleocatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/clover_gold": {
        slug: "clover_gold",
        name: "Clover Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/club_tropicana": {
        slug: "club_tropicana",
        name: "Club Tropicana",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/club_tropicana_happy_hour": {
        slug: "club_tropicana_happy_hour",
        name: "Club Tropicana Happy Hour",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/coffee_wild": {
        slug: "coffee_wild",
        name: "Coffee Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/colossal_cash_zone": {
        slug: "colossal_cash_zone",
        name: "Colossal Cash Zone",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/congo_cash": {
        slug: "congo_cash",
        name: "Congo Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/congo_cash_xl": {
        slug: "congo_cash_xl",
        name: "Congo Cash XL",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cosmic_cash": {
        slug: "cosmic_cash",
        name: "Cosmic Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cosmic_clusters": {
        slug: "cosmic_clusters",
        name: "Cosmic Clusters!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cowboy_coins": {
        slug: "cowboy_coins",
        name: "Cowboy Coins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cowboys_gold": {
        slug: "cowboys_gold",
        name: "Cowboys Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/crank_it_up": {
        slug: "crank_it_up",
        name: "Crank It Up",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/crown_of_fire": {
        slug: "crown_of_fire",
        name: "Crown of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/crown_of_fire_jackpot_play": {
        slug: "crown_of_fire_jackpot_play",
        name: "Crown of Fire Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/crystal_caverns_megaways": {
        slug: "crystal_caverns_megaways",
        name: "Crystal Caverns MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cult": {
        slug: "cult",
        name: "CULT",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/curse_of_the_werewolf_megaways": {
        slug: "curse_of_the_werewolf_megaways",
        name: "Curse of the Werewolf MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cyber_heist": {
        slug: "cyber_heist",
        name: "Cyber Heist",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cyber_pup_megaways": {
        slug: "cyber_pup_megaways",
        name: "Cyber Pup Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cyberheist_city": {
        slug: "cyberheist_city",
        name: "Cyberheist City",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cyclops_smash": {
        slug: "cyclops_smash",
        name: "Cyclops Smash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/da_vincis_treasure": {
        slug: "da_vincis_treasure",
        name: "Da Vinci's Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dance_party": {
        slug: "dance_party",
        name: "Dance Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/davincis_treasure": {
        slug: "davincis_treasure",
        name: "DaVinci's Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/day_of_dead": {
        slug: "day_of_dead",
        name: "Day of Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/demon_pots": {
        slug: "demon_pots",
        name: "Demon Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/devilicious": {
        slug: "devilicious",
        name: "Devilicious",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/devils_13": {
        slug: "devils_13",
        name: "Devil's 13",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/diamond_cascade": {
        slug: "diamond_cascade",
        name: "Diamond Cascade",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/diamond_strike": {
        slug: "diamond_strike",
        name: "Diamond Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/diamond_strike_scratch_250000": {
        slug: "diamond_strike_scratch_250000",
        name: "Diamond Strike Scratch 250,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/diamonds_are_forever_3_lines": {
        slug: "diamonds_are_forever_3_lines",
        name: "Diamonds are Forever 3 Lines",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/diamonds_of_egypt": {
        slug: "diamonds_of_egypt",
        name: "Diamonds of Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ding_dong_christmas_bells": {
        slug: "ding_dong_christmas_bells",
        name: "Ding Dong Christmas Bells",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/disco_lady": {
        slug: "disco_lady",
        name: "Disco Lady",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/down_the_rails": {
        slug: "down_the_rails",
        name: "Down the Rails",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/drago_jewels_of_fortune": {
        slug: "drago_jewels_of_fortune",
        name: "Drago - Jewels of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_bonus_baccarat": {
        slug: "dragon_bonus_baccarat",
        name: "Dragon Bonus Baccarat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_gold_88": {
        slug: "dragon_gold_88",
        name: "Dragon Gold 88",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_hero": {
        slug: "dragon_hero",
        name: "Dragon Hero",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_hot_hold_and_spin": {
        slug: "dragon_hot_hold_and_spin",
        name: "Dragon Hot Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_king_hot_pots": {
        slug: "dragon_king_hot_pots",
        name: "Dragon King Hot Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_kingdom": {
        slug: "dragon_kingdom",
        name: "Dragon Kingdom",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_kingdom_eyes_of_fire": {
        slug: "dragon_kingdom_eyes_of_fire",
        name: "Dragon Kingdom Eyes of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_pots_megaways": {
        slug: "dragon_pots_megaways",
        name: "Dragon Pots Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_tiger_fortunes": {
        slug: "dragon_tiger_fortunes",
        name: "Dragon Tiger Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragons_gate_bonus_choice": {
        slug: "dragons_gate_bonus_choice",
        name: "Dragon's Gate Bonus Choice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/drill_that_gold": {
        slug: "drill_that_gold",
        name: "Drill that Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/duel_of_night_and_day": {
        slug: "duel_of_night_and_day",
        name: "Duel of Night and Day",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dwarf_and_dragon": {
        slug: "dwarf_and_dragon",
        name: "Dwarf and Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dwarven_gold_deluxe": {
        slug: "dwarven_gold_deluxe",
        name: "Dwarven Gold Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dynamite_diggin_doug": {
        slug: "dynamite_diggin_doug",
        name: "Dynamite Diggin Doug",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/egg_rush_jackpot_play": {
        slug: "egg_rush_jackpot_play",
        name: "Egg Rush Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/egyptian_fortunes": {
        slug: "egyptian_fortunes",
        name: "Egyptian Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/elemental_gems_megaways": {
        slug: "elemental_gems_megaways",
        name: "Elemental Gems MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/emerald_king": {
        slug: "emerald_king",
        name: "Emerald King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/emerald_king_rainbow_road": {
        slug: "emerald_king_rainbow_road",
        name: "Emerald King Rainbow Road",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/emerald_king_wheel_of_wealth": {
        slug: "emerald_king_wheel_of_wealth",
        name: "Emerald King Wheel of Wealth",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/emperor_caishen": {
        slug: "emperor_caishen",
        name: "Emperor Caishen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/empty_the_bank": {
        slug: "empty_the_bank",
        name: "Empty the Bank!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/escape_the_pyramid_fire_and_ice": {
        slug: "escape_the_pyramid_fire_and_ice",
        name: "Escape the Pyramid Fire and Ice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/eternal_empress_freeze_time": {
        slug: "eternal_empress_freeze_time",
        name: "Eternal Empress Freeze Time",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/excalibur_unleashed": {
        slug: "excalibur_unleashed",
        name: "Excalibur Unleashed",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/extra_juicy": {
        slug: "extra_juicy",
        name: "Extra Juicy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/extra_juicy_megaways": {
        slug: "extra_juicy_megaways",
        name: "Extra Juicy MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/eye_of_cleopatra": {
        slug: "eye_of_cleopatra",
        name: "Eye of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/eye_of_spartacus": {
        slug: "eye_of_spartacus",
        name: "Eye of Spartacus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/eye_of_the_storm": {
        slug: "eye_of_the_storm",
        name: "Eye of the Storm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fairytale_fortune": {
        slug: "fairytale_fortune",
        name: "Fairytale Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fangtastic_freespins": {
        slug: "fangtastic_freespins",
        name: "Fangtastic Freespins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fat_panda": {
        slug: "fat_panda",
        name: "Fat Panda",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fiesta_fortune": {
        slug: "fiesta_fortune",
        name: "Fiesta Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/finger_lickn_free_spins": {
        slug: "finger_lickn_free_spins",
        name: "Finger Lick'n Free Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_88": {
        slug: "fire_88",
        name: "Fire 88",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_archer": {
        slug: "fire_archer",
        name: "Fire Archer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_100": {
        slug: "fire_hot_100",
        name: "Fire Hot 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_100_jackpot_play": {
        slug: "fire_hot_100_jackpot_play",
        name: "Fire Hot 100 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_20": {
        slug: "fire_hot_20",
        name: "Fire Hot 20",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_20_jackpot_play": {
        slug: "fire_hot_20_jackpot_play",
        name: "Fire Hot 20 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_40": {
        slug: "fire_hot_40",
        name: "Fire Hot 40",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_40_jackpot_play": {
        slug: "fire_hot_40_jackpot_play",
        name: "Fire Hot 40 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_5": {
        slug: "fire_hot_5",
        name: "Fire Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_5_jackpot_play": {
        slug: "fire_hot_5_jackpot_play",
        name: "Fire Hot 5 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_portals": {
        slug: "fire_portals",
        name: "Fire Portals",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_stampede": {
        slug: "fire_stampede",
        name: "Fire Stampede",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_stampede_2": {
        slug: "fire_stampede_2",
        name: "Fire Stampede 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_stampede_ultimate": {
        slug: "fire_stampede_ultimate",
        name: "Fire Stampede Ultimate",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_strike": {
        slug: "fire_strike",
        name: "Fire Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_strike_2": {
        slug: "fire_strike_2",
        name: "Fire Strike 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/firebird_spirit_connect_and_collect": {
        slug: "firebird_spirit_connect_and_collect",
        name: "Firebird Spirit Connect and Collect",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fish_eye": {
        slug: "fish_eye",
        name: "Fish Eye",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fishin_reels": {
        slug: "fishin_reels",
        name: "Fishin' Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon": {
        slug: "floating_dragon",
        name: "Floating Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon_dragon_boat_festival": {
        slug: "floating_dragon_dragon_boat_festival",
        name: "Floating Dragon Dragon Boat Festival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon_megaways": {
        slug: "floating_dragon_megaways",
        name: "Floating Dragon Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon_new_year_festival_ultra_megaways": {
        slug: "floating_dragon_new_year_festival_ultra_megaways",
        name: "Floating Dragon New Year Festival Ultra Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon_wild_horses": {
        slug: "floating_dragon_wild_horses",
        name: "Floating Dragon Wild Horses",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon_year_of_the_snake": {
        slug: "floating_dragon_year_of_the_snake",
        name: "Floating Dragon Year of the Snake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fonzos_feline_fortunes": {
        slug: "fonzos_feline_fortunes",
        name: "Fonzo's Feline Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/forge_of_olympus": {
        slug: "forge_of_olympus",
        name: "Forge of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/forging_wilds": {
        slug: "forging_wilds",
        name: "Forging Wilds",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_ace": {
        slug: "fortune_ace",
        name: "Fortune Ace",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_ace_scatter": {
        slug: "fortune_ace_scatter",
        name: "Fortune Ace Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_dragon": {
        slug: "fortune_dragon",
        name: "Fortune Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_hitn_roll": {
        slug: "fortune_hitn_roll",
        name: "Fortune Hit'n Roll",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_of_giza": {
        slug: "fortune_of_giza",
        name: "Fortune of Giza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_of_olympus": {
        slug: "fortune_of_olympus",
        name: "Fortune of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortunes_of_aztec": {
        slug: "fortunes_of_aztec",
        name: "Fortunes of Aztec",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/frightening_frankie": {
        slug: "frightening_frankie",
        name: "Frightening Frankie",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/frogs_and_bugs": {
        slug: "frogs_and_bugs",
        name: "Frogs & Bugs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/front_runner_odds_on": {
        slug: "front_runner_odds_on",
        name: "Front Runner Odds On",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/frozen_tropics": {
        slug: "frozen_tropics",
        name: "Frozen Tropics",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fruit_party": {
        slug: "fruit_party",
        name: "Fruit Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fruit_party_2": {
        slug: "fruit_party_2",
        name: "Fruit Party 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fruit_party_jackpot_play": {
        slug: "fruit_party_jackpot_play",
        name: "Fruit Party Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fruit_rainbow": {
        slug: "fruit_rainbow",
        name: "Fruit Rainbow",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fruity_treats": {
        slug: "fruity_treats",
        name: "Fruity Treats",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fu_fu_fu": {
        slug: "fu_fu_fu",
        name: "Fu Fu Fu",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/furry_bonanza_megaways": {
        slug: "furry_bonanza_megaways",
        name: "Furry Bonanza Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fury_of_anubis": {
        slug: "fury_of_anubis",
        name: "Fury of Anubis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fury_of_odin_megaways": {
        slug: "fury_of_odin_megaways",
        name: "Fury of Odin MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gameshow_party_jackpot_play": {
        slug: "gameshow_party_jackpot_play",
        name: "Gameshow Party Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_aztec": {
        slug: "gates_of_aztec",
        name: "Gates of Aztec",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_gatot_kaca": {
        slug: "gates_of_gatot_kaca",
        name: "Gates of Gatot Kaca",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_gatot_kaca_1000": {
        slug: "gates_of_gatot_kaca_1000",
        name: "Gates of Gatot Kaca 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_gatot_kaca_super_scatter": {
        slug: "gates_of_gatot_kaca_super_scatter",
        name: "Gates of Gatot Kaca Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_hades": {
        slug: "gates_of_hades",
        name: "Gates of Hades",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus": {
        slug: "gates_of_olympus",
        name: "Gates of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus_1000": {
        slug: "gates_of_olympus_1000",
        name: "Gates of Olympus 1,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus_dice": {
        slug: "gates_of_olympus_dice",
        name: "Gates of Olympus Dice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus_jackpot_play": {
        slug: "gates_of_olympus_jackpot_play",
        name: "Gates of Olympus Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus_super_scatter": {
        slug: "gates_of_olympus_super_scatter",
        name: "Gates of Olympus Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus_xmas_1000": {
        slug: "gates_of_olympus_xmas_1000",
        name: "Gates of Olympus Xmas 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_pyroth": {
        slug: "gates_of_pyroth",
        name: "Gates of Pyroth",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_valhalla": {
        slug: "gates_of_valhalla",
        name: "Gates of Valhalla",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gatot_kacas_fury": {
        slug: "gatot_kacas_fury",
        name: "Gatot Kaca's Fury",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gears_of_horus": {
        slug: "gears_of_horus",
        name: "Gears of Horus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gem_elevator": {
        slug: "gem_elevator",
        name: "Gem Elevator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gem_fire_fortune": {
        slug: "gem_fire_fortune",
        name: "Gem Fire Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gem_trio": {
        slug: "gem_trio",
        name: "Gem Trio",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gems_bonanza": {
        slug: "gems_bonanza",
        name: "Gems Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gems_of_serengeti": {
        slug: "gems_of_serengeti",
        name: "Gems of Serengeti",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gemstone": {
        slug: "gemstone",
        name: "Gemstone",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/genies_gem_bonanza": {
        slug: "genies_gem_bonanza",
        name: "Genie's Gem Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/goblin_heist_powernudge": {
        slug: "goblin_heist_powernudge",
        name: "Goblin Heist Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gods_of_giza": {
        slug: "gods_of_giza",
        name: "Gods of Giza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_oasis": {
        slug: "gold_oasis",
        name: "Gold Oasis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_party": {
        slug: "gold_party",
        name: "Gold Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_party_2_after_hours": {
        slug: "gold_party_2_after_hours",
        name: "Gold Party 2 After Hours",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_rush": {
        slug: "gold_rush",
        name: "Gold Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_rush_scratch_500000": {
        slug: "gold_rush_scratch_500000",
        name: "Gold Rush Scratch 500,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_train": {
        slug: "gold_train",
        name: "Gold Train",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/golden_beauty": {
        slug: "golden_beauty",
        name: "Golden Beauty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/golden_ox": {
        slug: "golden_ox",
        name: "Golden Ox",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/golden_pig": {
        slug: "golden_pig",
        name: "Golden Pig",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/good_luck_and_good_fortune": {
        slug: "good_luck_and_good_fortune",
        name: "Good Luck and Good Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gorilla_mayhem": {
        slug: "gorilla_mayhem",
        name: "Gorilla Mayhem",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/grace_of_ebisu": {
        slug: "grace_of_ebisu",
        name: "Grace of Ebisu",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gravity_bonanza": {
        slug: "gravity_bonanza",
        name: "Gravity Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_ghosts": {
        slug: "great_ghosts",
        name: "Great Ghosts!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_lagoon": {
        slug: "great_lagoon",
        name: "Great Lagoon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_reef": {
        slug: "great_reef",
        name: "Great Reef",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_rhino": {
        slug: "great_rhino",
        name: "Great Rhino",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_rhino_deluxe": {
        slug: "great_rhino_deluxe",
        name: "Great Rhino Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_rhino_megaways": {
        slug: "great_rhino_megaways",
        name: "Great Rhino MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/greedy_fortune_pig": {
        slug: "greedy_fortune_pig",
        name: "Greedy Fortune Pig",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/greedy_wolf": {
        slug: "greedy_wolf",
        name: "Greedy Wolf",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/greek_gods": {
        slug: "greek_gods",
        name: "Greek Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hammerstorm": {
        slug: "hammerstorm",
        name: "Hammerstorm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hand_of_midas_2": {
        slug: "hand_of_midas_2",
        name: "Hand of Midas 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/happy_fortune": {
        slug: "happy_fortune",
        name: "Happy Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/haunted_crypt": {
        slug: "haunted_crypt",
        name: "Haunted Crypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heart_of_cleopatra": {
        slug: "heart_of_cleopatra",
        name: "Heart of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heart_of_rio": {
        slug: "heart_of_rio",
        name: "Heart of Rio",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heartbreakers": {
        slug: "heartbreakers",
        name: "Heartbreakers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heist_for_the_golden_nuggets": {
        slug: "heist_for_the_golden_nuggets",
        name: "Heist for the Golden Nuggets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hell_butcher": {
        slug: "hell_butcher",
        name: "Hell Butcher",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hellvis_wild": {
        slug: "hellvis_wild",
        name: "Hellvis Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hercules_and_pegasus": {
        slug: "hercules_and_pegasus",
        name: "Hercules and Pegasus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hercules_son_of_zeus": {
        slug: "hercules_son_of_zeus",
        name: "Hercules Son of Zeus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heroic_spin": {
        slug: "heroic_spin",
        name: "Heroic Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heroic_spins": {
        slug: "heroic_spins",
        name: "Heroic Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/high_flyer": {
        slug: "high_flyer",
        name: "High Flyer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/himalayan_wild": {
        slug: "himalayan_wild",
        name: "Himalayan Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hockey_attack": {
        slug: "hockey_attack",
        name: "Hockey Attack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hokkaido_wolf": {
        slug: "hokkaido_wolf",
        name: "Hokkaido Wolf",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/holiday_ride": {
        slug: "holiday_ride",
        name: "Holiday Ride",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/honey_honey_honey": {
        slug: "honey_honey_honey",
        name: "Honey Honey Honey",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_chilli": {
        slug: "hot_chilli",
        name: "Hot Chilli",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_fiesta": {
        slug: "hot_fiesta",
        name: "Hot Fiesta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_pepper": {
        slug: "hot_pepper",
        name: "Hot Pepper",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_safari": {
        slug: "hot_safari",
        name: "Hot Safari",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_safari_scratch_75000": {
        slug: "hot_safari_scratch_75000",
        name: "Hot Safari Scratch 75,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn": {
        slug: "hot_to_burn",
        name: "Hot to Burn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn_7_deadly_free_spins": {
        slug: "hot_to_burn_7_deadly_free_spins",
        name: "Hot to Burn 7 Deadly Free Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn_extreme": {
        slug: "hot_to_burn_extreme",
        name: "Hot to Burn Extreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn_hold_and_spin": {
        slug: "hot_to_burn_hold_and_spin",
        name: "Hot to Burn Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn_jackpot_play": {
        slug: "hot_to_burn_jackpot_play",
        name: "Hot to Burn Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn_multiplier": {
        slug: "hot_to_burn_multiplier",
        name: "Hot to Burn Multiplier",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_tuna": {
        slug: "hot_tuna",
        name: "Hot Tuna",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hundreds_and_thousands": {
        slug: "hundreds_and_thousands",
        name: "Hundreds and Thousands",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ice_lobster": {
        slug: "ice_lobster",
        name: "Ice Lobster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ice_mint": {
        slug: "ice_mint",
        name: "Ice Mint",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/idol_pop_fever": {
        slug: "idol_pop_fever",
        name: "Idol Pop Fever",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/inca_queen": {
        slug: "inca_queen",
        name: "Inca Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/infective_wild": {
        slug: "infective_wild",
        name: "Infective Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/irish_charms": {
        slug: "irish_charms",
        name: "Irish Charms",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/irish_crown": {
        slug: "irish_crown",
        name: "Irish Crown",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jackpot_blaze": {
        slug: "jackpot_blaze",
        name: "Jackpot Blaze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jackpot_hunter": {
        slug: "jackpot_hunter",
        name: "Jackpot Hunter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jade_butterfly": {
        slug: "jade_butterfly",
        name: "Jade Butterfly",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jane_hunter_and_the_mask_of_montezuma": {
        slug: "jane_hunter_and_the_mask_of_montezuma",
        name: "Jane Hunter and the Mask of Montezuma",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jasmine_dreams": {
        slug: "jasmine_dreams",
        name: "Jasmine Dreams",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jelly_express": {
        slug: "jelly_express",
        name: "Jelly Express",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jewel_rush": {
        slug: "jewel_rush",
        name: "Jewel Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_galileos_secrets": {
        slug: "john_hunter_and_galileos_secrets",
        name: "John Hunter and Galileo's Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_aztec_treasure": {
        slug: "john_hunter_and_the_aztec_treasure",
        name: "John Hunter and the Aztec Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_book_of_tut": {
        slug: "john_hunter_and_the_book_of_tut",
        name: "John Hunter and the Book of Tut",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_book_of_tut_jackpot_play": {
        slug: "john_hunter_and_the_book_of_tut_jackpot_play",
        name: "John Hunter and the Book of Tut Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_book_of_tut_megaways": {
        slug: "john_hunter_and_the_book_of_tut_megaways",
        name: "John Hunter and the Book of Tut Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_book_of_tut_respin": {
        slug: "john_hunter_and_the_book_of_tut_respin",
        name: "John Hunter and the Book of Tut Respin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_mayan_gods": {
        slug: "john_hunter_and_the_mayan_gods",
        name: "John Hunter and the Mayan Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_quest_for_bermuda_riches": {
        slug: "john_hunter_and_the_quest_for_bermuda_riches",
        name: "John Hunter and the Quest for Bermuda Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_tomb_of_the_scarab_queen": {
        slug: "john_hunter_and_the_tomb_of_the_scarab_queen",
        name: "John Hunter and the Tomb of the Scarab Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_tomb_of_the_scarab_queen": {
        slug: "john_hunter_tomb_of_the_scarab_queen",
        name: "John Hunter - Tomb of the Scarab Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/joker_jewels_dice": {
        slug: "joker_jewels_dice",
        name: "Joker Jewels Dice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/joker_king": {
        slug: "joker_king",
        name: "Joker King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/joker_race": {
        slug: "joker_race",
        name: "Joker Race",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewel_hot": {
        slug: "jokers_jewel_hot",
        name: "Joker's Jewel Hot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels": {
        slug: "jokers_jewels",
        name: "Joker's Jewels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels_cash": {
        slug: "jokers_jewels_cash",
        name: "Joker's Jewels Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels_hold_and_spin": {
        slug: "jokers_jewels_hold_and_spin",
        name: "Joker's Jewels Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels_hot": {
        slug: "jokers_jewels_hot",
        name: "Joker's Jewels Hot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels_jackpot_play": {
        slug: "jokers_jewels_jackpot_play",
        name: "Joker's Jewels Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels_wild": {
        slug: "jokers_jewels_wild",
        name: "Joker's Jewels Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_revenge": {
        slug: "jokers_revenge",
        name: "Joker's Revenge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/journey_to_the_west": {
        slug: "journey_to_the_west",
        name: "Journey to the West",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/juicy_fruits": {
        slug: "juicy_fruits",
        name: "Juicy Fruits",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/juicy_fruits_multihold": {
        slug: "juicy_fruits_multihold",
        name: "Juicy Fruits Multihold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jumbo_safari": {
        slug: "jumbo_safari",
        name: "Jumbo Safari",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jungle_gorilla": {
        slug: "jungle_gorilla",
        name: "Jungle Gorilla",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/king_of_spear": {
        slug: "king_of_spear",
        name: "King of Spear",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/kingdom_of_asgard": {
        slug: "kingdom_of_asgard",
        name: "Kingdom of Asgard",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/kingdom_of_atlantis_jackpot_play": {
        slug: "kingdom_of_atlantis_jackpot_play",
        name: "Kingdom of Atlantis Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/kingdom_of_the_dead": {
        slug: "kingdom_of_the_dead",
        name: "Kingdom of The Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/knight_hot_spotz": {
        slug: "knight_hot_spotz",
        name: "Knight Hot Spotz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/knights_vs_barbarians": {
        slug: "knights_vs_barbarians",
        name: "Knights vs Barbarians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/koi_pond": {
        slug: "koi_pond",
        name: "Koi Pond",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/krakens_sky_bounty": {
        slug: "krakens_sky_bounty",
        name: "Kraken's Sky Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lady_godiva": {
        slug: "lady_godiva",
        name: "Lady Godiva",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lamp_of_infinity": {
        slug: "lamp_of_infinity",
        name: "Lamp Of Infinity",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/launch_to_riches": {
        slug: "launch_to_riches",
        name: "Launch to Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lava_balls": {
        slug: "lava_balls",
        name: "Lava Balls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/legend_of_heroes_megaways": {
        slug: "legend_of_heroes_megaways",
        name: "Legend of Heroes MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/leprechaun_carol": {
        slug: "leprechaun_carol",
        name: "Leprechaun Carol",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/leprechaun_song": {
        slug: "leprechaun_song",
        name: "Leprechaun Song",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/limbo": {
        slug: "limbo",
        name: "Limbo+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/little_gem": {
        slug: "little_gem",
        name: "Little Gem",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lobster_bobs_crazy_crab_shack": {
        slug: "lobster_bobs_crazy_crab_shack",
        name: "Lobster Bob's Crazy Crab Shack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lobster_bobs_sea_food_and_win_it": {
        slug: "lobster_bobs_sea_food_and_win_it",
        name: "Lobster Bob's Sea Food and Win It",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lobster_house": {
        slug: "lobster_house",
        name: "Lobster House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lokis_riches": {
        slug: "lokis_riches",
        name: "Loki's Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_dragon_ball": {
        slug: "lucky_dragon_ball",
        name: "Lucky Dragon Ball",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_dragons": {
        slug: "lucky_dragons",
        name: "Lucky Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_fishing_megaways": {
        slug: "lucky_fishing_megaways",
        name: "Lucky Fishing MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_grace_and_charm": {
        slug: "lucky_grace_and_charm",
        name: "Lucky, Grace and Charm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_lightning": {
        slug: "lucky_lightning",
        name: "Lucky Lightning",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_new_year": {
        slug: "lucky_new_year",
        name: "Lucky New Year",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_new_year_tiger_treasures": {
        slug: "lucky_new_year_tiger_treasures",
        name: "Lucky New Year: Tiger Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/luckys_wild_pub": {
        slug: "luckys_wild_pub",
        name: "Lucky's Wild Pub",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/luckys_wild_pub_2": {
        slug: "luckys_wild_pub_2",
        name: "Lucky's Wild Pub 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/luxor_of_cleopatra": {
        slug: "luxor_of_cleopatra",
        name: "Luxor of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/madame_destiny": {
        slug: "madame_destiny",
        name: "Madame Destiny",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/madame_destiny_megaways": {
        slug: "madame_destiny_megaways",
        name: "Madame Destiny MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/magic_journey": {
        slug: "magic_journey",
        name: "Magic Journey",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/magic_money_maze": {
        slug: "magic_money_maze",
        name: "Magic Money Maze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/magicians_secrets": {
        slug: "magicians_secrets",
        name: "Magician's Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_panda": {
        slug: "mahjong_panda",
        name: "Mahjong Panda",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_wins": {
        slug: "mahjong_wins",
        name: "Mahjong Wins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_wins_bonus": {
        slug: "mahjong_wins_bonus",
        name: "Mahjong Wins Bonus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_wins_super_scatter": {
        slug: "mahjong_wins_super_scatter",
        name: "Mahjong Wins Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_wins_triple_pot": {
        slug: "mahjong_wins_triple_pot",
        name: "Mahjong Wins Triple Pot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_x": {
        slug: "mahjong_x",
        name: "Mahjong X",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/majestic_express_gold_run": {
        slug: "majestic_express_gold_run",
        name: "Majestic Express Gold Run",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mammoth_gold_megaways": {
        slug: "mammoth_gold_megaways",
        name: "Mammoth Gold MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/master_chens_fortune": {
        slug: "master_chens_fortune",
        name: "Master Chen's Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/master_joker": {
        slug: "master_joker",
        name: "Master Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/medusas_stone": {
        slug: "medusas_stone",
        name: "Medusa's Stone",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mermaids_treasure_love": {
        slug: "mermaids_treasure_love",
        name: "Mermaid's Treasure Love",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/might_of_freya_megaways": {
        slug: "might_of_freya_megaways",
        name: "Might of Freya Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/might_of_ra": {
        slug: "might_of_ra",
        name: "Might of Ra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mighty_kong": {
        slug: "mighty_kong",
        name: "Mighty Kong",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mighty_munching_melons": {
        slug: "mighty_munching_melons",
        name: "Mighty Munching Melons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mines": {
        slug: "mines",
        name: "Mines+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mining_rush": {
        slug: "mining_rush",
        name: "Mining Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mochimon": {
        slug: "mochimon",
        name: "Mochimon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/moleionaire": {
        slug: "moleionaire",
        name: "Moleionaire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_blitz": {
        slug: "money_blitz",
        name: "Money Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_money_money": {
        slug: "money_money_money",
        name: "Money Money Money",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_mouse": {
        slug: "money_mouse",
        name: "Money Mouse",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_roll": {
        slug: "money_roll",
        name: "Money Roll",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_stacks": {
        slug: "money_stacks",
        name: "Money Stacks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_stacks_megaways": {
        slug: "money_stacks_megaways",
        name: "Money Stacks Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/monkey_king_rush": {
        slug: "monkey_king_rush",
        name: "Monkey King Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/monkey_madness": {
        slug: "monkey_madness",
        name: "Monkey Madness",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/monkey_warrior": {
        slug: "monkey_warrior",
        name: "Monkey Warrior",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/monster_superlanche": {
        slug: "monster_superlanche",
        name: "Monster Superlanche",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/moonshot": {
        slug: "moonshot",
        name: "Moonshot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mr_nulls_wicked_wares": {
        slug: "mr_nulls_wicked_wares",
        name: "Mr Null's Wicked Wares",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/muertos_multiplier_megaways": {
        slug: "muertos_multiplier_megaways",
        name: "Muertos Multiplier MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/multihand_blackjack": {
        slug: "multihand_blackjack",
        name: "Multihand Blackjack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mummys_jewels": {
        slug: "mummys_jewels",
        name: "Mummy's Jewels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mummys_jewels_100": {
        slug: "mummys_jewels_100",
        name: "Mummy's Jewels 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mustang_gold": {
        slug: "mustang_gold",
        name: "Mustang Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mustang_gold_megaways": {
        slug: "mustang_gold_megaways",
        name: "Mustang Gold Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mustang_trail": {
        slug: "mustang_trail",
        name: "Mustang Trail",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mysterious": {
        slug: "mysterious",
        name: "Mysterious",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mysterious_egypt": {
        slug: "mysterious_egypt",
        name: "Mysterious Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mystery_mice": {
        slug: "mystery_mice",
        name: "Mystery Mice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mystic_chief": {
        slug: "mystic_chief",
        name: "Mystic Chief",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/nile_fortune": {
        slug: "nile_fortune",
        name: "Nile Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/north_guardians": {
        slug: "north_guardians",
        name: "North Guardians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/octobeer_fortunes": {
        slug: "octobeer_fortunes",
        name: "Octobeer Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/old_gold_miner_megaways": {
        slug: "old_gold_miner_megaways",
        name: "Old Gold Miner MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/oodles_of_noodles": {
        slug: "oodles_of_noodles",
        name: "Oodles of Noodles",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/oracle_of_gold": {
        slug: "oracle_of_gold",
        name: "Oracle of Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/out_of_the_woods": {
        slug: "out_of_the_woods",
        name: "Out of the Woods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/panda_fortune_2": {
        slug: "panda_fortune_2",
        name: "Panda Fortune 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/panda_gold_scratch_50000": {
        slug: "panda_gold_scratch_50000",
        name: "Panda Gold Scratch 50,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pandas_fortune": {
        slug: "pandas_fortune",
        name: "Panda's Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pandas_fortune_2": {
        slug: "pandas_fortune_2",
        name: "Panda's Fortune 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pandemic_rising": {
        slug: "pandemic_rising",
        name: "Pandemic Rising",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/peking_luck": {
        slug: "peking_luck",
        name: "Peking Luck",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/penguins_christmas_party_time": {
        slug: "penguins_christmas_party_time",
        name: "Penguins Christmas Party Time",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/peppes_pepperoni_pizza_plaza": {
        slug: "peppes_pepperoni_pizza_plaza",
        name: "Peppe's Pepperoni Pizza Plaza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/phoenix_forge": {
        slug: "phoenix_forge",
        name: "Phoenix Forge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/piggy_bank_bills": {
        slug: "piggy_bank_bills",
        name: "Piggy Bank Bills",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/piggy_bankers": {
        slug: "piggy_bankers",
        name: "Piggy Bankers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pinup_girls": {
        slug: "pinup_girls",
        name: "Pinup Girls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pirate_gold": {
        slug: "pirate_gold",
        name: "Pirate Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pirate_gold_deluxe": {
        slug: "pirate_gold_deluxe",
        name: "Pirate Gold Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pirate_golden_age": {
        slug: "pirate_golden_age",
        name: "Pirate Golden Age",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pirates_pub": {
        slug: "pirates_pub",
        name: "Pirates Pub",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pixie_wings": {
        slug: "pixie_wings",
        name: "Pixie Wings",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pizza_pizza_pizza": {
        slug: "pizza_pizza_pizza",
        name: "PIZZA PIZZA PIZZA",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/plinko": {
        slug: "plinko",
        name: "Plinko+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pompeii_megareels_megaways": {
        slug: "pompeii_megareels_megaways",
        name: "Pompeii Megareels Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/port_of_fortune": {
        slug: "port_of_fortune",
        name: "Port of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pot_of_fortune": {
        slug: "pot_of_fortune",
        name: "Pot of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_ball_1_min": {
        slug: "power_ball_1_min",
        name: "Power Ball 1 min",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_ball_2_min": {
        slug: "power_ball_2_min",
        name: "Power Ball 2 min",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_ball_3_min": {
        slug: "power_ball_3_min",
        name: "Power Ball 3 min",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_ball_4_min": {
        slug: "power_ball_4_min",
        name: "Power Ball 4 min",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_ball_5_min": {
        slug: "power_ball_5_min",
        name: "Power Ball 5 min",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_of_merlin_megaways": {
        slug: "power_of_merlin_megaways",
        name: "Power of Merlin Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_of_ninja": {
        slug: "power_of_ninja",
        name: "Power of Ninja",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_of_thor_megaways": {
        slug: "power_of_thor_megaways",
        name: "Power of Thor MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pub_kings": {
        slug: "pub_kings",
        name: "Pub Kings",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pyramid_bonanza": {
        slug: "pyramid_bonanza",
        name: "Pyramid Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pyramid_king": {
        slug: "pyramid_king",
        name: "Pyramid King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/queen_of_gods": {
        slug: "queen_of_gods",
        name: "Queen of Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/queen_of_gold": {
        slug: "queen_of_gold",
        name: "Queen of Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/queen_of_gold_scratch_100000": {
        slug: "queen_of_gold_scratch_100000",
        name: "Queen of Gold Scratch 100,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/queenie": {
        slug: "queenie",
        name: "Queenie",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rabbit_garden": {
        slug: "rabbit_garden",
        name: "Rabbit Garden",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/raging_bull": {
        slug: "raging_bull",
        name: "Raging Bull",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/raging_waterfall_megaways": {
        slug: "raging_waterfall_megaways",
        name: "Raging Waterfall Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rainbow_gold": {
        slug: "rainbow_gold",
        name: "Rainbow Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rainbow_reels": {
        slug: "rainbow_reels",
        name: "Rainbow Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/reel_banks": {
        slug: "reel_banks",
        name: "Reel Banks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/release_the_bison": {
        slug: "release_the_bison",
        name: "Release the Bison",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/release_the_kraken": {
        slug: "release_the_kraken",
        name: "Release the Kraken",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/release_the_kraken_2": {
        slug: "release_the_kraken_2",
        name: "Release the Kraken 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/release_the_kraken_megaways": {
        slug: "release_the_kraken_megaways",
        name: "Release the Kraken Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/resurrecting_riches": {
        slug: "resurrecting_riches",
        name: "Resurrecting Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/return_of_the_dead": {
        slug: "return_of_the_dead",
        name: "Return of the Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/revenge_of_loki_megaways": {
        slug: "revenge_of_loki_megaways",
        name: "Revenge of Loki Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ride_the_lightning": {
        slug: "ride_the_lightning",
        name: "Ride the Lightning",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ripe_rewards": {
        slug: "ripe_rewards",
        name: "Ripe Rewards",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_giza_powernudge": {
        slug: "rise_of_giza_powernudge",
        name: "Rise of Giza PowerNudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_pyramids": {
        slug: "rise_of_pyramids",
        name: "Rise of Pyramids",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_samurai": {
        slug: "rise_of_samurai",
        name: "Rise of Samurai",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_samurai_4": {
        slug: "rise_of_samurai_4",
        name: "Rise of Samurai 4",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_samurai_iii": {
        slug: "rise_of_samurai_iii",
        name: "Rise of Samurai III",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_samurai_megaways": {
        slug: "rise_of_samurai_megaways",
        name: "Rise of Samurai MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/robber_strike": {
        slug: "robber_strike",
        name: "Robber Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rock_vegas": {
        slug: "rock_vegas",
        name: "Rock Vegas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rocket_blast_megaways": {
        slug: "rocket_blast_megaways",
        name: "Rocket Blast Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rolling_in_treasures": {
        slug: "rolling_in_treasures",
        name: "Rolling in Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/roulette": {
        slug: "roulette",
        name: "Roulette",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rujak_bonanza": {
        slug: "rujak_bonanza",
        name: "Rujak Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/running_sushi": {
        slug: "running_sushi",
        name: "Running Sushi",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/safari_king": {
        slug: "safari_king",
        name: "Safari King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/saiyan_mania": {
        slug: "saiyan_mania",
        name: "Saiyan Mania",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/samurai_code": {
        slug: "samurai_code",
        name: "Samurai Code",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sanatorium_secrets": {
        slug: "sanatorium_secrets",
        name: "Sanatorium Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/santa": {
        slug: "santa",
        name: "Santa",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/santas_great_gifts": {
        slug: "santas_great_gifts",
        name: "Santa's Great Gifts",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/santas_slay": {
        slug: "santas_slay",
        name: "Santa's Slay",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/santas_wonderland": {
        slug: "santas_wonderland",
        name: "Santa's Wonderland",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/santas_xmas_rush": {
        slug: "santas_xmas_rush",
        name: "Santa's Xmas Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/savannah_legend": {
        slug: "savannah_legend",
        name: "Savannah Legend",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sea_fantasy": {
        slug: "sea_fantasy",
        name: "Sea Fantasy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/secret_city_gold": {
        slug: "secret_city_gold",
        name: "Secret City Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shield_of_sparta": {
        slug: "shield_of_sparta",
        name: "Shield of Sparta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_100": {
        slug: "shining_hot_100",
        name: "Shining Hot 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_100_jackpot_play": {
        slug: "shining_hot_100_jackpot_play",
        name: "Shining Hot 100 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_20": {
        slug: "shining_hot_20",
        name: "Shining Hot 20",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_20_jackpot_play": {
        slug: "shining_hot_20_jackpot_play",
        name: "Shining Hot 20 Jackpot play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_40": {
        slug: "shining_hot_40",
        name: "Shining Hot 40",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_40_jackpot_play": {
        slug: "shining_hot_40_jackpot_play",
        name: "Shining Hot 40 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_5": {
        slug: "shining_hot_5",
        name: "Shining Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_5_jackpot_play": {
        slug: "shining_hot_5_jackpot_play",
        name: "Shining Hot 5 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sleeping_dragon": {
        slug: "sleeping_dragon",
        name: "Sleeping Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sleeping_dragon_ultra_dark": {
        slug: "sleeping_dragon_ultra_dark",
        name: "Sleeping Dragon Ultra Dark",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/slots_lobby": {
        slug: "slots_lobby",
        name: "Slots Lobby",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/smugglers_cove": {
        slug: "smugglers_cove",
        name: "Smugglers Cove",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/snakes_and_ladders_megadice": {
        slug: "snakes_and_ladders_megadice",
        name: "Snakes and Ladders Megadice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/snakes_and_ladders_snake_eyes": {
        slug: "snakes_and_ladders_snake_eyes",
        name: "Snakes and Ladders Snake Eyes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/snow_party": {
        slug: "snow_party",
        name: "Snow Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spaceman": {
        slug: "spaceman",
        name: "Spaceman",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spartan_king": {
        slug: "spartan_king",
        name: "Spartan King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spellbinding_mystery": {
        slug: "spellbinding_mystery",
        name: "Spellbinding Mystery",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spellmaster": {
        slug: "spellmaster",
        name: "Spellmaster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spin_and_score_megaways": {
        slug: "spin_and_score_megaways",
        name: "Spin and Score MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spire": {
        slug: "spire",
        name: "Spire+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spirit_of_adventure": {
        slug: "spirit_of_adventure",
        name: "Spirit of adventure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/star_bounty": {
        slug: "star_bounty",
        name: "Star Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/star_pirates_code": {
        slug: "star_pirates_code",
        name: "Star Pirates Code",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_archer_1000": {
        slug: "starlight_archer_1000",
        name: "Starlight Archer 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_christmas": {
        slug: "starlight_christmas",
        name: "Starlight Christmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_princess": {
        slug: "starlight_princess",
        name: "Starlight Princess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_princess_1000": {
        slug: "starlight_princess_1000",
        name: "Starlight Princess 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_princess_jackpot_play": {
        slug: "starlight_princess_jackpot_play",
        name: "Starlight Princess Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_princess_pachi": {
        slug: "starlight_princess_pachi",
        name: "Starlight Princess Pachi",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_princess_super_scatter": {
        slug: "starlight_princess_super_scatter",
        name: "Starlight Princess Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starz_megaways": {
        slug: "starz_megaways",
        name: "Starz MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/steamin_reels": {
        slug: "steamin_reels",
        name: "Steamin Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sticky_bees": {
        slug: "sticky_bees",
        name: "Sticky Bees",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/strawberry_cocktail": {
        slug: "strawberry_cocktail",
        name: "Strawberry Cocktail",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/street_racer": {
        slug: "street_racer",
        name: "Street Racer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/striking_hot_5": {
        slug: "striking_hot_5",
        name: "Striking Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/striking_hot_5_jackpot_play": {
        slug: "striking_hot_5_jackpot_play",
        name: "Striking Hot 5 Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_rush": {
        slug: "sugar_rush",
        name: "Sugar Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_rush_1000": {
        slug: "sugar_rush_1000",
        name: "Sugar Rush 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_rush_jackpot_play": {
        slug: "sugar_rush_jackpot_play",
        name: "Sugar Rush Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_rush_super_scatter": {
        slug: "sugar_rush_super_scatter",
        name: "Sugar Rush Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_rush_xmas": {
        slug: "sugar_rush_xmas",
        name: "Sugar Rush Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_supreme_powernudge": {
        slug: "sugar_supreme_powernudge",
        name: "Sugar Supreme Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sumo_supreme_megaways": {
        slug: "sumo_supreme_megaways",
        name: "Sumo Supreme Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sunnydaze_asylum": {
        slug: "sunnydaze_asylum",
        name: "Sunnydaze Asylum",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_7s": {
        slug: "super_7s",
        name: "Super 7s",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_gummy_strike": {
        slug: "super_gummy_strike",
        name: "Super Gummy Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_joker": {
        slug: "super_joker",
        name: "Super Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_tiki_strike": {
        slug: "super_tiki_strike",
        name: "Super Tiki Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_x": {
        slug: "super_x",
        name: "Super X",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/supermania": {
        slug: "supermania",
        name: "Supermania",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza": {
        slug: "sweet_bonanza",
        name: "Sweet Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_1000": {
        slug: "sweet_bonanza_1000",
        name: "Sweet Bonanza 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_2500": {
        slug: "sweet_bonanza_2500",
        name: "Sweet Bonanza 2500",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_dice": {
        slug: "sweet_bonanza_dice",
        name: "Sweet Bonanza Dice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_jackpot_play": {
        slug: "sweet_bonanza_jackpot_play",
        name: "Sweet Bonanza Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_super_scatter": {
        slug: "sweet_bonanza_super_scatter",
        name: "Sweet Bonanza Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_xmas": {
        slug: "sweet_bonanza_xmas",
        name: "Sweet Bonanza Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_craze": {
        slug: "sweet_craze",
        name: "Sweet Craze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_kingdom": {
        slug: "sweet_kingdom",
        name: "Sweet Kingdom",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_powernudge": {
        slug: "sweet_powernudge",
        name: "Sweet Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_rush_bonanza": {
        slug: "sweet_rush_bonanza",
        name: "Sweet Rush Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sword_of_ares": {
        slug: "sword_of_ares",
        name: "Sword of Ares",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/temple_guardians": {
        slug: "temple_guardians",
        name: "Temple Guardians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/temujin_treasures": {
        slug: "temujin_treasures",
        name: "Temujin Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_alter_ego": {
        slug: "the_alter_ego",
        name: "The Alter Ego",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_big_dawgs": {
        slug: "the_big_dawgs",
        name: "The Big Dawgs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_big_dog_house": {
        slug: "the_big_dog_house",
        name: "The Big Dog House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house": {
        slug: "the_dog_house",
        name: "The Dog House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_dice_show": {
        slug: "the_dog_house_dice_show",
        name: "The Dog House Dice Show",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_dog_or_alive": {
        slug: "the_dog_house_dog_or_alive",
        name: "The Dog House - Dog or Alive",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_jackpot_play": {
        slug: "the_dog_house_jackpot_play",
        name: "The Dog House Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_megaways": {
        slug: "the_dog_house_megaways",
        name: "The Dog House MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_megaways_1000": {
        slug: "the_dog_house_megaways_1000",
        name: "The Dog House Megaways 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_megaways_jackpot_play": {
        slug: "the_dog_house_megaways_jackpot_play",
        name: "The Dog House Megaways Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_multihold": {
        slug: "the_dog_house_multihold",
        name: "The Dog House Multihold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_muttley_crew": {
        slug: "the_dog_house_muttley_crew",
        name: "The Dog House Muttley Crew",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_royal_hunt": {
        slug: "the_dog_house_royal_hunt",
        name: "The Dog House Royal Hunt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dragon_tiger": {
        slug: "the_dragon_tiger",
        name: "The Dragon Tiger",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_great_chicken_escape": {
        slug: "the_great_chicken_escape",
        name: "The Great Chicken Escape",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_great_stickup": {
        slug: "the_great_stickup",
        name: "The Great Stick-Up",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_hand_of_midas": {
        slug: "the_hand_of_midas",
        name: "The Hand of Midas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_knight_king": {
        slug: "the_knight_king",
        name: "The Knight King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_magic_cauldron": {
        slug: "the_magic_cauldron",
        name: "The Magic Cauldron",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_magic_cauldron_enchanted_brew": {
        slug: "the_magic_cauldron_enchanted_brew",
        name: "The Magic Cauldron: Enchanted Brew",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_money_men_megaways": {
        slug: "the_money_men_megaways",
        name: "The Money Men Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_red_queen": {
        slug: "the_red_queen",
        name: "The Red Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_tiger_warrior": {
        slug: "the_tiger_warrior",
        name: "The Tiger Warrior",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_tweety_house": {
        slug: "the_tweety_house",
        name: "The Tweety House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_ultimate_5": {
        slug: "the_ultimate_5",
        name: "The Ultimate 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_wild_gang": {
        slug: "the_wild_gang",
        name: "The Wild Gang",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_wild_machine": {
        slug: "the_wild_machine",
        name: "The Wild Machine",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/three_star_fortune": {
        slug: "three_star_fortune",
        name: "Three Star Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tic_tac_take": {
        slug: "tic_tac_take",
        name: "Tic Tac Take",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tiki_hut_megaways_jackpot_play": {
        slug: "tiki_hut_megaways_jackpot_play",
        name: "Tiki Hut Megaways Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/timber_stacks": {
        slug: "timber_stacks",
        name: "Timber Stacks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tiny_toads": {
        slug: "tiny_toads",
        name: "Tiny Toads",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/towering_fortunes": {
        slug: "towering_fortunes",
        name: "Towering Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/treasure_horse": {
        slug: "treasure_horse",
        name: "Treasure Horse",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/treasure_wild": {
        slug: "treasure_wild",
        name: "Treasure Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/treasures_of_osiris": {
        slug: "treasures_of_osiris",
        name: "Treasures of Osiris",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tree_of_riches": {
        slug: "tree_of_riches",
        name: "Tree of Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/trees_of_treasure": {
        slug: "trees_of_treasure",
        name: "Trees of Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_dragons": {
        slug: "triple_dragons",
        name: "Triple Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_pot_diamond": {
        slug: "triple_pot_diamond",
        name: "Triple Pot Diamond",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_pot_god": {
        slug: "triple_pot_god",
        name: "Triple Pot God",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_pot_gold": {
        slug: "triple_pot_gold",
        name: "Triple Pot Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_pot_plinko_hercules": {
        slug: "triple_pot_plinko_hercules",
        name: "Triple Pot Plinko Hercules",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_tigers": {
        slug: "triple_tigers",
        name: "Triple Tigers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tropical_pop_jackpot_play": {
        slug: "tropical_pop_jackpot_play",
        name: "Tropical Pop Jackpot Play",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tropical_tiki": {
        slug: "tropical_tiki",
        name: "Tropical Tiki",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tundras_fortune": {
        slug: "tundras_fortune",
        name: "Tundra's Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/twilight_princess": {
        slug: "twilight_princess",
        name: "Twilight Princess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ultra_burn": {
        slug: "ultra_burn",
        name: "Ultra Burn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ultra_hold_and_spin": {
        slug: "ultra_hold_and_spin",
        name: "Ultra Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/vampires_vs_wolves": {
        slug: "vampires_vs_wolves",
        name: "Vampires vs Wolves",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/vampy_party": {
        slug: "vampy_party",
        name: "Vampy Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/vegas_magic": {
        slug: "vegas_magic",
        name: "Vegas Magic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/vegas_nights": {
        slug: "vegas_nights",
        name: "Vegas Nights",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/viking_forge": {
        slug: "viking_forge",
        name: "Viking Forge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/volcano_goddess": {
        slug: "volcano_goddess",
        name: "Volcano Goddess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/voodoo_magic": {
        slug: "voodoo_magic",
        name: "Voodoo Magic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/waves_of_poseidon": {
        slug: "waves_of_poseidon",
        name: "Waves of Poseidon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wheel_of_happiness": {
        slug: "wheel_of_happiness",
        name: "Wheel of Happiness",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wheel_ogold": {
        slug: "wheel_ogold",
        name: "Wheel O'Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_beach_party": {
        slug: "wild_beach_party",
        name: "Wild Beach Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_bison_charge": {
        slug: "wild_bison_charge",
        name: "Wild Bison Charge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_booster": {
        slug: "wild_booster",
        name: "Wild Booster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_celebrity_bus_megaways": {
        slug: "wild_celebrity_bus_megaways",
        name: "Wild Celebrity Bus Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_depths": {
        slug: "wild_depths",
        name: "Wild Depths",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_gladiator": {
        slug: "wild_gladiator",
        name: "Wild Gladiator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_gladiators": {
        slug: "wild_gladiators",
        name: "Wild Gladiators",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_hop_and_drop": {
        slug: "wild_hop_and_drop",
        name: "Wild Hop & Drop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_pixies": {
        slug: "wild_pixies",
        name: "Wild Pixies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_skullz": {
        slug: "wild_skullz",
        name: "Wild Skullz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_spells": {
        slug: "wild_spells",
        name: "Wild Spells",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_walker": {
        slug: "wild_walker",
        name: "Wild Walker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_west_gold": {
        slug: "wild_west_gold",
        name: "Wild West Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_west_gold_blazing_bounty": {
        slug: "wild_west_gold_blazing_bounty",
        name: "Wild West Gold Blazing Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_west_gold_megaways": {
        slug: "wild_west_gold_megaways",
        name: "Wild West Gold MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wild_bananas": {
        slug: "wild_wild_bananas",
        name: "Wild Wild Bananas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wild_joker": {
        slug: "wild_wild_joker",
        name: "Wild Wild Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wild_pearls": {
        slug: "wild_wild_pearls",
        name: "Wild Wild Pearls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wild_riches": {
        slug: "wild_wild_riches",
        name: "Wild Wild Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wild_riches_returns": {
        slug: "wild_wild_riches_returns",
        name: "Wild Wild Riches Returns",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wildebeest_wins": {
        slug: "wild_wildebeest_wins",
        name: "Wild Wildebeest Wins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wildies": {
        slug: "wildies",
        name: "Wildies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wildman_super_bonanza": {
        slug: "wildman_super_bonanza",
        name: "Wildman Super Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wisdom_of_athena": {
        slug: "wisdom_of_athena",
        name: "Wisdom of Athena",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wisdom_of_athena_1000": {
        slug: "wisdom_of_athena_1000",
        name: "Wisdom of Athena 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wisdom_of_athena_1000_xmas": {
        slug: "wisdom_of_athena_1000_xmas",
        name: "Wisdom of Athena 1000 Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/witch_heart_megaways": {
        slug: "witch_heart_megaways",
        name: "Witch Heart Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wolf_gold": {
        slug: "wolf_gold",
        name: "Wolf Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wolf_gold_4_pack": {
        slug: "wolf_gold_4_pack",
        name: "Wolf Gold 4 Pack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wolf_gold_scratch_1000000": {
        slug: "wolf_gold_scratch_1000000",
        name: "Wolf Gold Scratch 1,000,000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wolf_gold_ultimate": {
        slug: "wolf_gold_ultimate",
        name: "Wolf Gold Ultimate",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wukong_rush": {
        slug: "wukong_rush",
        name: "Wukong Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/year_of_the_dragon_king": {
        slug: "year_of_the_dragon_king",
        name: "Year of the Dragon King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/yeti_quest": {
        slug: "yeti_quest",
        name: "Yeti Quest",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/yi_sun_shin": {
        slug: "yi_sun_shin",
        name: "Yi Sun Shin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/you_can_piggy_bank_on_it": {
        slug: "you_can_piggy_bank_on_it",
        name: "You Can Piggy Bank On It",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/yum_yum_powerways": {
        slug: "yum_yum_powerways",
        name: "Yum Yum PowerWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zeus_vs_hades_gods_of_war": {
        slug: "zeus_vs_hades_gods_of_war",
        name: "Zeus vs Hades - Gods of War",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zeus_vs_hades_gods_of_war_250": {
        slug: "zeus_vs_hades_gods_of_war_250",
        name: "Zeus vs Hades Gods of War 250",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zeus_vs_typhoon": {
        slug: "zeus_vs_typhoon",
        name: "Zeus vs Typhoon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zombie_carnival": {
        slug: "zombie_carnival",
        name: "Zombie Carnival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zombie_school_megaways": {
        slug: "zombie_school_megaways",
        name: "Zombie School Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zombie_train": {
        slug: "zombie_train",
        name: "Zombie Train",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "print-studios/12_burning_baseballs": {
        slug: "12_burning_baseballs",
        name: "12 Burning Baseballs",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/big_stack_lumberjack": {
        slug: "big_stack_lumberjack",
        name: "Big Stack Lumberjack",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/big_stack_nutcrack": {
        slug: "big_stack_nutcrack",
        name: "Big Stack Nutcrack",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/book_of_destiny": {
        slug: "book_of_destiny",
        name: "Book of Destiny",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/cash_defense": {
        slug: "cash_defense",
        name: "Cash Defense",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/chomplings": {
        slug: "chomplings",
        name: "Chomplings",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/crystal_golem": {
        slug: "crystal_golem",
        name: "Crystal Golem",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/darkness": {
        slug: "darkness",
        name: "Darkness",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/deck_of_scurra": {
        slug: "deck_of_scurra",
        name: "Deck of Scurra",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/dreadworks": {
        slug: "dreadworks",
        name: "Dreadworks",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/eldritch_dungeon": {
        slug: "eldritch_dungeon",
        name: "Eldritch Dungeon",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/holy_hand_grenade": {
        slug: "holy_hand_grenade",
        name: "Holy Hand Grenade",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/holy_hand_grenade_2": {
        slug: "holy_hand_grenade_2",
        name: "Holy Hand Grenade 2",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/honey_hunters": {
        slug: "honey_hunters",
        name: "Honey Hunters",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/huntress_wild_vengeance": {
        slug: "huntress_wild_vengeance",
        name: "Huntress Wild Vengeance",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/out_of_the_ice": {
        slug: "out_of_the_ice",
        name: "Out of the Ice",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/phantom_pulse": {
        slug: "phantom_pulse",
        name: "Phantom Pulse",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/pine_of_plinko": {
        slug: "pine_of_plinko",
        name: "Pine of Plinko",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/pine_of_plinko_2": {
        slug: "pine_of_plinko_2",
        name: "Pine of Plinko 2",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/pond_of_plinko": {
        slug: "pond_of_plinko",
        name: "Pond of Plinko",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/punk_penguin": {
        slug: "punk_penguin",
        name: "Punk Penguin",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/reapers": {
        slug: "reapers",
        name: "Reapers",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/royal_potato": {
        slug: "royal_potato",
        name: "Royal Potato",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/shinobi_spirit": {
        slug: "shinobi_spirit",
        name: "Shinobi Spirit",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/tarasque": {
        slug: "tarasque",
        name: "Tarasque",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/uncle_profit": {
        slug: "uncle_profit",
        name: "Uncle Profit",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/wino_mart": {
        slug: "wino_mart",
        name: "Win-O Mart",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "prospectgaming/3_dragon_pots": {
        slug: "3_dragon_pots",
        name: "3 Dragon Pots",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/3_lucky_minecarts_hold_and_win": {
        slug: "3_lucky_minecarts_hold_and_win",
        name: "3 Lucky Minecarts Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/arriba_heat": {
        slug: "arriba_heat",
        name: "Arriba Heat",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/arriba_heat_fuego_fortunes": {
        slug: "arriba_heat_fuego_fortunes",
        name: "Arriba Heat Fuego Fortunes",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/arriba_heat_megaways": {
        slug: "arriba_heat_megaways",
        name: "Arriba Heat Megaways",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/blood_moon_hold_and_win": {
        slug: "blood_moon_hold_and_win",
        name: "Blood Moon Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/burn_in_hell": {
        slug: "burn_in_hell",
        name: "Burn in Hell",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/burn_in_love": {
        slug: "burn_in_love",
        name: "Burn in Love",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/cleopatra_wilds_hold_and_win": {
        slug: "cleopatra_wilds_hold_and_win",
        name: "Cleopatra Wilds Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/diamond_surge": {
        slug: "diamond_surge",
        name: "Diamond Surge",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/fruit_coins_hold_and_win": {
        slug: "fruit_coins_hold_and_win",
        name: "Fruit Coins Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/fruit_double_wins": {
        slug: "fruit_double_wins",
        name: "Fruit Double Wins",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/ghost_huntin": {
        slug: "ghost_huntin",
        name: "Ghost Huntin",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/hot_joker_fruits": {
        slug: "hot_joker_fruits",
        name: "Hot Joker Fruits",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/hot_joker_fruits_hold_and_win": {
        slug: "hot_joker_fruits_hold_and_win",
        name: "Hot Joker Fruits Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/hot_joker_fruits_scatter_pays": {
        slug: "hot_joker_fruits_scatter_pays",
        name: "Hot Joker Fruits Scatter Pays",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/hot_joker_fruits_stacks": {
        slug: "hot_joker_fruits_stacks",
        name: "Hot Joker Fruits Stacks",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/jokers_bar": {
        slug: "jokers_bar",
        name: "Joker's Bar",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/jokers_edge": {
        slug: "jokers_edge",
        name: "Joker's Edge",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/kings_relics": {
        slug: "kings_relics",
        name: "King's Relics",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/leprechaun_charms_hold_and_win": {
        slug: "leprechaun_charms_hold_and_win",
        name: "Leprechaun Charms Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/minted_coins": {
        slug: "minted_coins",
        name: "Minted Coins",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds": {
        slug: "prospector_wilds",
        name: "Prospector Wilds",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_gold_digga": {
        slug: "prospector_wilds_gold_digga",
        name: "Prospector Wilds: Gold Digga",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_hold_and_win": {
        slug: "prospector_wilds_hold_and_win",
        name: "Prospector Wilds Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_megaways": {
        slug: "prospector_wilds_megaways",
        name: "Prospector Wilds Megaways",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_minecart_madness": {
        slug: "prospector_wilds_minecart_madness",
        name: "Prospector Wilds Minecart Madness",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_wild_carts": {
        slug: "prospector_wilds_wild_carts",
        name: "Prospector Wilds: Wild Carts",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/solar_nova_hold_and_win": {
        slug: "solar_nova_hold_and_win",
        name: "Solar Nova Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/super_upgrade_joker": {
        slug: "super_upgrade_joker",
        name: "Super Upgrade Joker",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/sweet_candy_cash": {
        slug: "sweet_candy_cash",
        name: "Sweet Candy Cash",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/waikiki_hold_and_win": {
        slug: "waikiki_hold_and_win",
        name: "Waikiki Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "push-gaming/10_cash_bisons": {
        slug: "10_cash_bisons",
        name: "10 Cash Bisons",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/10_flaming_bisons": {
        slug: "10_flaming_bisons",
        name: "10 Flaming Bisons",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/10_pharaohs": {
        slug: "10_pharaohs",
        name: "10 Pharaohs",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/10_santas_reindeers": {
        slug: "10_santas_reindeers",
        name: "10 Santa's Reindeers",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/10_swords": {
        slug: "10_swords",
        name: "10 Swords",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/3_magic_pots": {
        slug: "3_magic_pots",
        name: "3 Magic Pots",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/bait_n_bank": {
        slug: "bait_n_bank",
        name: "Bait n Bank",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/bamboo_ways": {
        slug: "bamboo_ways",
        name: "Bamboo Ways",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/big_bam_book": {
        slug: "big_bam_book",
        name: "Big Bam Book",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/big_bamboo": {
        slug: "big_bamboo",
        name: "Big Bamboo",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/big_bamboo_2": {
        slug: "big_bamboo_2",
        name: "Big Bamboo 2",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/big_bite": {
        slug: "big_bite",
        name: "Big Bite",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/big_bite_push_ways": {
        slug: "big_bite_push_ways",
        name: "Big Bite Push Ways",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/bison_battle": {
        slug: "bison_battle",
        name: "Bison Battle",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/blaze_of_ra": {
        slug: "blaze_of_ra",
        name: "Blaze of Ra",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/boss_bear": {
        slug: "boss_bear",
        name: "Boss Bear",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/candy_blast": {
        slug: "candy_blast",
        name: "Candy Blast",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/cats_of_olympus": {
        slug: "cats_of_olympus",
        name: "Cats of Olympus",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/crystal_catcher": {
        slug: "crystal_catcher",
        name: "Crystal Catcher",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/deadly_5": {
        slug: "deadly_5",
        name: "Deadly 5",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/diamond_supernova_100": {
        slug: "diamond_supernova_100",
        name: "Diamond Supernova 100",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/diamond_supernova_20": {
        slug: "diamond_supernova_20",
        name: "Diamond Supernova 20",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/diamond_supernova_40": {
        slug: "diamond_supernova_40",
        name: "Diamond Supernova 40",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/diamond_supernova_5": {
        slug: "diamond_supernova_5",
        name: "Diamond Supernova 5",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/diamonds_4_the_win": {
        slug: "diamonds_4_the_win",
        name: "Diamonds 4 the Win",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/dino_pd": {
        slug: "dino_pd",
        name: "Dino P.D",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/dinopolis": {
        slug: "dinopolis",
        name: "Dinopolis",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/dj_cat": {
        slug: "dj_cat",
        name: "DJ Cat",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/dj_fox": {
        slug: "dj_fox",
        name: "DJ Fox",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/dragon_hopper": {
        slug: "dragon_hopper",
        name: "Dragon Hopper",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/fang_city": {
        slug: "fang_city",
        name: "Fang City",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/fat_banker": {
        slug: "fat_banker",
        name: "Fat Banker",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/fat_drac": {
        slug: "fat_drac",
        name: "Fat Drac",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/fat_rabbit": {
        slug: "fat_rabbit",
        name: "Fat Rabbit",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/fat_santa": {
        slug: "fat_santa",
        name: "Fat Santa",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/fire_hopper": {
        slug: "fire_hopper",
        name: "Fire Hopper",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/fire_pig_push_ways": {
        slug: "fire_pig_push_ways",
        name: "Fire Pig Push Ways",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/fish_n_nudge": {
        slug: "fish_n_nudge",
        name: "Fish 'n' Nudge",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/fish_n_nudge_big_catch": {
        slug: "fish_n_nudge_big_catch",
        name: "Fish n Nudge Big Catch",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/generous_jack": {
        slug: "generous_jack",
        name: "Generous Jack",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/giga_jar": {
        slug: "giga_jar",
        name: "Giga Jar",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/goat_getter": {
        slug: "goat_getter",
        name: "Goat Getter",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/happy_bamboo": {
        slug: "happy_bamboo",
        name: "Happy Bamboo",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/hearts_highway": {
        slug: "hearts_highway",
        name: "Hearts Highway",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/henry_the_ape": {
        slug: "henry_the_ape",
        name: "Henry the Ape",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/iron_phoenix": {
        slug: "iron_phoenix",
        name: "Iron Phoenix",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/jaguar_drop": {
        slug: "jaguar_drop",
        name: "Jaguar Drop",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/jammin_jars": {
        slug: "jammin_jars",
        name: "Jammin' Jars",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/jammin_jars_2": {
        slug: "jammin_jars_2",
        name: "Jammin' Jars 2",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/joker_troupe": {
        slug: "joker_troupe",
        name: "Joker Troupe",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/land_of_zenith": {
        slug: "land_of_zenith",
        name: "Land of Zenith",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/mad_blast": {
        slug: "mad_blast",
        name: "Mad Blast",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/mad_cars": {
        slug: "mad_cars",
        name: "Mad Cars",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/masked_mayhem": {
        slug: "masked_mayhem",
        name: "Masked Mayhem",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/mount_magmas_njp": {
        slug: "mount_magmas_njp",
        name: "Mount Magmas (NJP)",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/mystery_mission_to_the_moon": {
        slug: "mystery_mission_to_the_moon",
        name: "Mystery Mission - To The Moon",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/mystery_museum": {
        slug: "mystery_museum",
        name: "Mystery Museum",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/mystery_of_the_nile": {
        slug: "mystery_of_the_nile",
        name: "Mystery of the Nile",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/nightfall": {
        slug: "nightfall",
        name: "Nightfall",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/olympus_unleashed": {
        slug: "olympus_unleashed",
        name: "Olympus Unleashed",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/power_paws": {
        slug: "power_paws",
        name: "Power Paws",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/power_vault": {
        slug: "power_vault",
        name: "Power Vault",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/rat_king": {
        slug: "rat_king",
        name: "Rat King",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/razor_returns": {
        slug: "razor_returns",
        name: "Razor Returns",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/razor_shark": {
        slug: "razor_shark",
        name: "Razor Shark",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/razor_shark_jackpots": {
        slug: "razor_shark_jackpots",
        name: "Razor Shark Jackpots",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/razor_ways": {
        slug: "razor_ways",
        name: "Razor Ways",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/red_hot_multipliers": {
        slug: "red_hot_multipliers",
        name: "Red Hot Multipliers",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/regal_knights": {
        slug: "regal_knights",
        name: "Regal Knights",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/retro_sweets": {
        slug: "retro_sweets",
        name: "Retro Sweets",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/retro_tapes": {
        slug: "retro_tapes",
        name: "Retro Tapes",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/retroverse": {
        slug: "retroverse",
        name: "Retroverse",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/samurais_katana": {
        slug: "samurais_katana",
        name: "Samurai's Katana",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/santa_hopper": {
        slug: "santa_hopper",
        name: "Santa Hopper",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/santas_vault": {
        slug: "santas_vault",
        name: "Santa's Vault",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/sea_of_spirits": {
        slug: "sea_of_spirits",
        name: "Sea of Spirits",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/shamrock_saints": {
        slug: "shamrock_saints",
        name: "Shamrock Saints",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/space_stacks": {
        slug: "space_stacks",
        name: "Space Stacks",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/tarot_treasures": {
        slug: "tarot_treasures",
        name: "Tarot Treasures",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/the_grand_show": {
        slug: "the_grand_show",
        name: "The Grand Show",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/the_shadow_order": {
        slug: "the_shadow_order",
        name: "The Shadow Order",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/tiki_tumble_bonus_buy": {
        slug: "tiki_tumble_bonus_buy",
        name: "Tiki Tumble Bonus Buy",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/tricky_treats": {
        slug: "tricky_treats",
        name: "Tricky Treats",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/triple_rampage": {
        slug: "triple_rampage",
        name: "Triple Rampage",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/vegas_vault": {
        slug: "vegas_vault",
        name: "Vegas Vault",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/viking_clash": {
        slug: "viking_clash",
        name: "Viking Clash",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/wheel_of_wonders": {
        slug: "wheel_of_wonders",
        name: "Wheel of Wonders",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/wild_swarm": {
        slug: "wild_swarm",
        name: "Wild Swarm",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/wild_swarm_2": {
        slug: "wild_swarm_2",
        name: "Wild Swarm 2",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/wild_swarm_3_chocolate_eggs_94": {
        slug: "wild_swarm_3_chocolate_eggs_94",
        name: "Wild Swarm 3 Chocolate Eggs 94",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "push-gaming/wild_swarm_triple_hive": {
        slug: "wild_swarm_triple_hive",
        name: "Wild Swarm Triple Hive",
        provider: "Push Gaming",
        providerSlug: "push-gaming"
    },
    "quickspin/adventures_beyond_wonderland_magical_maze": {
        slug: "adventures_beyond_wonderland_magical_maze",
        name: "Adventures Beyond Wonderland Magical Maze",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/arcane_gems": {
        slug: "arcane_gems",
        name: "Arcane Gems",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/ark_of_mystery": {
        slug: "ark_of_mystery",
        name: "Ark of Mystery",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/artemis_vs_medusa": {
        slug: "artemis_vs_medusa",
        name: "Artemis vs Medusa",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/azticons_chaos_clusters": {
        slug: "azticons_chaos_clusters",
        name: "Azticons Chaos Clusters",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/big_bad_wolf": {
        slug: "big_bad_wolf",
        name: "Big Bad Wolf",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/big_bad_wolf_christmas_special": {
        slug: "big_bad_wolf_christmas_special",
        name: "Big Bad Wolf Christmas Special",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/big_bad_wolf_megaways": {
        slug: "big_bad_wolf_megaways",
        name: "Big Bad Wolf Megaways",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/big_bad_wolf_pigs_of_steel": {
        slug: "big_bad_wolf_pigs_of_steel",
        name: "Big Bad Wolf Pigs of Steel",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/big_bot_crew": {
        slug: "big_bot_crew",
        name: "Big Bot Crew",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/blue_fortune": {
        slug: "blue_fortune",
        name: "Blue Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/book_of_duat": {
        slug: "book_of_duat",
        name: "Book of Duat",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/book_of_yuletide": {
        slug: "book_of_yuletide",
        name: "Book of Yuletide",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/brawlers_bar_cash_collect": {
        slug: "brawlers_bar_cash_collect",
        name: "Brawlers Bar Cash Collect",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/brawlers_brew": {
        slug: "brawlers_brew",
        name: "Brawlers Brew",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/brooklyn_bootleggers": {
        slug: "brooklyn_bootleggers",
        name: "Brooklyn Bootleggers",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cabin_crashers": {
        slug: "cabin_crashers",
        name: "Cabin Crashers",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/candy_glyph": {
        slug: "candy_glyph",
        name: "Candy Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cash_truck": {
        slug: "cash_truck",
        name: "Cash Truck",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cash_truck_2": {
        slug: "cash_truck_2",
        name: "Cash Truck 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cash_truck_3_turbo": {
        slug: "cash_truck_3_turbo",
        name: "Cash Truck 3 Turbo",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cash_truck_begins": {
        slug: "cash_truck_begins",
        name: "Cash Truck Begins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/crown_of_valor": {
        slug: "crown_of_valor",
        name: "Crown of Valor",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/crystal_prince": {
        slug: "crystal_prince",
        name: "Crystal Prince",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/crystal_queen": {
        slug: "crystal_queen",
        name: "Crystal Queen",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/crystal_queen_coins": {
        slug: "crystal_queen_coins",
        name: "Crystal Queen Coins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/diamond_duke": {
        slug: "diamond_duke",
        name: "Diamond Duke",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/dinosaur_rage": {
        slug: "dinosaur_rage",
        name: "Dinosaur Rage",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/divine_dreams": {
        slug: "divine_dreams",
        name: "Divine Dreams",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/dragon_chase": {
        slug: "dragon_chase",
        name: "Dragon Chase",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/dragon_shrine": {
        slug: "dragon_shrine",
        name: "Dragon Shrine",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/durian_dynamite": {
        slug: "durian_dynamite",
        name: "Durian Dynamite",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/dwarfs_gone_wild": {
        slug: "dwarfs_gone_wild",
        name: "Dwarfs Gone Wild",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/eastern_emeralds": {
        slug: "eastern_emeralds",
        name: "Eastern Emeralds",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/epic_fish_adventure": {
        slug: "epic_fish_adventure",
        name: "Epic Fish Adventure",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/epic_fish_marlin_madness": {
        slug: "epic_fish_marlin_madness",
        name: "Epic Fish Marlin Madness",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/epic_fish_net_of_fortune": {
        slug: "epic_fish_net_of_fortune",
        name: "Epic Fish Net of Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/fairy_gate": {
        slug: "fairy_gate",
        name: "Fairy Gate",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/feasting_fox": {
        slug: "feasting_fox",
        name: "Feasting Fox",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/genies_touch": {
        slug: "genies_touch",
        name: "Genies Touch",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/ghost_glyph": {
        slug: "ghost_glyph",
        name: "Ghost Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/gloria_invicta": {
        slug: "gloria_invicta",
        name: "Gloria Invicta",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/golden_glyph": {
        slug: "golden_glyph",
        name: "Golden Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/golden_glyph_2": {
        slug: "golden_glyph_2",
        name: "Golden Glyph 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/golden_glyph_3": {
        slug: "golden_glyph_3",
        name: "Golden Glyph 3",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/goldilocks": {
        slug: "goldilocks",
        name: "Goldilocks",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/guardian_of_athens": {
        slug: "guardian_of_athens",
        name: "Guardian of athens",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/hall_of_the_mountain_king": {
        slug: "hall_of_the_mountain_king",
        name: "Hall of the Mountain King",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/hammer_of_vulcan": {
        slug: "hammer_of_vulcan",
        name: "Hammer of Vulcan",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/hidden_valley_120": {
        slug: "hidden_valley_120",
        name: "Hidden Valley 120",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/high_street_heist": {
        slug: "high_street_heist",
        name: "High Street Heist",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/honeylocks_pots": {
        slug: "honeylocks_pots",
        name: "Honeylocks Pots",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/hot_sync": {
        slug: "hot_sync",
        name: "Hot Sync",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/illuminous": {
        slug: "illuminous",
        name: "Illuminous",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/ivan_and_the_immortal_king": {
        slug: "ivan_and_the_immortal_king",
        name: "Ivan and the Immortal King",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/joker_strike": {
        slug: "joker_strike",
        name: "Joker Strike",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/king_colossus": {
        slug: "king_colossus",
        name: "King Colossus",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/leprechaun_hills": {
        slug: "leprechaun_hills",
        name: "Leprechaun Hills",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/loco_the_monkey": {
        slug: "loco_the_monkey",
        name: "Loco The Monkey",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/mayana": {
        slug: "mayana",
        name: "Mayana",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/midas_coins": {
        slug: "midas_coins",
        name: "Midas Coins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/mighty_arthur": {
        slug: "mighty_arthur",
        name: "Mighty Arthur",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/neros_fortune": {
        slug: "neros_fortune",
        name: "Nero's Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/northern_sky": {
        slug: "northern_sky",
        name: "Northern Sky",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/panthers_reign": {
        slug: "panthers_reign",
        name: "Panthers Reign",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/pearl_o_plinko": {
        slug: "pearl_o_plinko",
        name: "Pearl O Plinko",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/pearl_o_plinko_mermaid": {
        slug: "pearl_o_plinko_mermaid",
        name: "Pearl O Plinko Mermaid",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/phoenix_sun": {
        slug: "phoenix_sun",
        name: "Phoenix Sun",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/pied_piper": {
        slug: "pied_piper",
        name: "Pied Piper",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/pineapple_crush": {
        slug: "pineapple_crush",
        name: "Pineapple Crush",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/pirates_charm": {
        slug: "pirates_charm",
        name: "Pirate's Charm",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/polar_paws": {
        slug: "polar_paws",
        name: "Polar Paws",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/prime_zone": {
        slug: "prime_zone",
        name: "Prime Zone",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/rapunzels_tower": {
        slug: "rapunzels_tower",
        name: "Rapunzel's Tower",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/razortooth": {
        slug: "razortooth",
        name: "Razortooth",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/reel_nightmare": {
        slug: "reel_nightmare",
        name: "Reel Nightmare",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/reno_7s": {
        slug: "reno_7s",
        name: "Reno 7's",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/robbits": {
        slug: "robbits",
        name: "Robbits",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sakura_fortune": {
        slug: "sakura_fortune",
        name: "Sakura Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sakura_fortune_2": {
        slug: "sakura_fortune_2",
        name: "Sakura Fortune 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sakura_fortune_epic_bloom": {
        slug: "sakura_fortune_epic_bloom",
        name: "Sakura Fortune Epic Bloom",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/scepter_of_anubis": {
        slug: "scepter_of_anubis",
        name: "Scepter of Anubis",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/second_strike": {
        slug: "second_strike",
        name: "Second Strike",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sevens_high": {
        slug: "sevens_high",
        name: "Sevens High",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sevens_high_ultra": {
        slug: "sevens_high_ultra",
        name: "Sevens High Ultra",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/shields_of_lambda": {
        slug: "shields_of_lambda",
        name: "Shields of Lambda",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sinbad": {
        slug: "sinbad",
        name: "Sinbad",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/skulls_up": {
        slug: "skulls_up",
        name: "Skulls UP!",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/slugger_time": {
        slug: "slugger_time",
        name: "Slugger Time",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/spinions": {
        slug: "spinions",
        name: "Spinions",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/spinions_xmas_party": {
        slug: "spinions_xmas_party",
        name: "Spinions x-mas party",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits": {
        slug: "sticky_bandits",
        name: "Sticky Bandits",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits_3_most_wanted": {
        slug: "sticky_bandits_3_most_wanted",
        name: "Sticky Bandits 3 Most Wanted",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits_thunder_rail": {
        slug: "sticky_bandits_thunder_rail",
        name: "Sticky Bandits Thunder Rail",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits_trail_of_blood": {
        slug: "sticky_bandits_trail_of_blood",
        name: "Sticky Bandits Trail of Blood",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits_unchained": {
        slug: "sticky_bandits_unchained",
        name: "Sticky Bandits Unchained",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits_wild_return": {
        slug: "sticky_bandits_wild_return",
        name: "Sticky Bandits: Wild return",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/tales_of_dr_dolittle": {
        slug: "tales_of_dr_dolittle",
        name: "Tales of Dr. dolittle",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/temple_of_paw": {
        slug: "temple_of_paw",
        name: "Temple of Paw",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/the_grand": {
        slug: "the_grand",
        name: "The Grand",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/the_grim_reaper": {
        slug: "the_grim_reaper",
        name: "The Grim Reaper",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/the_wild_chase": {
        slug: "the_wild_chase",
        name: "The Wild Chase",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/ticket_to_the_stars": {
        slug: "ticket_to_the_stars",
        name: "Ticket to the stars",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/tigers_glory": {
        slug: "tigers_glory",
        name: "Tiger's Glory",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/tigers_glory_ultra": {
        slug: "tigers_glory_ultra",
        name: "Tiger's Glory Ultra",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/treasure_island": {
        slug: "treasure_island",
        name: "Treasure Island",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/vampire_senpai": {
        slug: "vampire_senpai",
        name: "Vampire Senpai",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/volcano_riches": {
        slug: "volcano_riches",
        name: "Volcano Riches",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/warp_wreckers_power_glyph": {
        slug: "warp_wreckers_power_glyph",
        name: "Warp Wreckers Power Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_beans": {
        slug: "wild_beans",
        name: "Wild Beans",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_cauldron": {
        slug: "wild_cauldron",
        name: "Wild Cauldron",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_chase_tokyo_go": {
        slug: "wild_chase_tokyo_go",
        name: "Wild Chase: Tokyo Go",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_harlequin": {
        slug: "wild_harlequin",
        name: "Wild Harlequin",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_luchador": {
        slug: "wild_luchador",
        name: "Wild Luchador",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_tome_of_the_woods": {
        slug: "wild_tome_of_the_woods",
        name: "Wild Tome of the Woods",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wins_of_fortune": {
        slug: "wins_of_fortune",
        name: "Wins of Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "ready-play-gaming/2_can_party_reel_triple": {
        slug: "2_can_party_reel_triple",
        name: "2 Can Party Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/20000_leagues": {
        slug: "20000_leagues",
        name: "20000 Leagues",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/african_rhino": {
        slug: "african_rhino",
        name: "African Rhino",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/blazn_buffalo": {
        slug: "blazn_buffalo",
        name: "Blazn Buffalo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/blazn_buffalo_super_reels": {
        slug: "blazn_buffalo_super_reels",
        name: "Blazn Buffalo Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/brain_busters_reel_bingo": {
        slug: "brain_busters_reel_bingo",
        name: "Brain Busters Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/cosmonaut": {
        slug: "cosmonaut",
        name: "Cosmonaut",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/dance_of_the_dead": {
        slug: "dance_of_the_dead",
        name: "Dance Of The Dead",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/deep_sea_dollars": {
        slug: "deep_sea_dollars",
        name: "Deep Sea Dollars",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/deep_sea_dollars_reel_bingo": {
        slug: "deep_sea_dollars_reel_bingo",
        name: "Deep Sea Dollars Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/deep_sea_dollars_reel_triple": {
        slug: "deep_sea_dollars_reel_triple",
        name: "Deep Sea Dollars Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/deep_seas_dollars_super_reels": {
        slug: "deep_seas_dollars_super_reels",
        name: "Deep Seas Dollars Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/dolphin_bay": {
        slug: "dolphin_bay",
        name: "Dolphin Bay",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/fast_fortune": {
        slug: "fast_fortune",
        name: "Fast Fortune",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/gold_diggin": {
        slug: "gold_diggin",
        name: "Gold Diggin",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/gold_diggin_super_spinner": {
        slug: "gold_diggin_super_spinner",
        name: "Gold Diggin’ Super Spinner",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/gold_train": {
        slug: "gold_train",
        name: "Gold Train",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/golden_elephant": {
        slug: "golden_elephant",
        name: "Golden Elephant",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/golden_sabre": {
        slug: "golden_sabre",
        name: "Golden Sabre",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/happy_lucky": {
        slug: "happy_lucky",
        name: "Happy Lucky",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/its_alive": {
        slug: "its_alive",
        name: "It's Alive",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jack_and_the_giant": {
        slug: "jack_and_the_giant",
        name: "Jack and the Giant",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jackpot_hits": {
        slug: "jackpot_hits",
        name: "Jackpot Hits",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jungle_fever_reel_triple": {
        slug: "jungle_fever_reel_triple",
        name: "Jungle Fever Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jungle_fever_super_reels": {
        slug: "jungle_fever_super_reels",
        name: "Jungle Fever Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jungle_fever_v2_reel_bingo": {
        slug: "jungle_fever_v2_reel_bingo",
        name: "Jungle Fever V2 Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jungle_hunt": {
        slug: "jungle_hunt",
        name: "Jungle Hunt",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jungle_jive_v2_snakes_and_ladders": {
        slug: "jungle_jive_v2_snakes_and_ladders",
        name: "Jungle Jive V2 Snakes and Ladders",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/lobster_pots": {
        slug: "lobster_pots",
        name: "Lobster Pots",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/lost_in_the_wild_reel_bingo": {
        slug: "lost_in_the_wild_reel_bingo",
        name: "Lost in the Wild Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/lucky_turtle": {
        slug: "lucky_turtle",
        name: "Lucky Turtle",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/master_of_elements": {
        slug: "master_of_elements",
        name: "Master Of Elements",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/mighty_medusa": {
        slug: "mighty_medusa",
        name: "Mighty Medusa",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/mighty_zeus": {
        slug: "mighty_zeus",
        name: "Mighty Zeus",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/mighty_zeus_reel_triple": {
        slug: "mighty_zeus_reel_triple",
        name: "Mighty Zeus Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/mighty_zeus_super_reels": {
        slug: "mighty_zeus_super_reels",
        name: "Mighty Zeus Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/montezumas_quest": {
        slug: "montezumas_quest",
        name: "Montezumas Quest",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/moonlight_panda": {
        slug: "moonlight_panda",
        name: "Moonlight Panda",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/more_candy": {
        slug: "more_candy",
        name: "More Candy",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/navajo_legend": {
        slug: "navajo_legend",
        name: "Navajo Legend",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/night_in_egypt": {
        slug: "night_in_egypt",
        name: "Night in Egypt",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/poco_loco_hot_hot_chili_climb": {
        slug: "poco_loco_hot_hot_chili_climb",
        name: "Poco Loco Hot Hot Chili Climb",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/power_pets": {
        slug: "power_pets",
        name: "Power Pets",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/pyramids_of_cash_reel_bingo": {
        slug: "pyramids_of_cash_reel_bingo",
        name: "Pyramids Of Cash Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/pyramids_of_gold": {
        slug: "pyramids_of_gold",
        name: "Pyramids of Gold",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/raiders_of_the_sea": {
        slug: "raiders_of_the_sea",
        name: "Raiders of the Sea",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/ready_yeti_go_rb": {
        slug: "ready_yeti_go_rb",
        name: "Ready Yeti Go RB",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/ready_yeti_go_reel_bingo": {
        slug: "ready_yeti_go_reel_bingo",
        name: "Ready Yeti Go Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/ready_yeti_go_respin": {
        slug: "ready_yeti_go_respin",
        name: "Ready Yeti Go Respin",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/ready_yeti_respin": {
        slug: "ready_yeti_respin",
        name: "Ready Yeti Respin",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/ready_yeti_respin_chasing_cheddar": {
        slug: "ready_yeti_respin_chasing_cheddar",
        name: "Ready Yeti Respin Chasing Cheddar",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/reels_2_riches": {
        slug: "reels_2_riches",
        name: "Reels 2 Riches",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/reels_2_riches_reel_bingo": {
        slug: "reels_2_riches_reel_bingo",
        name: "Reels 2 Riches Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/reels_2_riches_reel_triple": {
        slug: "reels_2_riches_reel_triple",
        name: "Reels 2 Riches Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/rise_of_the_pharaohs": {
        slug: "rise_of_the_pharaohs",
        name: "Rise of the Pharaohs",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/river_n_blues": {
        slug: "river_n_blues",
        name: "River n' Blues",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/road_trip": {
        slug: "road_trip",
        name: "Road Trip",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/romeo_and_juliet": {
        slug: "romeo_and_juliet",
        name: "Romeo and Juliet",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/royal_dragon": {
        slug: "royal_dragon",
        name: "Royal Dragon",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/sinbads_fortune": {
        slug: "sinbads_fortune",
        name: "Sinbad's Fortune",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/siren_of_the_deep": {
        slug: "siren_of_the_deep",
        name: "Siren of the Deep",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/sky_pirates": {
        slug: "sky_pirates",
        name: "Sky Pirates",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/spin_carnival": {
        slug: "spin_carnival",
        name: "Spin Carnival",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/sticky_feet_reel_bingo": {
        slug: "sticky_feet_reel_bingo",
        name: "Sticky Feet Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/tarzan": {
        slug: "tarzan",
        name: "Tarzan",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/the_awakening": {
        slug: "the_awakening",
        name: "The Awakening",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/the_big_five": {
        slug: "the_big_five",
        name: "The Big Five",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/the_last_dynasty": {
        slug: "the_last_dynasty",
        name: "The Last Dynasty",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/the_lost_idol_v2": {
        slug: "the_lost_idol_v2",
        name: "The Lost Idol V2",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/three_panditos_reel_bingo": {
        slug: "three_panditos_reel_bingo",
        name: "Three Panditos Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/thundering_hearts": {
        slug: "thundering_hearts",
        name: "Thundering Hearts",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/tiki_bar_reel_bingo": {
        slug: "tiki_bar_reel_bingo",
        name: "Tiki Bar Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/two_can_party_superreels": {
        slug: "two_can_party_superreels",
        name: "Two Can Party SuperReels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/unicorn_dreams": {
        slug: "unicorn_dreams",
        name: "Unicorn Dreams",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/way_of_the_tiger": {
        slug: "way_of_the_tiger",
        name: "Way of the Tiger",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/wild_lion": {
        slug: "wild_lion",
        name: "Wild Lion",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/wild_lion_reel_bingo": {
        slug: "wild_lion_reel_bingo",
        name: "Wild Lion Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/wild_lion_reel_triple": {
        slug: "wild_lion_reel_triple",
        name: "Wild Lion Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/wild_lion_superreels": {
        slug: "wild_lion_superreels",
        name: "Wild Lion SuperReels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/winning_bull": {
        slug: "winning_bull",
        name: "Winning Bull",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/wolf_pack": {
        slug: "wolf_pack",
        name: "Wolf Pack",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "reelplay/10000_wolves_10k_ways": {
        slug: "10000_wolves_10k_ways",
        name: "10,000 Wolves 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/10000_wonders": {
        slug: "10000_wonders",
        name: "10,000 Wonders",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/10000_wonders_10k_ways": {
        slug: "10000_wonders_10k_ways",
        name: "10,000 Wonders 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/10000_wonders_big_bang": {
        slug: "10000_wonders_big_bang",
        name: "10000 Wonders Big Bang",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/10000_wonders_multimax": {
        slug: "10000_wonders_multimax",
        name: "10000 Wonders Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/24k_gold_jailbreak": {
        slug: "24k_gold_jailbreak",
        name: "24K Gold Jailbreak",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/24k_gold_shamrock_on": {
        slug: "24k_gold_shamrock_on",
        name: "24K Gold Shamrock On",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/3_wonders_grillmaster_grizzly": {
        slug: "3_wonders_grillmaster_grizzly",
        name: "3 Wonders Grillmaster Grizzly",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/3_wonders_new_year_carnival": {
        slug: "3_wonders_new_year_carnival",
        name: "3 Wonders New Year Carnival",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/age_of_beasts_infinity_reels": {
        slug: "age_of_beasts_infinity_reels",
        name: "Age of Beasts Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/american_outlaws_multimax": {
        slug: "american_outlaws_multimax",
        name: "American Outlaws Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/arctic_sorcerer_gigablox": {
        slug: "arctic_sorcerer_gigablox",
        name: "Arctic Sorcerer Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/armageddon_10k_ways": {
        slug: "armageddon_10k_ways",
        name: "Armageddon 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/arrr_10k_ways": {
        slug: "arrr_10k_ways",
        name: "ARRR! 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/atlantis_megaways": {
        slug: "atlantis_megaways",
        name: "Atlantis Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/aztec_gigablox": {
        slug: "aztec_gigablox",
        name: "Aztec Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/bananaz_10k_ways": {
        slug: "bananaz_10k_ways",
        name: "Bananaz 10k Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/big_bucks_bandits_megaways": {
        slug: "big_bucks_bandits_megaways",
        name: "Big Bucks Bandits Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/big_bucks_bison_10k_ways": {
        slug: "big_bucks_bison_10k_ways",
        name: "Big Bucks Bison 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/big_bucks_buffalo_gigablox": {
        slug: "big_bucks_buffalo_gigablox",
        name: "Big Bucks Buffalo Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/bucks_and_doe_10k_ways": {
        slug: "bucks_and_doe_10k_ways",
        name: "Bucks and Doe 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/buffalo_blox_gigablox": {
        slug: "buffalo_blox_gigablox",
        name: "Buffalo Blox Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/buster_hammer_carnival": {
        slug: "buster_hammer_carnival",
        name: "Buster Hammer Carnival",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/castle_cash_megaways": {
        slug: "castle_cash_megaways",
        name: "Castle Cash Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/dolphin_hot_1": {
        slug: "dolphin_hot_1",
        name: "Dolphin Hot 1",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/dragon_50000": {
        slug: "dragon_50000",
        name: "Dragon 50000",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/dragons_vs_gigablox": {
        slug: "dragons_vs_gigablox",
        name: "Dragons vs Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/el_dorado_infinity_reels": {
        slug: "el_dorado_infinity_reels",
        name: "El Dorado Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/excalibur_vs_gigablox": {
        slug: "excalibur_vs_gigablox",
        name: "Excalibur vs Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/festival_10k_ways": {
        slug: "festival_10k_ways",
        name: "Festival 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/frankenstein_wild_surge": {
        slug: "frankenstein_wild_surge",
        name: "Frankenstein Wild Surge",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/fruit_combinator": {
        slug: "fruit_combinator",
        name: "Fruit Combinator",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/fruit_gemz_splitz": {
        slug: "fruit_gemz_splitz",
        name: "Fruit Gemz Splitz",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/gargoyle_infinity_reels": {
        slug: "gargoyle_infinity_reels",
        name: "Gargoyle Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/gems_infinity_reels": {
        slug: "gems_infinity_reels",
        name: "Gems Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/giga_bass_gigablox": {
        slug: "giga_bass_gigablox",
        name: "Giga Bass GigaBlox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/giza_infinity_reels": {
        slug: "giza_infinity_reels",
        name: "Giza Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/goblin_grand": {
        slug: "goblin_grand",
        name: "Goblin Grand",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/goblins_bargain_multimax": {
        slug: "goblins_bargain_multimax",
        name: "Goblin's Bargain MultiMax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/gods_vs_gigablox": {
        slug: "gods_vs_gigablox",
        name: "Gods VS Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/gold_is_all_mine_10k_ways": {
        slug: "gold_is_all_mine_10k_ways",
        name: "Gold is All Mine 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/hercules_10k_ways": {
        slug: "hercules_10k_ways",
        name: "Hercules 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/hyper_respins": {
        slug: "hyper_respins",
        name: "Hyper Respins",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/hypernova_10k_ways": {
        slug: "hypernova_10k_ways",
        name: "Hypernova 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/hypernova_infinity_reels": {
        slug: "hypernova_infinity_reels",
        name: "Hypernova Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/hypernova_megaways": {
        slug: "hypernova_megaways",
        name: "Hypernova Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/hypernova_radial_reels": {
        slug: "hypernova_radial_reels",
        name: "Hypernova Radial Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/jaguar_super_ways": {
        slug: "jaguar_super_ways",
        name: "Jaguar Super Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/joker_super_reels": {
        slug: "joker_super_reels",
        name: "Joker Super Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/king_arthur_10k_ways": {
        slug: "king_arthur_10k_ways",
        name: "King Arthur 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/lady_merlin_multimax": {
        slug: "lady_merlin_multimax",
        name: "Lady Merlin Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/legend_of_dragon_wins_doublemax": {
        slug: "legend_of_dragon_wins_doublemax",
        name: "Legend of Dragon Wins Doublemax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/lions_gigablox": {
        slug: "lions_gigablox",
        name: "Lions GigaBlox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/lucky_lady_leprechaun": {
        slug: "lucky_lady_leprechaun",
        name: "Lucky Lady Leprechaun",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/martian_miner_infinity_reels": {
        slug: "martian_miner_infinity_reels",
        name: "Martian Miner Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mega_money_machine": {
        slug: "mega_money_machine",
        name: "Mega Money Machine",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mega_pearl_gigablox": {
        slug: "mega_pearl_gigablox",
        name: "Mega Pearl Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mermaid_reef": {
        slug: "mermaid_reef",
        name: "Mermaid Reef",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/money_mariachi_infinity_reels": {
        slug: "money_mariachi_infinity_reels",
        name: "Money Mariachi Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/monsters_vs_gigablox": {
        slug: "monsters_vs_gigablox",
        name: "Monsters vs Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mow_money": {
        slug: "mow_money",
        name: "Mow Money",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mow_money_multimax": {
        slug: "mow_money_multimax",
        name: "Mow Money Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mystic_dolphin_charge_up": {
        slug: "mystic_dolphin_charge_up",
        name: "Mystic Dolphin Charge Up",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/nile_mystery_doublemax": {
        slug: "nile_mystery_doublemax",
        name: "Nile Mystery Doublemax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/odin_infinity_reels": {
        slug: "odin_infinity_reels",
        name: "Odin Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/odin_infinity_reels_megaways": {
        slug: "odin_infinity_reels_megaways",
        name: "Odin Infinity Reels Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/odin_lightning_blitz": {
        slug: "odin_lightning_blitz",
        name: "Odin Lightning Blitz",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/orcas_wild_bonanza": {
        slug: "orcas_wild_bonanza",
        name: "Orca's Wild Bonanza",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/pay_pig_10k_ways": {
        slug: "pay_pig_10k_ways",
        name: "Pay Pig 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/pearl_reef_gigablox_multimax": {
        slug: "pearl_reef_gigablox_multimax",
        name: "Pearl Reef Gigablox Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/pillage_the_village_10k_ways": {
        slug: "pillage_the_village_10k_ways",
        name: "Pillage The Village 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/primal_hunter_gigablox": {
        slug: "primal_hunter_gigablox",
        name: "Primal Hunter Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/professor_clanks_combinator": {
        slug: "professor_clanks_combinator",
        name: "Professor Clank's Combinator",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/ramesses_gold_10k_ways": {
        slug: "ramesses_gold_10k_ways",
        name: "Ramesses Gold 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/remember_remember": {
        slug: "remember_remember",
        name: "Remember Remember",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/royal_dragon_infinity_reels": {
        slug: "royal_dragon_infinity_reels",
        name: "Royal Dragon Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/shamrock_money_pot_10k_ways": {
        slug: "shamrock_money_pot_10k_ways",
        name: "Shamrock Money Pot 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/skylantis_2_wild_fight": {
        slug: "skylantis_2_wild_fight",
        name: "Skylantis 2 Wild Fight",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/the_good_farmer": {
        slug: "the_good_farmer",
        name: "The Good Farmer",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/the_trolls_treasure": {
        slug: "the_trolls_treasure",
        name: "The Trolls' Treasure",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/the_wild_drifter": {
        slug: "the_wild_drifter",
        name: "The Wild Drifter",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/thor_10k_ways": {
        slug: "thor_10k_ways",
        name: "Thor 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/thor_infinity_reels": {
        slug: "thor_infinity_reels",
        name: "Thor Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/tiger_doublemax": {
        slug: "tiger_doublemax",
        name: "Tiger DoubleMax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/tiki_infinity_reels_megaways": {
        slug: "tiki_infinity_reels_megaways",
        name: "Tiki Infinity Reels Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/towering_pays_excalibur": {
        slug: "towering_pays_excalibur",
        name: "Towering Pays Excalibur",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/towering_pays_valhalla": {
        slug: "towering_pays_valhalla",
        name: "Towering Pays Valhalla",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/troy_superways": {
        slug: "troy_superways",
        name: "Troy Superways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/tsai_shen_10k_ways": {
        slug: "tsai_shen_10k_ways",
        name: "Tsai Shen 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/west_coast_cash_infinity_reels": {
        slug: "west_coast_cash_infinity_reels",
        name: "West Coast Cash Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/what_the_fruit": {
        slug: "what_the_fruit",
        name: "What the Fruit",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/wild_joker_stacks": {
        slug: "wild_joker_stacks",
        name: "Wild Joker Stacks",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/wild_storm_legionnaire": {
        slug: "wild_storm_legionnaire",
        name: "Wild Storm Legionnaire",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/zodiac_infinity_reels": {
        slug: "zodiac_infinity_reels",
        name: "Zodiac Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reflex-gaming/2_fast_2_fruity": {
        slug: "2_fast_2_fruity",
        name: "2 Fast 2 Fruity",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/5_clans": {
        slug: "5_clans",
        name: "5 Clans",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/8_balls_of_fire": {
        slug: "8_balls_of_fire",
        name: "8 Balls of Fire",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/8_balls_of_fire_blazing_bounty": {
        slug: "8_balls_of_fire_blazing_bounty",
        name: "8 Balls of Fire Blazing Bounty",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/anubis_ii_doublemax": {
        slug: "anubis_ii_doublemax",
        name: "Anubis II Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/bank_of_blarney_tophit": {
        slug: "bank_of_blarney_tophit",
        name: "Bank of Blarney TopHit",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/big_game_fishing_christmas_catch": {
        slug: "big_game_fishing_christmas_catch",
        name: "Big Game Fishing Christmas Catch",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/big_game_fishing_golden_catch": {
        slug: "big_game_fishing_golden_catch",
        name: "Big Game Fishing Golden Catch",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/big_game_fishing_rapid_riches": {
        slug: "big_game_fishing_rapid_riches",
        name: "Big Game Fishing Rapid Riches",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/big_game_fishing_tophit": {
        slug: "big_game_fishing_tophit",
        name: "Big Game Fishing TopHit",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/bison_wilds_doublemax": {
        slug: "bison_wilds_doublemax",
        name: "Bison Wilds Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/book_of_blarney_gigablox": {
        slug: "book_of_blarney_gigablox",
        name: "Book of Blarney Gigablox",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/bugs_money": {
        slug: "bugs_money",
        name: "Bugs Money",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/candy_crazed_pandas_double_max": {
        slug: "candy_crazed_pandas_double_max",
        name: "Candy Crazed Pandas Double Max",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/dead_lucky_duomax": {
        slug: "dead_lucky_duomax",
        name: "Dead Lucky DuoMax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/desparate_dawgs": {
        slug: "desparate_dawgs",
        name: "Desparate Dawgs",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/desperate_dawgs": {
        slug: "desperate_dawgs",
        name: "Desperate Dawgs",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/desperate_dawgs_2_gigablox": {
        slug: "desperate_dawgs_2_gigablox",
        name: "Desperate Dawgs 2 Gigablox",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/diamond_miner_duomax": {
        slug: "diamond_miner_duomax",
        name: "Diamond Miner Duomax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/double_fruit_frenzy_doublemax": {
        slug: "double_fruit_frenzy_doublemax",
        name: "Double Fruit Frenzy Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/double_lucky_mushrooms_doublemax": {
        slug: "double_lucky_mushrooms_doublemax",
        name: "Double Lucky Mushrooms DoubleMax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/dublin_up": {
        slug: "dublin_up",
        name: "Dublin Up",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/dublin_up_pots_o_gold_double_max": {
        slug: "dublin_up_pots_o_gold_double_max",
        name: "Dublin Up Pots O' Gold Double Max",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/eye_of_persia_2": {
        slug: "eye_of_persia_2",
        name: "Eye of Persia 2",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/fast_fruits_doublemax": {
        slug: "fast_fruits_doublemax",
        name: "Fast Fruits Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/five_clans": {
        slug: "five_clans",
        name: "Five Clans",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/hells_hogs": {
        slug: "hells_hogs",
        name: "Hell's Hogs",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/hells_hogs_2_squealin_wheels": {
        slug: "hells_hogs_2_squealin_wheels",
        name: "Hell's Hogs 2 Squealin' Wheels",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/hillbilly_vegas": {
        slug: "hillbilly_vegas",
        name: "Hillbilly Vegas",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/jacks_beanstalk_bonanza": {
        slug: "jacks_beanstalk_bonanza",
        name: "Jack's Beanstalk Bonanza",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/krazy_klimber": {
        slug: "krazy_klimber",
        name: "Krazy Klimber",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/moley_moolah": {
        slug: "moley_moolah",
        name: "Moley Moolah",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/paddys_pool_party": {
        slug: "paddys_pool_party",
        name: "Paddy's Pool Party",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/piggies_prize_party": {
        slug: "piggies_prize_party",
        name: "Piggies Prize Party",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/purrfect_potions": {
        slug: "purrfect_potions",
        name: "Purrfect Potions",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/redbeards_rum_runners_doublemax": {
        slug: "redbeards_rum_runners_doublemax",
        name: "Redbeards Rum Runners Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/secret_of_anubis_doublemax": {
        slug: "secret_of_anubis_doublemax",
        name: "Secret of Anubis Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/sidewinder_doublemax": {
        slug: "sidewinder_doublemax",
        name: "Sidewinder DoubleMax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/sidewinder_xtra_power": {
        slug: "sidewinder_xtra_power",
        name: "Sidewinder Xtra Power",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/the_bounty_hunter": {
        slug: "the_bounty_hunter",
        name: "The Bounty Hunter",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/thors_hammer_time": {
        slug: "thors_hammer_time",
        name: "Thor's Hammer Time",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/time_machine": {
        slug: "time_machine",
        name: "Time Machine",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "relax-gaming/ancient_tumble": {
        slug: "ancient_tumble",
        name: "Ancient Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/atlantis_crush": {
        slug: "atlantis_crush",
        name: "Atlantis Crush",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/attila_the_hun": {
        slug: "attila_the_hun",
        name: "Attila The Hun",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/aura_god": {
        slug: "aura_god",
        name: "Aura God",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bacon_bankroll": {
        slug: "bacon_bankroll",
        name: "Bacon Bankroll",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/banana_town": {
        slug: "banana_town",
        name: "Banana Town",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/beast_gains": {
        slug: "beast_gains",
        name: "Beast Gains",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/beast_mode": {
        slug: "beast_mode",
        name: "Beast Mode",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bill_and_coin": {
        slug: "bill_and_coin",
        name: "Bill & Coin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bill_and_coin_2": {
        slug: "bill_and_coin_2",
        name: "Bill and Coin 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/blackjack_6_decks": {
        slug: "blackjack_6_decks",
        name: "Blackjack 6 Decks",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/blackjack_neo": {
        slug: "blackjack_neo",
        name: "Blackjack Neo",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/blender_blitz": {
        slug: "blender_blitz",
        name: "Blender Blitz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bone_raiders": {
        slug: "bone_raiders",
        name: "Bone Raiders",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bonsai_dragon_blitz": {
        slug: "bonsai_dragon_blitz",
        name: "Bonsai Dragon Blitz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/book_of": {
        slug: "book_of",
        name: "Book of",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/book_of_power": {
        slug: "book_of_power",
        name: "Book of Power",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bounty_county": {
        slug: "bounty_county",
        name: "Bounty County",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/camelot_cash": {
        slug: "camelot_cash",
        name: "Camelot Cash",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/cash_in_transit": {
        slug: "cash_in_transit",
        name: "Cash in Transit",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/caveman_bob": {
        slug: "caveman_bob",
        name: "Caveman Bob",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/chip_spin": {
        slug: "chip_spin",
        name: "Chip Spin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/cluster_tumble": {
        slug: "cluster_tumble",
        name: "Cluster Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/conquer_babylon": {
        slug: "conquer_babylon",
        name: "Conquer Babylon",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/dead_mans_trail": {
        slug: "dead_mans_trail",
        name: "Dead Man's Trail",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/dead_riders_trail": {
        slug: "dead_riders_trail",
        name: "Dead Riders Trail",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/deep_descent": {
        slug: "deep_descent",
        name: "Deep Descent",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/dragons_awakening": {
        slug: "dragons_awakening",
        name: "Dragons' Awakening",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/emeralds_infinity_reels": {
        slug: "emeralds_infinity_reels",
        name: "Emerald's Infinity Reels",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/epic_dreams": {
        slug: "epic_dreams",
        name: "Epic Dreams",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/epic_joker": {
        slug: "epic_joker",
        name: "Epic Joker",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/erik_the_red": {
        slug: "erik_the_red",
        name: "Erik the Red",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/fangs_inferno": {
        slug: "fangs_inferno",
        name: "Fang's Inferno",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/feather_fury": {
        slug: "feather_fury",
        name: "Feather Fury",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/firewins_factory": {
        slug: "firewins_factory",
        name: "FireWins Factory",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/franks_diner": {
        slug: "franks_diner",
        name: "Frank's Diner",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/frequent_flyer": {
        slug: "frequent_flyer",
        name: "Frequent Flyer",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/giants_and_sheep": {
        slug: "giants_and_sheep",
        name: "Giants and Sheep",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/glyph_of_gods": {
        slug: "glyph_of_gods",
        name: "Glyph of Gods",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/guitar_quest": {
        slug: "guitar_quest",
        name: "Guitar Quest",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/hazakura_ways": {
        slug: "hazakura_ways",
        name: "Hazakura Ways",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/helios_fury": {
        slug: "helios_fury",
        name: "Helios' Fury",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/hellcatraz": {
        slug: "hellcatraz",
        name: "Hellcatraz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/heroes_gathering": {
        slug: "heroes_gathering",
        name: "Heroes Gathering",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/hex": {
        slug: "hex",
        name: "Hex",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/horror_hotel": {
        slug: "horror_hotel",
        name: "Horror Hotel",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/hot_rod_racers": {
        slug: "hot_rod_racers",
        name: "Hot Rod Racers",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/ignite_the_night": {
        slug: "ignite_the_night",
        name: "Ignite the Night",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/immortal_5": {
        slug: "immortal_5",
        name: "Immortal 5",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/iron_bank": {
        slug: "iron_bank",
        name: "Iron Bank",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/iron_bank_2": {
        slug: "iron_bank_2",
        name: "Iron Bank 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/its_time": {
        slug: "its_time",
        name: "It's Time",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/joker_split": {
        slug: "joker_split",
        name: "Joker Split",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/jumbo_juicy": {
        slug: "jumbo_juicy",
        name: "Jumbo Juicy",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/jupiters_choice": {
        slug: "jupiters_choice",
        name: "Jupiters Choice",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/jurassic_party": {
        slug: "jurassic_party",
        name: "Jurassic Party",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/king_of_kings": {
        slug: "king_of_kings",
        name: "King of Kings",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/kluster_krystals_megaclusters": {
        slug: "kluster_krystals_megaclusters",
        name: "Kluster Krystals MegaClusters",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/krakens_cove": {
        slug: "krakens_cove",
        name: "Kraken's Cove",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/la_fiesta": {
        slug: "la_fiesta",
        name: "La Fiesta",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/lets_get_ready_to_rumble": {
        slug: "lets_get_ready_to_rumble",
        name: "Let's Get Ready to Rumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/lure_of_fortune": {
        slug: "lure_of_fortune",
        name: "Lure of Fortune",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/marching_legions": {
        slug: "marching_legions",
        name: "Marching Legions",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/masked_treasures": {
        slug: "masked_treasures",
        name: "Masked Treasures",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/mega_flip": {
        slug: "mega_flip",
        name: "Mega Flip",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/mega_heist": {
        slug: "mega_heist",
        name: "Mega Heist",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/mega_masks": {
        slug: "mega_masks",
        name: "Mega Masks",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/mega_mine": {
        slug: "mega_mine",
        name: "Mega Mine",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/midnight_marauder": {
        slug: "midnight_marauder",
        name: "Midnight Marauder",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_cart": {
        slug: "money_cart",
        name: "Money Cart",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_cart_2": {
        slug: "money_cart_2",
        name: "Money Cart 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_cart_3": {
        slug: "money_cart_3",
        name: "Money Cart 3",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_sleigh": {
        slug: "money_sleigh",
        name: "Money Sleigh",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_train": {
        slug: "money_train",
        name: "Money Train",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_train_2": {
        slug: "money_train_2",
        name: "Money Train 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_train_3": {
        slug: "money_train_3",
        name: "Money Train 3",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_train_4": {
        slug: "money_train_4",
        name: "Money Train 4",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/multiplier_odyssey": {
        slug: "multiplier_odyssey",
        name: "Multiplier Odyssey",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/necromancers_gate": {
        slug: "necromancers_gate",
        name: "Necromancer's Gate",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/net_gains": {
        slug: "net_gains",
        name: "Net Gains",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/pharaohs_last_wish": {
        slug: "pharaohs_last_wish",
        name: "Pharaoh's Last Wish",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/plunderland": {
        slug: "plunderland",
        name: "Plunderland",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/powerspin": {
        slug: "powerspin",
        name: "Powerspin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/purrrminator": {
        slug: "purrrminator",
        name: "Purrrminator",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/quackin_reels": {
        slug: "quackin_reels",
        name: "Quackin Reels",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/ramses_revenge": {
        slug: "ramses_revenge",
        name: "Ramses Revenge",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/roulette_neo": {
        slug: "roulette_neo",
        name: "Roulette Neo",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/sails_of_fortune": {
        slug: "sails_of_fortune",
        name: "Sails of Fortune",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/santas_stack": {
        slug: "santas_stack",
        name: "Santa's Stack",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/shark_wash": {
        slug: "shark_wash",
        name: "Shark Wash",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/sloth_tumble": {
        slug: "sloth_tumble",
        name: "Sloth Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/snake_arena": {
        slug: "snake_arena",
        name: "Snake Arena",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/snake_arena_2": {
        slug: "snake_arena_2",
        name: "Snake Arena 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/space_miners": {
        slug: "space_miners",
        name: "Space Miners",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/spirit_of_the_beast": {
        slug: "spirit_of_the_beast",
        name: "Spirit of the Beast",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/sultan_spins": {
        slug: "sultan_spins",
        name: "Sultan Spins",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/sweetopia_royale": {
        slug: "sweetopia_royale",
        name: "Sweetopia Royale",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/templar_tumble": {
        slug: "templar_tumble",
        name: "Templar Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/templar_tumble_dream_drop": {
        slug: "templar_tumble_dream_drop",
        name: "Templar Tumble Dream Drop",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/temple_tumble_megaways": {
        slug: "temple_tumble_megaways",
        name: "Temple Tumble MegaWays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/the_great_pigsby": {
        slug: "the_great_pigsby",
        name: "The Great Pigsby",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/the_great_pigsby_megapays": {
        slug: "the_great_pigsby_megapays",
        name: "The Great Pigsby Megapays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/the_great_pigsby_megaways": {
        slug: "the_great_pigsby_megaways",
        name: "The Great Pigsby MegaWays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/the_tumbles": {
        slug: "the_tumbles",
        name: "The Tumbles",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/tiger_kingdom": {
        slug: "tiger_kingdom",
        name: "Tiger Kingdom",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/tiger_shrine": {
        slug: "tiger_shrine",
        name: "Tiger Shrine",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/titan_strike": {
        slug: "titan_strike",
        name: "Titan Strike",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/tnt_tumble": {
        slug: "tnt_tumble",
        name: "TNT Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/top_dawg": {
        slug: "top_dawg",
        name: "Top Dawg$",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/torii_tumble": {
        slug: "torii_tumble",
        name: "Torii Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/tower_tumble": {
        slug: "tower_tumble",
        name: "Tower Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/treasure_tumble": {
        slug: "treasure_tumble",
        name: "Treasure Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/trolls_gold": {
        slug: "trolls_gold",
        name: "Troll's Gold",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/volatile_vikings": {
        slug: "volatile_vikings",
        name: "Volatile Vikings",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/wild_chapo": {
        slug: "wild_chapo",
        name: "Wild Chapo",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/wild_chapo_2": {
        slug: "wild_chapo_2",
        name: "Wild Chapo 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/wild_hike": {
        slug: "wild_hike",
        name: "Wild Hike",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/wild_yield": {
        slug: "wild_yield",
        name: "Wild Yield",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/wildchemy": {
        slug: "wildchemy",
        name: "Wildchemy",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/winter_champions": {
        slug: "winter_champions",
        name: "Winter Champions",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/zombie_circus": {
        slug: "zombie_circus",
        name: "Zombie Circus",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "rogue-gaming/121_gigawatts": {
        slug: "121_gigawatts",
        name: "1.21 Gigawatts",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/3_wonders_ny_carnival_94": {
        slug: "3_wonders_ny_carnival_94",
        name: "3 Wonders NY Carnival 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/3_wonders_underworld": {
        slug: "3_wonders_underworld",
        name: "3 Wonders Underworld",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/777_wealth": {
        slug: "777_wealth",
        name: "777 Wealth",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/american_respin": {
        slug: "american_respin",
        name: "American Respin",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/avalanche_rainblox": {
        slug: "avalanche_rainblox",
        name: "Avalanche Rainblox",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/bank_run": {
        slug: "bank_run",
        name: "Bank Run",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/big_buffalo_bonanza": {
        slug: "big_buffalo_bonanza",
        name: "Big Buffalo Bonanza",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/big_river_fishing": {
        slug: "big_river_fishing",
        name: "Big River Fishing",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/big_top_terror": {
        slug: "big_top_terror",
        name: "Big Top Terror",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/billy_west_wild_hunt_94": {
        slug: "billy_west_wild_hunt_94",
        name: "Billy West Wild Hunt 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/blazing_fire_balls_spin_win": {
        slug: "blazing_fire_balls_spin_win",
        name: "Blazing Fire Balls Spin Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/book_of_eternity_94": {
        slug: "book_of_eternity_94",
        name: "Book of Eternity 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/caichen_triple_blossom": {
        slug: "caichen_triple_blossom",
        name: "Caichen Triple Blossom",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/catch_a_wave": {
        slug: "catch_a_wave",
        name: "Catch a Wave",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/charlies_angel": {
        slug: "charlies_angel",
        name: "Charlies Angel",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/christmas_combo": {
        slug: "christmas_combo",
        name: "Christmas Combo",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/cloverland_riches": {
        slug: "cloverland_riches",
        name: "Cloverland Riches",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/combo_drop": {
        slug: "combo_drop",
        name: "Combo Drop",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/dan_marino_gunslinger": {
        slug: "dan_marino_gunslinger",
        name: "Dan Marino Gunslinger",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/dan_marino_perfect_pass": {
        slug: "dan_marino_perfect_pass",
        name: "Dan Marino Perfect Pass",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/davy_jones_locker_with_tsunami_reels": {
        slug: "davy_jones_locker_with_tsunami_reels",
        name: "Davy Jones Locker with Tsunami Reels",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/deadly_west": {
        slug: "deadly_west",
        name: "Deadly West",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/deep_treasure_gold": {
        slug: "deep_treasure_gold",
        name: "Deep Treasure Gold",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/derby_dash": {
        slug: "derby_dash",
        name: "Derby Dash",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/devils_kitchen_94": {
        slug: "devils_kitchen_94",
        name: "Devil's Kitchen 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/diamond_multiplier_respin": {
        slug: "diamond_multiplier_respin",
        name: "Diamond Multiplier Respin",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/dragon_and_dragons": {
        slug: "dragon_and_dragons",
        name: "Dragon and Dragons",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/elephants_vs_tigers": {
        slug: "elephants_vs_tigers",
        name: "Elephants vs Tigers",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/epic_phoenix": {
        slug: "epic_phoenix",
        name: "Epic Phoenix",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/family_feud": {
        slug: "family_feud",
        name: "Family Feud",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/farmyard_fortunes": {
        slug: "farmyard_fortunes",
        name: "Farmyard Fortunes",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/fate_of_the_gods": {
        slug: "fate_of_the_gods",
        name: "Fate of The Gods",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/fever_las_vegas": {
        slug: "fever_las_vegas",
        name: "Fever Las Vegas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/fireworks_of_fortune": {
        slug: "fireworks_of_fortune",
        name: "Fireworks of Fortune",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/football_rush": {
        slug: "football_rush",
        name: "Football Rush",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/fruit_fusion": {
        slug: "fruit_fusion",
        name: "Fruit Fusion",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/fu_ren_wu": {
        slug: "fu_ren_wu",
        name: "Fu Ren Wu",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/fujisan": {
        slug: "fujisan",
        name: "Fujisan",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/gemstones_cascade": {
        slug: "gemstones_cascade",
        name: "Gemstones Cascade",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/ghetto_gold": {
        slug: "ghetto_gold",
        name: "Ghetto Gold",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/godfather_megaways": {
        slug: "godfather_megaways",
        name: "Godfather Megaways",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/gold_n_spin": {
        slug: "gold_n_spin",
        name: "Gold n Spin",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/golden_koi": {
        slug: "golden_koi",
        name: "Golden Koi",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/great_luck": {
        slug: "great_luck",
        name: "Great Luck",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/happily_ever_after": {
        slug: "happily_ever_after",
        name: "Happily Ever After",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/happily_ever_after_once_upon_a_multiplier_94": {
        slug: "happily_ever_after_once_upon_a_multiplier_94",
        name: "Happily Ever After Once Upon a Multiplier 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/happy_holidays": {
        slug: "happy_holidays",
        name: "Happy Holidays",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/howling_inferno_hold_and_win_3x3": {
        slug: "howling_inferno_hold_and_win_3x3",
        name: "Howling Inferno Hold and Win 3x3",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/howling_inferno_hold_and_win_5x3": {
        slug: "howling_inferno_hold_and_win_5x3",
        name: "Howling Inferno Hold and Win 5x3",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/hyperbars": {
        slug: "hyperbars",
        name: "Hyperbars",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/keno_multiplay": {
        slug: "keno_multiplay",
        name: "Keno Multiplay",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/king_kerching": {
        slug: "king_kerching",
        name: "King Kerching",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/legacy_of_anubis": {
        slug: "legacy_of_anubis",
        name: "Legacy of Anubis",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/looters": {
        slug: "looters",
        name: "Looters",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/lucky_8_keno": {
        slug: "lucky_8_keno",
        name: "Lucky 8 Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/lucky_bonus_draw_keno": {
        slug: "lucky_bonus_draw_keno",
        name: "Lucky Bonus Draw Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/lucky_buddha": {
        slug: "lucky_buddha",
        name: "Lucky Buddha",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/lucky_star_keno": {
        slug: "lucky_star_keno",
        name: "Lucky Star Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/mafioso": {
        slug: "mafioso",
        name: "Mafioso",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/mayan_riches_prophecy_of_gold": {
        slug: "mayan_riches_prophecy_of_gold",
        name: "Mayan Riches Prophecy of Gold",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/mayan_temple_riches": {
        slug: "mayan_temple_riches",
        name: "Mayan Temple Riches",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/mega_laser_kitty_cubes": {
        slug: "mega_laser_kitty_cubes",
        name: "Mega Laser Kitty Cubes",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/merge_hold_and_drop": {
        slug: "merge_hold_and_drop",
        name: "Merge Hold and Drop",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/merlins_mixtures_94": {
        slug: "merlins_mixtures_94",
        name: "Merlin's Mixtures 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/moosey_money": {
        slug: "moosey_money",
        name: "Moosey Money",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/multiplier_mine": {
        slug: "multiplier_mine",
        name: "Multiplier Mine",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/mystic_magic": {
        slug: "mystic_magic",
        name: "Mystic Magic",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/neon_respin": {
        slug: "neon_respin",
        name: "Neon Respin",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/neon_wildfire": {
        slug: "neon_wildfire",
        name: "Neon Wildfire",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/overdrive": {
        slug: "overdrive",
        name: "Overdrive",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/pay_dirt": {
        slug: "pay_dirt",
        name: "Pay Dirt",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/picture_this_cute_christmas": {
        slug: "picture_this_cute_christmas",
        name: "Picture This Cute Christmas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/picture_this_xxmas": {
        slug: "picture_this_xxmas",
        name: "Picture This XXmas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/piggy_bank_riches": {
        slug: "piggy_bank_riches",
        name: "Piggy Bank Riches",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/piggy_bank_run_shriek_streak": {
        slug: "piggy_bank_run_shriek_streak",
        name: "Piggy Bank Run Shriek Streak",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/piggy_plunder": {
        slug: "piggy_plunder",
        name: "Piggy Plunder",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/power_strike_hyper_hits_94": {
        slug: "power_strike_hyper_hits_94",
        name: "Power Strike Hyper Hits 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/powerups": {
        slug: "powerups",
        name: "Power-ups",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/punk_rocks": {
        slug: "punk_rocks",
        name: "Punk Rocks",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/rainbow_falls": {
        slug: "rainbow_falls",
        name: "Rainbow Falls",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/rainbow_run_with_run_amok": {
        slug: "rainbow_run_with_run_amok",
        name: "Rainbow Run with Run Amok",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/rambo": {
        slug: "rambo",
        name: "Rambo",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/rave_up": {
        slug: "rave_up",
        name: "Rave UP",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/reign_of_maximus": {
        slug: "reign_of_maximus",
        name: "Reign of Maximus",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/riches_of_olympus": {
        slug: "riches_of_olympus",
        name: "Riches of Olympus",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/runaway_train": {
        slug: "runaway_train",
        name: "Runaway Train",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/shark_bait_94": {
        slug: "shark_bait_94",
        name: "Shark Bait 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/smash_street_wilds": {
        slug: "smash_street_wilds",
        name: "Smash Street Wilds",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/stacking_kong": {
        slug: "stacking_kong",
        name: "StacKING Kong",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/stacking_kong_bonus": {
        slug: "stacking_kong_bonus",
        name: "Stacking Kong Bonus",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/stacking_kong_bonus_christmas": {
        slug: "stacking_kong_bonus_christmas",
        name: "StacKing Kong Bonus Christmas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/stadium_megaways": {
        slug: "stadium_megaways",
        name: "Stadium Megaways",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/super_charged_fruits": {
        slug: "super_charged_fruits",
        name: "Super Charged Fruits",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/super_triple_fortune": {
        slug: "super_triple_fortune",
        name: "Super Triple Fortune",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/the_secret_of_amun_ra": {
        slug: "the_secret_of_amun_ra",
        name: "The Secret of Amun Ra",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/the_vigilantes": {
        slug: "the_vigilantes",
        name: "The Vigilantes",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/three_fortune_wishes": {
        slug: "three_fortune_wishes",
        name: "Three Fortune Wishes",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/tntina": {
        slug: "tntina",
        name: "TNTina",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/triple_fire_pots_hold_and_win": {
        slug: "triple_fire_pots_hold_and_win",
        name: "Triple Fire Pots Hold and Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/triple_hit_gold_mine_hold_and_win": {
        slug: "triple_hit_gold_mine_hold_and_win",
        name: "Triple Hit Gold Mine Hold and Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/triple_snack_attack": {
        slug: "triple_snack_attack",
        name: "Triple Snack Attack",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/vegas_triple_play_spin_n_win": {
        slug: "vegas_triple_play_spin_n_win",
        name: "Vegas Triple Play Spin n Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wheel_big_winner_millionaires_life": {
        slug: "wheel_big_winner_millionaires_life",
        name: "Wheel Big Winner Millionaires Life",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wheel_big_winner_power_tower": {
        slug: "wheel_big_winner_power_tower",
        name: "Wheel Big Winner Power Tower",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wheel_big_winner_red_hot_spins": {
        slug: "wheel_big_winner_red_hot_spins",
        name: "Wheel Big Winner Red Hot Spins",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wild_reel_royale": {
        slug: "wild_reel_royale",
        name: "Wild Reel Royale",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wild_whopper": {
        slug: "wild_whopper",
        name: "Wild Whopper",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wildfire_west": {
        slug: "wildfire_west",
        name: "Wildfire West",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wolf_diamond": {
        slug: "wolf_diamond",
        name: "Wolf Diamond",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wolf_peak": {
        slug: "wolf_peak",
        name: "Wolf Peak",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/xtra_ball_keno": {
        slug: "xtra_ball_keno",
        name: "Xtra Ball Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/zeus_thunder_tower": {
        slug: "zeus_thunder_tower",
        name: "Zeus Thunder Tower",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "slingo/baking_bonanza": {
        slug: "baking_bonanza",
        name: "Baking Bonanza",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/bar_x_colossal": {
        slug: "bar_x_colossal",
        name: "Bar X Colossal",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/bar_x_xl": {
        slug: "bar_x_xl",
        name: "Bar X XL",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/book_of_slingo": {
        slug: "book_of_slingo",
        name: "Book Of Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/china_shores_slingo": {
        slug: "china_shores_slingo",
        name: "China Shores Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_ante_up": {
        slug: "slingo_ante_up",
        name: "Slingo Ante Up",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_big_spin_booster": {
        slug: "slingo_big_spin_booster",
        name: "Slingo Big Spin Booster",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_big_wheel": {
        slug: "slingo_big_wheel",
        name: "Slingo Big Wheel",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_capital_gains": {
        slug: "slingo_capital_gains",
        name: "Slingo Capital Gains",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_carnival": {
        slug: "slingo_carnival",
        name: "Slingo Carnival",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_cascade": {
        slug: "slingo_cascade",
        name: "Slingo Cascade",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_centurionslingo_maximus": {
        slug: "slingo_centurionslingo_maximus",
        name: "Slingo Centurion/Slingo Maximus",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_classic": {
        slug: "slingo_classic",
        name: "Slingo Classic",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_constitution_hill": {
        slug: "slingo_constitution_hill",
        name: "Slingo Constitution Hill",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_da_vinci_diamonds": {
        slug: "slingo_da_vinci_diamonds",
        name: "Slingo Da Vinci Diamonds",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_day_of_the_dab": {
        slug: "slingo_day_of_the_dab",
        name: "Slingo Day of the Dab",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_deal_or_no_deal_uk": {
        slug: "slingo_deal_or_no_deal_uk",
        name: "Slingo Deal Or No Deal (UK)",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_extreme": {
        slug: "slingo_extreme",
        name: "Slingo Extreme",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_fishing_bob": {
        slug: "slingo_fishing_bob",
        name: "Slingo Fishing Bob",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_fluffy_favourites": {
        slug: "slingo_fluffy_favourites",
        name: "Slingo Fluffy Favourites",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_fowl_play": {
        slug: "slingo_fowl_play",
        name: "Slingo Fowl Play",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_gold_cash": {
        slug: "slingo_gold_cash",
        name: "Slingo Gold Cash",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_golden_envelope": {
        slug: "slingo_golden_envelope",
        name: "Slingo Golden Envelope",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_honey_crew": {
        slug: "slingo_honey_crew",
        name: "Slingo Honey Crew",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_hot_roll": {
        slug: "slingo_hot_roll",
        name: "Slingo Hot Roll",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_inca_trail": {
        slug: "slingo_inca_trail",
        name: "Slingo Inca Trail",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_journey_to_asgard": {
        slug: "slingo_journey_to_asgard",
        name: "Slingo Journey to Asgard",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_lucky_joker": {
        slug: "slingo_lucky_joker",
        name: "Slingo Lucky Joker",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_lucky_mcgold": {
        slug: "slingo_lucky_mcgold",
        name: "Slingo Lucky McGold",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_lucky_streak": {
        slug: "slingo_lucky_streak",
        name: "Slingo Lucky Streak",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_piggy_bank": {
        slug: "slingo_piggy_bank",
        name: "Slingo Piggy Bank",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_pop": {
        slug: "slingo_pop",
        name: "Slingo Pop",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_racing": {
        slug: "slingo_racing",
        name: "Slingo Racing",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_reel_king": {
        slug: "slingo_reel_king",
        name: "Slingo Reel King",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_reel_riches": {
        slug: "slingo_reel_riches",
        name: "Slingo Reel Riches",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_reveal": {
        slug: "slingo_reveal",
        name: "Slingo Reveal",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_riches": {
        slug: "slingo_riches",
        name: "Slingo Riches",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_river_re3ls": {
        slug: "slingo_river_re3ls",
        name: "Slingo River Re3ls",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_santa_king": {
        slug: "slingo_santa_king",
        name: "Slingo Santa King",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_shark_week_700": {
        slug: "slingo_shark_week_700",
        name: "Slingo Shark Week 700",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_stampede": {
        slug: "slingo_stampede",
        name: "Slingo Stampede",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_starburst": {
        slug: "slingo_starburst",
        name: "Slingo Starburst",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_stinkin_rich": {
        slug: "slingo_stinkin_rich",
        name: "Slingo Stinkin Rich",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_sweet_bonanza": {
        slug: "slingo_sweet_bonanza",
        name: "Slingo Sweet Bonanza",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_wild_adventure": {
        slug: "slingo_wild_adventure",
        name: "Slingo Wild Adventure",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_wwtbam": {
        slug: "slingo_wwtbam",
        name: "Slingo WWTBAM",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_xing_yun_xian": {
        slug: "slingo_xing_yun_xian",
        name: "Slingo Xing Yun Xian",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingo_xxx_treme": {
        slug: "slingo_xxx_treme",
        name: "Slingo XXX Treme",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingone_fishin": {
        slug: "slingone_fishin",
        name: "Slingone Fishin",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingoooal": {
        slug: "slingoooal",
        name: "Slingoooal",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/slingoooal_championship": {
        slug: "slingoooal_championship",
        name: "Slingoooal Championship",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/sun_bingo_slingo": {
        slug: "sun_bingo_slingo",
        name: "Sun Bingo Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/the_chase_slingo": {
        slug: "the_chase_slingo",
        name: "The Chase Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/the_price_is_right": {
        slug: "the_price_is_right",
        name: "The Price is Right",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/tipping_point_slingo": {
        slug: "tipping_point_slingo",
        name: "Tipping Point Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/tutans_treasure": {
        slug: "tutans_treasure",
        name: "Tutans Treasure",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/wheely_wheely_big_win": {
        slug: "wheely_wheely_big_win",
        name: "Wheely Wheely Big Win",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/wild_rover": {
        slug: "wild_rover",
        name: "Wild Rover",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slingo/william_hill_slingo": {
        slug: "william_hill_slingo",
        name: "William Hill Slingo",
        provider: "Slingo",
        providerSlug: "slingo"
    },
    "slotmill/brew_brothers": {
        slug: "brew_brothers",
        name: "Brew Brothers",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/brew_brothers_xmas_brew": {
        slug: "brew_brothers_xmas_brew",
        name: "Brew Brothers Xmas Brew",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/cash_pandas": {
        slug: "cash_pandas",
        name: "Cash Pandas",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/chilli_bandits": {
        slug: "chilli_bandits",
        name: "Chilli Bandits",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/coin_quest": {
        slug: "coin_quest",
        name: "Coin Quest",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/coin_quest_2": {
        slug: "coin_quest_2",
        name: "Coin Quest 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/coins_and_cannons": {
        slug: "coins_and_cannons",
        name: "Coins and Cannons",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/crazy_crops": {
        slug: "crazy_crops",
        name: "Crazy Crops",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/dark_forge": {
        slug: "dark_forge",
        name: "Dark Forge",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/dead_mans_drop": {
        slug: "dead_mans_drop",
        name: "Dead Man's Drop",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/demons_gate": {
        slug: "demons_gate",
        name: "Demon's Gate",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/drunken_sailors": {
        slug: "drunken_sailors",
        name: "Drunken Sailors",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/emberfall": {
        slug: "emberfall",
        name: "Emberfall",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/emberfall_40k": {
        slug: "emberfall_40k",
        name: "Emberfall 40K",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/emperors_rise": {
        slug: "emperors_rise",
        name: "Emperor's Rise",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/eternal_dawn": {
        slug: "eternal_dawn",
        name: "Eternal Dawn",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/eternal_dusk": {
        slug: "eternal_dusk",
        name: "Eternal Dusk",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/fortune_pandas": {
        slug: "fortune_pandas",
        name: "Fortune Pandas",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/fruit_smash": {
        slug: "fruit_smash",
        name: "Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/gem_rush": {
        slug: "gem_rush",
        name: "Gem Rush",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/gods_of_glory": {
        slug: "gods_of_glory",
        name: "Gods of Glory",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/golden_scrolls": {
        slug: "golden_scrolls",
        name: "Golden Scrolls",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/king_of_the_streets": {
        slug: "king_of_the_streets",
        name: "King of the Streets",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/last_man_standing": {
        slug: "last_man_standing",
        name: "Last Man Standing",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/lucky_lucifer": {
        slug: "lucky_lucifer",
        name: "Lucky Lucifer",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/lucy_luck_and_the_crimson_diamond": {
        slug: "lucy_luck_and_the_crimson_diamond",
        name: "Lucy Luck and the Crimson Diamond",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/lucy_luck_and_the_quest_for_coins": {
        slug: "lucy_luck_and_the_quest_for_coins",
        name: "Lucy Luck and the Quest for Coins",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/lucy_luck_and_the_temple_of_mysteries": {
        slug: "lucy_luck_and_the_temple_of_mysteries",
        name: "Lucy Luck and the Temple of Mysteries",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/merlins_fortune": {
        slug: "merlins_fortune",
        name: "Merlin's Fortune",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/money_jar": {
        slug: "money_jar",
        name: "Money Jar",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/money_jar_2": {
        slug: "money_jar_2",
        name: "Money Jar 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/neon_dreams": {
        slug: "neon_dreams",
        name: "Neon Dreams",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/outlaws": {
        slug: "outlaws",
        name: "Outlaws",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/raging_riches": {
        slug: "raging_riches",
        name: "Raging Riches",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/ragnarok": {
        slug: "ragnarok",
        name: "Ragnarok",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/ragnarok_40k": {
        slug: "ragnarok_40k",
        name: "Ragnarok 40k",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/rainbow_rush": {
        slug: "rainbow_rush",
        name: "Rainbow Rush",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/reel_rampage": {
        slug: "reel_rampage",
        name: "Reel Rampage",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/sands_of_eternity": {
        slug: "sands_of_eternity",
        name: "Sands of Eternity",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/sands_of_eternity_2": {
        slug: "sands_of_eternity_2",
        name: "Sands of Eternity 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/season_of_fortune": {
        slug: "season_of_fortune",
        name: "Season of Fortune",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/shark_frenzy": {
        slug: "shark_frenzy",
        name: "Shark Frenzy",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/starspell": {
        slug: "starspell",
        name: "StarSpell",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/super_fruit_smash": {
        slug: "super_fruit_smash",
        name: "Super Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/sweet_spotz": {
        slug: "sweet_spotz",
        name: "Sweet Spotz",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/the_big_hit": {
        slug: "the_big_hit",
        name: "The Big Hit",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/three_samurai": {
        slug: "three_samurai",
        name: "Three Samurai",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/thunder_wheel": {
        slug: "thunder_wheel",
        name: "Thunder Wheel",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/tiki_thunder": {
        slug: "tiki_thunder",
        name: "Tiki Thunder",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/tyrants_fall": {
        slug: "tyrants_fall",
        name: "Tyrant's Fall",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/ultra_fruit_smash": {
        slug: "ultra_fruit_smash",
        name: "Ultra Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/vegas_gold": {
        slug: "vegas_gold",
        name: "Vegas Gold",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/vikings_creed": {
        slug: "vikings_creed",
        name: "Vikings Creed",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/wildfire": {
        slug: "wildfire",
        name: "Wildfire",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/wildhalla": {
        slug: "wildhalla",
        name: "Wildhalla",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "solvited/book_hotfire": {
        slug: "book_hotfire",
        name: "Book HOTFIRE",
        provider: "Solvited",
        providerSlug: "solvited"
    },
    "solvited/gold_fever": {
        slug: "gold_fever",
        name: "Gold Fever",
        provider: "Solvited",
        providerSlug: "solvited"
    },
    "storm-gaming/alchemy": {
        slug: "alchemy",
        name: "Alchemy",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "storm-gaming/arto_and_the_seven_deadly_spins_megaways": {
        slug: "arto_and_the_seven_deadly_spins_megaways",
        name: "Arto and the Seven Deadly Spins MegaWays",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "storm-gaming/lucky_money": {
        slug: "lucky_money",
        name: "Lucky Money",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "storm-gaming/megaways_mob": {
        slug: "megaways_mob",
        name: "MegaWays Mob",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "storm-gaming/payday_megaways": {
        slug: "payday_megaways",
        name: "Payday MegaWays",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "storm-gaming/ticket_to_fortune": {
        slug: "ticket_to_fortune",
        name: "Ticket To Fortune",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "tomhorn/243_chili": {
        slug: "243_chili",
        name: "243 Chili",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/243_christmas_fruits": {
        slug: "243_christmas_fruits",
        name: "243 Christmas Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/243_crystal_fruits": {
        slug: "243_crystal_fruits",
        name: "243 Crystal Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/243_crystal_fruits_reversed": {
        slug: "243_crystal_fruits_reversed",
        name: "243 Crystal Fruits Reversed",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/243_fire_n_diamonds": {
        slug: "243_fire_n_diamonds",
        name: "243 Fire n Diamonds",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/243_zeus_fruits": {
        slug: "243_zeus_fruits",
        name: "243 Zeus Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/3_mermaids": {
        slug: "3_mermaids",
        name: "3 Mermaids",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/3_ribbon_pots": {
        slug: "3_ribbon_pots",
        name: "3 Ribbon Pots",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/81_creepy_circus": {
        slug: "81_creepy_circus",
        name: "81 Creepy Circus",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/81_frutas_grandes": {
        slug: "81_frutas_grandes",
        name: "81 Frutas Grandes",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/81_frutas_grandes_vip": {
        slug: "81_frutas_grandes_vip",
        name: "81 Frutas Grandes VIP",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/81_joker_x": {
        slug: "81_joker_x",
        name: "81 Joker X",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/aarupolis": {
        slug: "aarupolis",
        name: "Aarupolis",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/akne_fruits": {
        slug: "akne_fruits",
        name: "Akne Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/alien_sea_turtles_vs_humans": {
        slug: "alien_sea_turtles_vs_humans",
        name: "Alien Sea Turtles vs Humans",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/bank_wagon_heist": {
        slug: "bank_wagon_heist",
        name: "Bank Wagon Heist",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/beast_coinz": {
        slug: "beast_coinz",
        name: "Beast Coinz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/beastie_bux": {
        slug: "beastie_bux",
        name: "Beastie Bux",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/biggy_winnie_feat_the_rich_one": {
        slug: "biggy_winnie_feat_the_rich_one",
        name: "Biggy Winnie feat The Rich One",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/bison_vs_buffalo": {
        slug: "bison_vs_buffalo",
        name: "Bison vs Buffalo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/black_mummy": {
        slug: "black_mummy",
        name: "Black Mummy",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/blackbeards_quest": {
        slug: "blackbeards_quest",
        name: "Blackbeard's Quest",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/book_of_cleo": {
        slug: "book_of_cleo",
        name: "Book of Cleo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/book_of_crystal_fruits": {
        slug: "book_of_crystal_fruits",
        name: "Book of Crystal Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/book_of_darius": {
        slug: "book_of_darius",
        name: "Book of Darius",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/book_of_spells": {
        slug: "book_of_spells",
        name: "Book Of Spells",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/book_of_vampires": {
        slug: "book_of_vampires",
        name: "Book of Vampires",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/candy_coinz": {
        slug: "candy_coinz",
        name: "Candy Coinz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/cricket_mania": {
        slug: "cricket_mania",
        name: "Cricket Mania",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/crowns_legacy": {
        slug: "crowns_legacy",
        name: "Crown's Legacy",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/crystal_fruits_bonanza": {
        slug: "crystal_fruits_bonanza",
        name: "Crystal Fruits Bonanza",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/diamond_hill": {
        slug: "diamond_hill",
        name: "Diamond Hill",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/don_juans_peppers": {
        slug: "don_juans_peppers",
        name: "Don Juan's Peppers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/dragon_egg": {
        slug: "dragon_egg",
        name: "Dragon Egg",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/dragon_riches": {
        slug: "dragon_riches",
        name: "Dragon Riches",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/dragon_vs_phoenix": {
        slug: "dragon_vs_phoenix",
        name: "Dragon VS Phoenix",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/feng_fu": {
        slug: "feng_fu",
        name: "Feng Fu",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/firenhot": {
        slug: "firenhot",
        name: "Fire'n'Hot",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/flaming_fruit": {
        slug: "flaming_fruit",
        name: "Flaming Fruit",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/fluxberry": {
        slug: "fluxberry",
        name: "Fluxberry",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/frozen_queen": {
        slug: "frozen_queen",
        name: "Frozen Queen",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/fruits_go_pop": {
        slug: "fruits_go_pop",
        name: "Fruits Go Pop!",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/frutopia": {
        slug: "frutopia",
        name: "Frutopia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/geishas_fan": {
        slug: "geishas_fan",
        name: "Geisha's Fan",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/gizas_portals": {
        slug: "gizas_portals",
        name: "Giza's Portals",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/gold_x": {
        slug: "gold_x",
        name: "Gold X",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/hawaii_fever": {
        slug: "hawaii_fever",
        name: "Hawaii Fever",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/hook_the_fortune": {
        slug: "hook_the_fortune",
        name: "Hook the Fortune",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/hot_blizzard": {
        slug: "hot_blizzard",
        name: "Hot Blizzard",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/hot_blizzard_deluxe": {
        slug: "hot_blizzard_deluxe",
        name: "Hot Blizzard Deluxe",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/hotnfruity": {
        slug: "hotnfruity",
        name: "Hot'n'Fruity",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/incas_treasure": {
        slug: "incas_treasure",
        name: "Inca's Treasure",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/joker_reelz": {
        slug: "joker_reelz",
        name: "Joker Reelz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/kongo_bongo": {
        slug: "kongo_bongo",
        name: "Kongo Bongo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/la_tomatina": {
        slug: "la_tomatina",
        name: "La Tomatina",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/lucky_scarab": {
        slug: "lucky_scarab",
        name: "Lucky Scarab",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/majestic_coins": {
        slug: "majestic_coins",
        name: "Majestic Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/mine_mine_quest": {
        slug: "mine_mine_quest",
        name: "Mine Mine Quest",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/money_bunny_show": {
        slug: "money_bunny_show",
        name: "Money Bunny Show",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/monkey_27": {
        slug: "monkey_27",
        name: "Monkey 27",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/monster_madness": {
        slug: "monster_madness",
        name: "Monster Madness",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/pandas_run": {
        slug: "pandas_run",
        name: "Pandas Run",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/pantera_rica": {
        slug: "pantera_rica",
        name: "Pantera Rica",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/pengwins": {
        slug: "pengwins",
        name: "PengWins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/pirate_coins": {
        slug: "pirate_coins",
        name: "Pirate Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/reborn_of_zeus_3000": {
        slug: "reborn_of_zeus_3000",
        name: "Reborn of Zeus 3000",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/red_head_bounty": {
        slug: "red_head_bounty",
        name: "Red Head Bounty",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/red_lights": {
        slug: "red_lights",
        name: "Red Lights",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/rot_stormo": {
        slug: "rot_stormo",
        name: "Rot Stormo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/royal_ruby_featurestorm": {
        slug: "royal_ruby_featurestorm",
        name: "Royal Ruby FeatureStorm",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/santa_yetti": {
        slug: "santa_yetti",
        name: "Santa Yetti",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/savannah_king": {
        slug: "savannah_king",
        name: "Savannah King",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/shaolins_tiger": {
        slug: "shaolins_tiger",
        name: "Shaolin's Tiger",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/sherlock_a_scandal_in_bohemia": {
        slug: "sherlock_a_scandal_in_bohemia",
        name: "Sherlock: A Scandal in Bohemia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/sizable_win": {
        slug: "sizable_win",
        name: "Sizable Win",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/sky_barons": {
        slug: "sky_barons",
        name: "Sky Barons",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/space_jammers": {
        slug: "space_jammers",
        name: "Space Jammers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/spinball": {
        slug: "spinball",
        name: "Spinball",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/sweet_crush": {
        slug: "sweet_crush",
        name: "Sweet Crush",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/sweet_gold_3000": {
        slug: "sweet_gold_3000",
        name: "Sweet Gold 3000",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/tao_tree_coins": {
        slug: "tao_tree_coins",
        name: "Tao Tree Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/the_cup": {
        slug: "the_cup",
        name: "The Cup",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/the_secret_of_ba": {
        slug: "the_secret_of_ba",
        name: "The Secret of BA",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/thrones_of_persia": {
        slug: "thrones_of_persia",
        name: "Thrones of Persia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/triple_joker": {
        slug: "triple_joker",
        name: "Triple Joker",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/triple_thunder": {
        slug: "triple_thunder",
        name: "Triple Thunder",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/triple_up": {
        slug: "triple_up",
        name: "Triple Up",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wheel_of_luck_hold_and_win": {
        slug: "wheel_of_luck_hold_and_win",
        name: "Wheel of Luck Hold and Win",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wild_mirage": {
        slug: "wild_mirage",
        name: "Wild Mirage",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wild_skyfire": {
        slug: "wild_skyfire",
        name: "Wild Skyfire",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wild_tribe_wall": {
        slug: "wild_tribe_wall",
        name: "Wild Tribe Wall",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wild_weather": {
        slug: "wild_weather",
        name: "Wild Weather",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wolf_sierra": {
        slug: "wolf_sierra",
        name: "Wolf Sierra",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/zeus_diving_multipliers": {
        slug: "zeus_diving_multipliers",
        name: "Zeus Diving Multipliers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "topspin/3_cards": {
        slug: "3_cards",
        name: "3 Cards",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/3_cards_diwali_special": {
        slug: "3_cards_diwali_special",
        name: "3 Cards Diwali Special",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/airavat_the_white_elephant": {
        slug: "airavat_the_white_elephant",
        name: "Airavat The White Elephant",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/airavat_white_elephant_scratch": {
        slug: "airavat_white_elephant_scratch",
        name: "Airavat White Elephant Scratch",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/angel_ascend_crash": {
        slug: "angel_ascend_crash",
        name: "Angel Ascend Crash",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/bhanumatis_magic_box": {
        slug: "bhanumatis_magic_box",
        name: "Bhanumatis Magic Box",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/big_cats_of_india": {
        slug: "big_cats_of_india",
        name: "Big Cats of India",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/chicken_smash": {
        slug: "chicken_smash",
        name: "Chicken Smash",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/crown_flag": {
        slug: "crown_flag",
        name: "Crown Flag",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/divine_fruits": {
        slug: "divine_fruits",
        name: "Divine Fruits",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/end_of_us_zombie_respin": {
        slug: "end_of_us_zombie_respin",
        name: "End of Us Zombie Respin",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/gold_silver_diamond": {
        slug: "gold_silver_diamond",
        name: "Gold Silver Diamond",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/golden_egg": {
        slug: "golden_egg",
        name: "Golden Egg",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/holi_hai": {
        slug: "holi_hai",
        name: "Holi Hai",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/indian_fortune": {
        slug: "indian_fortune",
        name: "Indian Fortune",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/jhandi_munda": {
        slug: "jhandi_munda",
        name: "Jhandi Munda",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/jungle_jango": {
        slug: "jungle_jango",
        name: "Jungle Jango",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/kaboom": {
        slug: "kaboom",
        name: "Kaboom",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/kohinoor": {
        slug: "kohinoor",
        name: "Koh-i-noor",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/love_goa": {
        slug: "love_goa",
        name: "Love Goa",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/maharaja_and_the_vampire": {
        slug: "maharaja_and_the_vampire",
        name: "Maharaja and the Vampire",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/mahjong_dragon_tower": {
        slug: "mahjong_dragon_tower",
        name: "Mahjong Dragon Tower",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/ninja_chacha": {
        slug: "ninja_chacha",
        name: "Ninja Chacha",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/pandavas": {
        slug: "pandavas",
        name: "Pandavas",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/paper_plane": {
        slug: "paper_plane",
        name: "Paper Plane",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/paper_plane_crash": {
        slug: "paper_plane_crash",
        name: "Paper Plane Crash",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/power_play": {
        slug: "power_play",
        name: "Power Play",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/raja_mantri_chor_sipahi": {
        slug: "raja_mantri_chor_sipahi",
        name: "Raja Mantri Chor Sipahi",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/rock_paper_scissors": {
        slug: "rock_paper_scissors",
        name: "Rock Paper Scissors",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/saanp_seedhi": {
        slug: "saanp_seedhi",
        name: "Saanp Seedhi",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/sassy_santa_christmas_crash": {
        slug: "sassy_santa_christmas_crash",
        name: "Sassy Santa Christmas Crash",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/snake_and_ladder": {
        slug: "snake_and_ladder",
        name: "Snake and Ladder",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/street_ratz_the_heist": {
        slug: "street_ratz_the_heist",
        name: "Street Ratz The Heist",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/super_sixer": {
        slug: "super_sixer",
        name: "Super Sixer",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/super_sixer_classic_scratch": {
        slug: "super_sixer_classic_scratch",
        name: "Super Sixer Classic Scratch",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/super_sixer_xtreme": {
        slug: "super_sixer_xtreme",
        name: "Super Sixer Xtreme",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/sweet_shop": {
        slug: "sweet_shop",
        name: "Sweet Shop",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/sweetello": {
        slug: "sweetello",
        name: "Sweetello",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/teen_patti": {
        slug: "teen_patti",
        name: "Teen Patti",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/teen_patti_diwali_special": {
        slug: "teen_patti_diwali_special",
        name: "Teen Patti Diwali Special",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/thief_in_the_palace": {
        slug: "thief_in_the_palace",
        name: "Thief In The Palace",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/vikram_aur_betaal": {
        slug: "vikram_aur_betaal",
        name: "Vikram Aur Betaal",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "trigger/alice_in_winderland": {
        slug: "alice_in_winderland",
        name: "Alice in Winderland",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/beanstalk_grows_wild": {
        slug: "beanstalk_grows_wild",
        name: "Beanstalk Grows Wild",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/mister_payman": {
        slug: "mister_payman",
        name: "Mister Payman",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/phoenix_up_cash": {
        slug: "phoenix_up_cash",
        name: "Phoenix Up Cash",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/princess_pea_and_royal_wild": {
        slug: "princess_pea_and_royal_wild",
        name: "Princess, Pea and Royal Wild",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/robin_in_the_hood": {
        slug: "robin_in_the_hood",
        name: "Robin in the Hood",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/santas_secret_party": {
        slug: "santas_secret_party",
        name: "Santa's Secret Party",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "wazdan/12_coins_grand_gold_edition": {
        slug: "12_coins_grand_gold_edition",
        name: "12 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/12_coins_grand_platinum_edition": {
        slug: "12_coins_grand_platinum_edition",
        name: "12 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/15_coins": {
        slug: "15_coins",
        name: "15 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/15_coins_grand_diamond_edition": {
        slug: "15_coins_grand_diamond_edition",
        name: "15 Coins Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/15_coins_grand_platinum_edition": {
        slug: "15_coins_grand_platinum_edition",
        name: "15 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/16_coins": {
        slug: "16_coins",
        name: "16 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/16_coins_grand_gold_edition": {
        slug: "16_coins_grand_gold_edition",
        name: "16 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/16_coins_grand_platinum_edition": {
        slug: "16_coins_grand_platinum_edition",
        name: "16 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/16_coins_x5000": {
        slug: "16_coins_x5000",
        name: "16 Coins x5000",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/20_coins": {
        slug: "20_coins",
        name: "20 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/20_coins_grand_gold_edition": {
        slug: "20_coins_grand_gold_edition",
        name: "20 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/24_coins": {
        slug: "24_coins",
        name: "24 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/25_coins": {
        slug: "25_coins",
        name: "25 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/25_coins_grand_gold_edition": {
        slug: "25_coins_grand_gold_edition",
        name: "25 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/30_coins": {
        slug: "30_coins",
        name: "30 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/30_coins_grand_gold_edition": {
        slug: "30_coins_grand_gold_edition",
        name: "30 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/36_coins": {
        slug: "36_coins",
        name: "36 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/36_coins_grand_gold_edition": {
        slug: "36_coins_grand_gold_edition",
        name: "36 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_balls": {
        slug: "9_balls",
        name: "9 Balls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_burning_dragons": {
        slug: "9_burning_dragons",
        name: "9 Burning Dragons",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_burning_stars": {
        slug: "9_burning_stars",
        name: "9 Burning Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins": {
        slug: "9_coins",
        name: "9 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins_1000_edition": {
        slug: "9_coins_1000_edition",
        name: "9 Coins 1000 Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins_extremely_light": {
        slug: "9_coins_extremely_light",
        name: "9 Coins Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins_grand_diamond_edition": {
        slug: "9_coins_grand_diamond_edition",
        name: "9 Coins Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins_grand_gold_edition": {
        slug: "9_coins_grand_gold_edition",
        name: "9 Coins: Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins_grand_platinum_edition": {
        slug: "9_coins_grand_platinum_edition",
        name: "9 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_lions": {
        slug: "9_lions",
        name: "9 Lions",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_lions_hold_the_jackpot": {
        slug: "9_lions_hold_the_jackpot",
        name: "9 Lions Hold the Jackpot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_tigers": {
        slug: "9_tigers",
        name: "9 Tigers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/american_poker_gold": {
        slug: "american_poker_gold",
        name: "American Poker Gold",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/american_poker_v": {
        slug: "american_poker_v",
        name: "American Poker V",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/arcade": {
        slug: "arcade",
        name: "Arcade",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/back_to_70s": {
        slug: "back_to_70s",
        name: "Back to 70's",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/bars_and_7s": {
        slug: "bars_and_7s",
        name: "BARs and 7s",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/beach_party": {
        slug: "beach_party",
        name: "Beach Party",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/beach_party_hot": {
        slug: "beach_party_hot",
        name: "Beach Party Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/beauty_fruity": {
        slug: "beauty_fruity",
        name: "Beauty Fruity",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/bell_wizard": {
        slug: "bell_wizard",
        name: "Bell Wizard",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/black_hawk": {
        slug: "black_hawk",
        name: "Black Hawk",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/black_hawk_deluxe": {
        slug: "black_hawk_deluxe",
        name: "Black Hawk Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/black_horse": {
        slug: "black_horse",
        name: "Black Horse",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/black_horse_deluxe": {
        slug: "black_horse_deluxe",
        name: "Black Horse Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/blackjack": {
        slug: "blackjack",
        name: "BlackJack",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/book_of_faith": {
        slug: "book_of_faith",
        name: "Book of Faith",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/bumba_meu_boi_coin": {
        slug: "bumba_meu_boi_coin",
        name: "Bumba Meu Boi Coin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/burning_reels": {
        slug: "burning_reels",
        name: "Burning Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/burning_stars": {
        slug: "burning_stars",
        name: "Burning Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/burning_stars_3": {
        slug: "burning_stars_3",
        name: "Burning Stars 3",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/burning_sun": {
        slug: "burning_sun",
        name: "Burning Sun",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/burning_sun_extremely_light": {
        slug: "burning_sun_extremely_light",
        name: "Burning Sun Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/butterfly_lovers": {
        slug: "butterfly_lovers",
        name: "Butterfly Lovers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/captain_shark": {
        slug: "captain_shark",
        name: "Captain Shark",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/carribean_beach_poker": {
        slug: "carribean_beach_poker",
        name: "Carribean Beach Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/cash_grotto": {
        slug: "cash_grotto",
        name: "Cash Grotto",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/casino_roulette": {
        slug: "casino_roulette",
        name: "Casino Roulette",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/choco_reels": {
        slug: "choco_reels",
        name: "Choco Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/clover_lady": {
        slug: "clover_lady",
        name: "Clover Lady",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/colin_the_cat": {
        slug: "colin_the_cat",
        name: "Colin The Cat",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/corrida_romance": {
        slug: "corrida_romance",
        name: "Corrida Romance",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/corrida_romance_deluxe": {
        slug: "corrida_romance_deluxe",
        name: "Corrida Romance Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/crazy_cars": {
        slug: "crazy_cars",
        name: "Crazy Cars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/criss_cross_81": {
        slug: "criss_cross_81",
        name: "Criss Cross 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/cube_mania": {
        slug: "cube_mania",
        name: "Cube Mania",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/cube_mania_deluxe": {
        slug: "cube_mania_deluxe",
        name: "Cube Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/demon_jack_27": {
        slug: "demon_jack_27",
        name: "Demon Jack 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/dino_reels_81": {
        slug: "dino_reels_81",
        name: "Dino Reels 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/double_tigers": {
        slug: "double_tigers",
        name: "Double Tigers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/draculas_castle": {
        slug: "draculas_castle",
        name: "Dracula's Castle",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/dragons_lucky_8": {
        slug: "dragons_lucky_8",
        name: "Dragons Lucky 8",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/dwarfs_fortune": {
        slug: "dwarfs_fortune",
        name: "Dwarfs Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/eggs_of_fortune": {
        slug: "eggs_of_fortune",
        name: "Eggs of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/extra_bingo": {
        slug: "extra_bingo",
        name: "Extra Bingo",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fenix_play": {
        slug: "fenix_play",
        name: "Fenix Play",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fenix_play_27": {
        slug: "fenix_play_27",
        name: "Fenix Play 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fenix_play_27_deluxe": {
        slug: "fenix_play_27_deluxe",
        name: "Fenix Play 27 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fenix_play_deluxe": {
        slug: "fenix_play_deluxe",
        name: "Fenix Play Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fire_bird": {
        slug: "fire_bird",
        name: "Fire Bird",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fishermans_luck": {
        slug: "fishermans_luck",
        name: "Fisherman's Luck",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/football_mania": {
        slug: "football_mania",
        name: "Football Mania",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/football_mania_deluxe": {
        slug: "football_mania_deluxe",
        name: "Football Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fortune_reels": {
        slug: "fortune_reels",
        name: "Fortune Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fruit_fiesta": {
        slug: "fruit_fiesta",
        name: "Fruit Fiesta",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fruit_mania_deluxe": {
        slug: "fruit_mania_deluxe",
        name: "Fruit Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fruits_go_bananas": {
        slug: "fruits_go_bananas",
        name: "Fruits Go Bananas",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/gem_splitter": {
        slug: "gem_splitter",
        name: "Gem Splitter",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/gold_roulette": {
        slug: "gold_roulette",
        name: "Gold Roulette",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/golden_sphinx": {
        slug: "golden_sphinx",
        name: "Golden Sphinx",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/good_luck_40": {
        slug: "good_luck_40",
        name: "Good Luck 40",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/great_book_of_magic": {
        slug: "great_book_of_magic",
        name: "Great Book of Magic",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/great_book_of_magic_deluxe": {
        slug: "great_book_of_magic_deluxe",
        name: "Great Book of Magic Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/haunted_coins_x1000": {
        slug: "haunted_coins_x1000",
        name: "Haunted Coins x1000",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/haunted_hospital": {
        slug: "haunted_hospital",
        name: "Haunted Hospital",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/highschool_manga": {
        slug: "highschool_manga",
        name: "Highschool Manga",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/highway_to_hell": {
        slug: "highway_to_hell",
        name: "Highway To Hell",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/highway_to_hell_deluxe": {
        slug: "highway_to_hell_deluxe",
        name: "Highway to Hell Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_777": {
        slug: "hot_777",
        name: "Hot 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_777_deluxe": {
        slug: "hot_777_deluxe",
        name: "Hot 777 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_party": {
        slug: "hot_party",
        name: "Hot Party",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_party_deluxe": {
        slug: "hot_party_deluxe",
        name: "Hot Party Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_cash_out": {
        slug: "hot_slot_777_cash_out",
        name: "Hot Slot: 777 Cash Out",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_cash_out_extremely_light": {
        slug: "hot_slot_777_cash_out_extremely_light",
        name: "Hot Slot: 777 Cash Out Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_cash_out_grand_diamond_edition": {
        slug: "hot_slot_777_cash_out_grand_diamond_edition",
        name: "Hot Slot: 777 Cash Out Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_cash_out_grand_gold_edition": {
        slug: "hot_slot_777_cash_out_grand_gold_edition",
        name: "Hot Slot: 777 Cash Out Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_cash_out_grand_platinum_edition": {
        slug: "hot_slot_777_cash_out_grand_platinum_edition",
        name: "Hot Slot: 777 Cash Out Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_coins_extremely_light": {
        slug: "hot_slot_777_coins_extremely_light",
        name: "Hot Slot 777 Coins Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_crown": {
        slug: "hot_slot_777_crown",
        name: "Hot Slot: 777 Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_crown_extremely_light": {
        slug: "hot_slot_777_crown_extremely_light",
        name: "Hot Slot: 777 Crown Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_diamond_crown": {
        slug: "hot_slot_777_diamond_crown",
        name: "Hot Slot 777 Diamond Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_gold_crown": {
        slug: "hot_slot_777_gold_crown",
        name: "Hot Slot 777 Gold Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_hold_the_jackpot": {
        slug: "hot_slot_777_hold_the_jackpot",
        name: "Hot Slot 777 Hold the Jackpot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_platinum_crown": {
        slug: "hot_slot_777_platinum_crown",
        name: "Hot Slot 777 Platinum Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_rubies": {
        slug: "hot_slot_777_rubies",
        name: "Hot Slot: 777 Rubies",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_rubies_extremely_light": {
        slug: "hot_slot_777_rubies_extremely_light",
        name: "Hot Slot: 777 Rubies Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_stars": {
        slug: "hot_slot_777_stars",
        name: "Hot Slot: 777 Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_diamond_coins": {
        slug: "hot_slot_diamond_coins",
        name: "Hot Slot Diamond Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_gold_coins": {
        slug: "hot_slot_gold_coins",
        name: "Hot Slot Gold Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_great_book_of_magic": {
        slug: "hot_slot_great_book_of_magic",
        name: "Hot Slot: Great Book of Magic",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_magic_bombs": {
        slug: "hot_slot_magic_bombs",
        name: "Hot Slot: Magic Bombs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_magic_pearls": {
        slug: "hot_slot_magic_pearls",
        name: "Hot Slot: Magic Pearls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_mystery_jackpot_joker": {
        slug: "hot_slot_mystery_jackpot_joker",
        name: "Hot Slot: Mystery Jackpot Joker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_platinum_coins": {
        slug: "hot_slot_platinum_coins",
        name: "Hot Slot Platinum Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hungry_shark": {
        slug: "hungry_shark",
        name: "Hungry Shark",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/in_the_forest": {
        slug: "in_the_forest",
        name: "In the Forest",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/infinity_hero": {
        slug: "infinity_hero",
        name: "Infinity Hero",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/jack_on_hold": {
        slug: "jack_on_hold",
        name: "Jack on Hold",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/jackpot_builders": {
        slug: "jackpot_builders",
        name: "Jackpot Builders",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/jacks_ride": {
        slug: "jacks_ride",
        name: "Jack's Ride",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/jelly_reels": {
        slug: "jelly_reels",
        name: "Jelly Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/joker_explosion": {
        slug: "joker_explosion",
        name: "Joker Explosion",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/joker_poker": {
        slug: "joker_poker",
        name: "Joker Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/juicy_reels": {
        slug: "juicy_reels",
        name: "Juicy Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/jumping_fruits": {
        slug: "jumping_fruits",
        name: "Jumping Fruits",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/kickoff": {
        slug: "kickoff",
        name: "KickOff",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/larry_the_leprechaun": {
        slug: "larry_the_leprechaun",
        name: "Larry the Leprechaun",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/los_muertos": {
        slug: "los_muertos",
        name: "Los Muertos",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/los_muertos_ii": {
        slug: "los_muertos_ii",
        name: "Los Muertos II",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lost_treasure": {
        slug: "lost_treasure",
        name: "Lost Treasure",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lucky_9": {
        slug: "lucky_9",
        name: "Lucky 9",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lucky_fish": {
        slug: "lucky_fish",
        name: "Lucky Fish",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lucky_fortune": {
        slug: "lucky_fortune",
        name: "Lucky Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lucky_queen": {
        slug: "lucky_queen",
        name: "Lucky Queen",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lucky_reels": {
        slug: "lucky_reels",
        name: "Lucky Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_eggs": {
        slug: "magic_eggs",
        name: "Magic Eggs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruit_cherries": {
        slug: "magic_fruit_cherries",
        name: "Magic Fruit: Cherries",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruit_dice": {
        slug: "magic_fruit_dice",
        name: "Magic Fruit Dice",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits": {
        slug: "magic_fruits",
        name: "Magic Fruits",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_27": {
        slug: "magic_fruits_27",
        name: "Magic Fruits 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_4": {
        slug: "magic_fruits_4",
        name: "Magic Fruits 4",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_4_deluxe": {
        slug: "magic_fruits_4_deluxe",
        name: "Magic Fruits 4 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_81": {
        slug: "magic_fruits_81",
        name: "Magic Fruits 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_deluxe": {
        slug: "magic_fruits_deluxe",
        name: "Magic Fruits Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_oranges": {
        slug: "magic_fruits_oranges",
        name: "Magic Fruits Oranges",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_hot": {
        slug: "magic_hot",
        name: "Magic Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_hot_4": {
        slug: "magic_hot_4",
        name: "Magic Hot 4",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_hot_4_deluxe": {
        slug: "magic_hot_4_deluxe",
        name: "Magic Hot 4 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_of_the_ring": {
        slug: "magic_of_the_ring",
        name: "Magic Of The Ring",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_of_the_ring_deluxe": {
        slug: "magic_of_the_ring_deluxe",
        name: "Magic of the Ring Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_poker": {
        slug: "magic_poker",
        name: "Magic Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_spins": {
        slug: "magic_spins",
        name: "Magic Spins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_stars": {
        slug: "magic_stars",
        name: "Magic Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_stars_3": {
        slug: "magic_stars_3",
        name: "Magic Stars 3",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_stars_5": {
        slug: "magic_stars_5",
        name: "Magic Stars 5",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_stars_6": {
        slug: "magic_stars_6",
        name: "Magic Stars 6",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_stars_9": {
        slug: "magic_stars_9",
        name: "Magic Stars 9",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_target": {
        slug: "magic_target",
        name: "Magic Target",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_target_deluxe": {
        slug: "magic_target_deluxe",
        name: "Magic Target Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mayan_ritual": {
        slug: "mayan_ritual",
        name: "Mayan Ritual",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/miami_beach": {
        slug: "miami_beach",
        name: "Miami Beach",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/midnight_in_tokyo": {
        slug: "midnight_in_tokyo",
        name: "Midnight in Tokyo",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_crown_empire_of_gold": {
        slug: "mighty_crown_empire_of_gold",
        name: "Mighty Crown: Empire of Gold",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_crown_legacy_of_mars": {
        slug: "mighty_crown_legacy_of_mars",
        name: "Mighty Crown Legacy of Mars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_fish_blue_marlin": {
        slug: "mighty_fish_blue_marlin",
        name: "Mighty Fish: Blue Marlin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_hot_777": {
        slug: "mighty_hot_777",
        name: "Mighty Hot 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_hot_amazonia": {
        slug: "mighty_hot_amazonia",
        name: "Mighty Hot: Amazonia",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_symbols_crowns": {
        slug: "mighty_symbols_crowns",
        name: "Mighty Symbols Crowns",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_symbols_diamonds": {
        slug: "mighty_symbols_diamonds",
        name: "Mighty Symbols Diamonds",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_symbols_jokers": {
        slug: "mighty_symbols_jokers",
        name: "Mighty Symbols: Jokers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_symbols_sevens": {
        slug: "mighty_symbols_sevens",
        name: "Mighty Symbols: Sevens",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_gorilla": {
        slug: "mighty_wild_gorilla",
        name: "Mighty Wild Gorilla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_jaguar": {
        slug: "mighty_wild_jaguar",
        name: "Mighty Wild Jaguar",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_panther": {
        slug: "mighty_wild_panther",
        name: "Mighty Wild: Panther",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_panther_grand_diamond_edition": {
        slug: "mighty_wild_panther_grand_diamond_edition",
        name: "Mighty Wild: Panther Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_panther_grand_gold_edition": {
        slug: "mighty_wild_panther_grand_gold_edition",
        name: "Mighty Wild Panther Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_panther_grand_platinum_edition": {
        slug: "mighty_wild_panther_grand_platinum_edition",
        name: "Mighty Wild: Panther Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/moon_of_fortune": {
        slug: "moon_of_fortune",
        name: "Moon of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mystery_jack": {
        slug: "mystery_jack",
        name: "Mystery Jack",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mystery_jack_deluxe": {
        slug: "mystery_jack_deluxe",
        name: "Mystery Jack Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mystery_kindom_mystery_bells": {
        slug: "mystery_kindom_mystery_bells",
        name: "Mystery Kindom: Mystery Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/neon_city": {
        slug: "neon_city",
        name: "Neon City",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/night_club_81": {
        slug: "night_club_81",
        name: "Night Club 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/one_coins": {
        slug: "one_coins",
        name: "One Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/ox_coin": {
        slug: "ox_coin",
        name: "Ox Coin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_god_medusa_extremely_light": {
        slug: "power_of_god_medusa_extremely_light",
        name: "Power of God: Medusa Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_egypt": {
        slug: "power_of_gods_egypt",
        name: "Power of Gods: Egypt",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_hades": {
        slug: "power_of_gods_hades",
        name: "Power of Gods: Hades",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_medusa": {
        slug: "power_of_gods_medusa",
        name: "Power of Gods: Medusa",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_the_pantheon": {
        slug: "power_of_gods_the_pantheon",
        name: "Power of Gods: The Pantheon",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_valhalla": {
        slug: "power_of_gods_valhalla",
        name: "Power of Gods: Valhalla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_valhalla_extremely_light": {
        slug: "power_of_gods_valhalla_extremely_light",
        name: "Power of Gods: Valhalla Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_sun_svarog": {
        slug: "power_of_sun_svarog",
        name: "Power of Sun: Svarog",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/prosperity_pearls": {
        slug: "prosperity_pearls",
        name: "Prosperity Pearls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/prosperity_reels": {
        slug: "prosperity_reels",
        name: "Prosperity Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/reel_hero": {
        slug: "reel_hero",
        name: "Reel Hero",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/reel_joke": {
        slug: "reel_joke",
        name: "Reel Joke",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/relic_hunters_and_the_book_of_faith": {
        slug: "relic_hunters_and_the_book_of_faith",
        name: "Relic Hunters and the Book of Faith",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/santas_gift_frenzy": {
        slug: "santas_gift_frenzy",
        name: "Santa's Gift Frenzy",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sic_bo_dragons": {
        slug: "sic_bo_dragons",
        name: "Sic Bo Dragons",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_777": {
        slug: "sizzling_777",
        name: "Sizzling 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_777_deluxe": {
        slug: "sizzling_777_deluxe",
        name: "Sizzling 777 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_bells": {
        slug: "sizzling_bells",
        name: "Sizzling Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_eggs": {
        slug: "sizzling_eggs",
        name: "Sizzling Eggs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_eggs_extremely_light": {
        slug: "sizzling_eggs_extremely_light",
        name: "Sizzling Eggs Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_eggs_grand_gold_edition": {
        slug: "sizzling_eggs_grand_gold_edition",
        name: "Sizzling Eggs Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_eggs_grand_platinum_edition": {
        slug: "sizzling_eggs_grand_platinum_edition",
        name: "Sizzling Eggs Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_kindom_bison": {
        slug: "sizzling_kindom_bison",
        name: "Sizzling Kindom: Bison",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_moon": {
        slug: "sizzling_moon",
        name: "Sizzling Moon",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/slot_jam": {
        slug: "slot_jam",
        name: "Slot Jam",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sonic_reels": {
        slug: "sonic_reels",
        name: "Sonic Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/space_gem": {
        slug: "space_gem",
        name: "Space Gem",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/space_spins": {
        slug: "space_spins",
        name: "Space Spins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/spectrum": {
        slug: "spectrum",
        name: "Spectrum",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sun_of_fortune": {
        slug: "sun_of_fortune",
        name: "Sun of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/super_hot": {
        slug: "super_hot",
        name: "Super Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/telly_reels": {
        slug: "telly_reels",
        name: "Telly Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/three_cards": {
        slug: "three_cards",
        name: "Three Cards",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/triple_star": {
        slug: "triple_star",
        name: "Triple Star",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/turbo_play": {
        slug: "turbo_play",
        name: "Turbo Play",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/turbo_poker": {
        slug: "turbo_poker",
        name: "Turbo Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/unicorn_reels": {
        slug: "unicorn_reels",
        name: "Unicorn Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/valentines_coins": {
        slug: "valentines_coins",
        name: "Valentine's Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/valhalla": {
        slug: "valhalla",
        name: "Valhalla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/vegas_hot": {
        slug: "vegas_hot",
        name: "Vegas Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/vegas_hot_81": {
        slug: "vegas_hot_81",
        name: "Vegas Hot 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/vegas_reels_ii": {
        slug: "vegas_reels_ii",
        name: "Vegas Reels II",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/welcome_to_hell_81": {
        slug: "welcome_to_hell_81",
        name: "Welcome to Hell 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/wild_girls": {
        slug: "wild_girls",
        name: "Wild Girls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/wild_guns": {
        slug: "wild_guns",
        name: "Wild Guns",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/wild_jack": {
        slug: "wild_jack",
        name: "Wild Jack",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/wild_jack_81": {
        slug: "wild_jack_81",
        name: "Wild Jack 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/win_and_replay": {
        slug: "win_and_replay",
        name: "Win and Replay",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "winfast/almighty_goddess_zera": {
        slug: "almighty_goddess_zera",
        name: "Almighty Goddess Zera",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/aztecx": {
        slug: "aztecx",
        name: "Aztec-X",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/battle_dwarf": {
        slug: "battle_dwarf",
        name: "Battle Dwarf",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/battle_dwarf_2": {
        slug: "battle_dwarf_2",
        name: "Battle Dwarf 2",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/battle_dwarf_xmas": {
        slug: "battle_dwarf_xmas",
        name: "Battle Dwarf Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/beyond_dice": {
        slug: "beyond_dice",
        name: "Beyond Dice",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/dragons_pot": {
        slug: "dragons_pot",
        name: "Dragon's Pot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/dragons_win_multiplier": {
        slug: "dragons_win_multiplier",
        name: "Dragon's Win Multiplier",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/dreams_of_gold": {
        slug: "dreams_of_gold",
        name: "Dreams of Gold",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/dreams_of_gold_delight": {
        slug: "dreams_of_gold_delight",
        name: "Dreams of Gold Delight",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/dreams_of_gold_jackpot": {
        slug: "dreams_of_gold_jackpot",
        name: "Dreams of Gold Jackpot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/egg_hustler": {
        slug: "egg_hustler",
        name: "Egg Hustler",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/engeki_rising_x50": {
        slug: "engeki_rising_x50",
        name: "Engeki Rising x50",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/giant_king": {
        slug: "giant_king",
        name: "Giant King",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hawaiian_diva": {
        slug: "hawaiian_diva",
        name: "Hawaiian Diva",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hawaiian_dream": {
        slug: "hawaiian_dream",
        name: "Hawaiian Dream",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hawaiian_dream_gold": {
        slug: "hawaiian_dream_gold",
        name: "Hawaiian Dream GOLD",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hawaiian_dream_jackpot": {
        slug: "hawaiian_dream_jackpot",
        name: "Hawaiian Dream Jackpot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hawaiian_dream_xmas": {
        slug: "hawaiian_dream_xmas",
        name: "Hawaiian Dream Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hikaru_super_live_bazooka": {
        slug: "hikaru_super_live_bazooka",
        name: "Hikaru Super Live BAZOOKA",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/mighty_wins": {
        slug: "mighty_wins",
        name: "Mighty Wins",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/million_tree": {
        slug: "million_tree",
        name: "Million Tree",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/mummy_princess": {
        slug: "mummy_princess",
        name: "Mummy Princess",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/oiran_dream": {
        slug: "oiran_dream",
        name: "Oiran Dream",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/oiran_dream_xmas": {
        slug: "oiran_dream_xmas",
        name: "Oiran Dream Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/oiran_hearts": {
        slug: "oiran_hearts",
        name: "Oiran Hearts",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/pyramid_rising_x33": {
        slug: "pyramid_rising_x33",
        name: "Pyramid Rising x33",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/raigeki_rising_x30": {
        slug: "raigeki_rising_x30",
        name: "Raigeki Rising x30",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/star_treasure": {
        slug: "star_treasure",
        name: "Star Treasure",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/sword_of_fortune": {
        slug: "sword_of_fortune",
        name: "Sword of Fortune",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/team_win_fast": {
        slug: "team_win_fast",
        name: "Team Win Fast",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/treasure_labyrinth": {
        slug: "treasure_labyrinth",
        name: "Treasure Labyrinth",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/virus_mania": {
        slug: "virus_mania",
        name: "Virus Mania",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/wild_west_angel": {
        slug: "wild_west_angel",
        name: "Wild West Angel",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/wild_west_angel_rodeo": {
        slug: "wild_west_angel_rodeo",
        name: "Wild West Angel Rodeo",
        provider: "Winfast",
        providerSlug: "winfast"
    },
};
